// save-load.js
function convertLegacyPatch(patchData) {
  // Check if already new format
  if (patchData.version === 2) {
    return patchData;
  }

  console.log('Converting legacy patch to grid coordinates...');

  // Convert old zoomFactor to viewState if needed
  const zoom = patchData.zoomFactor || 1.0;
  const newViewState = patchData.viewState || {
    offsetX: -5000,
    offsetY: -5000,
    scale: zoom,
    gridSize: 20
  };

  // Modules in legacy were smaller, so spread them out slightly
  const spreadFactor = 1.2; // try 1.2–1.5 for different layouts

  // Convert each module's position to grid coordinates and apply offset + spread
  const convertedModules = patchData.modules.map(module => {
    let gridX, gridY;

    if (module.gridX !== undefined && module.gridY !== undefined) {
      // Already has grid coordinates — apply spread anyway
      gridX = Math.round(module.gridX * spreadFactor);
      gridY = Math.round(module.gridY * spreadFactor);
    } else if (module.position) {
      // Convert pixel position to grid coordinates, apply +5000 offset
      const adjustedLeft = (module.position.left + 5000) * spreadFactor;
      const adjustedTop = (module.position.top + 5000) * spreadFactor;

      gridX = Math.round(adjustedLeft / newViewState.gridSize);
      gridY = Math.round(adjustedTop / newViewState.gridSize);
    } else {
      // Fallback to default position
      gridX = 5;
      gridY = 5;
    }

    return {
      id: module.id,
      type: module.type,
      gridX,
      gridY,
      freq: module.freq,
      assignedKey: module.assignedKey,
      memoryData: module.memoryData
    };
  });

  return {
    version: 2,
    modules: convertedModules,
    connections: patchData.connections || [],
    viewState: newViewState,
    performanceAssignments: {
      oscillators: [],
      buttons: []
    }
  };
}



// Modified savePatch to work with the new menu system
function savePatch() {
  // Collect custom module definitions used in this patch
  const usedCustomModules = {};
  modules.forEach(m => {
    if (customModuleDefinitions[m.type]) {
      usedCustomModules[m.type] = customModuleDefinitions[m.type];
    }
  });

  const patchData = {
    version: 2,
    modules: modules.map(m => ({
      id: m.id,
      type: m.type,
      gridX: m.gridX,
      gridY: m.gridY,
      freq: m.freq,
      assignedKey: m.assignedKey,
      memoryData: m.memoryData
    })),
    connections: connections,
    viewState: { ...viewState },
    // Save performance assignments
    performanceAssignments: {
      oscillators: Array.from(performanceSnapshot.performanceOscillators.entries()),
      buttons: Array.from(performanceSnapshot.performanceButtons.entries())
    },
    customModules: usedCustomModules // Embed custom module definitions
  };

  const jsonData = JSON.stringify(patchData, null, 2);
  const blob = new Blob([jsonData], { type: 'application/json' });
  const url = URL.createObjectURL(blob);

  // Save to localStorage
  localStorage.setItem('savedPatch', jsonData);

  const a = document.createElement('a');
  a.href = url;
  a.download = 'patch.json';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

// Modify loadPatch and loadDefaultPatch to handle zoom factor
function loadPatch(file) {
  const reader = new FileReader();
  reader.onload = function (e) {
    try {
      const patchData = JSON.parse(e.target.result);
      loadPatchFromData(patchData);
    } catch (error) {
      console.error("Error loading patch:", error);
      showAlert("Error loading patch file.");
    }
  };
  reader.readAsText(file);
}

async function loadDefaultPatch() {
  undoStack = [];
  redoStack = [];

  let savedPatch = localStorage.getItem('savedPatch');
  let patchData;

  if (savedPatch) {
    // Use saved data
    try {
      patchData = JSON.parse(savedPatch);
      // Convert if legacy format
      patchData = convertLegacyPatch(patchData);
    } catch (error) {
      console.error("Error parsing saved patch:", error);
      patchData = null; // Will fall through to fetch default
    }
  }

  // If no saved patch or parsing failed, load from server
  if (!patchData) {
    try {
      const response = await fetch("/examples/tutorial/tutorial-9.json");
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      patchData = await response.json();
      patchData = convertLegacyPatch(patchData);
    } catch (error) {
      console.error("Error loading default patch:", error);
      patchData = {
        version: 2,
        modules: [{ id: 9, type: "Oscillator", gridX: 330, gridY: 307, freq: 880 }],
        connections: [],
        viewState: {
          offsetX: 0,
          offsetY: 0,
          scale: 1.0,
          gridSize: 20
        },
        performanceAssignments: {
          oscillators: [],
          buttons: []
        }
      };
    }
  }

  loadPatchFromData(patchData);
  centerPatchToOrigin();
  fitToView();
  closeAllEEPROMProgrammers();
  selectedOutput = null;
}

// Improved rebuildLedElements function
function rebuildLedElements() {
  ledElements = [];

  // Find all modules with LEDs
  modules.forEach(module => {
    const moduleDiv = document.querySelector(`[data-id='${module.id}']`);
    if (!moduleDiv) return;

    // Special handling for 7-Segment Display
    if (module.type === '7-Segment Display') {
      // Look for SVG path elements instead of .segment divs
      const svgPaths = Array.from(moduleDiv.querySelectorAll('svg path'));

      if (svgPaths.length > 0) {
        // SVG implementation - paths are in order: g, a, e, d, f, b, c
        const segmentOrder = ['g', 'f', 'e', 'd', 'c', 'b', 'a'];
        const pathToInput = { 'a': 0, 'b': 1, 'c': 2, 'd': 3, 'e': 4, 'f': 5, 'g': 6 };

        svgPaths.forEach((path, i) => {
          const segmentName = segmentOrder[i];
          const inputIndex = pathToInput[segmentName];

          ledElements.push({
            modId: module.id,
            led: path,
            outputIndex: inputIndex
          });
        });
      } else {
        // Fallback for old div-based segments (if they exist)
        const segments = Array.from(moduleDiv.querySelectorAll('.segment'));
        segments.forEach((segment, index) => {
          ledElements.push({
            modId: module.id,
            led: segment,
            outputIndex: index
          });
        });
      }
      return; // Skip the standard LED handling below
    }

    // For modules that have standard LEDs
    if (module.type === 'Binary Counter' || module.type === 'Ring Counter' ||
      module.type === 'Shift Register' || module.type === 'Multiplexer' ||
      module.type === 'Demultiplexer' || module.type === 'Shift Register (PISO)' ||
      module.type === 'AND' || module.type === 'NAND' ||
      module.type === 'OR' || module.type === 'NOR' ||
      module.type === 'XOR' || module.type === 'XNOR' ||
      module.type === 'NOT' || module.type === 'Flip-Flop' || module.type === 'Binary Rate Multiplier' ||
      module.type === 'EEPROM' || module.type === 'Button' ||
      module.type === 'BCD to 7-Segment'
    ) {

      const leds = Array.from(moduleDiv.querySelectorAll('.led'));

      // Match each LED with its module ID and output index
      leds.forEach((led, index) => {
        ledElements.push({
          modId: module.id,
          led: led,
          outputIndex: index
        });
      });
    }
    // Handle custom/composite modules
    else if (customModuleDefinitions[module.type]) {
      const leds = Array.from(moduleDiv.querySelectorAll('.led'));

      // Match each LED with its module ID and output index
      leds.forEach((led, index) => {
        ledElements.push({
          modId: module.id,
          led: led,
          outputIndex: index
        });
      });
    }
  });
}

// Create UI elements for save/load
function createSaveLoadUI() {

  // Save button
  const saveButton = document.getElementById('saveButton');
  saveButton.addEventListener('click', () => {
    savePatch();
  });

  // Load button/file input
  const loadInput = document.createElement('input');
  loadInput.type = 'file';
  loadInput.id = 'load-patch-input';
  loadInput.style.display = 'none';
  loadInput.accept = '.txt,.json';
  loadInput.addEventListener('change', (e) => {
    if (e.target.files.length > 0) {
      loadPatch(e.target.files[0]);
    }
  });

  const loadButton = document.getElementById('loadButton');
  loadButton.addEventListener('click', () => {
    loadInput.click();
  });
}

// IndexedDB setup
const DB_NAME = 'LogicSynthPatches';
const DB_VERSION = 1;
const STORE_NAME = 'userPatches';

let db = null;

// Initialize IndexedDB
async function initDB() {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, DB_VERSION);

    request.onerror = () => reject(request.error);
    request.onsuccess = () => {
      db = request.result;
      resolve(db);
    };

    request.onupgradeneeded = (event) => {
      const db = event.target.result;
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        const objectStore = db.createObjectStore(STORE_NAME, { keyPath: 'id', autoIncrement: true });
        objectStore.createIndex('name', 'name', { unique: false });
        objectStore.createIndex('timestamp', 'timestamp', { unique: false });
      }
    };
  });
}

// IndexedDB operations
async function saveToIndexedDB(name, patchData) {
  return new Promise((resolve, reject) => {
    const transaction = db.transaction([STORE_NAME], 'readwrite');
    const store = transaction.objectStore(STORE_NAME);

    const data = {
      name: name,
      patch: patchData,
      timestamp: Date.now()
    };

    const request = store.add(data);
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
}

async function updateInIndexedDB(id, name, patchData) {
  return new Promise((resolve, reject) => {
    const transaction = db.transaction([STORE_NAME], 'readwrite');
    const store = transaction.objectStore(STORE_NAME);

    const data = {
      id: id,
      name: name,
      patch: patchData,
      timestamp: Date.now()
    };

    const request = store.put(data);
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
}

async function deleteFromIndexedDB(id) {
  return new Promise((resolve, reject) => {
    const transaction = db.transaction([STORE_NAME], 'readwrite');
    const store = transaction.objectStore(STORE_NAME);

    const request = store.delete(id);
    request.onsuccess = () => resolve();
    request.onerror = () => reject(request.error);
  });
}

async function getAllFromIndexedDB() {
  return new Promise((resolve, reject) => {
    const transaction = db.transaction([STORE_NAME], 'readonly');
    const store = transaction.objectStore(STORE_NAME);

    const request = store.getAll();
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
}

async function getFromIndexedDB(id) {
  return new Promise((resolve, reject) => {
    const transaction = db.transaction([STORE_NAME], 'readonly');
    const store = transaction.objectStore(STORE_NAME);

    const request = store.get(id);
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
}

// Example patches structure (you'll need to create these JSON files)
const examplePatchesStructure = {
  "Basic": [
    { name: "Oscillator Button", file: "examples/basic/oscillator-button.json" },
    { name: "Toggle Button", file: "examples/basic/toggle-button.json" },
    { name: "Subharmonics", file: "examples/basic/subharmonics.json" },
    { name: "Harmonics", file: "examples/basic/harmonics.json" },
    { name: "Ring Modulation", file: "examples/basic/ring-mod.json" },
    { name: "Randomization", file: "examples/basic/randomization.json" },
    { name: "Random Bit Looper", file: "examples/basic/random-bit-looper.json" }
  ],
  "Grooves": [
    { name: "Noise Machine", file: "examples/grooves/noise-machine.json" },
    { name: "Polyrhythmic Matrix", file: "examples/grooves/poly-matrix.json" },
    { name: "Generative Drums", file: "examples/grooves/generative-drums.json" },
    { name: "In Three", file: "examples/grooves/in-three.json" },
    { name: "Noise Division", file: "examples/grooves/noise-division.json" },
  ],
  "Performance Mode": [
    { name: "Binary Keyboard", file: "examples/instruments/binary-keyboard.json" },
    { name: "Oscillator Noise", file: "examples/instruments/osc-noise.json" },
  ],
  "Complex": [
    { name: "Broken Nintendo", file: "examples/complex/broken-nintendo.json" },
    { name: "Minimal Melody", file: "examples/complex/minimal-melody.json" },
    { name: "Large Patch", file: "examples/complex/large-patch.json" }
  ],
  "7 Segment Display": [
    { name: "Basic with Hex", file: "examples/7-segment-display/basic-hex.json" },
    { name: "Count to 100", file: "examples/7-segment-display/count-to-100.json" },
    { name: "Count to 999", file: "examples/7-segment-display/count-to-999.json" },
    { name: "Decoder Rhythms", file: "examples/7-segment-display/BCD-7-Seg.json" }
  ],
  "Logic": [
    { name: "Binary Counter", file: "examples/logic/binary-counter.json" },
    { name: "Shift Register", file: "examples/logic/shift-register.json" },
    { name: "Cascading Ring Counters", file: "examples/logic/cascade-ring-counters.json" },
    { name: "Discrete Oscillator", file: "examples/logic/discrete-oscillator.json" },
    { name: "Adder", file: "examples/logic/adder.json" }
  ],
};

// State
let selectedPatch = null;
let selectedPatchType = null; // 'example' or 'user'
let selectedPatchData = null;

// Touch tracking for save-load menu (separate from main canvas)
let saveMenuTouchMoved = false;
let saveMenuTouchStartX = 0;
let saveMenuTouchStartY = 0;
const SAVE_MENU_TOUCH_MOVE_THRESHOLD = 10; // pixels

// UI Elements
let saveLoadOverlay, saveLoadMenuButton, closeSaveLoadMenu;
let loadPatchBtn, savePatchBtn, overwritePatchBtn, renamePatchBtn, deletePatchBtn;
let exportPatchBtn, exportAllBtn, importPatchBtn;
let selectedPatchName, selectedPatchTypeElement;
let confirmDialog, inputDialog;

// Initialize the save/load menu
async function initSaveLoadMenu() {
  await initDB();

  // Get UI elements
  saveLoadOverlay = document.getElementById('saveLoadOverlay');
  saveLoadMenuButton = document.getElementById('saveLoadMenuButton');
  closeSaveLoadMenu = document.getElementById('closeSaveLoadMenu');

  loadPatchBtn = document.getElementById('loadPatchBtn');
  savePatchBtn = document.getElementById('savePatchBtn');
  overwritePatchBtn = document.getElementById('overwritePatchBtn');
  renamePatchBtn = document.getElementById('renamePatchBtn');
  deletePatchBtn = document.getElementById('deletePatchBtn');
  exportPatchBtn = document.getElementById('exportPatchBtn');
  exportAllBtn = document.getElementById('exportAllBtn');
  importPatchBtn = document.getElementById('importPatchBtn');

  selectedPatchName = document.getElementById('selectedPatchName');
  selectedPatchTypeElement = document.getElementById('selectedPatchType');

  confirmDialog = document.getElementById('confirmDialog');
  inputDialog = document.getElementById('inputDialog');

  // Event listeners
  saveLoadMenuButton.addEventListener('click', openSaveLoadMenu);
  closeSaveLoadMenu.addEventListener('click', closeSaveLoadMenuHandler);

  loadPatchBtn.addEventListener('click', loadSelectedPatch);
  savePatchBtn.addEventListener('click', saveNewPatch);
  overwritePatchBtn.addEventListener('click', overwriteSelectedPatch);
  renamePatchBtn.addEventListener('click', renameSelectedPatch);
  deletePatchBtn.addEventListener('click', deleteSelectedPatch);
  exportPatchBtn.addEventListener('click', exportSelectedPatch);
  exportAllBtn.addEventListener('click', exportAllPatches);
  importPatchBtn.addEventListener('click', importPatchFromFile);

  // Tree header toggles
  document.querySelectorAll('.tree-header').forEach(header => {
    header.addEventListener('click', () => {
      const section = header.dataset.section;
      const children = document.querySelector(`.tree-children[data-parent="${section}"]`);
      header.classList.toggle('expanded');
      children.classList.toggle('expanded');
      // Update scroll indicators after expansion/collapse
      setTimeout(updateFileTreeScrollIndicators, 100);
    });
  });

  // Close overlay when clicking outside
  saveLoadOverlay.addEventListener('click', (e) => {
    if (e.target === saveLoadOverlay) {
      closeSaveLoadMenuHandler();
    }
  });

  // Setup touch tracking for save-load menu
  setupSaveMenuTouchTracking();

  // Build tree
  await buildFileTree();
}

// Setup touch tracking specifically for save-load menu
function setupSaveMenuTouchTracking() {
  const saveLoadContainer = document.querySelector('.save-load-container');
  if (!saveLoadContainer) return;

  saveLoadContainer.addEventListener('touchstart', (e) => {
    if (e.touches.length === 1) {
      saveMenuTouchMoved = false;
      const touch = e.touches[0];
      saveMenuTouchStartX = touch.clientX;
      saveMenuTouchStartY = touch.clientY;
    }
  }, { passive: true });

  saveLoadContainer.addEventListener('touchmove', (e) => {
    if (e.touches.length === 1) {
      const touch = e.touches[0];
      const deltaX = Math.abs(touch.clientX - saveMenuTouchStartX);
      const deltaY = Math.abs(touch.clientY - saveMenuTouchStartY);

      if (deltaX > SAVE_MENU_TOUCH_MOVE_THRESHOLD || deltaY > SAVE_MENU_TOUCH_MOVE_THRESHOLD) {
        saveMenuTouchMoved = true;
      }
    }
  }, { passive: true });

  saveLoadContainer.addEventListener('touchend', () => {
    // Reset after a short delay to allow click handlers to process
    setTimeout(() => {
      saveMenuTouchMoved = false;
    }, 100);
  }, { passive: true });
}

// Cache all elements you want to toggle
const elementsToToggle = [
  '#mobile-edit-bar',
  '.mobile-fab-container',
  '#mobile-audio-fab',
  '#mobile-module-menu',
  '#mobile-performance-fab',
  '#mobile-utility-menu'
].map(selector => document.querySelector(selector)).filter(Boolean);

// Store their original display values
const originalDisplays = new Map();
async function openSaveLoadMenu() {
  const saveLoadOverlay = document.getElementById('saveLoadOverlay');
  saveLoadOverlay.classList.add('open');

  // Set the flag to block canvas operations
  saveMenuOpen = true;

  // Hide each element, storing its original display type
  elementsToToggle.forEach(el => {
    if (!originalDisplays.has(el)) {
      originalDisplays.set(el, getComputedStyle(el).display);
    }
    el.style.display = 'none';
  });

  await buildFileTree();
  // Don't clear selection - preserve it if it exists

  // Update scroll indicators when menu opens
  setTimeout(updateFileTreeScrollIndicators, 100);
}

// Update your closeSaveLoadMenuHandler function in document 2:
function closeSaveLoadMenuHandler() {
  const saveLoadOverlay = document.getElementById('saveLoadOverlay');
  saveLoadOverlay.classList.remove('open');

  // Reset the flag to allow canvas operations
  saveMenuOpen = false;

  // Restore original display value
  elementsToToggle.forEach(el => {
    const originalDisplay = originalDisplays.get(el) || 'block';
    el.style.display = originalDisplay;
  });
}

function clearMenuSelection() {
  selectedPatch = null;
  selectedPatchType = null;
  selectedPatchData = null;
  selectedPatchName.textContent = 'no patch selected';
  selectedPatchTypeElement.textContent = '';

  document.querySelectorAll('.tree-item').forEach(item => {
    item.classList.remove('selected');
  });

  updateActionButtons();
}

function updateActionButtons() {
  const hasSelection = selectedPatch !== null;
  const isUserPatch = selectedPatchType === 'user';

  loadPatchBtn.disabled = !hasSelection;
  overwritePatchBtn.disabled = !isUserPatch;
  renamePatchBtn.disabled = !isUserPatch;
  deletePatchBtn.disabled = !isUserPatch;
  exportPatchBtn.disabled = !hasSelection;
}

async function buildFileTree() {
  // SVG icons as strings
  const chevronRightSVG = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><path fill="currentColor" d="M8.59 16.58L13.17 12L8.59 7.41L10 6l6 6l-6 6z"/></svg>`;
  const folderSVG = `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"><path fill="currentColor" d="M10 4H4c-1.11 0-2 .89-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-8z"/></svg>`;
  const folderOutlineSVG = `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"><path fill="currentColor" d="M20 6h-8l-2-2H4c-1.11 0-2 .89-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2m0 12H4V6h5.17l2 2H20z"/></svg>`;
  const fileMusicSVG = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><path fill="currentColor" d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8zm-1 2l5 5h-5zM9 19a3 3 0 1 1 3-3a3 3 0 0 1-3 3zm8-9h-6v2h6z"/></svg>`;

  // Build examples tree
  const examplesContainer = document.querySelector('.tree-children[data-parent="examples"]');
  examplesContainer.innerHTML = '';

  for (const [category, patches] of Object.entries(examplePatchesStructure)) {
    const categoryDiv = document.createElement('div');
    categoryDiv.className = 'tree-subsection';

    const categoryHeader = document.createElement('div');
    categoryHeader.className = 'tree-header tree-subheader';
    categoryHeader.innerHTML = `
      <span class="tree-icon">${chevronRightSVG}</span>
      <span class="folder-icon">${folderOutlineSVG}</span>
      <span class="tree-label">${category}</span>
    `;

    const categoryChildren = document.createElement('div');
    categoryChildren.className = 'tree-children';

    patches.forEach(patch => {
      const item = document.createElement('div');
      item.className = 'tree-item example';
      item.innerHTML = `
        <span>${fileMusicSVG}</span>
        <span>${patch.name}</span>
      `;
      item.addEventListener('click', () => selectPatch(patch, 'example', item));

      // Restore selection if this was the selected patch
      if (selectedPatch && selectedPatchType === 'example' && selectedPatch.name === patch.name) {
        item.classList.add('selected');
      }

      categoryChildren.appendChild(item);
    });

    categoryHeader.addEventListener('click', () => {
      categoryHeader.classList.toggle('expanded');
      categoryChildren.classList.toggle('expanded');
      // Update scroll indicators after expansion/collapse
      setTimeout(updateFileTreeScrollIndicators, 100);
    });

    categoryDiv.appendChild(categoryHeader);
    categoryDiv.appendChild(categoryChildren);
    examplesContainer.appendChild(categoryDiv);
  }

  // Build user patches tree
  const userPatches = await getAllFromIndexedDB();
  const userPatchesContainer = document.querySelector('.tree-children[data-parent="mypatches"]');
  userPatchesContainer.innerHTML = '';

  if (userPatches.length === 0) {
    const emptyMsg = document.createElement('div');
    emptyMsg.className = 'tree-item empty';
    emptyMsg.style.color = 'var(--text-muted)';
    emptyMsg.style.fontStyle = 'italic';
    emptyMsg.textContent = 'No saved patches';
    userPatchesContainer.appendChild(emptyMsg);
  } else {
    userPatches.forEach(patch => {
      const item = document.createElement('div');
      item.className = 'tree-item user';
      item.innerHTML = `
        <span>${fileMusicSVG}</span>
        <span>${patch.name}</span>
      `;
      item.addEventListener('click', () => selectPatch(patch, 'user', item));

      // Restore selection if this was the selected patch
      if (selectedPatch && selectedPatchType === 'user' && selectedPatch.id === patch.id) {
        item.classList.add('selected');
      }

      userPatchesContainer.appendChild(item);
    });
  }

  // Update scroll indicators after tree is built
  setTimeout(updateFileTreeScrollIndicators, 100);
}

function selectPatch(patch, type, element) {
  // Prevent selection if this was a scroll gesture (use local tracking)
  if (saveMenuTouchMoved) {
    return;
  }

  // Remove previous selection
  document.querySelectorAll('.tree-item').forEach(item => {
    item.classList.remove('selected');
  });

  // Set new selection
  element.classList.add('selected');
  selectedPatch = patch;
  selectedPatchType = type;

  selectedPatchName.textContent = patch.name;
  selectedPatchTypeElement.textContent = type === 'example' ? 'Example Patch:' : 'User Patch:';

  updateActionButtons();

  // Force a repaint to ensure selection is visible
  element.offsetHeight; // Trigger reflow
}

async function loadSelectedPatch() {
  if (!selectedPatch) return;

  let patchData;

  if (selectedPatchType === 'example') {
    // Load from server
    try {
      const response = await fetch(selectedPatch.file);
      patchData = await response.json();
    } catch (error) {
      console.error('Error loading example patch:', error);
      showAlert('Failed to load example patch');
      return;
    }
  } else {
    // Load from IndexedDB
    const dbPatch = await getFromIndexedDB(selectedPatch.id);
    patchData = dbPatch.patch;
  }

  // Use existing loadPatch logic but with data instead of file
  loadPatchFromData(patchData);
  closeSaveLoadMenuHandler();
}

async function saveNewPatch() {
  const name = await showInputDialog('Enter patch name:', '');
  if (!name) return;

  // Check for duplicate names
  const userPatches = await getAllFromIndexedDB();
  const duplicatePatch = userPatches.find(patch => patch.name === name);
  if (duplicatePatch) {
    await showAlert(`A patch named "${name}" already exists. Please choose a different name.`);
    return;
  }

  // Collect custom module definitions used in this patch
  const usedCustomModules = {};
  modules.forEach(m => {
    if (customModuleDefinitions[m.type]) {
      usedCustomModules[m.type] = customModuleDefinitions[m.type];
    }
  });

  // No need to call getModulePositions() anymore
  const patchData = {
    version: 2,
    modules: modules.map(m => ({
      id: m.id,
      type: m.type,
      gridX: m.gridX,
      gridY: m.gridY,
      freq: m.freq,
      assignedKey: m.assignedKey,
      memoryData: m.memoryData
    })),
    connections: connections,
    viewState: { ...viewState },
    performanceAssignments: {
      oscillators: Array.from(performanceSnapshot.performanceOscillators.entries()),
      buttons: Array.from(performanceSnapshot.performanceButtons.entries())
    },
    customModules: usedCustomModules // Embed custom module definitions
  };

  try {
    await saveToIndexedDB(name, patchData);
    localStorage.setItem('savedPatch', JSON.stringify(patchData));

    await buildFileTree();

    // Scroll to and flash the newly saved patch
    setTimeout(() => {
      const item = findTreeItemByName(name);
      if (item) {
        scrollToAndFlash(item);
      }
    }, 100);
  } catch (error) {
    console.error('Error saving patch:', error);
    showAlert('Failed to save patch');
  }
}

async function overwriteSelectedPatch() {
  if (!selectedPatch || selectedPatchType !== 'user') return;

  const confirmed = await showConfirmDialog(`Overwrite "${selectedPatch.name}"?`);
  if (!confirmed) return;

  const patchName = selectedPatch.name;

  // Collect custom module definitions used in this patch
  const usedCustomModules = {};
  modules.forEach(m => {
    if (customModuleDefinitions[m.type]) {
      usedCustomModules[m.type] = customModuleDefinitions[m.type];
    }
  });

  // No need to call getModulePositions() anymore
  const patchData = {
    version: 2,
    modules: modules.map(m => ({
      id: m.id,
      type: m.type,
      gridX: m.gridX,
      gridY: m.gridY,
      freq: m.freq,
      assignedKey: m.assignedKey,
      memoryData: m.memoryData
    })),
    connections: connections,
    viewState: { ...viewState },
    performanceAssignments: {
      oscillators: Array.from(performanceSnapshot.performanceOscillators.entries()),
      buttons: Array.from(performanceSnapshot.performanceButtons.entries())
    },
    customModules: usedCustomModules // Embed custom module definitions
  };

  try {
    await updateInIndexedDB(selectedPatch.id, patchName, patchData);
    localStorage.setItem('savedPatch', JSON.stringify(patchData));

    // Scroll to and flash the overwritten patch
    setTimeout(() => {
      const item = findTreeItemByName(patchName);
      if (item) {
        scrollToAndFlash(item);
      }
    }, 100);
  } catch (error) {
    console.error('Error overwriting patch:', error);
    showAlert('Failed to overwrite patch');
  }
}

async function renameSelectedPatch() {
  if (!selectedPatch || selectedPatchType !== 'user') return;

  const newName = await showInputDialog('Enter new name:', selectedPatch.name);
  if (!newName || newName === selectedPatch.name) return;

  // Check for duplicate names (excluding the current patch)
  const userPatches = await getAllFromIndexedDB();
  const duplicatePatch = userPatches.find(patch => patch.name === newName && patch.id !== selectedPatch.id);
  if (duplicatePatch) {
    await showAlert(`A patch named "${newName}" already exists. Please choose a different name.`);
    return;
  }

  try {
    const dbPatch = await getFromIndexedDB(selectedPatch.id);
    await updateInIndexedDB(selectedPatch.id, newName, dbPatch.patch);
    await buildFileTree();

    // Scroll to and flash the renamed patch
    setTimeout(() => {
      const item = findTreeItemByName(newName);
      if (item) {
        scrollToAndFlash(item);
      }
    }, 100);
  } catch (error) {
    console.error('Error renaming patch:', error);
    showAlert('Failed to rename patch');
  }
}

async function deleteSelectedPatch() {
  if (!selectedPatch || selectedPatchType !== 'user') return;

  const patchName = selectedPatch.name;
  const patchId = selectedPatch.id;

  // Step 1: Find and scroll to the item
  const item = findTreeItemByName(patchName);
  if (item) {
    // Ensure parent containers are expanded
    let current = item.parentElement;
    while (current) {
      if (current.classList.contains('tree-children')) {
        current.classList.add('expanded');
        const section = current.dataset.parent;
        if (section) {
          const header = document.querySelector(`.tree-header[data-section="${section}"]`);
          if (header) {
            header.classList.add('expanded');
          }
        }
      }
      if (current.classList.contains('tree-subsection')) {
        const subheader = current.querySelector('.tree-subheader');
        if (subheader) {
          subheader.classList.add('expanded');
          const subchildren = current.querySelector('.tree-children');
          if (subchildren) {
            subchildren.classList.add('expanded');
          }
        }
      }
      current = current.parentElement;
    }

    // Scroll to element
    setTimeout(() => {
      const fileTreeContent = document.querySelector('.file-tree-content');
      if (fileTreeContent && item) {
        item.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }, 50);
  }

  // Step 2: Show confirmation dialog (wait a bit for scroll to complete)
  await new Promise(resolve => setTimeout(resolve, 300));
  const confirmed = await showConfirmDialog(`Delete "${patchName}"?`);

  if (!confirmed) return;

  // Step 3: If confirmed, animate deletion
  if (item) {
    // Apply deleting animation class
    item.classList.add('deleting');

    // Step 4: After animation completes (0.8s), actually delete from IndexedDB
    setTimeout(async () => {
      try {
        await deleteFromIndexedDB(patchId);
        clearMenuSelection();
        await buildFileTree();
      } catch (error) {
        console.error('Error deleting patch:', error);
        showAlert('Failed to delete patch');
        // Remove animation class if deletion failed
        if (item && item.parentElement) {
          item.classList.remove('deleting');
        }
      }
    }, 200); // Match animation duration
  } else {
    // Fallback if item not found - delete immediately
    try {
      await deleteFromIndexedDB(patchId);
      clearMenuSelection();
      await buildFileTree();
    } catch (error) {
      console.error('Error deleting patch:', error);
      showAlert('Failed to delete patch');
    }
  }
}

function exportSelectedPatch() {
  if (!selectedPatch) return;

  if (selectedPatchType === 'user') {
    getFromIndexedDB(selectedPatch.id).then(dbPatch => {
      const jsonData = JSON.stringify(dbPatch.patch, null, 2);
      downloadJSON(jsonData, `${selectedPatch.name}.json`);
    });
  } else {
    // For example patches, export the currently loaded state
    const patchData = {
      version: 2,
      modules: modules.map(m => ({
        id: m.id,
        type: m.type,
        gridX: m.gridX,
        gridY: m.gridY,
        freq: m.freq,
        assignedKey: m.assignedKey,
        memoryData: m.memoryData
      })),
      connections: connections,
      viewState: { ...viewState },
      performanceAssignments: {
        oscillators: Array.from(performanceSnapshot.performanceOscillators.entries()),
        buttons: Array.from(performanceSnapshot.performanceButtons.entries())
      }
    };
    const jsonData = JSON.stringify(patchData, null, 2);
    downloadJSON(jsonData, `${selectedPatch.name}.json`);
  }
}

function downloadJSON(jsonData, filename) {
  const blob = new Blob([jsonData], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

async function exportAllPatches() {
  try {
    // Check if JSZip is available
    if (typeof JSZip === 'undefined') {
      showAlert('Failed to export patches.');
      return;
    }

    // Get all user patches from IndexedDB
    const userPatches = await getAllFromIndexedDB();

    if (userPatches.length === 0) {
      showAlert('No patches to export.');
      return;
    }

    // Create a new JSZip instance
    const zip = new JSZip();

    // Add each patch as a JSON file to the zip
    for (const patch of userPatches) {
      const jsonData = JSON.stringify(patch.patch, null, 2);
      // Sanitize filename - remove any invalid characters
      const filename = patch.name.replace(/[<>:"/\\|?*]/g, '_') + '.json';
      zip.file(filename, jsonData);
    }

    // Generate the zip file
    const zipBlob = await zip.generateAsync({ type: 'blob' });

    // Create download link
    const url = URL.createObjectURL(zipBlob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'all-patches.zip';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);

    showAlert(`Exported ${userPatches.length} patch${userPatches.length > 1 ? 'es' : ''} successfully!`);
  } catch (error) {
    console.error('Error exporting all patches:', error);
    showAlert('Failed to export patches.');
  }
}

function importPatchFromFile() {
  const input = document.createElement('input');
  input.type = 'file';
  input.accept = '.json,.txt';
  input.multiple = true; // Allow multiple file selection

  input.addEventListener('change', async (e) => {
    if (e.target.files.length === 0) return;

    const files = Array.from(e.target.files);
    let successCount = 0;
    let errorCount = 0;
    let duplicateCount = 0;
    const importedNames = []; // Track successfully imported patch names
    const duplicateNames = []; // Track duplicate patch names

    // Get all existing patches to check for duplicates
    const existingPatches = await getAllFromIndexedDB();
    const existingNames = new Set(existingPatches.map(patch => patch.name));

    // Process each file
    for (const file of files) {
      try {
        const fileContent = await readFileAsText(file);
        const patchData = JSON.parse(fileContent);

        // Extract name from filename (remove extension)
        const name = file.name.replace(/\.[^/.]+$/, '').trim();

        // Validate name
        if (!name || name.length === 0) {
          console.warn(`Skipping file "${file.name}" - invalid name`);
          errorCount++;
          continue;
        }

        // Validate patch data
        if (!patchData || typeof patchData !== 'object') {
          console.warn(`Skipping file "${file.name}" - invalid patch data`);
          errorCount++;
          continue;
        }

        // Check for duplicate names
        if (existingNames.has(name)) {
          duplicateNames.push(name);
          duplicateCount++;
          continue;
        }

        await saveToIndexedDB(name, patchData);
        importedNames.push(name);
        existingNames.add(name); // Add to set so duplicates within the same import batch are caught
        successCount++;
      } catch (error) {
        console.error(`Error importing patch "${file.name}":`, error);
        errorCount++;
      }
    }

    // Show result message and flash imported patches
    if (successCount > 0) {
      await buildFileTree();

      // Scroll to and flash all imported patches
      setTimeout(() => {
        const items = findTreeItemsByNames(importedNames);
        if (items.length > 0) {
          scrollToAndFlashMultiple(items);
        }
      }, 100);
    }

    // Show appropriate alerts
    if (duplicateCount > 0) {
      const duplicateList = duplicateNames.join(', ');
      showAlert(`Could not import ${duplicateCount} patch${duplicateCount > 1 ? 'es' : ''} (name${duplicateCount > 1 ? 's' : ''} already exist${duplicateCount > 1 ? '' : 's'}: ${duplicateList})${successCount > 0 ? `. ${successCount} patch${successCount > 1 ? 'es' : ''} imported successfully.` : ''}${errorCount > 0 ? ` ${errorCount} error${errorCount > 1 ? 's' : ''} occurred.` : ''}`);
    } else if (successCount > 0 && errorCount > 0) {
      showAlert(`Imported ${successCount} patch${successCount > 1 ? 'es' : ''}, ${errorCount} failed.`);
    } else if (successCount === 0 && errorCount === 0 && duplicateCount === 0) {
      // This shouldn't happen, but handle edge case
      showAlert(`No patches were imported.`);
    } else if (successCount === 0) {
      if (errorCount > 0) {
        showAlert(`Failed to import patches. ${errorCount} error${errorCount > 1 ? 's' : ''}.`);
      }
    }
  });

  input.click();
}

// Helper function to read file as text (returns Promise)
function readFileAsText(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (event) => resolve(event.target.result);
    reader.onerror = (error) => reject(error);
    reader.readAsText(file);
  });
}

// Helper function to load patch from data object
function loadPatchFromData(patchData) {
  undoStack = [];
  redoStack = [];

  try {
    // Convert legacy format if needed
    patchData = convertLegacyPatch(patchData);

    // Import custom modules from patch data if present
    if (patchData.customModules) {
      Object.entries(patchData.customModules).forEach(([name, definition]) => {
        // Only import if not already defined locally
        if (!customModuleDefinitions[name]) {
          customModuleDefinitions[name] = definition;
          // Save to DB asynchronously
          saveCustomModuleToDB(definition).catch(e => {
            console.error(`Failed to save imported custom module ${name}:`, e);
          });
        }
      });
      // Update the custom module menu to show imported modules
      if (typeof updateCustomModuleMenu === 'function') {
        updateCustomModuleMenu();
      }
    }

    // Clear existing modules and connections
    const container = document.getElementById('moduleContainer');
    if (container) {
      container.innerHTML = '';
    }
    modules = [];
    connections = [];
    ledElements = [];

    let maxId = -1;

    // Restore view state
    if (patchData.viewState) {
      viewState = { ...patchData.viewState };
      updateViewTransform();
      updateZoomText();
    } else {
      viewState = {
        offsetX: 0,
        offsetY: 0,
        scale: 1.0,
        gridSize: 20
      };
    }

    const STANDARD_MODULE_TYPES = new Set([
      'Oscillator', 'AND', 'OR', 'NAND', 'NOR', 'XOR', 'XNOR', 'NOT',
      'Noise', 'Flip-Flop', 'Binary Counter', 'Ring Counter', 'Shift Register',
      'Multiplexer', 'Demultiplexer', 'Shift Register (PISO)', 'Binary Rate Multiplier',
      'Output', 'Button', 'Harmonic Oscillator', 'Oscilloscope', 'EEPROM',
      'BCD to 7-Segment', '7-Segment Display', 'Inlet', 'Outlet'
    ]);

    // Track missing custom modules
    const missingCustomModules = new Set();
    const modulesToCreate = [];

    // Create modules (filtering out missing custom ones)
    patchData.modules.forEach(module => {
      // Check if it's a standard module OR a known custom module
      if (STANDARD_MODULE_TYPES.has(module.type) || customModuleDefinitions[module.type]) {

        const div = document.createElement('div');
        div.className = 'module';
        div.style.position = 'absolute';
        div.dataset.id = module.id;
        div.dataset.type = module.type;

        const newModule = {
          id: module.id,
          type: module.type,
          gridX: module.gridX,
          gridY: module.gridY,
          freq: module.freq,
          assignedKey: module.assignedKey,
          memoryData: module.memoryData
        };

        // Attach definition for custom modules so audio worklet can process them
        if (module.definition) {
          newModule.definition = module.definition;
        } else if (customModuleDefinitions[module.type]) {
          newModule.definition = customModuleDefinitions[module.type];
        }

        modules.push(newModule);
        modulesToCreate.push({ div, type: module.type, freq: module.freq, moduleData: module });

        if (module.id > maxId) maxId = module.id;

      } else {
        // Unknown module type
        missingCustomModules.add(module.type);
        console.warn(`Skipping missing module type: ${module.type} (ID: ${module.id})`);
      }
    });

    // Alert user if modules are missing
    if (missingCustomModules.size > 0) {
      const missingList = Array.from(missingCustomModules).join(', ');
      showAlert(`The following custom modules could not be loaded because their definitions are missing: ${missingList}`);
    }

    // Initialize UI for created modules
    modulesToCreate.forEach(item => {
      const { div, type, freq, moduleData } = item;

      if (type === 'Oscillator') {
        setupModuleUI(div, type, freq);
      } else {
        setupModuleUI(div, type);
      }

      if (type === 'Button' && moduleData.assignedKey) {
        updateButtonKeyMapping(div, moduleData.assignedKey);
      }

      if (type === 'EEPROM' && moduleData.memoryData && workletNode) {
        // Small delay to ensure worklet is ready
        setTimeout(() => {
          workletNode.port.postMessage({
            type: 'programEEPROM',
            moduleId: moduleData.id,
            memoryData: moduleData.memoryData
          });
        }, 100);
      }

      // Position using grid coordinates
      const pixelPos = gridToPixels(moduleData.gridX, moduleData.gridY);
      div.style.position = 'absolute';
      div.style.left = `${pixelPos.x}px`;
      div.style.top = `${pixelPos.y}px`;
      div.style.transform = 'none'; // No per-module transform

      // Append to container
      container.appendChild(div);
    });

    moduleId = maxId + 1;

    // Check if output module exists
    outModuleCreated = modules.some(m => m.type.toLowerCase() === 'output');
    const button = document.getElementById('createOutputModuleButton');
    if (button) {
      if (outModuleCreated) {
        button.classList.add('fake-disabled');
      } else {
        button.classList.remove('fake-disabled');
      }
    }

    // Check if output module exists
    scopeModuleCreated = modules.some(m => m.type.toLowerCase() === 'oscilloscope');
    const scopeButton = document.getElementById('createOscilloscopeButton');
    if (scopeButton) {
      if (scopeModuleCreated) {
        scopeButton.classList.add('fake-disabled');
      } else {
        scopeButton.classList.remove('fake-disabled');
      }
    }

    // Restore connections
    connections = patchData.connections || [];

    // Restore performance assignments
    if (patchData.performanceAssignments) {
      performanceSnapshot.performanceOscillators.clear();
      performanceSnapshot.performanceButtons.clear();
      usedOscillatorSlots.clear();
      usedButtonSlots.clear();

      // Restore oscillator assignments
      if (patchData.performanceAssignments.oscillators) {
        patchData.performanceAssignments.oscillators.forEach(([moduleId, slot]) => {
          performanceSnapshot.performanceOscillators.set(moduleId, slot);
          usedOscillatorSlots.add(slot);
        });
      }

      // Restore button assignments
      if (patchData.performanceAssignments.buttons) {
        patchData.performanceAssignments.buttons.forEach(([moduleId, slot]) => {
          performanceSnapshot.performanceButtons.set(moduleId, slot);
          usedButtonSlots.add(slot);
        });
      }

      // Rebuild slot tracking to update next available slots
      rebuildSlotTracking();
      updatePerformanceIndicators();
    }

    rebuildLedElements();

    if (audioStarted) {
      rebuildAudioGraph();
    }

    drawWires();

  } catch (error) {
    console.error("Error loading patch:", error);
    showAlert("Error loading patch file.");
  }

  // Save to localStorage
  localStorage.setItem('savedPatch', JSON.stringify(patchData));

  syncMobileOutputButton();
  centerPatchToOrigin();
  fitToView();
  closeAllEEPROMProgrammers();
  selectedOutput = null;
}

// Helper function to find a tree item by patch name
function findTreeItemByName(patchName) {
  const allItems = document.querySelectorAll('.tree-item');
  for (const item of allItems) {
    // Get the text content, which should be the patch name (second span)
    const spans = item.querySelectorAll('span');
    if (spans.length >= 2) {
      const nameSpan = spans[1];
      if (nameSpan.textContent.trim() === patchName) {
        return item;
      }
    }
  }
  return null;
}

// Helper function to find tree items by patch names (for multiple)
function findTreeItemsByNames(patchNames) {
  const foundItems = [];
  const allItems = document.querySelectorAll('.tree-item');
  for (const item of allItems) {
    const spans = item.querySelectorAll('span');
    if (spans.length >= 2) {
      const nameSpan = spans[1];
      const name = nameSpan.textContent.trim();
      if (patchNames.includes(name)) {
        foundItems.push(item);
      }
    }
  }
  return foundItems;
}

// Helper function to scroll to element and flash it
function scrollToAndFlash(element) {
  if (!element) return;

  // Ensure parent containers are expanded
  let current = element.parentElement;
  while (current) {
    if (current.classList.contains('tree-children')) {
      current.classList.add('expanded');
      // Find the corresponding header and expand it
      const section = current.dataset.parent;
      if (section) {
        const header = document.querySelector(`.tree-header[data-section="${section}"]`);
        if (header) {
          header.classList.add('expanded');
        }
      }
    }
    // Also check for tree-subsection parents
    if (current.classList.contains('tree-subsection')) {
      const subheader = current.querySelector('.tree-subheader');
      if (subheader) {
        subheader.classList.add('expanded');
        const subchildren = current.querySelector('.tree-children');
        if (subchildren) {
          subchildren.classList.add('expanded');
        }
      }
    }
    current = current.parentElement;
  }

  // Wait a bit for expansion to complete, then scroll
  setTimeout(() => {
    const fileTreeContent = document.querySelector('.file-tree-content');
    if (fileTreeContent && element) {
      // Scroll to element
      element.scrollIntoView({ behavior: 'smooth', block: 'center' });

      // Small delay before flashing to ensure scroll has started
      setTimeout(() => {
        // Add flash class
        element.classList.add('highlight-flash');

        // Remove flash class after animation completes
        setTimeout(() => {
          element.classList.remove('highlight-flash');
        }, 800);
      }, 100);
    }
  }, 50);
}

// Helper function to flash multiple elements
function scrollToAndFlashMultiple(elements) {
  if (!elements || elements.length === 0) return;

  // Ensure all parent containers are expanded
  elements.forEach(element => {
    let current = element.parentElement;
    while (current) {
      if (current.classList.contains('tree-children')) {
        current.classList.add('expanded');
        const section = current.dataset.parent;
        if (section) {
          const header = document.querySelector(`.tree-header[data-section="${section}"]`);
          if (header) {
            header.classList.add('expanded');
          }
        }
      }
      if (current.classList.contains('tree-subsection')) {
        const subheader = current.querySelector('.tree-subheader');
        if (subheader) {
          subheader.classList.add('expanded');
          const subchildren = current.querySelector('.tree-children');
          if (subchildren) {
            subchildren.classList.add('expanded');
          }
        }
      }
      current = current.parentElement;
    }
  });

  setTimeout(() => {
    const fileTreeContent = document.querySelector('.file-tree-content');
    if (fileTreeContent && elements.length > 0) {
      // Scroll to first element
      elements[0].scrollIntoView({ behavior: 'smooth', block: 'center' });

      setTimeout(() => {
        // Flash all elements
        elements.forEach((element, index) => {
          setTimeout(() => {
            element.classList.add('highlight-flash');
            setTimeout(() => {
              element.classList.remove('highlight-flash');
            }, 800);
          }, index * 100); // Stagger the flashes slightly
        });
      }, 100);
    }
  }, 50);
}

// Confirmation dialog helper
function showConfirmDialog(message) {
  return new Promise((resolve) => {
    const confirmMessage = document.getElementById('confirmMessage');
    const confirmYes = document.getElementById('confirmYes');
    const confirmNo = document.getElementById('confirmNo');

    confirmMessage.textContent = message;
    confirmDialog.classList.add('open');

    const handleYes = () => {
      confirmDialog.classList.remove('open');
      confirmYes.removeEventListener('click', handleYes);
      confirmNo.removeEventListener('click', handleNo);
      resolve(true);
    };

    const handleNo = () => {
      confirmDialog.classList.remove('open');
      confirmYes.removeEventListener('click', handleYes);
      confirmNo.removeEventListener('click', handleNo);
      resolve(false);
    };

    confirmYes.addEventListener('click', handleYes);
    confirmNo.addEventListener('click', handleNo);
  });
}

// Alert dialog helper - now only used for errors
function showAlert(message) {
  return new Promise((resolve) => {
    const alertMessage = document.getElementById('alertMessage');
    const alertYes = document.getElementById('alert-ok');

    alertMessage.textContent = message;
    alertDialog.classList.add('open');

    const handleYes = () => {
      alertDialog.classList.remove('open');
      alertYes.removeEventListener('click', handleYes);
      resolve(true);
    };

    alertYes.addEventListener('click', handleYes);
  });
}


// Input dialog helper
function showInputDialog(message, defaultValue = '') {
  return new Promise((resolve) => {
    const inputMessage = document.getElementById('inputMessage');
    const inputField = document.getElementById('inputField');
    const inputOk = document.getElementById('inputOk');
    const inputCancel = document.getElementById('inputCancel');

    inputMessage.textContent = message;
    inputField.value = defaultValue;
    inputDialog.classList.add('open');

    // Focus and select the input
    setTimeout(() => {
      inputField.focus();
      inputField.select();
    }, 100);

    const handleOk = () => {
      const value = inputField.value.trim();
      inputDialog.classList.remove('open');
      inputOk.removeEventListener('click', handleOk);
      inputCancel.removeEventListener('click', handleCancel);
      inputField.removeEventListener('keydown', handleKeydown);
      resolve(value || null);
    };

    const handleCancel = () => {
      inputDialog.classList.remove('open');
      inputOk.removeEventListener('click', handleOk);
      inputCancel.removeEventListener('click', handleCancel);
      inputField.removeEventListener('keydown', handleKeydown);
      resolve(null);
    };

    const handleKeydown = (e) => {
      if (e.key === 'Enter') {
        handleOk();
      } else if (e.key === 'Escape') {
        handleCancel();
      }
    };

    inputOk.addEventListener('click', handleOk);
    inputCancel.addEventListener('click', handleCancel);
    inputField.addEventListener('keydown', handleKeydown);
  });
}

// File tree scroll indicators
function updateFileTreeScrollIndicators() {
  const fileTreePanel = document.querySelector('.file-tree-panel');
  const fileTreeContent = document.querySelector('.file-tree-content');
  if (!fileTreePanel || !fileTreeContent) return;

  const scrollTop = fileTreeContent.scrollTop;
  const scrollHeight = fileTreeContent.scrollHeight;
  const clientHeight = fileTreeContent.clientHeight;
  const scrollBottom = scrollHeight - scrollTop - clientHeight;

  // Show top indicator if scrolled down (not at top)
  if (scrollTop > 20) {
    fileTreePanel.classList.add('scrolled-top');
  } else {
    fileTreePanel.classList.remove('scrolled-top');
  }

  // Show bottom indicator if there's more content below
  if (scrollBottom > 20) {
    fileTreePanel.classList.add('scrolled-bottom');
  } else {
    fileTreePanel.classList.remove('scrolled-bottom');
  }
}

// Initialize when page loads
window.addEventListener('load', () => {
  initSaveLoadMenu();

  // Set up file tree scroll indicators
  const fileTreePanel = document.querySelector('.file-tree-panel');
  const fileTreeContent = document.querySelector('.file-tree-content');
  if (fileTreePanel && fileTreeContent) {
    // Listen to scroll events on the content element
    fileTreeContent.addEventListener('scroll', updateFileTreeScrollIndicators);

    // Check initially
    updateFileTreeScrollIndicators();

    // Also check when content changes (e.g., after building tree)
    const fileTreeObserver = new MutationObserver(() => {
      // Small delay to ensure layout is complete
      setTimeout(updateFileTreeScrollIndicators, 100);
    });

    fileTreeObserver.observe(fileTreeContent, {
      childList: true,
      subtree: true
    });
  }
});

// undoRedo.js
function updateUndoRedoButtons() {
  const undoButton = document.getElementById('undoButton');
  const redoButton = document.getElementById('redoButton');

  if (!undoButton || !redoButton) return;

  if (undoStack.length === 0) {
    undoButton.classList.add('undoDisabled');
  } else {
    undoButton.classList.remove('undoDisabled');
  }

  if (redoStack.length === 0) {
    redoButton.classList.add('undoDisabled');
  } else {
    redoButton.classList.remove('undoDisabled');
  }
}

function undo() {
  if (undoStack.length === 0) return;

  const action = undoStack.pop();
  redoStack.push(action);

  switch (action.type) {
    case 'changeButtonKey': {
      const moduleElement = document.querySelector(`[data-id='${action.moduleId}']`);
      if (moduleElement) {
        updateButtonKeyMapping(moduleElement, action.oldKey);

        const mod = modules.find(m => m.id == action.moduleId);
        if (mod) {
          mod.assignedKey = action.oldKey;
        }
      }
      break;
    }

    case 'assignPerformance': {
      // Undo an assignment by removing it
      if (action.moduleType === 'Oscillator') {
        performanceSnapshot.performanceOscillators.delete(action.moduleId);
        usedOscillatorSlots.delete(action.slot);
      } else if (action.moduleType === 'Button') {
        performanceSnapshot.performanceButtons.delete(action.moduleId);
        usedButtonSlots.delete(action.slot);
      }
      rebuildSlotTracking();
      updatePerformanceIndicators();
      break;
    }

    case 'unassignPerformance': {
      // Undo an unassignment by reassigning it
      if (action.moduleType === 'Oscillator') {
        performanceSnapshot.performanceOscillators.set(action.moduleId, action.slot);
        usedOscillatorSlots.add(action.slot);
      } else if (action.moduleType === 'Button') {
        performanceSnapshot.performanceButtons.set(action.moduleId, action.slot);
        usedButtonSlots.add(action.slot);
      }
      rebuildSlotTracking();
      updatePerformanceIndicators();
      break;
    }

    case 'changeFrequency': {
      const moduleElement = document.querySelector(`[data-id='${action.moduleId}']`);
      if (moduleElement) {
        const mod = modules.find(m => m.id == action.moduleId);
        if (mod) {
          mod.freq = action.oldFrequency;

          const freqLabel = moduleElement.querySelector('.freq-label');
          const freqTextInput = moduleElement.querySelector('.freq-text-input');
          const freqSlider = moduleElement.querySelector('.freq-slider');

          if (freqLabel) freqLabel.innerText = `${action.oldFrequency.toFixed(2)} Hz`;
          if (freqTextInput) freqTextInput.value = action.oldFrequency.toFixed(2);

          if (freqSlider) {
            const normalized = Math.log(action.oldFrequency / 10) / Math.log(300);
            freqSlider.value = Math.round(normalized * 1500);
          }

          if (workletNode) {
            workletNode.port.postMessage({
              type: 'frequencyChange',
              moduleId: parseInt(action.moduleId),
              frequency: action.oldFrequency
            });
          }
        }
      }
      break;
    }

    case 'changeCompositeFrequency': {
      const moduleElement = document.querySelector(`[data-id='${action.moduleId}']`);
      if (moduleElement) {
        const mod = modules.find(m => m.id == action.moduleId);
        if (mod && mod.controls) {
          const ctrl = mod.controls.find(c => c.id === action.controlId);
          if (ctrl) {
            ctrl.freq = action.oldFrequency;

            const controlContainer = moduleElement.querySelector(`[data-control-id='${action.controlId}']`);
            if (controlContainer) {
              const freqLabel = controlContainer.querySelector('.freq-label');
              const freqTextInput = controlContainer.querySelector('.freq-text-input');
              const freqSlider = controlContainer.querySelector('.freq-slider');

              if (freqLabel) freqLabel.innerText = `${ctrl.freq.toFixed(2)} Hz`;
              if (freqTextInput) freqTextInput.value = ctrl.freq.toFixed(2);
              if (freqSlider) {
                const normalized = Math.log(ctrl.freq / 10) / Math.log(300);
                freqSlider.value = Math.round(normalized * 1500);
              }
            }

            if (workletNode) {
              workletNode.port.postMessage({
                type: 'compositeControlChange',
                moduleId: parseInt(action.moduleId),
                controlId: action.controlId,
                frequency: ctrl.freq
              });
            }
          }
        }
      }
      break;
    }

    case 'createModule':
      deleteModuleWithoutRecord(action.moduleData.id);
      break;

    case 'deleteModule': {
      restoreModule(action.moduleData, action.connections);
      break;
    }

    case 'deleteModules': {
      action.modules.forEach(moduleInfo => {
        restoreModule(moduleInfo.moduleData, []);
      });

      action.connections.forEach(conn => {
        connections.push(conn);
      });
      break;
    }

    case 'moveModule': {
      const module = modules.find(m => m.id === action.moduleId);
      const moduleElement = document.querySelector(`[data-id='${action.moduleId}']`);

      if (module && moduleElement) {
        // Restore grid coordinates
        module.gridX = action.fromGridX;
        module.gridY = action.fromGridY;

        // Update DOM position
        const pixelPos = gridToPixels(module.gridX, module.gridY);
        moduleElement.style.left = `${pixelPos.x}px`;
        moduleElement.style.top = `${pixelPos.y}px`;
      }
      break;
    }

    case 'moveModules': {
      action.movements.forEach(movement => {
        const module = modules.find(m => m.id === movement.moduleId);
        const moduleElement = document.querySelector(`[data-id='${movement.moduleId}']`);

        if (module && moduleElement) {
          // Restore grid coordinates
          module.gridX = movement.fromGridX;
          module.gridY = movement.fromGridY;

          // Update DOM position
          const pixelPos = gridToPixels(module.gridX, module.gridY);
          moduleElement.style.left = `${pixelPos.x}px`;
          moduleElement.style.top = `${pixelPos.y}px`;
        }
      });
      break;
    }

    case 'addConnection':
      removeConnectionWithoutRecord(action.connection);
      break;

    case 'removeConnection':
      connections.push(action.connection);
      break;

    case 'removeConnections': {
      // Restore all deleted connections
      action.connections.forEach(conn => {
        connections.push(conn);
      });
      break;
    }

    case 'addConnections': {
      // Remove multiple connections (inverse of removeConnections)
      action.connections.forEach(conn => {
        removeConnectionWithoutRecord(conn);
      });
      break;
    }

    case 'pasteModules': {
      action.pastedModuleIds.forEach(id => {
        deleteModuleWithoutRecord(id);
      });
      break;
    }

    case 'deleteItems': {
      // Restore modules
      action.modules.forEach(moduleInfo => {
        restoreModule(moduleInfo.moduleData, []);
      });

      // Restore connections
      action.connections.forEach(conn => {
        connections.push(conn);
      });
      break;
    }

  }

  if (audioStarted) {
    rebuildAudioGraph();
  }

  drawWires();
  updateUndoRedoButtons();
  updateOscillatorCheckboxes();
  updateButtonCheckboxes();
  updateModulePreview();
}


function redo() {
  if (redoStack.length === 0) return;

  const action = redoStack.pop();
  undoStack.push(action);

  switch (action.type) {
    case 'changeButtonKey': {
      const moduleElement = document.querySelector(`[data-id='${action.moduleId}']`);
      if (moduleElement) {
        updateButtonKeyMapping(moduleElement, action.newKey);

        const mod = modules.find(m => m.id == action.moduleId);
        if (mod) {
          mod.assignedKey = action.newKey;
        }
      }
      break;
    }

    case 'changeFrequency': {
      const moduleElement = document.querySelector(`[data-id='${action.moduleId}']`);
      if (moduleElement) {
        const mod = modules.find(m => m.id == action.moduleId);
        if (mod) {
          mod.freq = action.newFrequency;

          const freqLabel = moduleElement.querySelector('.freq-label');
          const freqTextInput = moduleElement.querySelector('.freq-text-input');
          const freqSlider = moduleElement.querySelector('.freq-slider');

          if (freqLabel) freqLabel.innerText = `${action.newFrequency.toFixed(2)} Hz`;
          if (freqTextInput) freqTextInput.value = action.newFrequency.toFixed(2);

          if (freqSlider) {
            const normalized = Math.log(action.newFrequency / 10) / Math.log(300);
            freqSlider.value = Math.round(normalized * 1500);
          }

          if (workletNode) {
            workletNode.port.postMessage({
              type: 'frequencyChange',
              moduleId: parseInt(action.moduleId),
              frequency: action.newFrequency
            });
          }
        }
      }
      break;
    }

    case 'changeCompositeFrequency': {
      const moduleElement = document.querySelector(`[data-id='${action.moduleId}']`);
      if (moduleElement) {
        const mod = modules.find(m => m.id == action.moduleId);
        if (mod && mod.controls) {
          const ctrl = mod.controls.find(c => c.id === action.controlId);
          if (ctrl) {
            ctrl.freq = action.newFrequency;

            const controlContainer = moduleElement.querySelector(`[data-control-id='${action.controlId}']`);
            if (controlContainer) {
              const freqLabel = controlContainer.querySelector('.freq-label');
              const freqTextInput = controlContainer.querySelector('.freq-text-input');
              const freqSlider = controlContainer.querySelector('.freq-slider');

              if (freqLabel) freqLabel.innerText = `${ctrl.freq.toFixed(2)} Hz`;
              if (freqTextInput) freqTextInput.value = ctrl.freq.toFixed(2);
              if (freqSlider) {
                const normalized = Math.log(ctrl.freq / 10) / Math.log(300);
                freqSlider.value = Math.round(normalized * 1500);
              }
            }

            if (workletNode) {
              workletNode.port.postMessage({
                type: 'compositeControlChange',
                moduleId: parseInt(action.moduleId),
                controlId: action.controlId,
                frequency: ctrl.freq
              });
            }
          }
        }
      }
      break;
    }

    case 'assignPerformance': {
      // Redo an assignment
      if (action.moduleType === 'Oscillator') {
        performanceSnapshot.performanceOscillators.set(action.moduleId, action.slot);
        usedOscillatorSlots.add(action.slot);
      } else if (action.moduleType === 'Button') {
        performanceSnapshot.performanceButtons.set(action.moduleId, action.slot);
        usedButtonSlots.add(action.slot);
      }
      rebuildSlotTracking();
      updatePerformanceIndicators();
      break;
    }

    case 'unassignPerformance': {
      // Redo an unassignment
      if (action.moduleType === 'Oscillator') {
        performanceSnapshot.performanceOscillators.delete(action.moduleId);
        usedOscillatorSlots.delete(action.slot);
      } else if (action.moduleType === 'Button') {
        performanceSnapshot.performanceButtons.delete(action.moduleId);
        usedButtonSlots.delete(action.slot);
      }
      rebuildSlotTracking();
      updatePerformanceIndicators();
      break;
    }

    case 'createModule': {
      restoreModule(action.moduleData, []);
      break;
    }

    case 'deleteModule':
      deleteModuleWithoutRecord(action.moduleData.id);
      break;

    case 'deleteModules':
      action.modules.forEach(moduleInfo => {
        deleteModuleWithoutRecord(moduleInfo.moduleData.id);
      });
      break;

    case 'deleteItems': {
      // Delete connections first (to avoid referencing deleted modules)
      action.connections.forEach(conn => {
        removeConnectionWithoutRecord(conn);
      });

      // Delete modules
      action.modules.forEach(moduleInfo => {
        deleteModuleWithoutRecord(moduleInfo.moduleData.id);
      });
      break;
    }

    case 'moveModule': {
      const module = modules.find(m => m.id === action.moduleId);
      const moduleElement = document.querySelector(`[data-id='${action.moduleId}']`);

      if (module && moduleElement) {
        // Restore grid coordinates
        module.gridX = action.toGridX;
        module.gridY = action.toGridY;

        // Update DOM position
        const pixelPos = gridToPixels(module.gridX, module.gridY);
        moduleElement.style.left = `${pixelPos.x}px`;
        moduleElement.style.top = `${pixelPos.y}px`;
      }
      break;
    }

    case 'moveModules': {
      action.movements.forEach(movement => {
        const module = modules.find(m => m.id === movement.moduleId);
        const moduleElement = document.querySelector(`[data-id='${movement.moduleId}']`);

        if (module && moduleElement) {
          // Restore grid coordinates
          module.gridX = movement.toGridX;
          module.gridY = movement.toGridY;

          // Update DOM position
          const pixelPos = gridToPixels(module.gridX, module.gridY);
          moduleElement.style.left = `${pixelPos.x}px`;
          moduleElement.style.top = `${pixelPos.y}px`;
        }
      });
      break;
    }

    case 'addConnection':
      connections.push(action.connection);
      break;

    case 'removeConnection':
      removeConnectionWithoutRecord(action.connection);
      break;

    case 'removeConnections': {
      // Re-remove connections (was incorrectly restoring them)
      action.connections.forEach(conn => {
        removeConnectionWithoutRecord(conn);
      });
      break;
    }

    case 'addConnections': {
      // Remove multiple connections (inverse of removeConnections)
      action.connections.forEach(conn => {
        removeConnectionWithoutRecord(conn);
      });
      break;
    }

    case 'pasteModules': {
      action.pastedModules.forEach(moduleData => {
        restoreModule(moduleData, []);  // moduleData is already the module data
      });

      action.pastedConnections.forEach(conn => {
        connections.push(conn);
      });
      break;
    }
  }

  if (audioStarted) {
    rebuildAudioGraph();
  }

  drawWires();
  updateUndoRedoButtons();
  updateOscillatorCheckboxes();
  updateButtonCheckboxes();
  updateModulePreview();
}


// Helper function to restore a module from history
function restoreModule(moduleData, moduleConnections) {
  const div = document.createElement('div');
  div.className = 'module';
  div.style.position = 'absolute';
  div.dataset.id = moduleData.id;
  div.dataset.type = moduleData.type;

  // Position using grid coordinates
  const pixelPos = gridToPixels(moduleData.gridX, moduleData.gridY);
  div.style.left = `${pixelPos.x}px`;
  div.style.top = `${pixelPos.y}px`;
  div.style.transform = 'none';

  // Add to modules array BEFORE setting up UI so that UI setup can access the module
  modules.push(moduleData);
  
  // Set up UI based on module type
  if (moduleData.type === 'Oscillator') {
    setupModuleUI(div, moduleData.type, moduleData.freq);
  } else {
    setupModuleUI(div, moduleData.type);
  }

  if (moduleData.type === 'Button' && moduleData.assignedKey) {
    updateButtonKeyMapping(div, moduleData.assignedKey);
  }

  // Append to container (not body)
  document.getElementById('moduleContainer').appendChild(div);

  // Attach definition for custom modules so audio worklet can process them
  if (customModuleDefinitions[moduleData.type]) {
    moduleData.definition = customModuleDefinitions[moduleData.type];
  }

  // If module is Output, update flag
  if (moduleData.type === 'Output') {
    outModuleCreated = true;
    const button = document.getElementById('createOutputModuleButton');
    if (button) {
      button.classList.add('fake-disabled');
    }
  }

  // Add selection handler to the new module
  addModuleSelectionHandler(div);

  // Add back connections if provided
  if (moduleConnections && moduleConnections.length > 0) {
    moduleConnections.forEach(conn => {
      connections.push(conn);
    });
  }

  syncMobileOutputButton();
}


function pushToUndoStack(action) {
  // No coordinate conversion needed - we store grid coordinates directly
  // The action already contains gridX/gridY from the calling code

  // Clear redo stack whenever a new action is performed
  redoStack = [];

  // Add the new action to the undo stack
  undoStack.push(action);

  // Keep the stack at a reasonable size
  if (undoStack.length > MAX_HISTORY) {
    undoStack.shift(); // Remove oldest item
  }

  updateUndoRedoButtons();
}

// Version of deleteModule that doesn't record history
function deleteModuleWithoutRecord(moduleId) {
  const moduleData = modules.find(m => m.id === moduleId);
  if (!moduleData) return;

  // Clean up performance assignments
  if (performanceSnapshot.performanceOscillators.has(moduleId)) {
    const slot = performanceSnapshot.performanceOscillators.get(moduleId);
    performanceSnapshot.performanceOscillators.delete(moduleId);
    usedOscillatorSlots.delete(slot);
  }

  if (performanceSnapshot.performanceButtons.has(moduleId)) {
    const slot = performanceSnapshot.performanceButtons.get(moduleId);
    performanceSnapshot.performanceButtons.delete(moduleId);
    usedButtonSlots.delete(slot);
  }

  updatePerformanceIndicators();

  if (moduleData.type === 'Output') {
    outModuleCreated = false;
    const button = document.getElementById('createOutputModuleButton');
    if (button) {
      button.classList.remove('fake-disabled');
    }
    syncMobileOutputButton();
  }

  if (moduleData.type === 'Oscilloscope') {
    scopeModuleCreated = false;
    const button = document.getElementById('createOscilloscopeButton');
    if (button) {
      button.classList.remove('fake-disabled');
    }

    if (scopePanelOpen) {
      toggleScopePanel();
    }
    syncMobileOutputButton();
  }
  // Remove module element from DOM
  const moduleElement = document.querySelector(`[data-id='${moduleId}']`);
  if (moduleElement) {
    // Clean up key handlers if they exist
    if (moduleElement.cleanupKeyHandlers) {
      moduleElement.cleanupKeyHandlers();
    }
    moduleElement.remove();
  }

  // Remove module from modules array
  const moduleIndex = modules.findIndex(m => m.id === moduleId);
  if (moduleIndex !== -1) {
    modules.splice(moduleIndex, 1);
  }

  // Remove all connections to/from this module
  connections = connections.filter(conn => conn.from !== moduleId && conn.to !== moduleId);

  // Clear any LED elements for this module
  ledElements = ledElements.filter(led => led.modId !== moduleId);

  // Reset selectedOutput if it points to the deleted module
  if (selectedOutput && selectedOutput.id === moduleId) {
    selectedOutput = null;
  }
}

// Helper function to remove a connection without recording history
function removeConnectionWithoutRecord(connection) {
  const index = connections.findIndex(conn =>
    conn.from === connection.from &&
    conn.to === connection.to &&
    conn.fromOutputIndex === connection.fromOutputIndex &&
    conn.inputIndex === connection.inputIndex
  );

  if (index !== -1) {
    connections.splice(index, 1);
  }
}

// performance-assign.js
// Add near the top with other globals
let assignPerformanceMode = false;

const performanceTooltip = document.getElementById('performance-tooltip');

function showPerformanceTooltip() {
  // Hide snippet tooltip when showing performance tooltip
  if (typeof hideSnippetTooltip === 'function') {
    hideSnippetTooltip();
  }
  // Also deactivate any active snippet
  if (typeof activeSnippet !== 'undefined' && activeSnippet !== null) {
    activeSnippet = null;
    document.querySelectorAll('.snippet-item').forEach(i => i.classList.remove('active'));
  }

  performanceTooltip.classList.remove('hidden');
  performanceTooltip.classList.add('visible');
}

function hidePerformanceTooltip() {
  performanceTooltip.classList.remove('visible');
  performanceTooltip.classList.add('hidden');
}


// Improved assignment function with toggle
function toggleModulePerformanceAssignment(moduleId) {
  const module = modules.find(m => m.id === moduleId);
  if (!module) return;

  if (module.type === 'Oscillator') {
    // Check if already assigned - if so, unassign
    if (performanceSnapshot.performanceOscillators.has(moduleId)) {
      const slot = performanceSnapshot.performanceOscillators.get(moduleId);

      // Push to undo stack BEFORE making changes
      pushToUndoStack({
        type: 'unassignPerformance',
        moduleId: moduleId,
        moduleType: 'Oscillator',
        slot: slot
      });

      performanceSnapshot.performanceOscillators.delete(moduleId);
      usedOscillatorSlots.delete(slot);

      rebuildSlotTracking();
      updatePerformanceIndicators();
      console.log(`Unassigned Oscillator ${moduleId} from performance slot ${slot}`);
      return;
    }

    // Find next available slot (1-6)
    let slot = nextOscillatorSlot;

    while (usedOscillatorSlots.has(slot) && slot <= MAX_OSCILLATOR_CONTROLS) {
      slot++;
    }

    if (slot > MAX_OSCILLATOR_CONTROLS) {
      // showAlert(`Maximum ${MAX_OSCILLATOR_CONTROLS} oscillators can be assigned to performance mode.`);
      return;
    }

    // Push to undo stack BEFORE making changes
    pushToUndoStack({
      type: 'assignPerformance',
      moduleId: moduleId,
      moduleType: 'Oscillator',
      slot: slot
    });

    performanceSnapshot.performanceOscillators.set(moduleId, slot);
    usedOscillatorSlots.add(slot);

    rebuildSlotTracking();
    updatePerformanceIndicators();
    console.log(`Assigned Oscillator ${moduleId} to performance slot ${slot}`);

  } else if (module.type === 'Button') {
    // Check if already assigned - if so, unassign
    if (performanceSnapshot.performanceButtons.has(moduleId)) {
      const slot = performanceSnapshot.performanceButtons.get(moduleId);

      // Push to undo stack BEFORE making changes
      pushToUndoStack({
        type: 'unassignPerformance',
        moduleId: moduleId,
        moduleType: 'Button',
        slot: slot
      });

      performanceSnapshot.performanceButtons.delete(moduleId);
      usedButtonSlots.delete(slot);

      rebuildSlotTracking();
      updatePerformanceIndicators();
      console.log(`Unassigned Button ${moduleId} from performance slot ${slot}`);
      return;
    }

    // Find next available slot (1-4)
    let slot = nextButtonSlot;

    while (usedButtonSlots.has(slot) && slot <= MAX_BUTTON_CONTROLS) {
      slot++;
    }

    if (slot > MAX_BUTTON_CONTROLS) {
      // showAlert(`Maximum ${MAX_BUTTON_CONTROLS} buttons can be assigned to performance mode.`);
      return;
    }

    // Push to undo stack BEFORE making changes
    pushToUndoStack({
      type: 'assignPerformance',
      moduleId: moduleId,
      moduleType: 'Button',
      slot: slot
    });

    performanceSnapshot.performanceButtons.set(moduleId, slot);
    usedButtonSlots.add(slot);

    rebuildSlotTracking();
    updatePerformanceIndicators();
    console.log(`Assigned Button ${moduleId} to performance slot ${slot}`);

  } else {
    // alert('Only Oscillators and Buttons can be assigned to performance mode.');
    return;
  }
}

// Function to exit assignment mode
function exitAssignmentMode() {
  assignPerformanceMode = false;
  const assignButton = document.getElementById('assignPerformanceButton');
  const assignButtonMobile = document.getElementById('assignButtonMobile');
  if (assignButton) {
    assignButton.classList.remove('active');
    hidePerformanceTooltip();
  }
  if (assignButtonMobile) {
    assignButtonMobile.classList.remove('active');
    hidePerformanceTooltip();
  }
}

// Add button to trigger assignment mode
document.addEventListener('DOMContentLoaded', () => {
  const assignButton = document.getElementById('assignPerformanceButton');
  const assignButtonMobile = document.getElementById('assignButtonMobile');
  if (assignButton) {
    assignButton.addEventListener('click', () => {
      assignPerformanceMode = !assignPerformanceMode;

      if (assignPerformanceMode) {
        assignButton.classList.add('active');
        showPerformanceTooltip();
      } else {
        exitAssignmentMode();
        hidePerformanceTooltip(); 
      }
    });
  }
  if (assignButtonMobile) {
    assignButtonMobile.addEventListener('click', () => {
      assignPerformanceMode = !assignPerformanceMode;

      if (assignPerformanceMode) {
        assignButtonMobile.classList.add('active');
        showPerformanceTooltip();
      } else {
        exitAssignmentMode();
        hidePerformanceTooltip(); 
      }
    });
  }
});

// Update click handler for assignment with toggle
document.addEventListener('click', (e) => {
  if (assignPerformanceMode) {
    const moduleElement = e.target.closest('.module');

    // If clicking on a module, toggle its assignment
    if (moduleElement) {
      const moduleId = parseInt(moduleElement.dataset.id);
      const module = modules.find(m => m.id === moduleId);

      // Only allow oscillators and buttons
      if (module && (module.type === 'Oscillator' || module.type === 'Button')) {
        toggleModulePerformanceAssignment(moduleId);
        e.stopPropagation();
        e.preventDefault();
      }
    }
    // Don't exit mode when clicking modules - let user assign multiple
  }
});

// volume-control.js
// Add these global variables near the top
let currentVolume = 0.5; // 50% default
let isMuted = true;
let volumeSliderVisible = false;
let previousVolume = currentVolume;
let desktopLongPressTimer = null;
let desktopSliderHideTimer = null;

function setupVolumeListeners() {
  const audioButton = document.getElementById('startAudioButton');
  const sliderContainer = document.getElementById('volume-slider-container');
  const slider = document.getElementById('volume-slider');
  const percentage = document.getElementById('volume-percentage');

  // Mobile elements
  const mobileAudioFab = document.getElementById('mobile-audio-fab');
  const mobileSliderContainer = document.getElementById('mobile-volume-slider-container');
  const mobileSlider = document.getElementById('mobile-volume-slider');
  const mobilePercentage = document.getElementById('mobile-volume-percentage');

  if (!audioButton || !sliderContainer || !slider || !percentage) {
    console.error('Volume control elements not found:', {
      audioButton: !!audioButton,
      sliderContainer: !!sliderContainer,
      slider: !!slider,
      percentage: !!percentage
    });
    return;
  }

  // Desktop: Show slider on hover over audio button
  if (!isTouchDevice()) {

    audioButton.addEventListener('mouseenter', (e) => {
      // if (audioStarted) {
        clearTimeout(desktopSliderHideTimer);
        sliderContainer.classList.remove('volume-slider-hidden');
        sliderContainer.classList.add('volume-slider-visible');
      // }
    });

    audioButton.addEventListener('mouseleave', (e) => {
      // Check if mouse is moving to the slider container
      const relatedTarget = e.relatedTarget;
      if (relatedTarget && (sliderContainer.contains(relatedTarget) || relatedTarget === sliderContainer)) {
        return; // Don't hide if moving to slider
      }
      sliderContainer.classList.remove('volume-slider-visible');
      sliderContainer.classList.add('volume-slider-hidden');
    });

    // Keep slider visible when hovering over it
    sliderContainer.addEventListener('mouseenter', (e) => {
      // if (audioStarted) {
        clearTimeout(desktopSliderHideTimer);
        sliderContainer.classList.remove('volume-slider-hidden');
        sliderContainer.classList.add('volume-slider-visible');
      // }
    });

    sliderContainer.addEventListener('mouseleave', (e) => {
      // Check if mouse is moving back to audio button
      const relatedTarget = e.relatedTarget;
      if (relatedTarget && (audioButton.contains(relatedTarget) || relatedTarget === audioButton)) {
        return; // Don't hide if moving back to button
      }
      sliderContainer.classList.remove('volume-slider-visible');
      sliderContainer.classList.add('volume-slider-hidden');
    });
  }

  // Desktop touch accessibility: Long press to show slider
  audioButton.addEventListener('touchstart', (e) => {
    // if (!audioStarted) return;

    desktopLongPressTimer = setTimeout(() => {
      clearTimeout(desktopSliderHideTimer);
      sliderContainer.classList.remove('volume-slider-hidden');
      sliderContainer.classList.add('volume-slider-visible');

      // Auto-hide after 3 seconds of no interaction
      desktopSliderHideTimer = setTimeout(() => {
        sliderContainer.classList.remove('volume-slider-visible');
        sliderContainer.classList.add('volume-slider-hidden');
      }, 3000);
    }, 500); // 500ms long press
  }, { passive: true });

  audioButton.addEventListener('touchend', () => {
    clearTimeout(desktopLongPressTimer);
  });

  audioButton.addEventListener('touchmove', () => {
    clearTimeout(desktopLongPressTimer);
  });

  // Keep slider visible when interacting with it (touch)
  sliderContainer.addEventListener('touchstart', (e) => {
    // if (audioStarted) {
      clearTimeout(desktopSliderHideTimer);
      e.stopPropagation(); // Prevent triggering outside touch handler
    // }
  }, { passive: true });

  // Reset hide timer when interacting with slider
  sliderContainer.addEventListener('touchmove', (e) => {
    clearTimeout(desktopSliderHideTimer);
    // Restart the hide timer
    desktopSliderHideTimer = setTimeout(() => {
      sliderContainer.classList.remove('volume-slider-visible');
      sliderContainer.classList.add('volume-slider-hidden');
    }, 3000);
  }, { passive: true });

  // Close desktop slider when touching outside
  document.addEventListener('touchstart', (e) => {
    if (!sliderContainer.contains(e.target) &&
      !audioButton.contains(e.target) &&
      sliderContainer.classList.contains('volume-slider-visible')) {
      clearTimeout(desktopSliderHideTimer);
      sliderContainer.classList.remove('volume-slider-visible');
      sliderContainer.classList.add('volume-slider-hidden');
    }
  });

  // Desktop slider change
  slider.addEventListener('input', (e) => {
    const value = parseInt(e.target.value);
    const fill = document.querySelector('.volume-slider-fill');

    // Reset hide timer when adjusting slider
    if (desktopSliderHideTimer) {
      clearTimeout(desktopSliderHideTimer);
      desktopSliderHideTimer = setTimeout(() => {
        sliderContainer.classList.remove('volume-slider-visible');
        sliderContainer.classList.add('volume-slider-hidden');
      }, 3000);
    }

    // Check if we're in desktop (>1000px) or tablet mode (<=1000px)
    if (fill) {
      if (window.innerWidth > 1000) {
        fill.style.width = `${value}%`;  // Horizontal on desktop
        fill.style.height = '';
      } else {
        // For vertical slider with rtl direction, we need to invert the visual
        fill.style.height = `${value}%`; // The direction: rtl handles the inversion
        fill.style.width = '';
      }
    }

    currentVolume = value / 100;
    percentage.textContent = `${value}%`;
    updateVolume();

    if (value === 0 && !isMuted) {
      toggleMute(true);
    } else if (value > 0 && isMuted) {
      previousVolume = currentVolume;
      toggleMute(false);
    }
  });

  // Mobile: Show slider on hover over FAB
  if (mobileAudioFab && mobileSliderContainer && mobileSlider && mobilePercentage) {
    if (!isTouchDevice()) {
      // Desktop behavior for mobile FAB (if shown on desktop)
      mobileAudioFab.addEventListener('mouseenter', (e) => {
        // if (audioStarted) {
          mobileSliderContainer.classList.remove('volume-slider-hidden');
          mobileSliderContainer.classList.add('volume-slider-visible');
        // }
      });

      mobileAudioFab.addEventListener('mouseleave', (e) => {
        const relatedTarget = e.relatedTarget;
        if (relatedTarget && (mobileSliderContainer.contains(relatedTarget) || relatedTarget === mobileSliderContainer)) {
          return;
        }
        mobileSliderContainer.classList.remove('volume-slider-visible');
        mobileSliderContainer.classList.add('volume-slider-hidden');
      });

      mobileSliderContainer.addEventListener('mouseenter', (e) => {
        if (audioStarted) {
          mobileSliderContainer.classList.remove('volume-slider-hidden');
          mobileSliderContainer.classList.add('volume-slider-visible');
        }
      });

      mobileSliderContainer.addEventListener('mouseleave', (e) => {
        const relatedTarget = e.relatedTarget;
        if (relatedTarget && (mobileAudioFab.contains(relatedTarget) || relatedTarget === mobileAudioFab)) {
          return;
        }
        mobileSliderContainer.classList.remove('volume-slider-visible');
        mobileSliderContainer.classList.add('volume-slider-hidden');
      });
    } else {
      // Touch device: long press to show/hide slider
      let longPressTimer;

      mobileAudioFab.addEventListener('touchstart', (e) => {
        if (!audioStarted) return;

        longPressTimer = setTimeout(() => {
          const isVisible = mobileSliderContainer.classList.contains('volume-slider-visible');
          if (isVisible) {
            mobileSliderContainer.classList.remove('volume-slider-visible');
            mobileSliderContainer.classList.add('volume-slider-hidden');
          } else {
            mobileSliderContainer.classList.remove('volume-slider-hidden');
            mobileSliderContainer.classList.add('volume-slider-visible');
          }
        }, 500); // 500ms long press
      }, { passive: true });

      mobileAudioFab.addEventListener('touchend', () => {
        clearTimeout(longPressTimer);
      });

      mobileAudioFab.addEventListener('touchmove', () => {
        clearTimeout(longPressTimer);
      });

      // Close slider when touching outside
      document.addEventListener('touchstart', (e) => {
        if (!mobileSliderContainer.contains(e.target) &&
          !mobileAudioFab.contains(e.target) &&
          mobileSliderContainer.classList.contains('volume-slider-visible')) {
          mobileSliderContainer.classList.remove('volume-slider-visible');
          mobileSliderContainer.classList.add('volume-slider-hidden');
        }
      });
    }

    // Mobile slider change
    mobileSlider.addEventListener('input', (e) => {
      const value = parseInt(e.target.value);
      const fill = document.querySelector('.mobile-volume-slider-fill');
      if (fill) fill.style.width = `${value}%`;

      currentVolume = value / 100;
      mobilePercentage.textContent = `${value}%`;

      if (slider) {
        slider.value = value;
        percentage.textContent = `${value}%`;
        const desktopFill = document.querySelector('.volume-slider-fill');
        if (desktopFill) desktopFill.style.height = `${value}%`;
      }

      updateVolume();

      if (value === 0 && !isMuted) {
        toggleMute(true);
      } else if (value > 0 && isMuted) {
        previousVolume = currentVolume;
        toggleMute(false);
      }
    });

  }

  // Set desktop slider
  if (slider && percentage) {
    slider.value = 0;
    percentage.textContent = '0%';
    const desktopFill = document.querySelector('.volume-slider-fill');
    if (desktopFill) {
      if (window.innerWidth > 1000) {
        desktopFill.style.width = '0%';
        desktopFill.style.height = '';
      } else {
        desktopFill.style.height = '0%';
        desktopFill.style.width = '';
      }
    }
  }

  // Set mobile slider
  if (mobileSlider && mobilePercentage) {
    mobileSlider.value = 0;
    mobilePercentage.textContent = '0%';
    const mobileFill = document.querySelector('.mobile-volume-slider-fill');
    if (mobileFill) mobileFill.style.width = '0%';
  }
  setupResponsiveVolumeSync();

}

function updateVolume() {
  if (workletNode && audioStarted) {
    workletNode.port.postMessage({
      type: 'setVolume',
      value: currentVolume
    });
  }
}

function updateMuteState() {
  if (workletNode && audioStarted) {
    workletNode.port.postMessage({
      type: 'setMuted',
      muted: isMuted
    });
  }

  const iconContainer = document.getElementById('audio-icon');
  const iconMobileContainer = document.getElementById('audio-icon-mobile');

  // Update icon
  iconMobileContainer.classList.remove("active");
  iconContainer.classList.remove("active");
  if (isMuted || !audioStarted) {
    iconContainer.innerHTML = iconMute;
    iconContainer.classList.remove("active");
    iconMobileContainer.innerHTML = iconMute;
    iconMobileContainer.classList.remove("active");
    iconContainer.style = "color: var(--text-primary);"
  } else {
    iconContainer.innerHTML = iconPlaying;
    iconContainer.classList.add("active");
    iconMobileContainer.innerHTML = iconPlaying;
    iconMobileContainer.classList.add("active");
    iconContainer.style = "color: var(--accent-primary);"
  }
}

function toggleMute(forceMute = null) {
  const slider = document.getElementById('volume-slider');
  const percentage = document.getElementById('volume-percentage');
  const mobileSlider = document.getElementById('mobile-volume-slider');
  const mobilePercentage = document.getElementById('mobile-volume-percentage');

  // If caller wants to force mute/unmute (e.g. when slider hits 0)
  if (forceMute !== null) {
    isMuted = forceMute;
  } else {
    isMuted = !isMuted;
  }

  if (isMuted) {
    // Store the last nonzero volume
    if (currentVolume > 0) previousVolume = currentVolume;
    currentVolume = 0;
  } else {
    // Restore previous volume or fallback to 50%
    currentVolume = previousVolume > 0.01 ? previousVolume : 0.5;
  }

  const volumePercent = Math.round(currentVolume * 100);

  // Sync slider UI and fills
  if (slider) {
    slider.value = volumePercent;
    percentage.textContent = `${volumePercent}%`;
    const desktopFill = document.querySelector('.volume-slider-fill');
    if (desktopFill) {
      if (window.innerWidth > 1000) {
        desktopFill.style.width = `${volumePercent}%`;  // Horizontal on desktop
        desktopFill.style.height = '';  // Clear height
      } else {
        desktopFill.style.height = `${volumePercent}%`; // Vertical on tablet
        desktopFill.style.width = '';  // Clear height
      }
    }
  }
  if (mobileSlider) {
    mobileSlider.value = volumePercent;
    mobilePercentage.textContent = `${volumePercent}%`;
    const mobileFill = document.querySelector('.mobile-volume-slider-fill');
    if (mobileFill) mobileFill.style.width = `${volumePercent}%`;
  }

  updateVolume();
  updateMuteState();
}

function setupResponsiveVolumeSync() {
  const mediaQuery = window.matchMedia('(max-width: 1000px)');

  function handleBreakpointChange(e) {
    const fill = document.querySelector('.volume-slider-fill');
    const slider = document.getElementById('volume-slider');

    if (!fill || !slider) return;

    const value = parseInt(slider.value);

    if (e.matches) {
      // Switched to vertical (≤1000px)
      fill.style.height = `${value}%`;
      fill.style.width = '';
    } else {
      // Switched to horizontal (>1000px)
      fill.style.width = `${value}%`;
      fill.style.height = '';
    }
  }

  // Listen for breakpoint changes
  mediaQuery.addEventListener('change', handleBreakpointChange);

  // Run once on load to set correct initial state
  handleBreakpointChange(mediaQuery);
}

// scope.js
let scopeDisplayMode = 'split'; // 'split' or 'superimpose'
let scopeTriggerEnabled = false;
let scopeTimeScaleA = 0.250;
let scopeTimeScaleB = 0.250;
let scopeTimeScaleCommon = 0.250;
let scopeBufferSize = 262144; // Larger buffer for zoom capability

function toggleScopePanel() {
  const panel = document.getElementById('scopePanel');
  scopePanelOpen = !scopePanelOpen;

  if (scopePanelOpen) {
    panel.classList.add('open');

    // Enable scope in worklet with buffer size
    if (workletNode) {
      workletNode.port.postMessage({
        type: 'enableScope',
        enabled: true,
        bufferSize: scopeBufferSize
      });
    }

    // Start animation loop
    startScopeAnimation();
  } else {
    panel.classList.remove('open');

    // Disable scope in worklet
    if (workletNode) {
      workletNode.port.postMessage({
        type: 'enableScope',
        enabled: false
      });
    }

    // Stop animation loop
    stopScopeAnimation();

    // Clear the canvas immediately
    const canvas = document.getElementById('scopeCanvas');
    if (canvas) {
      const ctx = canvas.getContext('2d');
      const rootStyles = getComputedStyle(document.documentElement);
      const bgColor = rootStyles.getPropertyValue('--bg-scope-canvas')?.trim() || '#1a1a1a';
      ctx.fillStyle = bgColor;
      ctx.fillRect(0, 0, canvas.width, canvas.height);
    }
  }
}

function startScopeAnimation() {
  if (scopeAnimationId) return;

  let lastRequestTime = 0;
  const requestInterval = 1000 / 20; // 30 FPS

  function animate(currentTime) {
    if (!scopePanelOpen) {
      scopeAnimationId = null;
      return;
    }

    if (currentTime - lastRequestTime >= requestInterval) {
      if (workletNode) {
        workletNode.port.postMessage({ type: 'requestScopeData' });
      }
      lastRequestTime = currentTime;
    }

    scopeAnimationId = requestAnimationFrame(animate);
  }

  scopeAnimationId = requestAnimationFrame(animate);
}

function stopScopeAnimation() {
  if (scopeAnimationId) {
    cancelAnimationFrame(scopeAnimationId);
    scopeAnimationId = null;
  }
}

// Initialize scope panel
function initScopePanel() {
  const closeBtn = document.getElementById('scopeCloseBtn');
  if (closeBtn) {
    closeBtn.addEventListener('click', toggleScopePanel);
  }

  // Display mode toggle
  const displayModeBtn = document.getElementById('scopeDisplayMode');
  if (displayModeBtn) {
    displayModeBtn.addEventListener('click', () => {
      scopeDisplayMode = scopeDisplayMode === 'split' ? 'superimpose' : 'split';
      displayModeBtn.textContent = scopeDisplayMode === 'split' ? 'Split' : 'Superimpose';
      updateTimeScaleVisibility();
    });
  }

  // Trigger toggle
  const triggerBtn = document.getElementById('scopeTrigger');
  if (triggerBtn) {
    triggerBtn.addEventListener('click', () => {
      scopeTriggerEnabled = !scopeTriggerEnabled;
      triggerBtn.textContent = scopeTriggerEnabled ? 'On' : 'Off';
      triggerBtn.classList.toggle('active', scopeTriggerEnabled);
    });
  }

  // Time scale controls
  const timeScaleA = document.getElementById('scopeTimeScaleA');
  const timeScaleAValue = document.getElementById('scopeTimeScaleAValue');
  if (timeScaleA && timeScaleAValue) {
    timeScaleA.value = 25; // Set to 0.25x starting position
    timeScaleA.addEventListener('input', (e) => {
      const normalized = (parseFloat(e.target.value) - 1) / 99;
      scopeTimeScaleA = Math.pow(10, normalized * 3 - 2);
      timeScaleAValue.textContent = scopeTimeScaleA.toFixed(2) + 'x';
    });
    timeScaleAValue.textContent = '0.25x'; // Initial display
  }

  const timeScaleB = document.getElementById('scopeTimeScaleB');
  const timeScaleBValue = document.getElementById('scopeTimeScaleBValue');
  if (timeScaleB && timeScaleBValue) {
    timeScaleB.value = 25;
    timeScaleB.addEventListener('input', (e) => {
      const normalized = (parseFloat(e.target.value) - 1) / 99;
      scopeTimeScaleB = Math.pow(10, normalized * 3 - 2);
      timeScaleBValue.textContent = scopeTimeScaleB.toFixed(2) + 'x';
    });
    timeScaleBValue.textContent = '0.25x';
  }

  const timeScaleCommon = document.getElementById('scopeTimeScaleCommon');
  const timeScaleCommonValue = document.getElementById('scopeTimeScaleCommonValue');
  if (timeScaleCommon && timeScaleCommonValue) {
    timeScaleCommon.value = 25;
    timeScaleCommon.addEventListener('input', (e) => {
      const normalized = (parseFloat(e.target.value) - 1) / 99;
      scopeTimeScaleCommon = Math.pow(10, normalized * 3 - 2);
      timeScaleCommonValue.textContent = scopeTimeScaleCommon.toFixed(2) + 'x';
    });
    timeScaleCommonValue.textContent = '0.25x';
  }

  // Set up worklet message handler for scope data
  if (workletNode) {
    const originalOnMessage = workletNode.port.onmessage;
    workletNode.port.onmessage = (event) => {
      if (originalOnMessage) originalOnMessage(event);

      if (event.data.type === 'scopeData') {
        drawScope(event.data.dataA, event.data.dataB);
      }
    };
  }
}

function updateTimeScaleVisibility() {
  const timeScaleAGroup = document.getElementById('scopeTimeScaleA-group');
  const timeScaleBGroup = document.getElementById('scopeTimeScaleB-group');
  const timeScaleCommonGroup = document.getElementById('scopeTimeScaleCommon-group');

  if (scopeDisplayMode === 'split') {
    timeScaleAGroup.style.display = 'flex';
    timeScaleBGroup.style.display = 'flex';
    timeScaleCommonGroup.style.display = 'none';
  } else {
    timeScaleAGroup.style.display = 'none';
    timeScaleBGroup.style.display = 'none';
    timeScaleCommonGroup.style.display = 'flex';
  }
}

function findTriggerPoint(data, threshold = 0.5, hysteresis = 0.1) {
  // Search only last 10000 samples instead of 50000
  const searchLength = Math.min(data.length, 10000);
  const searchStart = data.length - searchLength;

  // Step through data instead of checking every sample
  const step = 2;
  for (let i = searchStart + 1; i < data.length; i += step) {
    if (data[i - 1] < (threshold - hysteresis) && data[i] >= threshold) {
      return i;
    }
  }

  return -1;
}

function applyTimeScale(data, scale, triggerIndex = -1) {
  if (!data || data.length === 0) return data;

  const baseWindowSize = 144000; // ~3 seconds at 48kHz

  let windowSize;
  if (scale === 1.0) {
    windowSize = Math.min(data.length, baseWindowSize);
  } else if (scale < 1.0) {
    windowSize = Math.floor(baseWindowSize * scale);
    windowSize = Math.max(windowSize, 256);
  } else {
    windowSize = Math.min(data.length, Math.floor(baseWindowSize * scale));
  }

  // If we have a valid trigger point, center the window around it
  if (triggerIndex >= 0 && triggerIndex < data.length) {
    const pretrigger = Math.floor(windowSize * 0.1); // Show 10% before trigger
    const start = Math.max(0, triggerIndex - pretrigger);
    const end = Math.min(data.length, start + windowSize);

    // Make sure we actually have data to return
    if (end > start) {
      return data.slice(start, end);
    }
  }

  // No trigger or invalid range - show most recent data
  return data.slice(-windowSize);
}

function drawScope(dataA, dataB) {
  const canvas = document.getElementById('scopeCanvas');
  if (!canvas) return;

  const ctx = canvas.getContext('2d', {
    alpha: false,
    desynchronized: true // Hint for better performance
  });

  const width = canvas.width;
  const height = canvas.height;
  const rootStyles = getComputedStyle(document.documentElement);
  const bgColor = rootStyles.getPropertyValue('--bg-scope-canvas')?.trim() || '#1a1a1a';

  ctx.fillStyle = bgColor;
  ctx.fillRect(0, 0, width, height);

  ctx.imageSmoothingEnabled = false;


  const showA = document.getElementById('scopeChannelA')?.checked ?? true;
  const showB = document.getElementById('scopeChannelB')?.checked ?? true;

  // FIX 1: Find trigger points INDEPENDENTLY for each channel
  let triggerIndexA = -1;
  let triggerIndexB = -1;

  if (scopeTriggerEnabled) {
    if (showA && dataA && dataA.length > 0) {
      triggerIndexA = findTriggerPoint(dataA);
    }
    if (showB && dataB && dataB.length > 0) {
      triggerIndexB = findTriggerPoint(dataB);
    }
  }

  if (scopeDisplayMode === 'split') {
    let displayDataA = dataA;
    let displayDataB = dataB;

    if (showA && dataA && dataA.length > 0) {
      displayDataA = applyTimeScale(dataA, scopeTimeScaleA, triggerIndexA);
    }

    if (showB && dataB && dataB.length > 0) {
      displayDataB = applyTimeScale(dataB, scopeTimeScaleB, triggerIndexB);
    }

    drawSplitMode(ctx, width, height, displayDataA, displayDataB, showA, showB);
  } else {
    let displayDataA = dataA;
    let displayDataB = dataB;

    // In superimpose mode, use channel A's trigger for both
    const commonTrigger = triggerIndexA >= 0 ? triggerIndexA : triggerIndexB;

    if (showA && dataA && dataA.length > 0) {
      displayDataA = applyTimeScale(dataA, scopeTimeScaleCommon, commonTrigger);
    }

    if (showB && dataB && dataB.length > 0) {
      displayDataB = applyTimeScale(dataB, scopeTimeScaleCommon, commonTrigger);
    }

    drawSuperimposeMode(ctx, width, height, displayDataA, displayDataB, showA, showB);
  }
}

function drawSplitMode(ctx, width, height, dataA, dataB, showA, showB) {
  const halfHeight = height / 2;

  if (showA && dataA && dataA.length > 0) {
    drawGrid(ctx, width, halfHeight, 0, 'Channel A');
    drawWaveform(ctx, width, halfHeight, 0, dataA, '#ffa735');
  }

  ctx.strokeStyle = 'rgba(150, 150, 150, 0.5)';
  ctx.lineWidth = 2;
  ctx.beginPath();
  ctx.moveTo(0, halfHeight);
  ctx.lineTo(width, halfHeight);
  ctx.stroke();

  if (showB && dataB && dataB.length > 0) {
    drawGrid(ctx, width, halfHeight, halfHeight, 'Channel B');
    drawWaveform(ctx, width, halfHeight, halfHeight, dataB, '#ff6b35');
  }
}

function drawSuperimposeMode(ctx, width, height, dataA, dataB, showA, showB) {
  drawGrid(ctx, width, height, 0, 'Channels A+B');

  if (showA && dataA && dataA.length > 0) {
    drawWaveform(ctx, width, height, 0, dataA, '#ffa735');
  }

  if (showB && dataB && dataB.length > 0) {
    drawWaveform(ctx, width, height, 0, dataB, '#ff6b35');
  }
}

function drawGrid(ctx, width, height, offsetY, label) {
  // Draw vertical lines
  ctx.strokeStyle = 'rgba(100, 100, 100, 0.3)';
  ctx.lineWidth = 1;

  for (let i = 0; i <= 10; i++) {
    const x = (i * width) / 10;
    ctx.beginPath();
    ctx.moveTo(x, offsetY);
    ctx.lineTo(x, offsetY + height);
    ctx.stroke();
  }

  // Draw horizontal lines
  for (let i = 0; i <= 8; i++) {
    const y = offsetY + (i * height) / 8;
    ctx.beginPath();
    ctx.moveTo(0, y);
    ctx.lineTo(width, y);
    ctx.stroke();
  }

  // Center line (thicker)
  ctx.strokeStyle = 'rgba(150, 150, 150, 0.5)';
  ctx.lineWidth = 2;
  ctx.beginPath();
  ctx.moveTo(0, offsetY + height / 2);
  ctx.lineTo(width, offsetY + height / 2);
  ctx.stroke();

  // Draw label
  ctx.fillStyle = 'rgba(150, 150, 150, 0.7)';
  ctx.font = '12px monospace';
  ctx.fillText(label, 10, offsetY + 20);
}

// FIX 2 & 3: Glowy analog look + Performance optimization
function drawWaveform(ctx, width, height, offsetY, data, color) {
  if (!data || data.length === 0) return;

  // More aggressive downsampling - 1 sample per pixel maximum
  const maxSamples = width;
  let processedData = data;

  if (data.length > maxSamples) {
    const step = Math.floor(data.length / maxSamples);
    processedData = [];
    for (let i = 0; i < data.length; i += step) {
      processedData.push(data[i]);
    }
  }

  const samplesPerPixel = processedData.length / width;

  // Simplified glow - only 2 passes instead of 3
  // Outer glow
  ctx.shadowBlur = 3;
  ctx.shadowColor = color;
  ctx.strokeStyle = color.replace('ff', '60');
  ctx.lineWidth = 2;
  drawWaveformPath(ctx, width, height, offsetY, processedData, samplesPerPixel);

  // Core line
  ctx.shadowBlur = 1;
  ctx.shadowColor = color;
  ctx.strokeStyle = color;
  ctx.lineWidth = 1;
  drawWaveformPath(ctx, width, height, offsetY, processedData, samplesPerPixel);

  ctx.shadowBlur = 0;
}

// FIX 3: Separate path drawing for reuse - reduces redundant calculations
function drawWaveformPath(ctx, width, height, offsetY, data, samplesPerPixel) {
  ctx.beginPath();

  let started = false;

  for (let x = 0; x < width; x++) {
    const sampleIndex = Math.floor(x * samplesPerPixel);
    if (sampleIndex >= data.length) break;

    const value = data[sampleIndex];

    if (value !== undefined && !isNaN(value)) {
      // Map 0-1 signal to canvas coordinates
      const y = offsetY + height - (value * height * 0.8 + height * 0.1);

      if (!started) {
        ctx.moveTo(x, y);
        started = true;
      } else {
        ctx.lineTo(x, y);
      }
    }
  }

  if (started) {
    ctx.stroke();
  }
}

// dictionary.js
// dictionary.js - Module information dictionary system
let dictionaryActive = false;

// Module information database - UPDATE THIS
const moduleInfo = {
  'AND': {
    title: 'AND Gate',
    description: 'Outputs 1 only when both inputs A and B are 1. The most restrictive logic gate.',
    tips: 'Use AND gates as on/off switches, or to combine multiple control signals.',
    techDescription: 'Digital logic gate implementing logical conjunction. Output is HIGH only when all inputs are HIGH.',
    truthTable: {
      inputs: ['A', 'B'],
      rows: [
        ['0', '0', '0'],
        ['0', '1', '0'],
        ['1', '0', '0'],
        ['1', '1', '1']
      ]
    },
    hardware: 'CD4081',
    schematic: 'schematics/AND.svg',
    schematicInfo: {
      description: 'Simple AND gate schematic. Make sure to include decoupling capacitors close to the IC power pins to ensure stable operation. Use current-limiting resistors for the LEDs to prevent damage. 100k pulldown resistors on the inputs helps keep inputs in a defined state when not driven. 4.7k resistors are recommended for LED current limiting to ensure visibility without excessive current draw at 5-9V operation.',
      tips: 'Extra gates included for pinout reference.',
      bom: [
        { name: 'CD4081', quantity: 1, note: 'AND Gate IC' },
        { name: 'LED', quantity: 1, note: 'Output indicator' },
        { name: '1k Resistor', quantity: 1, note: 'Output short protection' },
        { name: '4.7k Resistor', quantity: 1, note: 'LED current limiting resistor' },
        { name: '100k Resistor', quantity: 2, note: 'Input pulldown resistors' },
        { name: '100nF Capacitor', quantity: 1, note: '100nF decoupling' }
      ]
    }
  },
  'OR': {
    title: 'OR Gate',
    description: 'Outputs 1 when either input A or B (or both) are 1. The most permissive logic gate.',
    tips: 'Use OR gates to combine multiple sound sources or trigger signals.',
    techDescription: 'Digital logic gate implementing logical disjunction. Output is HIGH when any input is HIGH.',
    truthTable: {
      inputs: ['A', 'B'],
      rows: [
        ['0', '0', '0'],
        ['0', '1', '1'],
        ['1', '0', '1'],
        ['1', '1', '1']
      ]
    },
    hardware: 'CD4071',
    schematic: 'schematics/OR.svg',
    schematicInfo: {
      description: 'Simple OR gate schematic. Make sure to include decoupling capacitors close to the IC power pins to ensure stable operation. Use current-limiting resistors for the LEDs to prevent damage. 100k pulldown resistors on the inputs helps keep inputs in a defined state when not driven. 4.7k resistors are recommended for LED current limiting to ensure visibility without excessive current draw at 5-9V operation.',
      tips: 'Extra gates included for pinout reference.',
      bom: [
        { name: 'CD4071', quantity: 1, note: 'OR Gate IC' },
        { name: 'LED', quantity: 1, note: 'Output indicator' },
        { name: '1k Resistor', quantity: 1, note: 'Output short protection' },
        { name: '4.7k Resistor', quantity: 1, note: 'LED current limiting resistor' },
        { name: '100k Resistor', quantity: 2, note: 'Input pulldown resistors' },
        { name: '100nF Capacitor', quantity: 1, note: '100nF decoupling' }
      ]
    }
  },
  'NAND': {
    title: 'NAND Gate',
    description: 'Outputs 0 only when both inputs are 1. The inverse of AND.',
    tips: 'Use NAND gates to invert AND logic or create complex gating patterns.',
    techDescription: 'Inverted AND gate (NOT-AND). NAND is functionally complete - any boolean function can be implemented using only NAND gates.',
    truthTable: {
      inputs: ['A', 'B'],
      rows: [
        ['0', '0', '1'],
        ['0', '1', '1'],
        ['1', '0', '1'],
        ['1', '1', '0']
      ]
    },
    hardware: 'CD4011',
    schematic: 'schematics/NAND.svg',
    schematicInfo: {
      description: 'Simple NAND gate schematic. Make sure to include decoupling capacitors close to the IC power pins to ensure stable operation. Use current-limiting resistors for the LEDs to prevent damage. 100k pulldown resistors on the inputs helps keep inputs in a defined state when not driven. 4.7k resistors are recommended for LED current limiting to ensure visibility without excessive current draw at 5-9V operation.',
      tips: 'Extra gates included for pinout reference.',
      bom: [
        { name: 'CD4011', quantity: 1, note: 'NAND Gate IC' },
        { name: 'LED', quantity: 1, note: 'Output indicator' },
        { name: '1k Resistor', quantity: 1, note: 'Output short protection' },
        { name: '4.7k Resistor', quantity: 1, note: 'LED current limiting resistor' },
        { name: '100k Resistor', quantity: 2, note: 'Input pulldown resistors' },
        { name: '100nF Capacitor', quantity: 1, note: '100nF decoupling' }
      ]
    }
  },
  'NOR': {
    title: 'NOR Gate',
    description: 'Outputs 1 only when both inputs are 0. The inverse of OR.',
    tips: 'Use NOR gates to invert OR logic or detect silence in multiple signals.',
    techDescription: 'Inverted OR gate (NOT-OR). NOR is functionally complete - any boolean function can be implemented using only NOR gates.',
    truthTable: {
      inputs: ['A', 'B'],
      rows: [
        ['0', '0', '1'],
        ['0', '1', '0'],
        ['1', '0', '0'],
        ['1', '1', '0']
      ]
    },
    hardware: 'CD4001',
    schematic: 'schematics/NOR.svg',
    schematicInfo: {
      description: 'Simple NOR gate schematic. Make sure to include decoupling capacitors close to the IC power pins to ensure stable operation. Use current-limiting resistors for the LEDs to prevent damage. 100k pulldown resistors on the inputs helps keep inputs in a defined state when not driven. 4.7k resistors are recommended for LED current limiting to ensure visibility without excessive current draw at 5-9V operation.',
      tips: 'Extra gates included for pinout reference.',
      bom: [
        { name: 'CD4001', quantity: 1, note: 'NOR Gate IC' },
        { name: 'LED', quantity: 1, note: 'Output indicator' },
        { name: '1k Resistor', quantity: 1, note: 'Output short protection' },
        { name: '4.7k Resistor', quantity: 1, note: 'LED current limiting resistor' },
        { name: '100k Resistor', quantity: 2, note: 'Input pulldown resistors' },
        { name: '100nF Capacitor', quantity: 1, note: '100nF decoupling' }
      ]
    }
  },
  'XOR': {
    title: 'XOR Gate (Exclusive OR)',
    description: 'Outputs 1 when inputs differ. A difference detector that produces 0 when inputs match.',
    tips: 'Use XOR gates for ring modulation effects or to create pseudo-random patterns with shift registers (LFSR configuration).',
    techDescription: 'Exclusive OR gate outputs HIGH when inputs differ. Essential for parity checking, arithmetic circuits, and LFSR-based random number generation.',
    truthTable: {
      inputs: ['A', 'B'],
      rows: [
        ['0', '0', '0'],
        ['0', '1', '1'],
        ['1', '0', '1'],
        ['1', '1', '0']
      ]
    },
    hardware: 'CD4070',
    schematic: 'schematics/XOR.svg',
    schematicInfo: {
      description: 'Simple XOR gate schematic. Make sure to include decoupling capacitors close to the IC power pins to ensure stable operation. Use current-limiting resistors for the LEDs to prevent damage. 100k pulldown resistors on the inputs helps keep inputs in a defined state when not driven. 4.7k resistors are recommended for LED current limiting to ensure visibility without excessive current draw at 5-9V operation.',
      tips: 'Extra gates included for pinout reference.',
      bom: [
        { name: 'CD4070', quantity: 1, note: 'XOR Gate IC' },
        { name: 'LED', quantity: 1, note: 'Output indicator' },
        { name: '1k Resistor', quantity: 1, note: 'Output short protection' },
        { name: '4.7k Resistor', quantity: 1, note: 'LED current limiting resistor' },
        { name: '100k Resistor', quantity: 2, note: 'Input pulldown resistors' },
        { name: '100nF Capacitor', quantity: 1, note: '100nF decoupling' }
      ]
    }
  },
  'XNOR': {
    title: 'XNOR Gate (Exclusive NOR)',
    description: 'Outputs 1 when inputs match. A similarity detector that produces 0 when inputs differ.',
    tips: 'Use XNOR gates to detect when two signals are synchronized or matching.',
    techDescription: 'Inverted XOR gate. Functions as an equality detector. output is HIGH when both inputs are equal.',
    truthTable: {
      inputs: ['A', 'B'],
      rows: [
        ['0', '0', '1'],
        ['0', '1', '0'],
        ['1', '0', '0'],
        ['1', '1', '1']
      ]
    },
    hardware: 'CD4077',
    schematic: 'schematics/XNOR.svg',
    schematicInfo: {
      description: 'Simple XNOR gate schematic. Make sure to include decoupling capacitors close to the IC power pins to ensure stable operation. Use current-limiting resistors for the LEDs to prevent damage. 100k pulldown resistors on the inputs helps keep inputs in a defined state when not driven. 4.7k resistors are recommended for LED current limiting to ensure visibility without excessive current draw at 5-9V operation.',
      tips: 'Extra gates included for pinout reference.',
      bom: [
        { name: 'CD4077', quantity: 1, note: 'XNOR Gate IC' },
        { name: 'LED', quantity: 1, note: 'Output indicator' },
        { name: '1k Resistor', quantity: 1, note: 'Output short protection' },
        { name: '4.7k Resistor', quantity: 1, note: 'LED current limiting resistor' },
        { name: '100k Resistor', quantity: 2, note: 'Input pulldown resistors' },
        { name: '100nF Capacitor', quantity: 1, note: '100nF decoupling' }
      ]
    }
  },
  'NOT': {
    title: 'NOT Gate (Inverter)',
    description: 'Inverts the input signal. Turns 1 into 0, and 0 into 1.',
    tips: 'Use NOT gates to invert control signals or create complementary patterns. Patch with feedback to produce stable ultra-sonic oscillation',
    techDescription: 'Single-input logic gate implementing logical negation. The simplest and most fundamental digital logic operation.',
    truthTable: {
      inputs: ['IN'],
      rows: [
        ['0', '1'],
        ['1', '0']
      ]
    },
    hardware: 'CD4069',
    schematic: 'schematics/NOT.svg',
    schematicInfo: {
      description: 'Simple NOT gate schematic. Make sure to include decoupling capacitors close to the IC power pins to ensure stable operation. Use current-limiting resistors for the LEDs to prevent damage. 100k pulldown resistors on the inputs helps keep inputs in a defined state when not driven. 4.7k resistors are recommended for LED current limiting to ensure visibility without excessive current draw at 5-9V operation.',
      tips: 'Extra gates included for pinout reference.',
      bom: [
        { name: 'CD4069', quantity: 1, note: 'NOT Gate IC' },
        { name: 'LED', quantity: 1, note: 'Output indicator' },
        { name: '1k Resistor', quantity: 1, note: 'Output short protection' },
        { name: '4.7k Resistor', quantity: 1, note: 'LED current limiting resistor' },
        { name: '100k Resistor', quantity: 2, note: 'Input pulldown resistors' },
        { name: '100nF Capacitor', quantity: 1, note: '100nF decoupling' }
      ]
    }
  },
  'Oscillator': {
    title: 'Oscillator',
    description: 'Generates a square wave that alternates between 0 and 1 at a controllable frequency.',
    tips: 'Use oscillators as audio sources or clock signals. Patch into binary counters to create lower octaves and rhythmic subdivisions.',
    techDescription: 'Schmitt trigger RC oscillator producing a square wave output. Inverter charges and discharges the timing capacitor through a resistor, with oscillation frequency set by the RC time constant.',
    hardware: 'CD40106 with resistor-capacitor network',
    schematic: 'schematics/oscillator.svg',
    schematicInfo: {
      description: 'Simple fixed Oscillator. Make sure to include decoupling capacitors close to the IC power pins to ensure stable operation. Use current-limiting resistors for the LEDs to prevent damage. RC formed by the potentiometer and C2 determines the frequency range. It is possible create six oscillators with the single IC by using the remaining inverters.',
      tips: 'Extra gates included for pinout reference.',
      bom: [
        { name: 'CD40106', quantity: 1, note: 'Hex Schmitt Trigger Inverter IC' },
        { name: 'LED', quantity: 1, note: 'Optional Output indicator' },
        { name: '1k Resistor', quantity: 2, note: 'Output short protection' },
        { name: '4.7k Resistor', quantity: 1, note: 'LED current limiting resistor' },
        { name: '100k Potentiometer', quantity: 1, note: 'Frequency control (RC resistor)' },
        { name: '100nF Capacitor', quantity: 1, note: '100nF decoupling' },
        { name: '10nF - 1µF Capacitor', quantity: 1, note: 'Sets frequency (RC capacitor)' },
      ]
    }
  },
  'Button': {
    title: 'Button',
    description: 'Manual control that outputs 1 when pressed, 0 when released. Can be assigned to keyboard keys.',
    tips: 'Use buttons as momentary gates, triggers, or performance controls. Combine with Flip-Flops to create toggle switches.',
    hardware: 'Mechanical momentary switch with pull-down resistor'
  },
  'Binary Counter': {
    title: 'Binary Counter',
    description: 'Divides the input clock signal by powers of 2. Each output represents a binary digit (bit) counting from the input.',
    tips: 'Use to create octave divisions for pitch, or slow down oscillators into rhythmic control signals. Higher numbered outputs produce lower frequencies.',
    techDescription: 'Ripple counter or synchronous counter with binary outputs. Each successive output divides frequency by 2 (Q0 ÷2, Q1 ÷4, Q2 ÷8, etc.).',
    hardware: 'CD4040',
    schematic: 'schematics/binary_counter.svg',
    schematicInfo: {
      description: 'Make sure to include decoupling capacitors close to the IC power pins to ensure stable operation. Use current-limiting resistors for the LEDs to prevent damage. NPN transistor Q1 and resistors R5, R7, and R8 form an RTL inverter to trigger clock on rising edge instead of falling edge.',
      tips: 'Continue the pattern of the Q0-Q7 outputs for outputs Q8-Q11 if more outputs are needed.',
      bom: [
        { name: 'CD4040', quantity: 1, note: '12-bit Binary Counter IC' },
        { name: 'LED', quantity: 8, note: 'Output indicators' },
        { name: '1k Resistor', quantity: 8, note: 'Output short protection' },
        { name: '4.7k Resistor', quantity: 8, note: 'LED current limiting resistor' },
        { name: '100k Resistor', quantity: 2, note: 'Input pulldown resistor' },
        { name: '47k Resistor', quantity: 1, note: 'RTL inverter' },
        { name: '10k Resistor', quantity: 1, note: 'Transistor input' },
        { name: '2n3904', quantity: 1, note: 'NPN for RTL inverter' },
        { name: '100nF Capacitor', quantity: 1, note: '100nF decoupling' },
      ]
    }
  },
  'Ring Counter': {
    title: 'Ring Counter',
    description: 'Counts from 0 to 8, with outputs stepping sequentially. Can reset at any step to create different cycle lengths.',
    tips: 'Use for rhythmic subdivisions, sequencing, or creating subharmonics. Patch different outputs to reset for varied patterns (e.g., patch output 3 to reset for a 3-step sequence).',
    techDescription: 'Johnson counter or decoded decade counter with sequential active outputs. Reset input allows variable modulo counting (2-10 steps).',
    hardware: 'CD4017 (decade counter)',
    schematic: 'schematics/ring_counter.svg',
    schematicInfo: {
      description: 'The CD4017 decade counter advances its output with each clock pulse. Make sure to include decoupling capacitors close to the IC power pins to ensure stable operation. Use current-limiting resistors for the LEDs to prevent damage. 100k pulldown resistors on the clock and reset inputs helps keep inputs in a defined state when not driven. 4.7k resistors are recommended for LED current limiting to ensure visibility without excessive current draw at 5-9V operation.',
      tips: 'Try patching different outputs to the reset input to create custom cycle lengths (e.g., patch output 3 to reset for a 3-step sequence). Combine with a multiplexer or hardware switches to select different reset points on the fly.',
      bom: [
        { name: 'CD4017', quantity: 1, note: 'Decade Counter IC' },
        { name: 'LEDs', quantity: 8, note: 'Output indicators' },
        { name: '1k Resistor', quantity: 8, note: 'Output short protection' },
        { name: '4.7k Resistor', quantity: 8, note: 'LED current limiting resistor' },
        { name: '100k Resistor', quantity: 2, note: 'Input pulldown resistors' },
        { name: '100nF Capacitor', quantity: 1, note: '100nF decoupling' }
      ]
    }
  },
  'Shift Register': {
    title: 'Shift Register (SIPO)',
    description: 'An 8-bit memory that shifts data through its outputs with each clock pulse. The data input determines what enters the register.',
    tips: 'Create pseudo-random patterns by patching an XOR gate from outputs back to input (LFSR). Loop patterns by patching Q7 to DATA. Use for evolving sequences and generative patterns.',
    techDescription: 'Serial-in parallel-out (SIPO) 8-bit shift register.',
    hardware: 'CD4015',
    schematic: 'schematics/shift_register.svg',
    schematicInfo: {
      description: 'Chain two 4-bit registers to make an 8-bit register if desired. Make sure to include decoupling capacitors close to the IC power pins to ensure stable operation. Use current-limiting resistors for the LEDs to prevent damage. 100k pulldown resistors on the data and reset inputs helps keep inputs in a defined state when not driven. 4.7k resistors are recommended for LED current limiting to ensure visibility without excessive current draw at 5-9V operation. RTL inverter is formed by R1, R2, and R3, with Q1 as the NPN transistor. This ensures clock triggers on the rising edge instead of falling edge.',
      tips: 'Try patching output Q7 back to the DATA input through XOR gates to create a linear feedback shift register (LFSR) for pseudo-random pattern generation. Alternatively, patch Q7 directly to DATA to create looping patterns.',
      bom: [
        { name: 'CD4015', quantity: 1, note: 'Dual 4-bit Shift Register IC' },
        { name: 'LEDs', quantity: 8, note: 'Output indicators' },
        { name: '1k Resistor', quantity: 8, note: 'Output short protection' },
        { name: '4.7k Resistor', quantity: 8, note: 'LED current limiting resistor' },
        { name: '100k Resistor', quantity: 2, note: 'Input pulldown resistors' },
        { name: '10k Resistor', quantity: 1, note: 'Transistor input' },
        { name: '47k Resistor', quantity: 1, note: 'RTL Inverter' },
        { name: '100nF Capacitor', quantity: 1, note: '100nF decoupling' }
      ]
    }
  },
  'Shift Register (PISO)': {
    title: 'Shift Register (PISO)',
    description: 'An 8-bit latch that loads all inputs at once, then shifts data out one bit per clock pulse. Useful for turning parallel signals into a serial stream.',
    tips: 'Use LOAD (LD) to latch a full 8-bit snapshot, then drive CLK to stream the bits out MSB-first (D7 shifts out of the register first). Great for pattern playback, timed triggers, or serial data transmission.',
    techDescription: 'Parallel-in serial-out (PISO) 8-bit shift register. Loads D0–D7 on LOAD high; Shifts on rising clock edge with the MSB appearing at the output.',
    hardware: 'CD4021B'
  },
  'Binary Rate Multiplier': {
    title: 'Binary Rate Multiplier',
    description: 'Outputs pulses at a rate determined by the binary number present at its inputs. Creates rhythmic subdivisions based on binary counting.',
    tips: 'Use to create complex polyrhythms and harmonics ratios based on the input clock. Different input combinations produce different pulse rates. For evenly distributed clock pulses use a high clock input speed and average the output using a binary counter.',
    techDescription: 'Digital frequency divider where output rate = input rate × (N/16), where N is the binary input value (0-16). Enables fractional division through uneven pulse trains, which when averaged produce even results.',
    hardware: 'CD4089'
  },
  'Multiplexer': {
    title: 'Multiplexer (8-to-1 MUX)',
    description: 'Selects one of 8 inputs to route to the output. The selection is determined by the binary number at inputs A, B, and C.',
    tips: 'Use for sequential switching when driven by a binary counter, or for pattern selection. Inputs 0-7 can hold different signals or patterns.',
    techDescription: 'Data selector with 8 inputs and 3-bit address lines (A, B, C). Output = Input[ABC], where ABC forms a 3-bit binary address (0-7).',
    hardware: 'CD4051',
    schematic: 'schematics/multiplexer.svg',
    schematicInfo: {
      description: "CD4051 8-to-1 analog/digital multiplexer. All input channels (X0-X7) include 100k pulldown resistors to ensure defined state when unpatched. Address lines A, B, C also include 100k pulldowns. Output includes a 1k resistor for short protection and a 4.7k resistor to drive the LED indicator. Include a 100nF decoupling capacitor close to the IC.",
      tips: "Drive A/B/C with a binary counter to step through inputs rhythmically. CD4051 is bidirectional and analog, so it is possible to switch any signals so long as they respect the rail voltages.",
      bom: [
        { "name": "CD4051", "quantity": 1, "note": "8-to-1 multiplexer" },
        { "name": "100k Resistor", "quantity": 11, "note": "Input pulldown resistors" },
        { "name": "1k Resistor", "quantity": 1, "note": "Output short protection" },
        { "name": "4.7k Resistor", "quantity": 1, "note": "LED current limiting" },
        { "name": "LED", "quantity": 1, "note": "Output indicator" },
        { "name": "100nF Capacitor", "quantity": 1, "note": "Decoupling capacitor" }
      ]
    }
  },
  'Demultiplexer': {
    title: 'Demultiplexer (1-to-8 DMUX)',
    description: 'Routes the input (IN) to one of the 8 outputs. The selection is determined by the binary number at inputs A, B, and C.',
    tips: 'Use for sequential switching when driven by a binary counter, or for pattern selection.',
    techDescription: 'Data selector with 8 outputs and 3-bit address lines (A, B, C). Output[ABC] = Input, where ABC forms a 3-bit binary address (0-7).',
    hardware: 'CD4051',
    schematic: 'schematics/demultiplexer.svg',
    schematicInfo: {
      description: "CD4051 used as a 1-to-8 demultiplexer. Input IN has a 100k pulldown. Address lines A, B, C each have 100k pulldown resistors. All eight outputs include a 1k resistor for short protection and a 4.7k resistor to drive an LED indicator. Include 100nF decoupling capacitor close to the IC.",
      tips: "Use a binary counter on A/B/C to step a signal through outputs for sequencing or rhythmic routing.",
      bom: [
        { "name": "CD4051", "quantity": 1, "note": "1-to-8 demultiplexer" },
        { "name": "100k Resistor", "quantity": 4, "note": "Input pulldown for IN + A/B/C" },
        { "name": "1k Resistor", "quantity": 8, "note": "Output short protection" },
        { "name": "4.7k Resistor", "quantity": 8, "note": "LED current limiting" },
        { "name": "LED", "quantity": 8, "note": "Output indicators" },
        { "name": "100nF Capacitor", "quantity": 1, "note": "Decoupling" }
      ]
    }
  },
  'Flip-Flop': {
    title: 'Flip-Flop (D-Type)',
    description: 'A 1-bit memory that captures and holds the input state when triggered by the clock signal.',
    tips: 'Use to sample and hold signals, create rhythm variations, or build toggle switches. The output only changes when clocked.',
    techDescription: 'Edge-triggered D-type flip-flop. Output Q captures input D on rising clock edge and holds value until next clock. Fundamental building block of digital memory.',
    truthTable: {
      inputs: ['D', 'CLK'],
      rows: [
        ['0', '↑', '0'],
        ['1', '↑', '1'],
        ['X', '0', 'Q']
      ]
    },
    hardware: 'CD4013',
    schematic: 'schematics/flip-flop.svg',
    schematicInfo: {
      description: "CD4013 dual D-type flip-flop. Inputs D and CLK include 100k pulldown resistors to guarantee stable idle states. Outputs Q and Q' include a 1k resistor for short protection and a 4.7k resistor to drive LED indicators. Include 100nF decoupling capacitor near the IC for stability.",
      tips: "Use to sample logic levels, build toggles, or divide clocks by 2. Chain Q' → D for latching patterns.",
      bom: [
        { "name": "CD4013", "quantity": 1, "note": "Dual D-type flip-flop" },
        { "name": "100k Resistor", "quantity": 2, "note": "Input pulldown for D and CLK" },
        { "name": "1k Resistor", "quantity": 2, "note": "Output short protection" },
        { "name": "4.7k Resistor", "quantity": 2, "note": "LED current limiting" },
        { "name": "LED", "quantity": 2, "note": "Output indicators" },
        { "name": "100nF Capacitor", "quantity": 1, "note": "Decoupling" }
      ]
    }
  },
  'Noise': {
    title: 'Noise Generator',
    description: 'Generates random binary values (0 or 1) at audio rate. Pure digital noise source.',
    tips: 'Use as a chaotic trigger source or as raw noise audio. Combine with gates to create filtered noise or probability-based triggers.',
    techDescription: 'Maximal-length LFSR generating pseudo-random binary sequence.',
    hardware: 'Linear Feedback Shift Register (LFSR) circuit',
    schematic: 'schematics/noise.svg',
    schematicInfo: {
      description: "16-bit LFSR circuit. Any shift register will work, inverting the data input ensures the register starts with some data.",
      tips: "Chain together more registers (with appropriate taps) for a longer noise sequence.",
      bom: [
        { "name": "CD4015", "quantity": 2, "note": "Dual 4-bit Shift Register" },
        { "name": "CD40106", "quantity": 1, "note": "Schmitt trigger inverter" },
        { "name": "CD4077", "quantity": 1, "note": "Quad XOR gate" },
        { "name": "1k Resistor", "quantity": 1, "note": "Output short protection" },
        { "name": "100nF Capacitor", "quantity": 4, "note": "Decoupling" },
        { "name": "10nF Capacitor", "quantity": 1, "note": "Oscillator timing" }
      ]
    }
  },
  'Output': {
    title: 'Audio Output',
    description: 'The final output module. Routes all patched signals to your speakers/headphones. Only one output module allowed per patch.',
    tips: 'All audio paths must eventually connect to the output. Use logic gates to combine multiple sources. Inputs A, B, C, and D are mixed.',
    techDescription: 'A four channel mixer can be implemented using two op-amps as a summing circuit',
    hardware: 'Dual Op-Amp (e.g. LM358 or TL072)',
    schematic: 'schematics/output.svg',
    schematicInfo: {
      description: "Unity gain mixer circuit with 4 inputs. All inputs are AC coupled to the buffered virtual ground circuit, which is also used as the ground reference in the non-inverting input of the op-amps. Use audio-taper potentiometers for best results on input levels. Place decoupling capacitors physically close to the IC power pins. 1k resistor on output is for short protection.",
      tips: "Gain of the mixer is set by R6, where decreasing its value will increase gain and increasing its value will decrease gain.",
      bom: [
        { "name": "LM324", "quantity": 1, "note": "Quad op-amp" },
        { "name": "1k Resistor", "quantity": 1, "note": "Output short protection" },
        { "name": "100k Resistor", "quantity": 10, "note": "Various uses" },
        { "name": "100nF Capacitor", "quantity": 3, "note": "Decoupling" },
        { "name": "1uF Capacitor", "quantity": 1, "note": "AC coupling" },
        { "name": "10uF Capacitor", "quantity": 2, "note": "Vgnd decoupling" },
        { "name": "100k Potentiometer", "quantity": 4, "note": "Input levels" },
      ]
    }
  },
  'Oscilloscope': {
    title: 'Oscilloscope',
    description: 'Visual display of the input signal over time. Shows the waveform as it changes.',
    tips: 'Use to visualize signal patterns, debug patches, or understand how modules interact. Great for seeing rhythm and timing relationships.',
    hardware: 'ADC + display controller (e.g., microcontroller with LCD/OLED)'
  },
  'EEPROM': {
    title: 'EEPROM (16x8 Memory)',
    description: 'A small 16-address, 8-bit memory module. Outputs data from one of 16 memory locations based on the 4-bit address. Data appears on the 8-bit outputs when CE is LOW (or unconnected). Pressing the program button opens a menu where all 16 bytes can be edited bit-by-bit.',
    tips: 'Use EEPROM to store specific arbitrary patterns or sequences. Combine with counters for stepped playback, or patch logic signals into the address lines for dynamic pattern recall.',
    techDescription: 'A 16×8 electrically erasable read-only memory.',
    hardware: 'Parallel EEPROM (conceptually similar to 28C16, scaled down to 16×8)'
  },
  'BCD to 7-Segment': {
    title: '7-Segment Decoder',
    description: 'Converts a 4-bit binary number into the correct 7-segment pattern to display digits 0–9.',
    tips: 'Use with a counter or shift register to show numbers. Patch binary signals into inputs A–D and connect the segment outputs (a–g) to a 7-seg display. Binary inputs above 1001 (9) will result in a hex (A-F) output.',
    techDescription: 'BCD to 7-segment decoder/driver. Takes a binary value and outputs corresponding logic levels for each segment (a–g). Includes latch (LT) input that locks output states when HIGH.',
    hardware: 'CD4511B BCD to 7-Segment Decoder / Driver (NB: does not decode hex values in hardware)'
  },
  '7-Segment Display': {
    title: '7-Segment Display',
    description: 'Visual display that shows digits using seven LEDs (a–g). Each segment lights up when its input is HIGH. Commonly used with the 7-Segment Decoder.',
    tips: 'Drive segments manually or let a decoder (BCD to 7-Segment) do the work. Use a binary counter + decoder to show numbers increasing automatically.',
    techDescription: 'Seven individual LED segments arranged to form digits. Segments are named a–g.',
    hardware: 'Standard LED 7-segment display'
  }
};

// Initialize dictionary system
function initDictionary() {
  const dictionaryButton = document.getElementById('module-info-button');
  const closeButton = document.getElementById('dictionary-close-btn');
  const textBox = document.getElementById('dictionary-text-box');

  if (dictionaryButton) {
    dictionaryButton.addEventListener('click', toggleDictionary);
  }

  if (closeButton) {
    closeButton.addEventListener('click', closeDictionary);
  }

  // Schematic Close Button
  const schematicCloseBtn = document.getElementById('schematicCloseBtn');
  if (schematicCloseBtn) {
    schematicCloseBtn.addEventListener('click', closeSchematic);
  }

  // Add event delegation for pagination buttons on the stable container
  if (textBox) {
    textBox.addEventListener('click', (e) => {

      const button = e.target.closest('.dictionary-page-btn');

      if (!button) {
        return;
      }

      // CRITICAL: Stop propagation immediately
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation(); // Add this!


      if (button.disabled) {
        return;
      }

      if (button.innerHTML.includes('Previous')) {
        if (currentDictionaryPage > 0) {
          currentDictionaryPage--;
          updateDictionaryContent();
        }
      } else if (button.innerHTML.includes('Next')) {
        const maxPages = 5;
        if (currentDictionaryPage < maxPages - 1) {
          currentDictionaryPage++;
          updateDictionaryContent();
        }
      }
    });
  }


  document.addEventListener('selectionChanged', updateDictionaryButton);
}

// Update dictionary button and content based on selection
function updateDictionaryButton() {
  const dictionaryButton = document.getElementById('module-info-button');
  if (!dictionaryButton) return;

  // Button is always visible (no display change)

  // If dictionary mode is active and exactly one module is selected, open dictionary
  if (dictionaryActive && selectedModules.size === 1) {
    // openDictionary();
  } else if (dictionaryActive && selectedModules.size === 0) {
    // If dictionary mode is active but selection is not exactly one, close it
    // closeDictionary();
  }
}

// Toggle dictionary mode
function toggleDictionary() {
  const dictionaryButton = document.getElementById('module-info-button');

  dictionaryActive = !dictionaryActive;

  // Update button active state
  if (dictionaryActive) {
    dictionaryButton.classList.add('active');
    // If exactly one module is selected, open dictionary
    // if (selectedModules.size >= 1) {
    openDictionary();
    // }
  } else {
    dictionaryButton.classList.remove('active');
    closeDictionary();
  }
}

// Open dictionary
function openDictionary() {
  if (tutorialActive) {
    closeDictionary();
    return;
  }
  const textBox = document.getElementById('dictionary-text-box');
  if (!textBox) return;

  textBox.classList.add('active');

  // Populate with current selection info
  updateDictionaryContent();
}

// Close dictionary
function closeDictionary() {

  const textBox = document.getElementById('dictionary-text-box');
  if (!textBox) return;

  textBox.classList.remove('active');

  const dictionaryButton = document.getElementById('module-info-button');

  dictionaryActive = false;
  dictionaryButton.classList.remove('active');
}

// Update dictionary content based on selection
function updateDictionaryContent() {
  const textElement = document.getElementById('dictionary-text');
  if (!textElement) return;

  textElement.innerHTML = '';

  // Handle different selection states
  if (selectedModules.size === 0) {
    renderMultipleSelection(textElement);
  } else if (selectedModules.size === 1) {
    const moduleId = Array.from(selectedModules)[0];
    const module = modules.find(m => m.id === moduleId);
    if (module) {
      renderModuleInfo(textElement, module);
    }
  } else {
    renderMultipleSelection(textElement);
  }
}

// Render info for no selection
function renderNoSelection(container) {
  const title = document.createElement('div');
  title.className = 'dictionary-title';
  title.textContent = 'No Module Selected';
  container.appendChild(title);

  const description = document.createElement('div');
  description.className = 'dictionary-description';
  description.textContent = 'Select a single module to view its information.';
  container.appendChild(description);
}

let currentDictionaryPage = 0;

// Render info for multiple selection
function renderMultipleSelection(container) {
  const currentPage = currentDictionaryPage;

  // Define pages
  const pages = [
    {
      title: 'Canvas Editor',
      description: 'A visual patching environment for digital logic synthesis. Connect modules with patch cables to create audio circuits. Select a module to view info about it.',
      sectionTitle: 'Basic Controls',
      sectionIcon: `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
        <path fill="currentColor" d="M12 17q.425 0 .713-.288T13 16t-.288-.712T12 15t-.712.288T11 16t.288.713T12 17m-1-4h2V7h-2zm1 9q-2.075 0-3.9-.788t-3.175-2.137T2.788 15.9T2 12t.788-3.9t2.137-3.175T8.1 2.788T12 2t3.9.788t3.175 2.137T21.213 8.1T22 12t-.788 3.9t-2.137 3.175t-3.175 2.138T12 22" />
      </svg>`,
      content: `
        <strong>Click/Tap port:</strong> Start patch connection<br>
        <strong>Click/Tap module:</strong> Select modules or connections<br>
        <strong>Drag:</strong> Move selected modules or pan canvas<br>
        <strong>Cmd/ctrl + Drag:</strong> Multi-select modules or connections<br>
      `
    },
    {
      title: 'Hotkeys and Shortcuts',
      description: 'A visual patching environment for digital logic synthesis. Connect modules with patch cables to create audio circuits. Select a module to view info about it.',
      sectionTitle: 'Hotkeys',
      sectionIcon: `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
        <path fill="currentColor" d="M19 10h-6V4h-2v6H5v2h6v6h2v-6h6z"/>
      </svg>`,
      content: `
        <strong>Delete/Backspace:</strong> Delete selected modules or connections<br>
        <strong>Ctrl/Cmd + A:</strong> Select all modules<br>
        <strong>Ctrl/Cmd + Z:</strong> Undo<br>
        <strong>Shift Ctrl/Cmd + Z:</strong> Redo<br>
        <strong>Ctrl/Cmd + C:</strong> Copy<br>
        <strong>Ctrl/Cmd + X:</strong> Cut<br>
        <strong>Ctrl/Cmd + V:</strong> Paste<br>
        <strong>Ctrl/Cmd + 0:</strong> Fit patch to view<br>
        <strong>Shift Ctrl/Cmd + 0:</strong> Fit selection to view<br>
        <strong>Escape:</strong> Exit selection tool or menus<br>
        <strong>Tab:</strong> Switch to/from performance mode
      `
    },
    {
      title: 'Module Shortcuts',
      description: 'A visual patching environment for digital logic synthesis. Connect modules with patch cables to create audio circuits. Select a module to view info about it.',
      sectionTitle: 'Module Creation Shortcuts',
      sectionIcon: `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
        <path fill="currentColor" d="M19 10h-6V4h-2v6H5v2h6v6h2v-6h6z"/>
      </svg>`,
      content: `
        <strong>Shift + Q</strong> Oscillator<br>
        <strong>Shift + E:</strong> Noise<br>
        <strong>Shift + W:</strong> Output<br>
        <strong>Shift + B:</strong> Button<br>
        <strong>Shift + F</strong> Flip-Flop<br>
        <strong>Shift + C:</strong> Binary Counter<br>
        <strong>Shift + R:</strong> Shift Register<br>
        <strong>Shift + D:</strong> Ring Counter<br>
        <strong>Shift + T:</strong> Binary Rate Multiplier<br>
        <strong>Shift + X:</strong> Multiplexer<br>
        <strong>Shift + 1-7:</strong> Logic Gates<br>
      `
    },
    {
      title: 'Performance Mode',
      description: '',
      sectionTitle: 'Using Performance Mode',
      sectionIcon: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" style="transform: rotate(45deg) translateY(0px) translateX(0px);">
                    <path fill="currentColor"
                      d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10s10-4.5 10-10S17.5 2 12 2m1 8h-2V4.1c.3-.1.7-.1 1-.1s.7 0 1 .1z" />
                    </svg>`,
      content: `Performance mode is accessed with the 
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" style="transform: rotate(45deg) translateY(0px) translateX(0px);">
                  <path fill="currentColor"
                    d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10s10-4.5 10-10S17.5 2 12 2m1 8h-2V4.1c.3-.1.7-.1 1-.1s.7 0 1 .1z" />
                </svg>
                 button. <br><br>
                In performance mode, you can access the buttons and oscillators present in your patch, as well as two built in effects. 
                If no buttons/oscillators are assigned, performance mode will auto-populate.  <br><br> 
                Otherwise, press
                <svg width="16" height="16" viewBox="0 0 24 24" version="1.1" id="svg1" style="transform: translateY(3px) translateX(2px);" sodipodi:docname="mdi--knob.svg"
                  xml:space="preserve" inkscape:version="1.3 (0e150ed, 2023-07-21)"
                  xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
                  xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd" xmlns="http://www.w3.org/2000/svg"
                  xmlns:svg="http://www.w3.org/2000/svg">
                  <defs id="defs1" />
                  <path fill="currentColor" id="path1" style="display:inline;stroke-width:0.877808"
                    d="m 9.2402344,0.48828125 c -2.2500446,0 -4.5001011,0.85361695 -6.2070313,2.56054685 -3.41386038,3.4138611 -3.41386027,9.0002009 0,12.4140629 2.2209302,2.220928 5.3592407,2.991183 8.2226559,2.322265 -0.03998,-0.08453 -0.07819,-0.169893 -0.109375,-0.257812 -0.02963,-0.08722 -0.06001,-0.171073 -0.09375,-0.257813 -0.0458,-0.133996 -0.08785,-0.270018 -0.11914,-0.408203 -0.04627,-0.187935 -0.08638,-0.379146 -0.07031,-0.574219 0.0066,-0.13683 0.01694,-0.272612 0.03711,-0.408203 0.02622,-0.173171 0.06061,-0.344481 0.09766,-0.515625 0.03983,-0.178912 0.08609,-0.356943 0.128906,-0.535156 0.03944,-0.163362 0.07475,-0.327641 0.136719,-0.484375 0.04763,-0.123483 0.09732,-0.245941 0.15039,-0.367188 0.0603,-0.134079 0.126576,-0.265609 0.197266,-0.394531 0.06393,-0.122756 0.127476,-0.246391 0.191406,-0.36914 0.07147,-0.141834 0.141715,-0.284491 0.234375,-0.414063 0.0849,-0.11996 0.169772,-0.241349 0.269532,-0.349609 0.118252,-0.119692 0.241089,-0.236234 0.367187,-0.347657 0.125842,-0.11057 0.245606,-0.226245 0.378906,-0.328124 0.09565,-0.07392 0.194233,-0.145704 0.289063,-0.220704 0.102311,-0.07397 0.206431,-0.142482 0.318359,-0.201172 0.09303,-0.05272 0.188278,-0.103087 0.285156,-0.148437 0.07606,-0.03718 0.152896,-0.07324 0.228516,-0.111328 0.03226,-0.01228 0.06802,-0.04167 0.09766,-0.05859 0.07869,-0.04492 0.159271,-0.08691 0.244141,-0.119141 0.112182,-0.04384 0.22659,-0.08466 0.34375,-0.113281 0.120676,-0.02836 0.2368,-0.07384 0.361328,-0.08594 0.115948,-0.01906 0.232345,-0.03923 0.349609,-0.04883 0.04975,-0.0027 0.09875,-0.0047 0.148438,-0.0059 0.04969,-0.0011 0.100571,-0.0016 0.150391,0 0.07863,0.0011 0.157768,0.0023 0.236328,0.0059 0.120958,0.0059 0.240688,0.01479 0.361328,0.02539 0.162182,0.0133 0.323582,0.02209 0.486328,0.02539 0.170436,0.0074 0.341123,0.02078 0.511719,0.02148 h 0.371094 c 0.01204,0 0.02326,0.0018 0.03516,0.002 C 18.331868,8.0254503 17.531192,5.1327556 15.447266,3.0488281 13.740334,1.3418978 11.490279,0.48828125 9.2402344,0.48828125 Z M 13.521484,3.7324219 c 0.248282,0.1241396 0.497383,0.3723832 0.683594,0.5585937 0.186211,0.1862107 0.434453,0.4333595 0.558594,0.6816406 L 11.101562,8.6347656 9.859375,7.3945312 Z" />
                  <path fill="currentColor"
                    d="m 16.035466,11.338924 c 2.598776,0 4.713264,2.114488 4.713264,4.713264 0,2.598776 -2.114488,4.713264 -4.713264,4.713264 -2.598776,0 -4.713264,-2.114488 -4.713264,-4.713264 0,-2.598776 2.114488,-4.713264 4.713264,-4.713264 m 0,-1.178316 c -3.25392,0 -5.89158,2.63766 -5.89158,5.89158 0,3.25392 2.63766,5.89158 5.89158,5.89158 3.25392,0 5.89158,-2.63766 5.89158,-5.89158 0,-3.25392 -2.63766,-5.89158 -5.89158,-5.89158 m 2.94579,5.302422 h -2.356632 v -2.356632 h -1.178316 v 2.356632 h -2.356632 v 1.178316 h 2.356632 v 2.356632 h 1.178316 v -2.356632 h 2.356632 z"
                    id="path1-3" style="stroke-width:0.589158" sodipodi:insensitive="true" />
                </svg> 
                and click on up to six buttons and oscillators to assign them. <br><br>
                
                The <strong> link </strong> and <strong> FX link </strong> buttons toggle whether performance mode changes effect the current patch. If the links are not on, then performance mode tweaks are superficial changes that don't effect the base patch.`,
      useInnerHTML: true
    },
    {
      title: 'Module Designer',
      description: '',
      sectionTitle: 'Using Module Designer',
      sectionIcon: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 36 36">
                      <path fill="currentColor"
                        d="M34.87 32.21L30 27.37V8.75l-2.3-4.23a2 2 0 0 0-3.54 0L22 8.76v10.65L3.71 1.21A1 1 0 0 0 2 1.92V10h2.17v1.6H2V18h2.17v1.6H2v6.65h2.17v1.6H2v5.07a1 1 0 0 0 1 1h31.16a1 1 0 0 0 .71-1.71M10 26v-9.06L19.07 26Zm18 2.11h-4v-2.43h4Zm0-4h-4V9.25l1.94-3.77L28 9.26Z"
                        class="clr-i-solid clr-i-solid-path-1" />
                      <path fill="none" d="M0 0h36v36H0z" />
                    </svg>`,
      content: `Module Designer is accessed with the 
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 36 36" translateY(0px) translateX(0px);>
                  <path fill="currentColor"
                    d="M34.87 32.21L30 27.37V8.75l-2.3-4.23a2 2 0 0 0-3.54 0L22 8.76v10.65L3.71 1.21A1 1 0 0 0 2 1.92V10h2.17v1.6H2V18h2.17v1.6H2v6.65h2.17v1.6H2v5.07a1 1 0 0 0 1 1h31.16a1 1 0 0 0 .71-1.71M10 26v-9.06L19.07 26Zm18 2.11h-4v-2.43h4Zm0-4h-4V9.25l1.94-3.77L28 9.26Z"
                    class="clr-i-solid clr-i-solid-path-1" />
                  <path fill="none" d="M0 0h36v36H0z" />
                </svg>
                 button. <br><br>
                In the designer, you can create your own custom modules by combining existing modules into a single unit. Modules created there will appear in the <strong>Custom Modules</strong> menu in the <strong>User</strong> tab of the module menu. <br><br>
                You can add inputs and outputs to your custom modules, name the module, provide a description, and include buttons and oscillators on the module interface. <br><br>
                To edit an existing custom module, click the edit icon in the <strong>Custom Modules</strong> menu.`,
      useInnerHTML: true
    }
  ];

  const page = pages[currentPage];

  // Title
  const title = document.createElement('div');
  title.className = 'dictionary-title';
  title.textContent = page.title;
  container.appendChild(title);

  // Description
  const description = document.createElement('div');
  description.className = 'dictionary-description';
  if (page.useInnerHTML) {
    description.innerHTML = page.description;
  } else {
    description.textContent = page.description;
  }
  container.appendChild(description);

  // Section
  const sectionContainer = document.createElement('div');
  sectionContainer.className = 'dictionary-section';

  const sectionTitle = document.createElement('div');
  sectionTitle.className = 'dictionary-section-title';
  sectionTitle.innerHTML = `${page.sectionIcon} ${page.sectionTitle}`;
  sectionContainer.appendChild(sectionTitle);

  const contentDiv = document.createElement('div');
  contentDiv.className = 'dictionary-tips';
  if (page.useInnerHTML) {
    contentDiv.innerHTML = page.content;
  } else {
    contentDiv.innerHTML = page.content;
  }
  sectionContainer.appendChild(contentDiv);

  // Pagination controls
  const paginationDiv = document.createElement('div');
  paginationDiv.className = 'dictionary-pagination';

  // Previous button - NO EVENT LISTENERS HERE
  const prevButton = document.createElement('button');
  prevButton.className = 'dictionary-page-btn';
  prevButton.innerHTML = '← Previous';
  prevButton.disabled = currentPage === 0;

  // Page indicator
  const pageIndicator = document.createElement('span');
  pageIndicator.className = 'dictionary-page-indicator';
  pageIndicator.textContent = `${currentPage + 1} / ${pages.length}`;

  // Next button - NO EVENT LISTENERS HERE
  const nextButton = document.createElement('button');
  nextButton.className = 'dictionary-page-btn';
  nextButton.innerHTML = 'Next →';
  nextButton.disabled = currentPage === pages.length - 1;

  paginationDiv.appendChild(prevButton);
  paginationDiv.appendChild(pageIndicator);
  paginationDiv.appendChild(nextButton);

  sectionContainer.appendChild(paginationDiv);
  container.appendChild(sectionContainer);
}


// Render module information
function renderModuleInfo(container, module) {
  let info = moduleInfo[module.type];

  // Check if this is a custom module
  if (!info && customModuleDefinitions && customModuleDefinitions[module.type]) {
    const customDef = customModuleDefinitions[module.type];
    info = {
      title: customDef.name,
      description: 'User-created module that combines multiple components.',
      tips: 'Custom modules can be edited in the Module Designer. Click the edit icon in the Custom Modules menu to modify this module.',
      techDescription: customDef.definition,
      hardware: `Custom module with ${customDef.modules ? customDef.modules.length : 0} internal components.`
    };
  }

  if (!info) {
    const title = document.createElement('div');
    title.className = 'dictionary-title';
    title.textContent = module.type;
    container.appendChild(title);

    const description = document.createElement('div');
    description.className = 'dictionary-description';
    description.textContent = 'Information not available for this module type.';
    container.appendChild(description);
    return;
  }

  // Title
  const title = document.createElement('div');
  title.className = 'dictionary-title';
  title.textContent = info.title;
  container.appendChild(title);

  // Description
  const description = document.createElement('div');
  description.className = 'dictionary-description';
  description.textContent = info.description;
  container.appendChild(description);

  // Tips section
  if (info.tips) {
    const tipsContainer = document.createElement('div');
    tipsContainer.className = 'dictionary-section';

    const tipsTitle = document.createElement('div');
    tipsTitle.className = 'dictionary-section-title';
    tipsTitle.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
      <path fill="currentColor" d="M12 17q.425 0 .713-.288T13 16t-.288-.712T12 15t-.712.288T11 16t.288.713T12 17m-1-4h2V7h-2zm1 9q-2.075 0-3.9-.788t-3.175-2.137T2.788 15.9T2 12t.788-3.9t2.137-3.175T8.1 2.788T12 2t3.9.788t3.175 2.137T21.213 8.1T22 12t-.788 3.9t-2.137 3.175t-3.175 2.138T12 22" />
    </svg> Tips`;
    tipsContainer.appendChild(tipsTitle);

    const tips = document.createElement('div');
    tips.className = 'dictionary-tips';
    tips.textContent = info.tips;
    tipsContainer.appendChild(tips);

    container.appendChild(tipsContainer);
  }

  // Technical section
  if (info.truthTable || info.hardware) {
    const techContainer = document.createElement('div');
    techContainer.className = 'dictionary-section';

    // Section title
    const techTitle = document.createElement('div');
    techTitle.className = 'dictionary-section-title';
    techTitle.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
	<path fill="currentColor" d="M4.86 4.03L2.03 6.86l3.18 3.18v2.83l1.42 1.41l5.65-5.65l-1.41-1.42H8.04zM17 6v1.5c1 0 1.85.83 1.85 1.85S18 11.2 17 11.2v1.5c2.24 0 4 1.83 4 4.07V21h1.5v-4.24c0-2.22-1.28-4.14-3.15-5.03c.62-.61 1-1.45 1-2.38C20.35 7.5 18.85 6 17 6m-5.07 5.1L9.1 13.93l4.95 4.95l.71-.71l2.12 2.12L19 21l-.71-2.12l-2.12-2.12l.71-.71z" />
</svg> Technical`;
    techContainer.appendChild(techTitle);

    // Technical description (if applicable)
    if (info.techDescription) {
      const techDescription = document.createElement('div');
      techDescription.className = 'dictionary-tech-description';
      techDescription.textContent = info.techDescription;
      techContainer.appendChild(techDescription);
    }

    // Flex container for truth table + hardware
    const technical = document.createElement('div');
    technical.className = 'dictionary-technical';
    // default CSS should use display: flex; flex-direction: row;
    // but you can dynamically change to column if only one exists
    if (!(info.truthTable && info.hardware)) {
      technical.style.flexDirection = 'column';
    }

    // --- Truth Table subsection ---
    if (info.truthTable) {
      const truthDiv = document.createElement('div');
      truthDiv.className = 'technical-subsection truth-table-section';

      const truthTableTitle = document.createElement('div');
      truthTableTitle.className = 'dictionary-subsection-title';
      truthTableTitle.textContent = 'Truth Table';
      truthDiv.appendChild(truthTableTitle);

      const table = document.createElement('table');
      table.className = 'truth-table';

      // Header row
      const thead = document.createElement('thead');
      const headerRow = document.createElement('tr');
      info.truthTable.inputs.forEach(input => {
        const th = document.createElement('th');
        th.textContent = input;
        headerRow.appendChild(th);
      });
      const outTh = document.createElement('th');
      outTh.textContent = 'OUT';
      headerRow.appendChild(outTh);
      thead.appendChild(headerRow);
      table.appendChild(thead);

      // Body rows
      const tbody = document.createElement('tbody');
      info.truthTable.rows.forEach(row => {
        const tr = document.createElement('tr');
        row.forEach(cell => {
          const td = document.createElement('td');
          td.textContent = cell;
          tr.appendChild(td);
        });
        tbody.appendChild(tr);
      });
      table.appendChild(tbody);

      truthDiv.appendChild(table);
      technical.appendChild(truthDiv);
    }

    // --- Hardware subsection ---
    if (info.hardware) {
      const hardwareDiv = document.createElement('div');
      hardwareDiv.className = 'technical-subsection hardware-section';

      const hardwareTitle = document.createElement('div');
      hardwareTitle.className = 'dictionary-subsection-title';
      hardwareTitle.textContent = 'Hardware';
      hardwareDiv.appendChild(hardwareTitle);

      // Determine layout based on whether truth table exists
      const hasTruthTable = !!info.truthTable;

      if (hasTruthTable) {
        // If truth table exists, place hardware text first
        const hardwareText = document.createElement('div');
        hardwareText.className = 'dictionary-hardware';
        hardwareText.textContent = info.hardware;
        hardwareDiv.appendChild(hardwareText);

        // Then place schematic button below as a separate div
        if (info.schematic) {
          const schematicBtn = document.createElement('button');
          schematicBtn.className = 'schematic-btn';

          schematicBtn.innerHTML = `
            <svg class="schematic-icon" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 26 26">
              <path fill="currentColor" d="M7 2a2 2 0 0 0-2 2v18a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm3 1.938c1.132 0 2.063.93 2.063 2.062A2.073 2.073 0 0 1 10 8.063A2.07 2.07 0 0 1 7.937 6c0-1.132.931-2.063 2.063-2.063zM2.437 4A.433.433 0 0 0 2 4.438V5H.437A.433.433 0 0 0 0 5.438v1.125C0 6.809.193 7 .438 7H2v.563c0 .245.192.437.438.437h1.124A.433.433 0 0 0 4 7.562V4.438A.433.433 0 0 0 3.562 4H2.438zm20 0a.433.433 0 0 0-.437.438v3.125c0 .245.192.437.438.437h1.125A.433.433 0 0 0 24 7.562V7h1.563A.433.433 0 0 0 26 6.562V5.438A.433.433 0 0 0 25.562 5H24v-.563A.433.433 0 0 0 23.562 4zm-20 7a.433.433 0 0 0-.437.438V12H.437a.433.433 0 0 0-.437.438v1.124c0 .247.193.438.438.438H2v.563c0 .244.192.437.438.437h1.124A.433.433 0 0 0 4 14.562v-3.124A.433.433 0 0 0 3.562 11H2.438zm20 0a.433.433 0 0 0-.437.438v3.124c0 .245.192.438.438.438h1.125a.433.433 0 0 0 .437-.438V14h1.563a.433.433 0 0 0 .437-.438v-1.124a.433.433 0 0 0-.438-.438H24v-.563a.433.433 0 0 0-.438-.437zm-20 7a.433.433 0 0 0-.437.438V19H.437a.433.433 0 0 0-.437.438v1.125c0 .245.193.437.438.437H2v.563c0 .245.192.437.438.437h1.124A.433.433 0 0 0 4 21.562v-3.125A.433.433 0 0 0 3.562 18H2.438zm20 0a.433.433 0 0 0-.437.438v3.125c0 .245.192.437.438.437h1.125a.433.433 0 0 0 .437-.438V21h1.563a.433.433 0 0 0 .437-.438v-1.125a.433.433 0 0 0-.438-.437H24v-.563a.433.433 0 0 0-.438-.437z" />
            </svg>
            Schematic
            `;

          schematicBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            openSchematic(info.schematic, info.schematicInfo, info.title);
          });

          hardwareDiv.appendChild(schematicBtn);
        }
      } else {
        // No truth table: use space-between layout
        const hardwareContent = document.createElement('div');
        hardwareContent.style.display = 'flex';
        hardwareContent.style.justifyContent = 'space-between';
        hardwareContent.style.alignItems = 'center';
        hardwareContent.style.gap = '12px';

        const hardwareText = document.createElement('div');
        hardwareText.className = 'dictionary-hardware';
        hardwareText.textContent = info.hardware;
        hardwareContent.appendChild(hardwareText);

        // Add schematic button on the right
        if (info.schematic) {
          const schematicBtn = document.createElement('button');
          schematicBtn.className = 'schematic-btn';

          schematicBtn.innerHTML = `
            <svg class="schematic-icon" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 26 26">
              <path fill="currentColor" d="M7 2a2 2 0 0 0-2 2v18a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm3 1.938c1.132 0 2.063.93 2.063 2.062A2.073 2.073 0 0 1 10 8.063A2.07 2.07 0 0 1 7.937 6c0-1.132.931-2.063 2.063-2.063zM2.437 4A.433.433 0 0 0 2 4.438V5H.437A.433.433 0 0 0 0 5.438v1.125C0 6.809.193 7 .438 7H2v.563c0 .245.192.437.438.437h1.124A.433.433 0 0 0 4 7.562V4.438A.433.433 0 0 0 3.562 4H2.438zm20 0a.433.433 0 0 0-.437.438v3.125c0 .245.192.437.438.437h1.125A.433.433 0 0 0 24 7.562V7h1.563A.433.433 0 0 0 26 6.562V5.438A.433.433 0 0 0 25.562 5H24v-.563A.433.433 0 0 0 23.562 4zm-20 7a.433.433 0 0 0-.437.438V12H.437a.433.433 0 0 0-.437.438v1.124c0 .247.193.438.438.438H2v.563c0 .244.192.437.438.437h1.124A.433.433 0 0 0 4 14.562v-3.124A.433.433 0 0 0 3.562 11H2.438zm20 0a.433.433 0 0 0-.437.438v3.124c0 .245.192.438.438.438h1.125a.433.433 0 0 0 .437-.438V14h1.563a.433.433 0 0 0 .437-.438v-1.124a.433.433 0 0 0-.438-.438H24v-.563a.433.433 0 0 0-.438-.437zm-20 7a.433.433 0 0 0-.437.438V19H.437a.433.433 0 0 0-.437.438v1.125c0 .245.193.437.438.437H2v.563c0 .245.192.437.438.437h1.124A.433.433 0 0 0 4 21.562v-3.125A.433.433 0 0 0 3.562 18H2.438zm20 0a.433.433 0 0 0-.437.438v3.125c0 .245.192.437.438.437h1.125a.433.433 0 0 0 .437-.438V21h1.563a.433.433 0 0 0 .437-.438v-1.125a.433.433 0 0 0-.438-.437H24v-.563a.433.433 0 0 0-.438-.437z" />
            </svg>
            Schematic
            `;

          schematicBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            openSchematic(info.schematic, info.schematicInfo, info.title);
          });

          hardwareContent.appendChild(schematicBtn);
        }

        hardwareDiv.appendChild(hardwareContent);
      }

      technical.appendChild(hardwareDiv);
    }

    // Append technical section
    techContainer.appendChild(technical);

    container.appendChild(techContainer);
  }
}

// Dispatch selection changed event (add this to your selection handling code)
function notifySelectionChanged() {
  updateDictionaryButton();
  updateDictionaryContent();
}

// Open Schematic Overlay
// Open Schematic Overlay
function openSchematic(svgPath, info, title) {
  schematicOpen = true;
  const overlay = document.getElementById('schematicOverlay');
  const container = document.getElementById('schematicContainer');
  const titleEl = document.getElementById('schematicTitle');
  const infoContainer = document.getElementById('schematicInfo');

  if (!overlay || !container || !titleEl || !infoContainer) return;

  // Set Title
  titleEl.textContent = title;

  // Clear Info
  infoContainer.innerHTML = '';

  // Add Description
  if (info && info.description) {
    const descSection = document.createElement('div');
    descSection.className = 'schematic-section';
    descSection.innerHTML = `<div class="schematic-section-title">Description</div><div class="schematic-text">${info.description}</div>`;
    infoContainer.appendChild(descSection);
  }

  // Add RC Calculator for Oscillator (replaces Tips section)
  if (title === 'Oscillator') {
    const calcSection = document.createElement('div');
    calcSection.className = 'schematic-section';
    calcSection.appendChild(createRCCalculator());
    infoContainer.appendChild(calcSection);
  }

  // Add BOM
  if (info && info.bom) {
    const bomSection = document.createElement('div');
    bomSection.className = 'schematic-section';
    bomSection.innerHTML = `<div class="schematic-section-title">Bill of Materials</div>`;

    const ul = document.createElement('ul');
    ul.className = 'schematic-bom-list';
    info.bom.forEach(item => {
      const li = document.createElement('li');
      li.innerHTML = `<span>${item.quantity}x ${item.name}</span> <span style="opacity: 0.7; font-size: 0.85em;">${item.note || ''}</span>`;
      ul.appendChild(li);
    });
    bomSection.appendChild(ul);
    infoContainer.appendChild(bomSection);
  }

  // Add Tips (only if NOT oscillator - calculator replaces it)
  if (info && info.tips && title !== 'Oscillator') {
    const tipsSection = document.createElement('div');
    tipsSection.className = 'schematic-section';
    tipsSection.innerHTML = `<div class="schematic-section-title">Tips</div><div class="schematic-text">${info.tips}</div>`;
    infoContainer.appendChild(tipsSection);
  }

  // Load SVG
  container.innerHTML = `<div style="color: var(--text-secondary);">Loading schematic...</div>`;

  fetch(svgPath)
    .then(response => response.text())
    .then(svgText => {
      container.innerHTML = svgText;
      const svg = container.querySelector('svg');
      if (svg) {
        svg.style.width = '100%';
        svg.style.height = '100%';
        svg.removeAttribute('width');
        svg.removeAttribute('height');
        svg.querySelectorAll('title').forEach(t => t.remove());
      }
    })
    .catch(err => {
      container.innerHTML = `<div style="color: red;">Error loading schematic: ${err.message}</div>`;
    });

  overlay.classList.add('active');
}

function closeSchematic() {
  schematicOpen = false;
  const overlay = document.getElementById('schematicOverlay');
  if (overlay) {
    overlay.classList.remove('active');
  }
}

function createRCCalculator() {
  const container = document.createElement('div');
  container.className = 'rc-calculator';
  container.style.cssText = 'display: flex; flex-direction: column; gap: 12px; padding: 12px; background: var(--bg-secondary); border: solid 1px var(border-primary); border-radius: 8px;';

  // Capacitor values (in Farads)
  const capacitorValues = [
    // nF range
    { display: '1nF', value: 1e-9 },
    { display: '2.2nF', value: 2.2e-9 },
    { display: '4.7nF', value: 4.7e-9 },
    { display: '10nF', value: 10e-9 },
    { display: '22nF', value: 22e-9 },
    { display: '47nF', value: 47e-9 },
    { display: '68nF', value: 68e-9 },
    { display: '100nF', value: 100e-9 },

    // µF range
    { display: '220nF', value: 220e-9 },
    { display: '470nF', value: 470e-9 },
    { display: '1µF', value: 1e-6 },
    { display: '2.2µF', value: 2.2e-6 },
    { display: '4.7µF', value: 4.7e-6 },
    { display: '10µF', value: 10e-6 },
    { display: '22µF', value: 22e-6 },
    { display: '47µF', value: 47e-6 }
  ];

  // Potentiometer values (in Ohms)
  const potValues = [
    { display: '10kΩ', value: 10000 },
    { display: '47kΩ', value: 47000 },
    { display: '100kΩ', value: 100000 },
    { display: '470kΩ', value: 470000 },
    { display: '1MΩ', value: 1000000 }
  ];

  let currentCapIndex = 7; // Default to 100nF
  let currentPotIndex = 2; // Default to 100kΩ

  // Calculate frequency range
  function calculateFrequency() {
    const C = capacitorValues[currentCapIndex].value;
    const R_pot = potValues[currentPotIndex].value;
    const R_series = 1000; // 1kΩ series resistor

    // For CD40106 Schmitt trigger oscillator: f ≈ 1 / (2.2 * R * C)
    const f_min = 1 / (2.2 * (R_pot + R_series) * C);
    const f_max = 1 / (2.2 * R_series * C);

    return { min: f_min, max: f_max };
  }

  function formatFrequency(freq) {
    if (freq >= 1000) {
      return (freq / 1000).toFixed(1) + 'kHz';
    } else if (freq >= 1) {
      return freq.toFixed(1) + 'Hz';
    } else {
      return (freq * 1000).toFixed(1) + 'mHz';
    }
  }

  function updateResult() {
    const { min, max } = calculateFrequency();
    resultText.textContent = `~ ${formatFrequency(min)} - ${formatFrequency(max)}`;
  }

  function createNumberInput(values, currentIndex, onUpdate) {
    const wrapper = document.createElement('div');
    wrapper.style.cssText = 'position: relative; display: flex;';

    const input = document.createElement('span');
    // input.type = 'text';
    input.readOnly = true;
    input.textContent = values[currentIndex].display;
    input.style.cssText = `
      padding: 8px 24px 8px 8px;
      background: var(--bg-tertiary);
      border: 1px solid var(--border-primary);
      border-radius: 4px;
      color: var(--text-primary);
      font-size: 0.7em;
      text-align: center;
      width: 100%;
      cursor: default;
    `;

    const arrowContainer = document.createElement('div');
    arrowContainer.style.cssText = `
      position: absolute;
      right: 1px;
      top: 1px;
      bottom: 1px;
      width: 20px;
      display: flex;
      flex-direction: column;
      border-left: 1px solid var(--border-primary);
      background: var(--bg-tertiary);
      border-radius: 0 3px 3px 0;
    `;

    const upArrow = document.createElement('button');
    upArrow.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 24 24">
          <path fill="currentColor" d="M3 19h18a1.002 1.002 0 0 0 .823-1.569l-9-13c-.373-.539-1.271-.539-1.645 0l-9 13A.999.999 0 0 0 3 19" />
        </svg>`;
    upArrow.style.cssText = `
      flex: 1;
      border: none;
      background: transparent;
      color: var(--text-secondary);
      cursor: pointer;
      margin: 2px;
      font-size: 8px;
      padding: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 0 3px 0 0;
      transition: background 0.15s;
    `;
    upArrow.addEventListener('mouseenter', () => {
      upArrow.style.background = 'var(--bg-tertiary)';
      upArrow.style.color = 'var(--text-primary)';
    });
    upArrow.addEventListener('mouseleave', () => {
      upArrow.style.background = 'transparent';
      upArrow.style.color = 'var(--text-secondary)';
    });

    const downArrow = document.createElement('button');
    downArrow.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 24 24">
        <path fill="currentColor" d="M11.178 19.569a.998.998 0 0 0 1.644 0l9-13A.999.999 0 0 0 21 5H3a1.002 1.002 0 0 0-.822 1.569z" />
      </svg>`;
    downArrow.style.cssText = `
      flex: 1;
      border: none;
      background: transparent;
      color: var(--text-secondary);
      cursor: pointer;
      font-size: 8px;
      padding: 0;
      margin: 2px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-top: 1px solid var(--border-color);
      border-radius: 0 0 3px 0;
      transition: background 0.15s;
    `;
    downArrow.addEventListener('mouseenter', () => {
      downArrow.style.background = 'var(--bg-tertiary)';
      downArrow.style.color = 'var(--text-primary)';
    });
    downArrow.addEventListener('mouseleave', () => {
      downArrow.style.background = 'transparent';
      downArrow.style.color = 'var(--text-secondary)';
    });

    let index = currentIndex;

    upArrow.addEventListener('click', (e) => {
      e.preventDefault();
      index = (index + 1) % values.length;
      input.textContent = values[index].display;
      onUpdate(index);
    });

    downArrow.addEventListener('click', (e) => {
      e.preventDefault();
      index = (index - 1 + values.length) % values.length;
      input.textContent = values[index].display;
      onUpdate(index);
    });

    arrowContainer.appendChild(upArrow);
    arrowContainer.appendChild(downArrow);
    wrapper.appendChild(input);
    wrapper.appendChild(arrowContainer);

    return wrapper;
  }

  // Title
  const title = document.createElement('div');
  title.className = 'schematic-section-title';
  title.textContent = 'Frequency Calculator';
  title.style.marginBottom = '8px';
  container.appendChild(title);

  // Inputs row
  const inputsRow = document.createElement('div');
  inputsRow.style.cssText = 'display: flex; gap: 12px; align-items: center;';

  // Capacitor input
  const capContainer = document.createElement('div');
  capContainer.style.cssText = 'flex: 1; display: flex; flex-direction: column; gap: 4px;';

  const capLabel = document.createElement('label');
  capLabel.textContent = 'Capacitor (C2)';
  capLabel.style.cssText = 'font-size: 0.85em; opacity: 0.7; color: var(--text-primary);';

  const capInput = createNumberInput(capacitorValues, currentCapIndex, (newIndex) => {
    currentCapIndex = newIndex;
    updateResult();
  });

  capContainer.appendChild(capLabel);
  capContainer.appendChild(capInput);

  // Potentiometer input
  const potContainer = document.createElement('div');
  potContainer.style.cssText = 'flex: 1; display: flex; flex-direction: column; gap: 4px; color: var(--text-secondary);';

  const potLabel = document.createElement('label');
  potLabel.textContent = 'Potentiometer (RV1)';
  potLabel.style.cssText = 'font-size: 0.85em; opacity: 0.7; color: var(--text-primary);';

  const potInput = createNumberInput(potValues, currentPotIndex, (newIndex) => {
    currentPotIndex = newIndex;
    updateResult();
  });

  potContainer.appendChild(potLabel);
  potContainer.appendChild(potInput);

  inputsRow.appendChild(capContainer);
  inputsRow.appendChild(potContainer);
  container.appendChild(inputsRow);

  // Result display
  const resultContainer = document.createElement('div');
  resultContainer.style.cssText = 'text-align: center; padding: 12px; background: var(--bg-tertiary); border-radius: 4px; border: 1px solid var(--border-primary); color: var(--text-secondary);';

  const resultLabel = document.createElement('div');
  resultLabel.textContent = 'Frequency Range';
  resultLabel.style.cssText = 'font-size: 0.85em; opacity: 0.7; margin-bottom: 4px; color: var(--text-secondary);';

  const resultText = document.createElement('div');
  resultText.style.cssText = 'font-size: 0.85em; font-weight: 500; color: var(--text-primary);';

  resultContainer.appendChild(resultLabel);
  resultContainer.appendChild(resultText);
  container.appendChild(resultContainer);

  // Initial calculation
  updateResult();

  return container;
}

// customModulesDB.js
// customModulesDB.js - IndexedDB storage for custom modules

let customModulesDB = null;

// Initialize IndexedDB for custom modules
async function initCustomModulesDB() {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open('StateMachineCustomModules', 1);

    request.onerror = () => {
      console.error("IndexedDB error:", request.error);
      reject(request.error);
    };

    request.onsuccess = () => {
      customModulesDB = request.result;
      resolve(customModulesDB);
    };

    request.onupgradeneeded = (event) => {
      const db = event.target.result;
      if (!db.objectStoreNames.contains('custom_modules')) {
        const store = db.createObjectStore('custom_modules', { keyPath: 'name' });
        // We can add indexes if needed, e.g., created date
        // store.createIndex('created', 'created', { unique: false });
      }
    };
  });
}

// Save a custom module to IndexedDB
async function saveCustomModuleToDB(moduleDef) {
  if (!customModulesDB) await initCustomModulesDB();

  return new Promise((resolve, reject) => {
    const transaction = customModulesDB.transaction(['custom_modules'], 'readwrite');
    const store = transaction.objectStore('custom_modules');
    const request = store.put(moduleDef); // put updates if exists, add if new

    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
}

// Get a single custom module by name
async function getCustomModuleFromDB(name) {
  if (!customModulesDB) await initCustomModulesDB();

  return new Promise((resolve, reject) => {
    const transaction = customModulesDB.transaction(['custom_modules'], 'readonly');
    const store = transaction.objectStore('custom_modules');
    const request = store.get(name);

    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
}

// Get all custom modules
async function loadCustomModulesFromDB() {
  if (!customModulesDB) await initCustomModulesDB();

  return new Promise((resolve, reject) => {
    const transaction = customModulesDB.transaction(['custom_modules'], 'readonly');
    const store = transaction.objectStore('custom_modules');
    const request = store.getAll();

    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
}

// Delete a custom module
async function deleteCustomModuleFromDB(name) {
  if (!customModulesDB) await initCustomModulesDB();

  return new Promise((resolve, reject) => {
    const transaction = customModulesDB.transaction(['custom_modules'], 'readwrite');
    const store = transaction.objectStore('custom_modules');
    const request = store.delete(name);

    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
}

// Migration helper: Move from localStorage to IndexedDB
async function migrateCustomModulesToDB() {
  const stored = localStorage.getItem('customModuleDefinitions');
  if (stored) {
    try {
      const definitions = JSON.parse(stored);
      const names = Object.keys(definitions);

      if (names.length > 0) {
        console.log(`Migrating ${names.length} custom modules to IndexedDB...`);
        for (const name of names) {
          await saveCustomModuleToDB(definitions[name]);
        }
        console.log("Migration complete. Clearing localStorage 'customModuleDefinitions'.");
        // Optional: Clear localStorage after successful migration
        // localStorage.removeItem('customModuleDefinitions'); 
        // Keeping it for now as backup until fully verified
      }
    } catch (e) {
      console.error("Migration failed:", e);
    }
  }
}


// main.js
let audioContext;
let workletNode;
let modules = [];
let connections = [];
let selectedOutput = null;
let moduleId = 0;
let dragging = null;
let wirePaths = [];
let mouseX = 0;
let mouseY = 0;
let ledElements = [];  // Array to hold LED elements
let audioStarted = false;
let startButton; // Reference to the start/stop button
let scopeModuleCreated = false;
let scopePanelOpen = false;
let scopeAnimationId = null;
let selectedConnections = new Set(); // Set of connection indices that are selected

let schematicOpen = false;
let performanceMode = false;
let isModuleDesigner = false;
let customModuleDefinitions = {};
// Add this near the top with your other globals
let saveMenuOpen = false;

// Add these global variables near the top with your other globals
const MIN_ZOOM = 0.3;
const MAX_ZOOM = 2.0;
const ZOOM_SPEED = 0.05;

// Global variables for selection and copy-paste
let selectedModules = new Set(); // Set of module IDs that are selected
let selectionBox = null; // For drawing selection box
let selectionStart = { x: 0, y: 0 };
let clipboard = null; // Will store copied modules and their connections


const CANVAS_BOUNDS = {
  minX: 0,
  minY: 0,
  maxX: 500,  // 10000px canvas / 20px grid = 500 grid units
  maxY: 500
};

// Undo system variables
let undoStack = [];
let redoStack = [];
let MAX_HISTORY = 50; // Maximum number of actions to keep in history

let outModuleCreated = false;
let ledUpdateInterval;
let ledPersistence = 30; // Time in ms that LEDs stay illuminated after being turned on

let selectToolActive = false; // track selection tool button
let pasteToolActive = false;

let showGrid = true;
let gridCanvas = null;

let viewState = {
  offsetX: 0,      // pixels
  offsetY: 0,      // pixels
  scale: 1.0,      // zoom level
  gridSize: 20     // pixels per grid unit at scale 1.0
};

document.addEventListener('contextmenu', function (e) {
  e.preventDefault();
});

function isTouchDevice() {
  return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
}

// Initialize grid canvas in initializeContainers()
function initializeContainers() {
  // Create grid SVG (bottom layer)
  const gridSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  gridSvg.id = 'gridSvg';
  gridSvg.style.cssText = `
    position: absolute;
    top: 0;
    left: 0;
    width: 10000px;
    height: 10000px;
    pointer-events: none;
    transform-origin: 0 0;
    border: 1px var(--text-tertiary) solid;
  `;
  document.body.appendChild(gridSvg);

  // Module container (middle)
  const moduleContainer = document.createElement('div');
  moduleContainer.id = 'moduleContainer';
  moduleContainer.style.cssText = `
    position: absolute;
    top: 0;
    left: 0;
    transform-origin: 0 0;
    width: 10000px;
    height: 10000px;
  `;
  document.body.appendChild(moduleContainer);

  // Wire SVG (top layer)
  const wireSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  wireSvg.id = 'wireSvg';
  wireSvg.style.cssText = `
    position: absolute;
    top: 0;
    left: 0;
    width: 10000px;
    height: 10000px;
    pointer-events: none;
    transform-origin: 0 0;
  `;
  document.body.appendChild(wireSvg);

  updateViewTransform();
  drawGrid();
}

// Add debounce utility
let gridDrawTimeout = null;

function drawGridDebounced() {
  if (gridDrawTimeout) clearTimeout(gridDrawTimeout);
  gridDrawTimeout = setTimeout(() => {
    drawGrid();
  }, 100); // Wait 100ms after last call
}

// Apply view transform to both container and canvas
function updateViewTransform() {
  const transform = `translate(${viewState.offsetX}px, ${viewState.offsetY}px) scale(${viewState.scale})`;

  const container = document.getElementById('moduleContainer');
  const wireSvg = document.getElementById('wireSvg');
  const gridSvg = document.getElementById('gridSvg');

  if (container) container.style.transform = transform;
  if (wireSvg) wireSvg.style.transform = transform;
  if (gridSvg) gridSvg.style.transform = transform;

  // Draw grid after transform update
  if (showGrid) drawGridDebounced();
}

function drawGrid() {
  if (!showGrid) return;

  const svg = document.getElementById('gridSvg');
  if (!svg) return;

  svg.innerHTML = ''; // Clear existing

  const gridSize = viewState.gridSize;
  const rootStyles = getComputedStyle(document.documentElement);
  const gridColor = rootStyles.getPropertyValue('--grid-color')?.trim() || 'rgba(100, 100, 100, 0.2)';

  const gridExtent = 1000;

  // Vertical lines
  for (let x = -gridExtent; x <= gridExtent; x++) {
    const line = document.createElementNS('http://www.w3.org/2000/svg', 'line');
    line.setAttribute('x1', x * gridSize);
    line.setAttribute('y1', -gridExtent * gridSize);
    line.setAttribute('x2', x * gridSize);
    line.setAttribute('y2', gridExtent * gridSize);
    line.setAttribute('stroke', gridColor);
    line.setAttribute('stroke-width', '1');
    svg.appendChild(line);
  }

  // Horizontal lines
  for (let y = -gridExtent; y <= gridExtent; y++) {
    const line = document.createElementNS('http://www.w3.org/2000/svg', 'line');
    line.setAttribute('x1', -gridExtent * gridSize);
    line.setAttribute('y1', y * gridSize);
    line.setAttribute('x2', gridExtent * gridSize);
    line.setAttribute('y2', y * gridSize);
    line.setAttribute('stroke', gridColor);
    line.setAttribute('stroke-width', '1');
    svg.appendChild(line);
  }
}


// Convert screen coordinates to grid coordinates
function screenToGrid(screenX, screenY) {
  const gridX = (screenX - viewState.offsetX) / (viewState.scale * viewState.gridSize);
  const gridY = (screenY - viewState.offsetY) / (viewState.scale * viewState.gridSize);
  return { gridX, gridY };
}

// Convert grid coordinates to screen coordinates
function gridToScreen(gridX, gridY) {
  const screenX = gridX * viewState.gridSize * viewState.scale + viewState.offsetX;
  const screenY = gridY * viewState.gridSize * viewState.scale + viewState.offsetY;
  return { screenX, screenY };
}

// Convert grid coordinates to logical pixel coordinates (for module positioning)
function gridToPixels(gridX, gridY) {
  return {
    x: gridX * viewState.gridSize,
    y: gridY * viewState.gridSize
  };
}

function showShare() {
  return new Promise((resolve) => {
    const shareMessage = document.getElementById('shareMessage');
    const shareExit = document.getElementById('shareExit');

    shareMessage.classList.add('open');

    const handleYes = () => {
      shareMessage.classList.remove('open');
      shareExit.removeEventListener('click', handleYes);
      resolve(true);
    };

    shareExit.addEventListener('click', handleYes);
  });
}


window.onload = () => {

  const toggle = document.getElementById('darkModeToggle');
  const toggleMobile = document.getElementById('darkModeToggleMobile');

  // Load dark mode preference on page load
  if (localStorage.getItem('darkMode') === 'enabled') {
    document.documentElement.classList.add('dark-mode');
  }
  // const tutorialButton = document.getElementById('tutorialButton');
  // const tutorialBox = document.getElementById('tutorialBox');
  initializeContainers();
  updateUndoRedoButtons();
  updateDeleteButtonState();
  updateCopyPasteButtonState();

  const modulesBtn = document.getElementById('modulesPageBtn');
  const snippetsBtn = document.getElementById('snippetsPageBtn');
  const modulesPage = document.getElementById('modulesPage');
  const snippetsPage = document.getElementById('snippetsPage');
  modulesBtn.classList.add('active');
  snippetsBtn.classList.remove('active');
  modulesPage.classList.add('active');
  snippetsPage.classList.remove('active');

  const toggleButton = document.getElementById('toggle-controls');
  const controlsContainer = document.getElementById('controls-container');

  document.getElementById('fitToViewButton')?.addEventListener('click', () => {
    fitToView(false);
  });

  toggleButton.addEventListener('click', function (e) {
    // currentTarget always refers to the element the listener is attached to
    const isExpanded = controlsContainer.classList.contains('expanded');

    if (isExpanded) {
      controlsContainer.classList.remove('expanded');
      toggleButton.textContent = '+';
    } else {
      controlsContainer.classList.add('expanded');
      toggleButton.textContent = '-';
    }

    e.stopPropagation();
  });

  // Toggle dark mode on click
  toggle.addEventListener('click', () => {
    document.documentElement.classList.toggle('dark-mode');

    if (document.documentElement.classList.contains('dark-mode')) {
      localStorage.setItem('darkMode', 'enabled');
      requestWireRedraw();
      drawGrid();
    } else {
      localStorage.setItem('darkMode', 'disabled');
      requestWireRedraw();
      drawGrid();
    }
  });


  // Toggle dark mode on click
  toggleMobile.addEventListener('click', () => {
    document.documentElement.classList.toggle('dark-mode');

    if (document.documentElement.classList.contains('dark-mode')) {
      localStorage.setItem('darkMode', 'enabled');
      requestWireRedraw();
      drawGrid();
    } else {
      localStorage.setItem('darkMode', 'disabled');
      requestWireRedraw();
      drawGrid();
    }
  });

  const likeButton = document.getElementById('likeButton');

  likeButton.addEventListener('click', function (e) {
    showShare();
  });

  const undoButton = document.getElementById('undoButton');
  const redoButton = document.getElementById('redoButton');

  undoButton.addEventListener('click', function (e) {
    undo();
  });

  redoButton.addEventListener('click', function (e) {
    redo();
  });

  const deleteButton = document.getElementById('deleteButton');

  deleteButton.addEventListener('click', function (e) {
    deleteSelectedItems();
  });

  const cutButton = document.getElementById('cutButton');
  const copyButton = document.getElementById('copyButton');
  const pasteButton = document.getElementById('pasteButton');

  cutButton.addEventListener('click', () => {
    cutSelectedModules();
    updateCopyPasteButtonState();
  });

  copyButton.addEventListener('click', () => {
    copySelectedModules();
    updateCopyPasteButtonState();
  });

  pasteButton.addEventListener('click', () => {
    if (!clipboard || clipboard.modules.length === 0) return;

    // Toggle paste tool mode
    pasteToolActive = !pasteToolActive;

    if (pasteToolActive) {
      pasteButton.classList.add('active');
    } else {
      pasteButton.classList.remove('active');
    }

    updateCopyPasteButtonState();
  });


  const selectButton = document.getElementById('selectButton');

  selectButton.addEventListener('click', (e) => {
    selectToolActive = !selectToolActive;

    if (selectToolActive) {
      selectButton.classList.add('active');
    } else {
      selectButton.classList.remove('active');
    }

    e.stopPropagation();
  });


  const gridToggleButton = document.getElementById('gridToggleButton');
  if (gridToggleButton) {
    gridToggleButton.addEventListener('click', () => {
      showGrid = !showGrid;
      if (showGrid) {
        drawGrid();
        gridToggleButton.classList.add('active');
      } else {
        const canvas = document.getElementById('gridCanvas');
        if (canvas) {
          const ctx = canvas.getContext('2d');
          ctx.clearRect(0, 0, canvas.width, canvas.height);
        }
        gridToggleButton.classList.remove('active');
      }
    });
  }

  performanceLinked = true;
  fxLinked = true;
  updateLinkButtonStates();

  // Module Designer Event Listeners
  document.getElementById('moduleDesignerButton')?.addEventListener('click', enterModuleDesigner);
  document.getElementById('bomExportButton')?.addEventListener('click', enterBomExport);

  document.getElementById('addInletBtn')?.addEventListener('click', () => {
    const inlets = modules.filter(m => m.type === 'Inlet').sort((a, b) => a.gridY - b.gridY);
    const outlets = modules.filter(m => m.type === 'Outlet').sort((a, b) => a.gridY - b.gridY);

    if (inlets.length + outlets.length >= 20) {
      showAlert('Maximum number of inputs and outputs reached');
      return;
    }
    createModule('Inlet', true);
  });

  document.getElementById('addOutletBtn')?.addEventListener('click', () => {
    const inlets = modules.filter(m => m.type === 'Inlet').sort((a, b) => a.gridY - b.gridY);
    const outlets = modules.filter(m => m.type === 'Outlet').sort((a, b) => a.gridY - b.gridY);

    if (inlets.length + outlets.length >= 20) {
      showAlert('Maximum number of inputs and outputs reached');
      return;
    }
    createModule('Outlet', true);
  });


  document.getElementById('addExportInletBtn')?.addEventListener('click', () => {
    createModule('ExportInlet', true);
  });

  document.getElementById('addExportOutletBtn')?.addEventListener('click', () => {
    createModule('ExportOutlet', true);
  });

  document.getElementById('addExportLedBtn')?.addEventListener('click', () => {
    createModule('ExportLed', true);
  });

};


const zoomText = document.getElementById('zoomText');
const zoomInButton = document.getElementById('zoomInButton');
const zoomOutButton = document.getElementById('zoomOutButton');

const zoomLevels = [0.3, 0.5, 0.67, 0.75, 0.8, 0.9, 1, 1.1, 1.25, 1.5, 1.75, 2];

function getClosestZoomIndex(currentZoom) {
  let closest = 0;
  let minDiff = Infinity;
  for (let i = 0; i < zoomLevels.length; i++) {
    const diff = Math.abs(zoomLevels[i] - currentZoom);
    if (diff < minDiff) {
      closest = i;
      minDiff = diff;
    }
  }
  return closest;
}

// Use the last known mouse position for zoom center
let clickZoomX = window.innerWidth / 2;
let clickZoomY = window.innerHeight / 2;
// REPLACE zoom wheel handler
document.addEventListener('wheel', (e) => {
  if (saveMenuOpen || schematicOpen) return;

  if (e.ctrlKey || e.metaKey) {
    e.preventDefault();

    const delta = e.deltaY > 0 ? -0.05 : 0.05;
    const oldScale = viewState.scale;
    const newScale = Math.max(MIN_ZOOM, Math.min(MAX_ZOOM, oldScale + delta));

    if (newScale !== oldScale) {
      // Zoom toward mouse position
      const mouseX = e.clientX;
      const mouseY = e.clientY;

      // Adjust offset so zoom is centered on mouse
      viewState.offsetX = mouseX - (mouseX - viewState.offsetX) * (newScale / oldScale);
      viewState.offsetY = mouseY - (mouseY - viewState.offsetY) * (newScale / oldScale);
      viewState.scale = newScale;

      updateViewTransform();
      updateZoomText();
      requestWireRedraw();
    }
  }
}, { passive: false });

// REPLACE zoom button handlers
zoomInButton.addEventListener('click', () => {
  const currentIndex = getClosestZoomIndex(viewState.scale);
  const nextIndex = Math.min(currentIndex + 1, zoomLevels.length - 1);
  const newScale = zoomLevels[nextIndex];

  if (newScale !== viewState.scale) {
    const centerX = window.innerWidth / 2;
    const centerY = window.innerHeight / 2;

    const oldScale = viewState.scale;
    viewState.offsetX = centerX - (centerX - viewState.offsetX) * (newScale / oldScale);
    viewState.offsetY = centerY - (centerY - viewState.offsetY) * (newScale / oldScale);
    viewState.scale = newScale;

    updateViewTransform();
    updateZoomText();
    requestWireRedraw();
  }
});

zoomOutButton.addEventListener('click', () => {
  const currentIndex = getClosestZoomIndex(viewState.scale);
  const nextIndex = Math.max(currentIndex - 1, 0);
  const newScale = zoomLevels[nextIndex];

  if (newScale !== viewState.scale) {
    const centerX = window.innerWidth / 2;
    const centerY = window.innerHeight / 2;

    const oldScale = viewState.scale;
    viewState.offsetX = centerX - (centerX - viewState.offsetX) * (newScale / oldScale);
    viewState.offsetY = centerY - (centerY - viewState.offsetY) * (newScale / oldScale);
    viewState.scale = newScale;

    updateViewTransform();
    updateZoomText();
    requestWireRedraw();
  }
});

// Update zoom text display
function updateZoomText() {
  zoomText.textContent = `${Math.round(viewState.scale * 100)}%`;
}


function startLedUpdate() {
  ledUpdateInterval = setInterval(updateLedStates, 17);
}

function stopLedUpdate() {
  if (ledUpdateInterval) {
    clearInterval(ledUpdateInterval);
  }
}

window.addEventListener('load', async function () {
  initializeAudioButton();

  // Initialize DBs
  try {
    await initCustomModulesDB();

    // Load custom modules into memory for synchronous access
    const loadedModules = await loadCustomModulesFromDB();
    loadedModules.forEach(mod => {
      customModuleDefinitions[mod.name] = mod;
    });

    // Update menu after loading
    if (typeof updateCustomModuleMenu === 'function') {
      updateCustomModuleMenu();
    }
  } catch (e) {
    console.error("Failed to initialize custom modules DB:", e);
  }

  loadDefaultPatch();
  initTutorial();
  initDictionary();

  setupVolumeListeners();


  if (!localStorage.getItem('tutorialShown')) {
    // First visit - show tutorial
    startTutorial();
    localStorage.setItem('tutorialShown', 'true');
  }

});

// Helper function to prevent default behavior
function preventDefault(e) {
  e.preventDefault();
  e.stopPropagation();
  return false;
}

const iconMute = `
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
	<path fill="currentColor" d="M5.707 4.293a1 1 0 0 0-1.414 1.414l14 14a1 1 0 0 0 1.414-1.414l-.004-.005C21.57 16.498 22 13.938 22 12a9.97 9.97 0 0 0-2.929-7.071a1 1 0 1 0-1.414 1.414A7.97 7.97 0 0 1 20 12c0 1.752-.403 3.636-1.712 4.873l-1.433-1.433C17.616 14.37 18 13.107 18 12c0-1.678-.69-3.197-1.8-4.285a1 1 0 1 0-1.4 1.428A4 4 0 0 1 16 12c0 .606-.195 1.335-.59 1.996L13 11.586V6.135c0-1.696-1.978-2.622-3.28-1.536L7.698 6.284l-1.99-1.991ZM4 8h.586L13 16.414v1.451c0 1.696-1.978 2.622-3.28 1.536L5.638 16H4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2" />
</svg>
`;

const iconPlaying = `
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
	<g fill="currentColor">
		<path d="M13 6.037c0-1.724-1.978-2.665-3.28-1.562L5.638 7.933H4c-1.105 0-2 .91-2 2.034v4.066c0 1.123.895 2.034 2 2.034h1.638l4.082 3.458c1.302 1.104 3.28.162 3.28-1.562z" />
		<path fill-rule="evenodd" d="M14.786 7.658a.99.99 0 0 1 1.414-.014A6.14 6.14 0 0 1 18 12c0 1.662-.655 3.17-1.715 4.27a.99.99 0 0 1-1.414.014a1.03 1.03 0 0 1-.014-1.437A4.1 4.1 0 0 0 16 12a4.1 4.1 0 0 0-1.2-2.904a1.03 1.03 0 0 1-.014-1.438" clip-rule="evenodd" />
		<path fill-rule="evenodd" d="M17.657 4.811a.99.99 0 0 1 1.414 0A10.22 10.22 0 0 1 22 12c0 2.807-1.12 5.35-2.929 7.189a.99.99 0 0 1-1.414 0a1.03 1.03 0 0 1 0-1.438A8.17 8.17 0 0 0 20 12a8.17 8.17 0 0 0-2.343-5.751a1.03 1.03 0 0 1 0-1.438" clip-rule="evenodd" />
	</g>
</svg>
`;

async function toggleAudio() {

  const iconContainer = document.getElementById('audio-icon');
  const iconMobileContainer = document.getElementById('audio-icon-mobile');

  if (!audioStarted) {
    try {
      startButton.classList.add("active");

      // Set initial icon states to playing
      iconContainer.innerHTML = iconPlaying;
      iconMobileContainer.innerHTML = iconPlaying;
      iconMobileContainer.classList.add("active");

      audioContext = new (window.AudioContext || window.webkitAudioContext)();
      await audioContext.resume();

      await audioContext.audioWorklet.addModule('worklet-ui.js');

      workletNode = new AudioWorkletNode(audioContext, 'logic-synth-ui');
      workletNode.connect(audioContext.destination);
      workletNode.port.onmessage = (event) => {
        const { ledData } = event.data;
        if (ledData && Array.isArray(ledData)) {
          // Process each LED with its identifier
          ledData.forEach(item => {
            const { moduleId, outputIndex, state } = item;

            // Find the matching LED element by ID and output index
            const ledElement = ledElements.find(led =>
              led.modId === moduleId && led.outputIndex === outputIndex
            );

            if (ledElement && ledElement.led) {
              const isSVG = ledElement.led.tagName === 'path';
              const colorProperty = isSVG ? 'fill' : 'backgroundColor';

              if (state) {
                // LED is on - update timestamp and turn on
                ledElement.lastOnTime = Date.now();
                ledElement.led.style[colorProperty] = 'var(--led-on)';
                ledElement.led.style.opacity = '1';
                if (!isSVG) {
                  ledElement.led.style.boxShadow = '0 0 3px 1px var(--led-glow)';
                }
                // ledElement.led.style.border ='1px solid var(--led-glow)';
              } else {
                // LED is off - calculate fade-out based on time since last on
                const timeSinceLastOn = Date.now() - (ledElement.lastOnTime || 0);
                if (timeSinceLastOn < ledPersistence) {
                  // Calculate opacity based on remaining persistence time
                  const opacity = 1 - (timeSinceLastOn / ledPersistence);
                  ledElement.led.style.opacity = opacity.toString();
                  ledElement.led.style[colorProperty] = 'var(--led-on)';
                  if (!isSVG) {
                    ledElement.led.style.boxShadow = `0 0 ${2 * opacity}px var(--led-on)`;
                  }
                } else {
                  ledElement.led.style[colorProperty] = 'var(--led-off)';
                  // ledElement.led.style.border = '1px solid var(--led-border)';
                  ledElement.led.style.opacity = '1';
                  if (!isSVG) {
                    ledElement.led.style.boxShadow = '0 0 0px rgba(0, 0, 0, 0)';
                  }
                }
              }
            }
          });
        }
        if (event.data.type === 'scopeData') {
          drawScope(event.data.dataA, event.data.dataB);
        }
      };
      // Check if user has already adjusted volume from initial 0%
      // If they have, use their volume; otherwise default to 50%
      const userHasSetVolume = currentVolume > 0;

      if (!userHasSetVolume) {
        // User hasn't touched slider, initialize at 50% volume, unmuted
        isMuted = false;
        currentVolume = 0.5;
      } else {
        // User has set volume via slider, use their setting and unmute
        isMuted = false;
      }

      // Update slider UI elements
      const slider = document.getElementById('volume-slider');
      const percentage = document.getElementById('volume-percentage');
      const mobileSlider = document.getElementById('mobile-volume-slider');
      const mobilePercentage = document.getElementById('mobile-volume-percentage');

      const volumePercent = Math.round(currentVolume * 100);

      // Set desktop slider
      if (slider && percentage) {
        slider.value = volumePercent;
        percentage.textContent = `${volumePercent}%`;
        const desktopFill = document.querySelector('.volume-slider-fill');
        if (desktopFill) {
          if (window.innerWidth > 1000) {
            desktopFill.style.width = `${volumePercent}%`;
            desktopFill.style.height = '';
          } else {
            desktopFill.style.height = `${volumePercent}%`;
            desktopFill.style.width = '';
          }
        }
      }

      // Set mobile slider
      if (mobileSlider && mobilePercentage) {
        mobileSlider.value = volumePercent;
        mobilePercentage.textContent = `${volumePercent}%`;
        const mobileFill = document.querySelector('.mobile-volume-slider-fill');
        if (mobileFill) mobileFill.style.width = `${volumePercent}%`;
      }

      // Small delay to ensure worklet is ready
      setTimeout(() => {
        updateVolume();
        updateMuteState();
      }, 100);

      rebuildAudioGraph();

      modules.forEach(module => {
        if (module.type === 'EEPROM' && module.memoryData) {
          workletNode.port.postMessage({
            type: 'programEEPROM',
            moduleId: module.id,
            memoryData: module.memoryData
          });
        }
      });

      startLedUpdate();
      initScopePanel();

      if (scopePanelOpen) {
        workletNode.port.postMessage({
          type: 'enableScope',
          enabled: true,
          bufferSize: scopeBufferSize
        });
        startScopeAnimation();
      }

      audioStarted = true;

    } catch (error) {
      console.error("Error starting audio:", error);
      startButton.classList.remove("active");
      iconContainer.innerHTML = iconMute;
      iconMobileContainer.innerHTML = iconMute;
      iconMobileContainer.classList.remove("active");
      audioStarted = false;
    }
  } else {
    // Toggle mute instead of stopping audio
    toggleMute();

    // Stop/start LED updates based on mute state
    // if (isMuted) {
    //   stopLedUpdate();
    // } else {
    //   startLedUpdate();
    // }
  }
}

function initializeAudioButton() {
  startButton = document.getElementById('startAudioButton');
  if (startButton) {
    startButton.addEventListener('click', toggleAudio);
  }
}

document.addEventListener('mousedown', (e) => {
  if (performanceMode || saveMenuOpen || schematicOpen) return;

  if (e.target.closest('.dictionary-page-btn')) {
    return;
  }

  const isPort = e.target.dataset &&
    (e.target.dataset.type === 'input' || e.target.dataset.type === 'output');

  if (isPort) {
    return;
  }

  const isButton = e.target.tagName === 'BUTTON' || e.target.closest('button');
  const isButtonModule = e.target.classList.contains('buttonModule');
  const isInput = e.target.tagName === 'INPUT';
  const isLeftClick = e.button === 0;

  if (isButton || isInput || isButtonModule) {
    return;
  }

  if (!isLeftClick || dragging || selectionBox) {
    return;
  }

  const mx = e.clientX;
  const my = e.clientY;

  // FIRST: Check for wire clicks
  let clickedWireIndex = -1;

  for (let i = 0; i < wirePaths.length; i++) {
    const path = wirePaths[i];
    const isNear = isNearLine(mx, my, path.x1, path.y1, path.x2, path.y2);
    if (isNear) {
      clickedWireIndex = i;
      break;
    }
  }

  // SECOND: Only check for modules if we didn't click a wire
  let clickedModuleElement = null;
  let clickedModuleId = null;

  if (clickedWireIndex === -1) {
    // Only do the expensive module detection if we didn't click a wire
    const wireSvg = document.getElementById('wireSvg');
    const originalPointerEvents = wireSvg ? wireSvg.style.pointerEvents : null;
    if (wireSvg) {
      wireSvg.style.pointerEvents = 'none';
    }

    const elementUnderMouse = document.elementFromPoint(mx, my);
    clickedModuleElement = elementUnderMouse ? elementUnderMouse.closest('.module') : null;

    if (wireSvg) {
      wireSvg.style.pointerEvents = originalPointerEvents || 'none';
    }

    if (clickedModuleElement) {
      clickedModuleId = parseInt(clickedModuleElement.dataset.id);
    }
  }

  const hasWire = clickedWireIndex !== -1;
  const hasModule = clickedModuleId !== null;
  const withModifier = e.metaKey || e.ctrlKey || selectToolActive;

  // Case 1: Clicked on wire (with or without module underneath)
  if (hasWire) {
    if (withModifier) {
      // Toggle wire selection
      if (selectedConnections.has(clickedWireIndex)) {
        selectedConnections.delete(clickedWireIndex);
      } else {
        selectedConnections.add(clickedWireIndex);
      }
      requestWireRedraw();
      updateDeleteButtonState();
      e.stopPropagation();
      e.preventDefault();
    } else {
      // Without modifier: Start canvas pan
      // Store which wire was clicked for mouseup handling
      dragging = {
        isCanvasPan: true,
        startScreenX: mx,
        startScreenY: my,
        startOffsetX: viewState.offsetX,
        startOffsetY: viewState.offsetY,
        hasMoved: false,
        clickedWireIndex: clickedWireIndex  // Store the wire index
      };
    }
    return;
  }

  // Case 2: Clicked on module only (no wire)
  if (!hasWire && hasModule) {
    const module = modules.find(m => m.id === clickedModuleId);
    if (!module) return;

    const gridCoords = screenToGrid(mx, my);

    if (withModifier || selectToolActive) {
      if (selectedModules.has(clickedModuleId)) {
        selectedModules.delete(clickedModuleId);
      } else {
        selectedModules.add(clickedModuleId);
      }
      updateSelectionHighlights();
      updateDeleteButtonState();
      e.stopPropagation();
      return;
    } else {
      if (selectedModules.has(clickedModuleId)) {
        const dragInfo = {};
        selectedModules.forEach(id => {
          const mod = modules.find(m => m.id === id);
          if (mod) {
            dragInfo[id] = {
              initialGridX: mod.gridX,
              initialGridY: mod.gridY,
              offsetX: mod.gridX - gridCoords.gridX,
              offsetY: mod.gridY - gridCoords.gridY
            };
            const elem = document.querySelector(`[data-id='${id}']`);
            if (elem) elem.classList.add('grabbed');
          }
        });

        dragging = {
          isMulti: true,
          modules: dragInfo
        };
      } else {
        clearSelection();
        selectedConnections.clear();
        selectedModules.add(clickedModuleId);
        updateSelectionHighlights();
        requestWireRedraw();
        updateDeleteButtonState();

        clickedModuleElement.classList.add('grabbed');

        dragging = {
          isMulti: false,
          moduleId: clickedModuleId,
          initialGridX: module.gridX,
          initialGridY: module.gridY,
          offsetX: module.gridX - gridCoords.gridX,
          offsetY: module.gridY - gridCoords.gridY
        };
      }
      return;
    }
  }

  // Case 3: Clicked on empty space
  if (!hasWire && !hasModule) {
    if (withModifier || selectToolActive) {
      selectionStart = { x: mx, y: my };
      selectionBox = document.createElement('div');

      selectionBox.style.position = 'absolute';
      selectionBox.style.top = '-10000px';
      selectionBox.style.border = '1px dashed var(--selection-box-border)';
      selectionBox.style.backgroundColor = 'var(--selection-box-bg)';
      selectionBox.style.pointerEvents = 'none';
      selectionBox.style.zIndex = '11000';
      document.body.appendChild(selectionBox);

      if (!e.shiftKey && !selectToolActive && !e.metaKey && !e.ctrlKey) {
        clearSelection();
        selectedConnections.clear();
        updateSelectionHighlights();
        requestWireRedraw();
        updateDeleteButtonState();
      }
    } else {
      dragging = {
        isCanvasPan: true,
        startScreenX: mx,
        startScreenY: my,
        startOffsetX: viewState.offsetX,
        startOffsetY: viewState.offsetY,
        hasMoved: false
      };
    }
  }
});

let lastDragRedraw = 0;
const DRAG_REDRAW_INTERVAL = 16; // ~30fps during drag
let lastHoverCheckTime = 0;
const HOVER_CHECK_INTERVAL = 50; // Check hover every 50ms instead of every frame

document.addEventListener('mousemove', (e) => {
  mouseX = e.clientX;
  mouseY = e.clientY;

  if (dragging) {
    if (dragging.isCanvasPan) {
      const deltaX = e.clientX - dragging.startScreenX;
      const deltaY = e.clientY - dragging.startScreenY;

      if (Math.abs(deltaX) > 2 || Math.abs(deltaY) > 2) {
        dragging.hasMoved = true;
      }

      viewState.offsetX = dragging.startOffsetX + deltaX;
      viewState.offsetY = dragging.startOffsetY + deltaY;
      updateViewTransform();
    } else {
      const gridCoords = screenToGrid(e.clientX, e.clientY);

      if (dragging.isMulti) {
        Object.keys(dragging.modules).forEach(idStr => {
          const id = parseInt(idStr);
          const info = dragging.modules[idStr];
          const module = modules.find(m => m.id === id);
          const element = document.querySelector(`[data-id='${id}']`);

          if (module && element) {
            module.gridX = gridCoords.gridX + info.offsetX;
            module.gridY = gridCoords.gridY + info.offsetY;

            const pixelPos = gridToPixels(module.gridX, module.gridY);
            element.style.left = `${pixelPos.x}px`;
            element.style.top = `${pixelPos.y}px`;
          }
        });
      } else {
        const module = modules.find(m => m.id === dragging.moduleId);
        const element = document.querySelector(`[data-id='${dragging.moduleId}']`);

        if (module && element) {
          module.gridX = gridCoords.gridX + dragging.offsetX;
          module.gridY = gridCoords.gridY + dragging.offsetY;

          const pixelPos = gridToPixels(module.gridX, module.gridY);
          element.style.left = `${pixelPos.x}px`;
          element.style.top = `${pixelPos.y}px`;
        }
      }
    }
    const now = performance.now();
    if (now - lastDragRedraw > DRAG_REDRAW_INTERVAL) {
      requestWireRedraw();
      lastDragRedraw = now;
    }
  }

  if (selectionBox) {
    const left = Math.min(selectionStart.x, e.clientX);
    const top = Math.min(selectionStart.y, e.clientY);
    const width = Math.abs(e.clientX - selectionStart.x);
    const height = Math.abs(e.clientY - selectionStart.y);

    selectionBox.style.left = `${left}px`;
    selectionBox.style.top = `${top}px`;
    selectionBox.style.width = `${width}px`;
    selectionBox.style.height = `${height}px`;
  }


  const now = performance.now();
  if (now - lastDragRedraw > HOVER_CHECK_INTERVAL) {
    checkWireHover(e.clientX, e.clientY);
    requestWireRedraw();
    lastDragRedraw = now;
  }
});

let hoveredWireIndex = -1; // Add this line

// wire hover checking:
function checkWireHover(x, y) {
  if (performanceMode) return;
  if (saveMenuOpen) return;
  if (schematicOpen) return;
  if (dragging) return;
  if (selectionBox) return;

  const targetElement = document.elementFromPoint(x, y);
  const isPort = targetElement && targetElement.dataset &&
    (targetElement.dataset.type === 'input' || targetElement.dataset.type === 'output');

  if (!isPort) {
    let foundHover = -1;
    for (let i = 0; i < wirePaths.length; i++) {
      const path = wirePaths[i];
      if (isNearLine(x, y, path.x1, path.y1, path.x2, path.y2)) {
        foundHover = i;
        break;
      }
    }

    if (foundHover !== hoveredWireIndex) {
      hoveredWireIndex = foundHover;

      // Add or remove cursor class
      if (hoveredWireIndex !== -1) {
        document.body.classList.add('wire-hover');
      } else {
        document.body.classList.remove('wire-hover');
      }

      requestWireRedraw();
    }
  } else {
    if (hoveredWireIndex !== -1) {
      hoveredWireIndex = -1;
      document.body.classList.remove('wire-hover');
      requestWireRedraw();
    }
  }
}

let justSelected = false;
let justFinishedDragging = false;
let justFinishedSelecting = false;
let wasSimpleBlankClick = false;


// Modified mouseup handler to snap modules to grid after dragging
const originalMouseUpHandler = document.addEventListener;
// Modified mouseup handler to snap modules to grid after dragging WITH collision detection
document.addEventListener('mouseup', (e) => {
  if (saveMenuOpen || schematicOpen) return;

  if (dragging && dragging.isCanvasPan) {
    if (!dragging.hasMoved) {
      // Simple click on blank space OR wire - clear all selections or handle wire click
      if (dragging.clickedWireIndex !== undefined) {
        // It was a wire click that didn't move - deselect if selected, otherwise select it
        const wireIndex = dragging.clickedWireIndex;
        if (selectedConnections.has(wireIndex)) {
          selectedConnections.delete(wireIndex);
        } else {
          selectedModules.clear();
          selectedConnections.clear();
          selectedConnections.add(wireIndex);
          updateSelectionHighlights();
        }
        requestWireRedraw();
        updateDeleteButtonState();
        wasSimpleBlankClick = false; // Wire click, not blank space
      } else {
        // It was a blank space click
        wasSimpleBlankClick = true;
        clearSelection();
        selectedConnections.clear();
        updateSelectionHighlights();
        requestWireRedraw();
        updateDeleteButtonState();

        // Clear selectedOutput only on true blank space click
        if (selectedOutput) {
          selectedOutput = null;
          requestWireRedraw();
        }
      }
    } else {
      // Canvas was panned (moved) - don't treat as blank click
      wasSimpleBlankClick = false;
    }
    dragging = null;

    return; // Remove the selectedOutput clearing from here
  }

  if (dragging && !dragging.isCanvasPan) {
    document.querySelectorAll('.module.grabbed').forEach(elem => {
      elem.classList.remove('grabbed');
    });

    if (dragging.isMulti) {
      const movements = [];
      const moduleIds = Object.keys(dragging.modules).map(id => parseInt(id));

      let sumX = 0, sumY = 0;
      Object.keys(dragging.modules).forEach(idStr => {
        const id = parseInt(idStr);
        const module = modules.find(m => m.id === id);
        if (module) {
          sumX += module.gridX;
          sumY += module.gridY;
        }
      });
      const centerX = sumX / moduleIds.length;
      const centerY = sumY / moduleIds.length;

      let targetGridX = Math.round(centerX);
      let targetGridY = Math.round(centerY);

      function checkGroupCollision(offsetX, offsetY) {
        return Object.keys(dragging.modules).some(idStr => {
          const id = parseInt(idStr);
          const module = modules.find(m => m.id === id);
          if (!module) return false;

          const modOffsetX = module.gridX - centerX;
          const modOffsetY = module.gridY - centerY;
          const newX = Math.round(offsetX + modOffsetX);
          const newY = Math.round(offsetY + modOffsetY);

          return isGridPositionOccupied(newX, newY, module.type, moduleIds);
        });
      }

      if (checkGroupCollision(targetGridX, targetGridY)) {
        let found = false;
        for (let r = 1; r <= 50 && !found; r++) {
          for (let angle = 0; angle < 360; angle += 15) {
            const rad = (angle * Math.PI) / 180;
            const testX = Math.round(targetGridX + r * Math.cos(rad));
            const testY = Math.round(targetGridY + r * Math.sin(rad));

            if (!checkGroupCollision(testX, testY)) {
              targetGridX = testX;
              targetGridY = testY;
              found = true;
              break;
            }
          }
        }
      }

      Object.keys(dragging.modules).forEach(idStr => {
        const id = parseInt(idStr);
        const module = modules.find(m => m.id === id);
        const element = document.querySelector(`[data-id='${id}']`);
        const dragInfo = dragging.modules[idStr];

        if (module && element) {
          const offsetX = module.gridX - centerX;
          const offsetY = module.gridY - centerY;

          const newGridX = Math.round(targetGridX + offsetX);
          const newGridY = Math.round(targetGridY + offsetY);

          module.gridX = newGridX;
          module.gridY = newGridY;

          const pixelPos = gridToPixels(newGridX, newGridY);
          element.style.left = `${pixelPos.x}px`;
          element.style.top = `${pixelPos.y}px`;

          if (dragInfo.initialGridX !== module.gridX || dragInfo.initialGridY !== module.gridY) {
            movements.push({
              moduleId: id,
              fromGridX: dragInfo.initialGridX,
              fromGridY: dragInfo.initialGridY,
              toGridX: module.gridX,
              toGridY: module.gridY
            });
          }
        }
      });

      if (movements.length > 0) {
        pushToUndoStack({
          type: 'moveModules',
          movements
        });
      }

      if (isModuleDesigner) {
        updateModulePreview();
      }
    } else if (dragging.moduleId !== undefined) {
      const module = modules.find(m => m.id === dragging.moduleId);
      const element = document.querySelector(`[data-id='${dragging.moduleId}']`);

      if (module && element) {
        let newGridX = Math.round(module.gridX);
        let newGridY = Math.round(module.gridY);

        if (isGridPositionOccupied(newGridX, newGridY, module.type, [dragging.moduleId])) {
          const available = findNearestAvailablePosition(newGridX, newGridY, [dragging.moduleId], module.type);
          newGridX = available.gridX;
          newGridY = available.gridY;
        }

        module.gridX = newGridX;
        module.gridY = newGridY;

        const pixelPos = gridToPixels(newGridX, newGridY);
        element.style.left = `${pixelPos.x}px`;
        element.style.top = `${pixelPos.y}px`;

        if (dragging.initialGridX !== module.gridX || dragging.initialGridY !== module.gridY) {
          pushToUndoStack({
            type: 'moveModule',
            moduleId: dragging.moduleId,
            fromGridX: dragging.initialGridX,
            fromGridY: dragging.initialGridY,
            toGridX: module.gridX,
            toGridY: module.gridY
          });
        }

        if (isModuleDesigner) {
          updateModulePreview();
        }
      }
    }

    justFinishedDragging = true;
    dragging = null;
    requestWireRedraw();
  }

  if (selectionBox) {
    const boxRect = selectionBox.getBoundingClientRect();

    if (!e.shiftKey && !selectToolActive && !e.metaKey && !e.ctrlKey) {
      clearSelection();
      selectedConnections.clear();
    }

    // Select modules
    document.querySelectorAll('.module').forEach(moduleElement => {
      const moduleRect = moduleElement.getBoundingClientRect();
      if (
        boxRect.left < moduleRect.right &&
        boxRect.right > moduleRect.left &&
        boxRect.top < moduleRect.bottom &&
        boxRect.bottom > moduleRect.top
      ) {
        const moduleId = parseInt(moduleElement.dataset.id);
        selectedModules.add(moduleId);
      }
    });

    // Select wires that intersect the selection box
    wirePaths.forEach((path, i) => {
      if (lineIntersectsRect(path.x1, path.y1, path.x2, path.y2, boxRect)) {
        selectedConnections.add(i);
      }
    });

    selectionBox.remove();
    selectionBox = null;

    updateSelectionHighlights();
    requestWireRedraw();
    updateDeleteButtonState();
    justFinishedSelecting = true;
  }
});

function centerPatchToOrigin() {
  if (modules.length === 0) {
    console.warn('No modules to center');
    return;
  }

  // Calculate the current bounding box of all modules
  let minX = Infinity, minY = Infinity;
  let maxX = -Infinity, maxY = -Infinity;

  modules.forEach(module => {
    const dims = getModuleGridDimensions(module.type);
    minX = Math.min(minX, module.gridX);
    minY = Math.min(minY, module.gridY);
    maxX = Math.max(maxX, module.gridX + dims.width);
    maxY = Math.max(maxY, module.gridY + dims.height);
  });

  // Calculate the center of all modules
  const centerX = (minX + maxX) / 2;
  const centerY = (minY + maxY) / 2;

  // Calculate offset to move center to origin (with some padding)
  const targetX = 250; // 10 grid units from left edge
  const targetY = 250; // 10 grid units from top edge

  const offsetX = targetX - centerX;
  const offsetY = targetY - centerY;

  // Check if any module would go out of bounds with this offset
  let adjustedOffsetX = offsetX;
  let adjustedOffsetY = offsetY;

  modules.forEach(module => {
    const dims = getModuleGridDimensions(module.type);
    const newX = module.gridX + offsetX;
    const newY = module.gridY + offsetY;

    // Adjust offset if module would go out of bounds
    if (newX < CANVAS_BOUNDS.minX) {
      adjustedOffsetX = Math.max(adjustedOffsetX, CANVAS_BOUNDS.minX - module.gridX);
    }
    if (newY < CANVAS_BOUNDS.minY) {
      adjustedOffsetY = Math.max(adjustedOffsetY, CANVAS_BOUNDS.minY - module.gridY);
    }
    if (newX + dims.width > CANVAS_BOUNDS.maxX) {
      adjustedOffsetX = Math.min(adjustedOffsetX, CANVAS_BOUNDS.maxX - dims.width - module.gridX);
    }
    if (newY + dims.height > CANVAS_BOUNDS.maxY) {
      adjustedOffsetY = Math.min(adjustedOffsetY, CANVAS_BOUNDS.maxY - dims.height - module.gridY);
    }
  });

  // Store movements for undo
  const movements = [];

  // Move all modules
  modules.forEach(module => {
    const oldGridX = module.gridX;
    const oldGridY = module.gridY;

    module.gridX = Math.round(module.gridX + adjustedOffsetX);
    module.gridY = Math.round(module.gridY + adjustedOffsetY);

    // Update visual position
    const element = document.querySelector(`[data-id='${module.id}']`);
    if (element) {
      const pixelPos = gridToPixels(module.gridX, module.gridY);
      element.style.left = `${pixelPos.x}px`;
      element.style.top = `${pixelPos.y}px`;
    }

    movements.push({
      moduleId: module.id,
      fromGridX: oldGridX,
      fromGridY: oldGridY,
      toGridX: module.gridX,
      toGridY: module.gridY
    });
  });

  // Add to undo stack
  // if (movements.length > 0) {
  //   pushToUndoStack({
  //     type: 'moveModules',
  //     movements
  //   });
  // }

  // Redraw wires and update view
  requestWireRedraw();

  // Optionally fit to view after centering
  setTimeout(() => {
    fitToView(false);
  }, 50);
}


// Fit all modules (or selected modules) into view with padding
function fitToView(selectedOnly = false) {
  // Determine which modules to fit
  const modulesToFit = selectedOnly && selectedModules.size > 0
    ? modules.filter(m => selectedModules.has(m.id))
    : modules;

  if (modulesToFit.length === 0) {
    console.warn('No modules to fit');
    return;
  }

  // Calculate bounding box of modules
  let minX = Infinity, minY = Infinity;
  let maxX = -Infinity, maxY = -Infinity;

  modulesToFit.forEach(module => {
    const pixelPos = gridToPixels(module.gridX, module.gridY);
    const dims = getModuleGridDimensions(module.type);
    const moduleWidth = dims.width * viewState.gridSize;
    const moduleHeight = dims.height * viewState.gridSize;

    minX = Math.min(minX, pixelPos.x);
    minY = Math.min(minY, pixelPos.y);
    maxX = Math.max(maxX, pixelPos.x + moduleWidth);
    maxY = Math.max(maxY, pixelPos.y + moduleHeight);
  });

  // Get actual viewport size
  const viewportWidth = window.innerWidth;
  const viewportHeight = window.innerHeight;

  // Calculate content dimensions
  const contentWidth = maxX - minX;
  const contentHeight = maxY - minY;

  // Prevent division by zero
  if (contentWidth === 0 || contentHeight === 0) {
    console.warn('Content has zero dimensions');
    return;
  }

  // Calculate scale to fit with padding
  const padding = 100; // pixels of padding around content
  const scaleX = (viewportWidth - 2 * padding) / contentWidth;
  const scaleY = (viewportHeight - 2 * padding) / contentHeight;
  let scale = Math.min(scaleX, scaleY, MAX_ZOOM); // Cap at maximum zoom

  // Ensure scale is valid and reasonable
  scale = Math.max(MIN_ZOOM, Math.min(MAX_ZOOM, scale));

  // Calculate offsets to center content
  const centerX = (minX + maxX) / 2;
  const centerY = (minY + maxY) / 2;
  const offsetX = viewportWidth / 2 - centerX * scale;
  const offsetY = viewportHeight / 2 - centerY * scale;

  // Apply view state
  viewState.scale = scale;
  viewState.offsetX = offsetX;
  viewState.offsetY = offsetY;

  updateViewTransform();
  updateZoomText();
  requestWireRedraw();
}

document.addEventListener("keydown", (e) => {
  const isEditing =
    document.activeElement.tagName === 'INPUT' ||
    document.activeElement.tagName === 'TEXTAREA' ||
    document.activeElement.getAttribute('contenteditable') === 'true';

  const metaOrCtrl = e.metaKey || e.ctrlKey;

  // Handle Escape key (works even when editing)
  if (e.key === 'Escape') {
    if (performanceMode) {
      exitPerformanceMode();
      return;
    }
    if (assignPerformanceMode) {
      exitAssignmentMode();
      hidePerformanceTooltip();
      e.preventDefault();
      return;
    }
    if (selectToolActive) {
      selectToolActive = false;
      selectButton.classList.remove('active');
      e.preventDefault();
      return;
    }
    if (selectedOutput) {
      selectedOutput = null;
      requestWireRedraw();
      e.preventDefault();
      return;
    }
  }

  // Handle Tab key (works even when editing)
  if (e.key === 'Tab') {
    if (performanceMode) {
      exitPerformanceMode();
    } else {
      enterPerformanceMode();
    }
    return;
  }

  // Exit early if editing - all shortcuts below require not editing
  if (isEditing) return;

  // Fit all modules: Cmd/Ctrl + 0
  if (metaOrCtrl && !e.shiftKey && e.key === '0') {
    e.preventDefault();
    fitToView(false);
    return;
  }

  // Fit selected modules: Cmd/Ctrl + Shift + 0
  if (metaOrCtrl && e.shiftKey && e.key === '0' && selectedModules.size > 0) {
    e.preventDefault();
    fitToView(true);
    return;
  }

  // Copy: Cmd+C or Ctrl+C
  if (metaOrCtrl && e.key === 'c') {
    copySelectedModules();
    return;
  }

  // Paste: Cmd+V or Ctrl+V
  if (metaOrCtrl && e.key === 'v') {
    pasteModules(mouseX, mouseY);
    return;
  }

  // Cut: Cmd+X or Ctrl+X
  if (metaOrCtrl && e.key === 'x') {
    e.preventDefault();
    cutSelectedModules();
    return;
  }

  // Select All: Cmd+A or Ctrl+A
  if (metaOrCtrl && e.key === 'a') {
    e.preventDefault();
    selectAll();
    return;
  }

  // Undo: Cmd+Z or Ctrl+Z
  if (metaOrCtrl && !e.shiftKey && e.key === 'z') {
    e.preventDefault();
    undo();
    return;
  }

  // Redo: Cmd+Shift+Z or Ctrl+Shift+Z or Ctrl+Y
  if ((metaOrCtrl && e.shiftKey && e.key === 'z') || (metaOrCtrl && e.key === 'y')) {
    e.preventDefault();
    redo();
    return;
  }

  // Delete: Delete or Backspace key
  if (e.key === 'Delete' || e.key === 'Backspace') {
    deleteSelectedItems();
    return;
  }

  // Module creation shortcuts (require Shift key)
  if (!e.shiftKey) return;

  const key = e.key.toUpperCase();

  // Sources
  if (key === "Q") return createModule("Oscillator", true, mouseX, mouseY);
  if (key === "E") return createModule("Noise", true, mouseX, mouseY);

  // Utilities
  if (key === "B") return createModule("Button", true, mouseX, mouseY);
  if (key === "W") return createModule("Output", true, mouseX, mouseY);

  // Sequential Logic
  if (key === "F") return createModule("Flip-Flop", true, mouseX, mouseY);
  if (key === "C") return createModule("Binary Counter", true, mouseX, mouseY);
  if (key === "D") return createModule("Ring Counter", true, mouseX, mouseY);
  if (key === "R") return createModule("Shift Register", true, mouseX, mouseY);
  if (key === "X") return createModule("Multiplexer", true, mouseX, mouseY);
  if (key === "T") return createModule("Binary Rate Multiplier", true, mouseX, mouseY);

  // Gates via Shift + numbers
  const gateMap = {
    "!": "AND",
    "@": "OR",
    "#": "NOT",
    "$": "NAND",
    "%": "NOR",
    "^": "XOR",
    "&": "XNOR",
  };

  if (gateMap[key]) {
    return createModule(gateMap[key], true, mouseX, mouseY);
  }
});

// Add these variables at the top with your other globals
let touchMoved = false;
let touchStartTime = 0;
const TOUCH_MOVE_THRESHOLD = 10; // pixels
let touchStartX = 0;
let touchStartY = 0;
let touchStartedOnPort = false;

if (isTouchDevice()) {
  document.addEventListener('touchstart', (e) => {
    if (saveMenuOpen || schematicOpen) return;

    if (e.touches.length === 2) {
      return; // Let the zoom handler deal with it
    }

    // Reset touch tracking
    touchMoved = false;
    touchStartTime = Date.now();
    const touch = e.touches[0];
    touchStartX = touch.clientX;
    touchStartY = touch.clientY;

    // Check if starting on a port
    touchStartedOnPort = e.target.dataset &&
      (e.target.dataset.type === 'input' || e.target.dataset.type === 'output');

    // Allow scrolling in mobile menus
    if (e.target.closest('#mobile-module-menu') ||
      e.target.closest('#mobile-utility-menu') ||
      e.target.closest('.controls-content') ||
      e.target.closest('.save-load-container')) {
      return;
    }

    // Allow native slider handling
    if (e.target.type === 'range' || e.target.classList.contains('freq-slider')) {
      return;
    }

    // Allow native click handling for buttons and UI control elements
    if (e.target.tagName === 'BUTTON' ||
      e.target.closest('button') ||
      e.target.closest('.iconify') ||
      e.target.closest('.undoRedoButton') ||
      e.target.closest('#toggle-controls') ||
      e.target.closest('#tutorialButton') ||
      e.target.closest('.mobile-fab') ||
      e.target.closest('#mobile-edit-bar') ||
      e.target.closest('.ui-controls')) {
      return;
    }

    e.preventDefault();

    // Check if touching near a wire (but don't break it yet)
    // Only check if NOT starting on a port
    if (!touchStartedOnPort && e.touches.length === 1) {
      const touch = e.touches[0];

      // Check if touching a wire
      let touchedWireIndex = -1;
      for (let i = 0; i < wirePaths.length; i++) {
        const path = wirePaths[i];
        if (isNearLine(touch.clientX, touch.clientY, path.x1, path.y1, path.x2, path.y2)) {
          touchedWireIndex = i;
          break;
        }
      }

      if (touchedWireIndex !== -1) {
        // If select tool is active, toggle wire selection
        if (selectToolActive) {
          if (selectedConnections.has(touchedWireIndex)) {
            selectedConnections.delete(touchedWireIndex);
          } else {
            selectedConnections.add(touchedWireIndex);
          }
        } else {
          // Without select tool: clear all and select only this wire
          selectedModules.clear();
          selectedConnections.clear();
          selectedConnections.add(touchedWireIndex);
          updateSelectionHighlights();
        }
        requestWireRedraw();
        updateDeleteButtonState();
        return;
      }

      // If not touching a wire, dispatch mousedown as before
      const simulatedEvent = new MouseEvent('mousedown', {
        clientX: touch.clientX,
        clientY: touch.clientY,
        button: 0,
        bubbles: true,
        cancelable: true
      });
      e.target.dispatchEvent(simulatedEvent);
    }

    // Don't dispatch mousedown yet if starting on port - wait to see if user drags
    if (!touchStartedOnPort && e.touches.length === 1) {
      const simulatedEvent = new MouseEvent('mousedown', {
        clientX: touch.clientX,
        clientY: touch.clientY,
        button: 0,
        bubbles: true,
        cancelable: true
      });
      e.target.dispatchEvent(simulatedEvent);
    }
  }, { passive: false });

  document.addEventListener('touchmove', (e) => {
    if (saveMenuOpen || schematicOpen) return;

    if (e.touches.length === 2) {
      return; // Let the zoom handler deal with it
    }

    // Track if touch has moved significantly
    if (e.touches.length === 1) {
      const touch = e.touches[0];
      const deltaX = Math.abs(touch.clientX - touchStartX);
      const deltaY = Math.abs(touch.clientY - touchStartY);

      if (deltaX > TOUCH_MOVE_THRESHOLD || deltaY > TOUCH_MOVE_THRESHOLD) {
        // If touch started on port and now moved, convert to drag
        if (touchStartedOnPort && !touchMoved) {
          // Find the module element
          const moduleElement = e.target.closest('.module');
          if (moduleElement) {
            // Dispatch a mousedown on the module to start dragging
            const simulatedEvent = new MouseEvent('mousedown', {
              clientX: touchStartX,
              clientY: touchStartY,
              button: 0,
              bubbles: true,
              cancelable: true
            });
            moduleElement.dispatchEvent(simulatedEvent);
          }
        }
        touchMoved = true;
      }
    }

    // Allow scrolling in mobile menus
    if (e.target.closest('#mobile-module-menu') ||
      e.target.closest('#mobile-utility-menu') ||
      e.target.closest('.controls-content') ||
      e.target.closest('.save-load-container')) {
      return;
    }

    if (e.target.type === 'range' || e.target.classList.contains('freq-slider')) {
      return;
    }

    // Allow native handling for UI controls
    if (e.target.tagName === 'BUTTON' ||
      e.target.closest('button') ||
      e.target.closest('.iconify') ||
      e.target.closest('.undoRedoButton') ||
      e.target.closest('#toggle-controls') ||
      e.target.closest('#tutorialButton') ||
      e.target.closest('.mobile-fab') ||
      e.target.closest('#mobile-edit-bar') ||
      e.target.closest('.ui-controls')) {
      return;
    }

    e.preventDefault();

    if (e.touches.length === 1) {
      const touch = e.touches[0];
      const simulatedEvent = new MouseEvent('mousemove', {
        clientX: touch.clientX,
        clientY: touch.clientY,
        bubbles: true,
        cancelable: true
      });
      e.target.dispatchEvent(simulatedEvent);
    }
  }, { passive: false });

  document.addEventListener('touchend', (e) => {
    if (saveMenuOpen || schematicOpen) return;

    // Allow normal behavior in mobile menus
    if (e.target.closest('#mobile-module-menu') ||
      e.target.closest('#mobile-utility-menu')) {
      return;
    }

    //Allow native handling for snippet items and delete buttons
    if (e.target.closest('.snippet-item') ||
      e.target.closest('.snippet-delete') ||
      e.target.closest('#createSnippetBtn') ||
      e.target.closest('.dictionary-page-btn')) {
      return;
    }

    if (e.target.type === 'range' || e.target.classList.contains('freq-slider')) {
      return;
    }

    // Allow native click handling for buttons and UI controls
    if (e.target.tagName === 'BUTTON' ||
      e.target.closest('button') ||
      e.target.closest('.iconify') ||
      e.target.closest('.undoRedoButton') ||
      e.target.closest('#toggle-controls') ||
      e.target.closest('#tutorialButton') ||
      e.target.closest('.mobile-fab') ||
      e.target.closest('#mobile-edit-bar') ||
      e.target.closest('.performance-exit-btn') ||
      e.target.closest('.ui-controls')) {
      return;
    }

    // e.preventDefault();

    // Get the touch that ended
    const touch = e.changedTouches[0];

    // Dispatch mouseup
    const mouseUpEvent = new MouseEvent('mouseup', {
      clientX: touch.clientX,
      clientY: touch.clientY,
      bubbles: true,
      cancelable: true
    });
    e.target.dispatchEvent(mouseUpEvent);

    // Only dispatch click if touch didn't move AND didn't start on a port being dragged
    if (!touchMoved) {
      const clickEvent = new MouseEvent('click', {
        clientX: touch.clientX,
        clientY: touch.clientY,
        bubbles: true,
        cancelable: true
      });
      e.target.dispatchEvent(clickEvent);
    }

    // Reset port tracking
    touchStartedOnPort = false;

  }, { passive: false });
}


function selectModule(moduleId) {
  selectedModules.add(moduleId);
}

function clearSelection() {
  selectedModules.clear();
}

function selectAll() {
  clearSelection();

  // Select all modules
  document.querySelectorAll('.module').forEach(moduleElement => {
    const moduleId = parseInt(moduleElement.dataset.id);
    selectedModules.add(moduleId);
  });

  // Select all connections
  connections.forEach((conn, i) => {
    selectedConnections.add(i);
  });

  updateSelectionHighlights();
  requestWireRedraw();
  updateDeleteButtonState();
}

function cutSelectedModules() {
  if (selectedModules.size === 0) return;

  copySelectedModules();

  // Filter out Output and Oscilloscope modules
  const modulesToCut = Array.from(selectedModules).filter(id => {
    const m = modules.find(mod => mod.id === id);
    return m && m.type !== 'Output' && m.type !== 'Oscilloscope';
  });

  if (modulesToCut.length === 0) return;

  // Gather info for undo stack
  const modulesInfo = [];
  modulesToCut.forEach(id => {
    const moduleData = modules.find(m => m.id === id);
    if (!moduleData) return;

    const moduleElement = document.querySelector(`[data-id='${id}']`);
    const position = moduleElement
      ? {
        left: parseInt(moduleElement.style.left || 0),
        top: parseInt(moduleElement.style.top || 0)
      }
      : { left: 0, top: 0 };

    modulesInfo.push({ moduleData: { ...moduleData }, position });
  });

  // Collect affected connections
  const affectedConnections = connections.filter(conn =>
    modulesToCut.includes(conn.from) || modulesToCut.includes(conn.to)
  );

  // Record the cut operation for undo
  pushToUndoStack({
    type: 'deleteModules',
    modules: modulesInfo,
    connections: [...affectedConnections]
  });

  // Delete only the allowed modules
  modulesToCut.forEach(id => deleteModuleWithoutRecord(id));

  // Clear ALL selections (modules and wires)
  selectedModules.clear();
  selectedConnections.clear();

  updateSelectionHighlights();
  requestWireRedraw();
  updateDeleteButtonState();

  if (audioStarted) {
    rebuildAudioGraph();
  }
}

// Add click handler for module selection
function addModuleSelectionHandler(moduleElement) {
  moduleElement.addEventListener('mousedown', (e) => {
    // Only handle port clicks here, let document handler deal with selection
    if (e.target.dataset && (e.target.dataset.type === 'input' || e.target.dataset.type === 'output')) {
      // Let port handling code work
      return;
    }

    // Don't handle anything else - let it bubble to document handler
    // The document handler will handle all selection logic
  });
}

// Clear the selection when clicking on empty space
document.addEventListener('click', (e) => {
  if (justSelected) {
    justSelected = false; // reset the flag
    return; // Don't clear selection
  }
  // if (!e.target.closest('.module') && !selectionBox) {
  //     clearSelection();
  //     updateSelectionHighlights();
  // }
});

function updateSelectionHighlights() {
  // Remove highlights from all modules
  document.querySelectorAll('.module').forEach(module => {
    // Don't override grabbed shadow
    if (!module.classList.contains('grabbed')) {
      module.style.boxShadow = 'none';
    }
  });

  // Add highlights to selected modules
  selectedModules.forEach(id => {
    const module = document.querySelector(`[data-id='${id}']`);
    if (module && !module.classList.contains('grabbed')) {
      module.style.boxShadow = '0 0 0 3px var(--module-selected-border)';
    }
  });

  updateDeleteButtonState();
  updateCopyPasteButtonState();
  updateSnippetButtonState();
  notifySelectionChanged();
}


function updateCopyPasteButtonState() {
  // Copy is enabled if at least one module is selected
  if (selectedModules.size > 0) {
    copyButton.classList.remove('disabled');
    cutButton.classList.remove('disabled');
    copyButton.disabled = false;
    cutButton.disabled = false;
  } else {
    copyButton.classList.add('disabled');
    cutButton.classList.add('disabled');
    copyButton.disabled = true;
    cutButton.disabled = true;
  }

  // Paste is enabled if there is something in the clipboard
  if (clipboard && clipboard.modules.length > 0) {
    pasteButton.classList.remove('disabled');
    pasteButton.disabled = false;
  } else {
    pasteButton.classList.add('disabled');
    pasteButton.disabled = true;
  }
}

function copySelectedModules() {
  if (selectedModules.size === 0) return;

  const modulesToCopy = modules.filter(m =>
    selectedModules.has(m.id) && m.type !== 'Output' && m.type !== 'Oscilloscope'
  );

  const validModuleIds = new Set(modulesToCopy.map(m => m.id));

  const connectionsToCopy = connections.filter(conn =>
    validModuleIds.has(conn.from) && validModuleIds.has(conn.to)
  );

  const minGridX = Math.min(...modulesToCopy.map(m => m.gridX));
  const minGridY = Math.min(...modulesToCopy.map(m => m.gridY));

  clipboard = {
    modules: modulesToCopy.map(m => ({
      ...m,
      memoryData: m.memoryData ? [...m.memoryData] : undefined  // Add this line - deep copy array
    })),
    connections: connectionsToCopy,
    offsetGridX: minGridX,
    offsetGridY: minGridY
  };

  updateCopyPasteButtonState();
}

// Modified pasteModules to use snap-to-grid and collision detection
function pasteModules(screenX, screenY) {
  if (!clipboard || clipboard.modules.length === 0) return;

  // Filter out Inlet and Outlet modules if not in Module Designer
  if (!isModuleDesigner) {
    clipboard.modules = clipboard.modules.filter(m => m.type !== 'Inlet' && m.type !== 'Outlet');
    // Also filter connections that might involve these removed modules
    const validIds = new Set(clipboard.modules.map(m => m.id));
    clipboard.connections = clipboard.connections.filter(c => validIds.has(c.from) && validIds.has(c.to));

    if (clipboard.modules.length === 0) return;
  }

  if (!isBomExport) {
    clipboard.modules = clipboard.modules.filter(m => m.type !== 'ExportInlet' && m.type !== 'ExportOutlet' && m.type !== 'ExportLed');
    // Also filter connections that might involve these removed modules
    const validIds = new Set(clipboard.modules.map(m => m.id));
    clipboard.connections = clipboard.connections.filter(c => validIds.has(c.from) && validIds.has(c.to));

    if (clipboard.modules.length === 0) return;
  }

  clearSelection();

  const gridPos = screenToGrid(screenX, screenY);

  // Calculate bounding box
  const minX = Math.min(...clipboard.modules.map(m => m.gridX));
  const maxX = Math.max(...clipboard.modules.map(m => m.gridX));
  const minY = Math.min(...clipboard.modules.map(m => m.gridY));
  const maxY = Math.max(...clipboard.modules.map(m => m.gridY));

  const centerX = (minX + maxX) / 2;
  const centerY = (minY + maxY) / 2;

  let targetGridX = Math.round(gridPos.gridX);
  let targetGridY = Math.round(gridPos.gridY);

  // Check if ANY module in group would collide
  function checkGroupCollision(offsetX, offsetY) {
    return clipboard.modules.some(origModule => {
      const modOffsetX = origModule.gridX - centerX;
      const modOffsetY = origModule.gridY - centerY;
      const newX = Math.round(offsetX + modOffsetX);
      const newY = Math.round(offsetY + modOffsetY);
      return isGridPositionOccupied(newX, newY, origModule.type, []);
    });
  }

  // If collision, spiral search for valid group position
  if (checkGroupCollision(targetGridX, targetGridY)) {
    let found = false;
    for (let r = 1; r <= 50 && !found; r++) {
      for (let angle = 0; angle < 360; angle += 15) {
        const rad = (angle * Math.PI) / 180;
        const testX = Math.round(targetGridX + r * Math.cos(rad));
        const testY = Math.round(targetGridY + r * Math.sin(rad));

        if (!checkGroupCollision(testX, testY)) {
          targetGridX = testX;
          targetGridY = testY;
          found = true;
          break;
        }
      }
    }
  }

  const idMapping = {};
  const pastedModules = [];

  clipboard.modules.forEach(origModule => {
    const newId = moduleId++;
    idMapping[origModule.id] = newId;

    const offsetX = origModule.gridX - centerX;
    const offsetY = origModule.gridY - centerY;
    const newGridX = Math.round(targetGridX + offsetX);
    const newGridY = Math.round(targetGridY + offsetY);

    const moduleData = {
      id: newId,
      type: origModule.type,
      gridX: newGridX,
      gridY: newGridY,
      freq: origModule.freq,
      assignedKey: origModule.assignedKey,
      memoryData: origModule.memoryData ? [...origModule.memoryData] : undefined
    };

    // Attach definition for custom modules so audio worklet can process them
    if (customModuleDefinitions[origModule.type]) {
      moduleData.definition = customModuleDefinitions[origModule.type];
    }

    modules.push(moduleData);
    pastedModules.push({ ...moduleData });

    const div = document.createElement('div');
    div.className = 'module';
    div.dataset.id = newId;
    div.dataset.type = origModule.type;

    setupModuleUI(div, origModule.type, origModule.freq);
    if (origModule.assignedKey) {
      updateButtonKeyMapping(div, origModule.assignedKey);
    }

    const pixelPos = gridToPixels(newGridX, newGridY);
    div.style.position = 'absolute';
    div.style.left = `${pixelPos.x}px`;
    div.style.top = `${pixelPos.y}px`;
    div.style.transform = 'none';

    document.getElementById('moduleContainer').appendChild(div);
    selectedModules.add(newId);
  });

  const pastedConnections = [];
  clipboard.connections.forEach(conn => {
    const newConnection = {
      from: idMapping[conn.from],
      fromOutputIndex: conn.fromOutputIndex,
      to: idMapping[conn.to],
      inputIndex: conn.inputIndex
    };
    connections.push(newConnection);
    pastedConnections.push({ ...newConnection });
  });

  pushToUndoStack({
    type: 'pasteModules',
    pastedModules,
    pastedConnections,
    pastedModuleIds: pastedModules.map(m => m.id)  // Add this line
  });

  updateSelectionHighlights();
  rebuildAudioGraph();
  requestWireRedraw();
  updateOscillatorCheckboxes();
  updateButtonCheckboxes();
  updateModulePreview();
}


function updateDeleteButtonState() {
  if (selectedModules.size === 0 && selectedConnections.size === 0) {
    deleteButton.classList.add('disabled');
    deleteButton.disabled = true;
  } else {
    deleteButton.classList.remove('disabled');
    deleteButton.disabled = false;
  }
}

function deleteSelectedModules() {
  if (selectedModules.size === 0) return;

  // Convert set to array to avoid modification during iteration
  const modulesToDelete = Array.from(selectedModules);

  // Gather information about all modules before deletion
  const modulesInfo = [];
  modulesToDelete.forEach(id => {
    const moduleData = modules.find(m => m.id === id);
    if (!moduleData) return;

    const moduleElement = document.querySelector(`[data-id='${id}']`);

    // Store the exact current position of the module
    const position = moduleElement ? {
      left: parseInt(moduleElement.style.left || 0),
      top: parseInt(moduleElement.style.top || 0)
    } : { left: 0, top: 0 };

    modulesInfo.push({
      moduleData: { ...moduleData },
    });
  });

  // Find all connections between selected modules
  const affectedConnections = connections.filter(conn =>
    modulesToDelete.includes(conn.from) || modulesToDelete.includes(conn.to)
  );

  // Record for undo history
  pushToUndoStack({
    type: 'deleteModules',
    modules: modulesInfo,
    connections: [...affectedConnections]
  });

  // Delete each selected module using the non-recording version
  modulesToDelete.forEach(id => {
    deleteModuleWithoutRecord(id);
  });

  // Clear selection
  clearSelection();
  updateSelectionHighlights();
  requestWireRedraw();
  // only clear eeprom programmers if any eeprom modules were deleted
  if (modulesInfo.some(m => m.moduleData.type === 'EEPROM')) {
    closeAllEEPROMProgrammers();
  }
  updateDeleteButtonState();
  // Rebuild audio graph
  if (audioStarted) {
    rebuildAudioGraph();
  }

  // Update module designer if active
  if (isModuleDesigner) {
    updateOscillatorCheckboxes();
    updateButtonCheckboxes();
    updateModulePreview();
  }
}

function deleteSelectedItems() {
  if (selectedModules.size === 0 && selectedConnections.size === 0) return;

  const modulesToDelete = Array.from(selectedModules);
  const connectionsToDelete = Array.from(selectedConnections).sort((a, b) => b - a);

  // Gather module info
  const modulesInfo = [];
  modulesToDelete.forEach(id => {
    const moduleData = modules.find(m => m.id === id);
    if (!moduleData) return;
    modulesInfo.push({ moduleData: { ...moduleData } });
  });

  // Gather connection info (both selected and affected by module deletion)
  const affectedConnections = connections.filter(conn =>
    modulesToDelete.includes(conn.from) || modulesToDelete.includes(conn.to)
  );

  const deletedConnections = [];
  connectionsToDelete.forEach(index => {
    if (index < connections.length) {
      deletedConnections.push({ ...connections[index] });
    }
  });

  // Combine and deduplicate connections
  const allDeletedConnections = [...deletedConnections];
  affectedConnections.forEach(conn => {
    if (!allDeletedConnections.some(c =>
      c.from === conn.from && c.to === conn.to &&
      c.fromOutputIndex === conn.fromOutputIndex && c.inputIndex === conn.inputIndex)) {
      allDeletedConnections.push({ ...conn });
    }
  });

  // Single undo push for everything
  if (modulesInfo.length > 0 || allDeletedConnections.length > 0) {
    pushToUndoStack({
      type: 'deleteItems',
      modules: modulesInfo,
      connections: allDeletedConnections
    });
  }

  // Perform deletions
  connectionsToDelete.forEach(index => {
    if (index < connections.length) {
      connections.splice(index, 1);
    }
  });

  modulesToDelete.forEach(id => {
    deleteModuleWithoutRecord(id);
  });

  // Clear selections
  selectedModules.clear();
  selectedConnections.clear();
  updateSelectionHighlights();
  requestWireRedraw();
  updateDeleteButtonState();
  if (modulesInfo.some(m => m.moduleData.type === 'EEPROM')) {
    closeAllEEPROMProgrammers();
  }

  if (audioStarted) {
    rebuildAudioGraph();
  }
  updateOscillatorCheckboxes();
  updateButtonCheckboxes();
  updateModulePreview();
}


function deleteSelectedConnections() {
  if (selectedConnections.size === 0) return;

  const connectionsToDelete = Array.from(selectedConnections).sort((a, b) => b - a); // Sort descending to avoid index issues
  const deletedConnections = [];

  connectionsToDelete.forEach(index => {
    if (index < connections.length) {
      deletedConnections.push({ ...connections[index] });
      connections.splice(index, 1);
    }
  });

  if (deletedConnections.length > 0) {
    pushToUndoStack({
      type: 'removeConnections', // New type for multiple connections
      connections: deletedConnections
    });
  }

  selectedConnections.clear();
  requestWireRedraw();
  updateDeleteButtonState();

  if (audioStarted) {
    rebuildAudioGraph();
  }
}

let currentRowTop = 180;  // track vertical position for wrapping
const baseLeft = 40;
const baseTop = 180;
const wrapThreshold = window.innerWidth - 100; // wrap earlier to avoid cutoff

function createModule(type, shouldFlash = true, targetX = null, targetY = null) {
  if (type === 'Output') {
    if (outModuleCreated) {
      syncMobileOutputButton();
      return;
    }
    outModuleCreated = true;

    const button = document.getElementById('createOutputModuleButton');
    if (button) {
      button.classList.add('fake-disabled');
      button.addEventListener('click', (e) => {
        if (button.classList.contains('fake-disabled')) {
          e.preventDefault();
          e.stopPropagation();
          syncMobileOutputButton();
          return;
        }
      }, true);
    }
  }

  if (type === 'Oscilloscope') {
    if (scopeModuleCreated) {
      // Show a message that scope already exists
      return;
    }
    scopeModuleCreated = true;

    // Disable the create button
    const button = document.getElementById('createOscilloscopeButton');
    if (button) {
      button.classList.add('fake-disabled');
      button.addEventListener('click', (e) => {
        if (button.classList.contains('fake-disabled')) {
          e.preventDefault();
          e.stopPropagation();
          return;
        }
      }, true);
    }
  }

  const div = document.createElement('div');
  div.className = 'module';
  div.dataset.id = moduleId;
  div.dataset.type = type;

  let centerGrid;

  // Use provided coordinates if available, otherwise use viewport center
  if (targetX !== null && targetY !== null) {
    centerGrid = screenToGrid(targetX, targetY);
  } else {
    const viewportCenterX = window.innerWidth / 2;
    const viewportCenterY = window.innerHeight / 2;
    centerGrid = screenToGrid(viewportCenterX, viewportCenterY);
  }

  // Find available position near the target
  const gridPos = findNearestAvailablePosition(centerGrid.gridX, centerGrid.gridY, [], type);

  const newModule = {
    id: moduleId++,
    type: type,
    gridX: gridPos.gridX,
    gridY: gridPos.gridY,
    inputs: [],
    outputs: []
  };

  // If it's a custom module, attach the definition
  if (customModuleDefinitions[type]) {
    newModule.definition = customModuleDefinitions[type];
    // Also set label if not present?
    // newModule.label = type;
  }

  if (type === 'Oscillator') {
    newModule.freq = 220;
  } else if (type === 'Harmonic Oscillator') {
    newModule.baseFreq = 55;
  } else if (type === 'Noise') {
    newModule.density = 0.5;
    newModule.holdSamples = 1;
    newModule.clockMode = false;
  } else if (type === 'EEPROM') {
    newModule.memoryData = new Array(256).fill(0);
  } else if (type === 'Inlet' || type === 'Outlet') {
    newModule.label = type === 'Inlet' ? 'IN' : 'OUT';
  } else if (type === 'ExportOutlet') {
    newModule.label = 'OUT';
  } else if (type === 'ExportLed') {
    newModule.label = 'LED';
  }

  modules.push(newModule);
  setupModuleUI(div, type);

  const pixelPos = gridToPixels(gridPos.gridX, gridPos.gridY);
  div.style.position = 'absolute';
  div.style.left = `${pixelPos.x}px`;
  div.style.top = `${pixelPos.y}px`;
  div.style.transform = 'none';

  document.getElementById('moduleContainer').appendChild(div);

  if (shouldFlash) {
    div.classList.add('module-flash');
    // Remove the class after animation completes
    setTimeout(() => {
      div.classList.remove('module-flash');
    }, 1200); // 0.6s * 2 iterations = 1200ms
  }

  pushToUndoStack({
    type: 'createModule',
    moduleData: { ...newModule }
  });

  // moduleId++;

  if (audioStarted) rebuildAudioGraph();

  // Send EEPROM data to worklet for newly pasted modules
  if (audioStarted && type === 'EEPROM' && workletNode) {
    workletNode.port.postMessage({
      type: 'programEEPROM',
      moduleId: newModule.id,
      memoryData: newModule.memoryData
    });
  }

  requestWireRedraw();
  updateOscillatorCheckboxes();
  updateButtonCheckboxes();
  updateModulePreview();
}

function findNearestAvailablePosition(targetGridX, targetGridY, excludeIds = [], moduleType = 'default') {
  const searchRadius = 150;
  let bestPos = null;
  let bestDist = Infinity;

  // Get module dimensions for boundary checking
  const dims = typeof moduleType === 'string' ?
    getModuleGridDimensions(moduleType) :
    { width: 7, height: 4 };

  // Clamp target to valid bounds
  targetGridX = Math.max(CANVAS_BOUNDS.minX, Math.min(CANVAS_BOUNDS.maxX - dims.width, Math.round(targetGridX)));
  targetGridY = Math.max(CANVAS_BOUNDS.minY, Math.min(CANVAS_BOUNDS.maxY - dims.height, Math.round(targetGridY)));

  // Spiral search - check outward from target
  for (let r = 0; r <= searchRadius; r++) {
    // Check all positions at this radius
    for (let angle = 0; angle < 360; angle += 15) {
      const rad = (angle * Math.PI) / 180;
      const testX = Math.round(targetGridX + r * Math.cos(rad));
      const testY = Math.round(targetGridY + r * Math.sin(rad));

      // Skip if outside canvas bounds
      if (testX < CANVAS_BOUNDS.minX || testX + dims.width > CANVAS_BOUNDS.maxX ||
        testY < CANVAS_BOUNDS.minY || testY + dims.height > CANVAS_BOUNDS.maxY) {
        continue;
      }

      if (!isGridPositionOccupied(testX, testY, moduleType, excludeIds)) {
        const dist = (testX - targetGridX) ** 2 + (testY - targetGridY) ** 2;
        if (dist < bestDist) {
          bestDist = dist;
          bestPos = { gridX: testX, gridY: testY };
        }
      }
    }

    // If we found a position at this radius, use it
    if (bestPos && r > 0) break;
  }

  // If no position found, clamp to nearest valid position
  return bestPos || {
    gridX: Math.max(CANVAS_BOUNDS.minX, Math.min(CANVAS_BOUNDS.maxX - dims.width, targetGridX)),
    gridY: Math.max(CANVAS_BOUNDS.minY, Math.min(CANVAS_BOUNDS.maxY - dims.height, targetGridY))
  };
}

// Helper to find next grid position (simple increment)
let nextModuleGridX = 2;
let nextModuleGridY = 9;

function findNextAvailableGridPosition() {
  const maxGridX = 50;  // Wrap at this X

  while (isGridPositionOccupied(nextModuleGridX, nextModuleGridY)) {
    nextModuleGridX += 8;  // Module is ~6-7 grid units wide
    if (nextModuleGridX > maxGridX) {
      nextModuleGridX = 2;
      nextModuleGridY += 8;  // Module is ~5-6 grid units tall
    }
  }

  const result = { gridX: nextModuleGridX, gridY: nextModuleGridY };
  nextModuleGridX += 8;  // Prepare next position

  return result;
}

// Add this function near the top with your other utility functions
function getModuleGridDimensions(type) {
  // Check if this is a custom module first
  if (customModuleDefinitions[type]) {
    const definition = customModuleDefinitions[type];
    // Use stored grid dimensions if available
    if (definition.gridWidth && definition.gridHeight) {
      return {
        width: definition.gridWidth,
        height: definition.gridHeight
      };
    }
  }

  // These should be in GRID UNITS (gridSize = 20px per unit)
  // Measure actual module widths and convert: pixels / 20 = grid units
  const dimensions = {
    // Logic gates
    'AND': { width: 7, height: 4 },
    'OR': { width: 7, height: 4 },
    'NAND': { width: 7, height: 4 },
    'NOR': { width: 7, height: 4 },
    'XOR': { width: 7, height: 4 },
    'XNOR': { width: 7, height: 4 },
    'Oscilloscope': { width: 7, height: 4 },

    // Smaller modules
    'Noise': { width: 7, height: 3 },
    'NOT': { width: 7, height: 3 },
    'Outlet': { width: 5, height: 3 },
    'ExportOutlet': { width: 5, height: 3 },
    'ExportLed': { width: 5, height: 3 },
    'ExportInlet': { width: 5, height: 3 },
    'Inlet': { width: 5, height: 3 },

    // Medium modules
    'Oscillator': { width: 7, height: 6 },
    'Button': { width: 7, height: 5 },
    'Flip-Flop': { width: 7, height: 4 },

    // Large modules
    'Binary Counter': { width: 11, height: 7 },
    'BCD to 7-Segment': { width: 11, height: 7 },
    'Ring Counter': { width: 11, height: 7 },
    'Shift Register': { width: 11, height: 7 },
    'Binary Rate Multiplier': { width: 10, height: 7 },
    'Multiplexer': { width: 13, height: 7 },
    'Demultiplexer': { width: 11, height: 7 },
    'Shift Register (PISO)': { width: 13, height: 7 },
    'EEPROM': { width: 11, height: 8 },

    // Segment display
    '7-Segment Display': { width: 6, height: 9 },

    // Output
    'Output': { width: 4, height: 7 }
  };

  return dimensions[type] || { width: 7, height: 4 };
}

// Update isGridPositionOccupied to use this function
// Update the isGridPositionOccupied function to include boundary check
function isGridPositionOccupied(gridX, gridY, moduleType = 'default', excludeIds = []) {
  // Get dimensions of module we're trying to place
  const newDims = typeof moduleType === 'string' ?
    getModuleGridDimensions(moduleType) :
    { width: 7, height: 4 }; // fallback

  // Check canvas boundaries first
  if (gridX < CANVAS_BOUNDS.minX ||
    gridY < CANVAS_BOUNDS.minY ||
    gridX + newDims.width > CANVAS_BOUNDS.maxX ||
    gridY + newDims.height > CANVAS_BOUNDS.maxY) {
    return true; // Position is out of bounds
  }

  // Then check collision with other modules
  return modules.some(m => {
    if (excludeIds.includes(m.id)) return false;

    const existingDims = getModuleGridDimensions(m.type);

    // Rectangle collision: check if rectangles overlap
    // Add 0.5 grid unit padding on all sides
    const padding = 0.5;

    return !(
      gridX + newDims.width + padding < m.gridX - padding ||  // New is left of existing
      gridX - padding > m.gridX + existingDims.width + padding ||  // New is right of existing
      gridY + newDims.height + padding < m.gridY - padding ||  // New is above existing
      gridY - padding > m.gridY + existingDims.height + padding   // New is below existing
    );
  });
}


function deleteModule(moduleId) {
  const moduleData = modules.find(m => m.id === moduleId);
  if (!moduleData) return;

  const moduleConnections = connections.filter(conn =>
    conn.from === moduleId || conn.to === moduleId
  );

  // Record for undo history (gridX/gridY already in moduleData)
  pushToUndoStack({
    type: 'deleteModule',
    moduleData: { ...moduleData },
    connections: [...moduleConnections]
  });

  // Use the non-recording version to actually delete
  deleteModuleWithoutRecord(moduleId);
  // Rebuild audio graph
  if (audioStarted) {
    rebuildAudioGraph();
    requestWireRedraw();
  }
}

function updateLedStates() {
  if (workletNode) {
    // Request the LED updates
    workletNode.port.postMessage({ requestLedUpdate: true });
  }
}

function rebuildAudioGraph() {
  if (workletNode) {
    // Create a serializable copy of modules with their IDs
    const serializedModules = modules.map(mod => ({
      id: mod.id,
      type: mod.type,
      freq: mod.freq,
      definition: mod.definition // Include definition for composite modules
    }));

    workletNode.port.postMessage({
      modules: serializedModules,
      connections: connections
    });

    modules.forEach(module => {
      if (module.type === 'EEPROM' && module.memoryData) {
        workletNode.port.postMessage({
          type: 'programEEPROM',
          moduleId: module.id,
          memoryData: module.memoryData
        });
      }
    });
  }
}

document.addEventListener('click', (e) => {

  if (pasteToolActive) {
    // Prevent pasting on UI controls
    if (e.target.closest('.ui-controls') ||
      e.target.closest('#toggle-controls') ||
      e.target.closest('.controls-container') ||
      e.target.closest('#mobile-module-menu') ||
      e.target.closest('#mobile-utility-menu') ||
      e.target.closest('.module') ||
      e.target.closest('.port')) {
      return;
    }

    // Paste at click location
    pasteModules(e.clientX, e.clientY);
    pasteToolActive = false;
    pasteButton.classList.remove('active');
    updateCopyPasteButtonState();
    return;
  }

  // Prevent unwanted behavior during selection or dragging
  if (selectionBox || dragging || justFinishedDragging || justFinishedSelecting) {
    // Reset flags
    justFinishedDragging = false;
    justFinishedSelecting = false;
    return;
  }

  // // Check if clicking on a port
  // const isPort = e.target.dataset && (e.target.dataset.type === 'input' || e.target.dataset.type === 'output');

  // if (!isPort) {
  //   // Reset selectedOutput when clicking elsewhere
  //   selectedOutput = null;
  //   requestWireRedraw();
  // }
});

function isNearLine(px, py, x1, y1, x2, y2) {
  const dx = x2 - x1;
  const dy = y2 - y1;
  const lenSq = dx * dx + dy * dy;
  const t = Math.max(0, Math.min(1, ((px - x1) * dx + (py - y1) * dy) / lenSq));
  const nearestX = x1 + t * dx;
  const nearestY = y1 + t * dy;
  const distSq = (px - nearestX) ** 2 + (py - nearestY) ** 2;
  return distSq < 25;
}
// Check if a line segment intersects with a rectangle
function lineIntersectsRect(x1, y1, x2, y2, rect) {
  // Check if either endpoint is inside the rectangle
  if (x1 >= rect.left && x1 <= rect.right && y1 >= rect.top && y1 <= rect.bottom) return true;
  if (x2 >= rect.left && x2 <= rect.right && y2 >= rect.top && y2 <= rect.bottom) return true;

  // Check if line intersects any of the four edges of the rectangle
  const rectLines = [
    { x1: rect.left, y1: rect.top, x2: rect.right, y2: rect.top },       // top
    { x1: rect.right, y1: rect.top, x2: rect.right, y2: rect.bottom },   // right
    { x1: rect.left, y1: rect.bottom, x2: rect.right, y2: rect.bottom }, // bottom
    { x1: rect.left, y1: rect.top, x2: rect.left, y2: rect.bottom }      // left
  ];

  return rectLines.some(edge => linesIntersect(x1, y1, x2, y2, edge.x1, edge.y1, edge.x2, edge.y2));
}

// Check if two line segments intersect
function linesIntersect(x1, y1, x2, y2, x3, y3, x4, y4) {
  const denominator = (x1 - x2) * (y3 - y4) - (y1 - y2) * (x3 - x4);
  if (denominator === 0) return false;

  const t = ((x1 - x3) * (y3 - y4) - (y1 - y3) * (x3 - x4)) / denominator;
  const u = -((x1 - x2) * (y1 - y3) - (y1 - y2) * (x1 - x3)) / denominator;

  return t >= 0 && t <= 1 && u >= 0 && u <= 1;
}

let dashOffset = 0;
// Add at top with globals:
let wireElements = []; // Cache wire elements

function drawWires() {
  const svg = document.getElementById('wireSvg');
  if (!svg) return;

  let elementIndex = 0;

  function getElement(tag) {
    if (elementIndex < wireElements.length) {
      const elem = wireElements[elementIndex++];
      if (elem.tagName.toLowerCase() === tag) {
        elem.removeAttribute('visibility');
        return elem;
      }
    }
    const elem = document.createElementNS('http://www.w3.org/2000/svg', tag);
    svg.appendChild(elem);
    wireElements.push(elem);
    elementIndex++;
    return elem;
  }

  // Clear port highlights
  document.querySelectorAll('.port-highlighted').forEach(port => {
    port.classList.remove('port-highlighted');
  });

  const rootStyles = getComputedStyle(document.documentElement);
  const wireColor = rootStyles.getPropertyValue('--wire-color').trim();
  const wireSelectedColor = rootStyles.getPropertyValue('--wire-hover-color').trim(); // Reuse hover color for selection

  // Rebuild wirePaths
  wirePaths = [];

  connections.forEach((conn, i) => {
    const fromDiv = document.querySelector(`[data-id='${conn.from}']`);
    const toDiv = document.querySelector(`[data-id='${conn.to}']`);
    if (!fromDiv || !toDiv) return;

    const fromPorts = fromDiv.querySelectorAll('[data-type="output"]');
    const fromPort = [...fromPorts].find(p => parseInt(p.dataset.index) === conn.fromOutputIndex) || fromPorts[0];
    const toPorts = toDiv.querySelectorAll('[data-type="input"]');
    const toPort = toPorts[conn.inputIndex] || toPorts[0];

    if (!fromPort || !toPort) return;

    const fromRect = fromPort.getBoundingClientRect();
    const toRect = toPort.getBoundingClientRect();
    const fromLogical = screenToLogical(fromRect.left + fromRect.width / 2, fromRect.top + fromRect.height / 2);
    const toLogical = screenToLogical(toRect.left + toRect.width / 2, toRect.top + toRect.height / 2);

    const isSelected = selectedConnections.has(i);
    const strokeColor = isSelected ? wireSelectedColor : wireColor;
    const strokeWidth = isSelected ? '3' : '2';

    // Draw line
    const line = getElement('line');
    line.setAttribute('x1', fromLogical.x);
    line.setAttribute('y1', fromLogical.y);
    line.setAttribute('x2', toLogical.x);
    line.setAttribute('y2', toLogical.y);
    line.setAttribute('stroke', strokeColor);
    line.setAttribute('stroke-width', strokeWidth);
    line.setAttribute('stroke-linecap', 'round');
    line.removeAttribute('stroke-dasharray');
    line.removeAttribute('stroke-dashoffset');

    // Draw circles
    const circle1 = getElement('circle');
    circle1.setAttribute('cx', fromLogical.x);
    circle1.setAttribute('cy', fromLogical.y);
    circle1.setAttribute('r', '2.5');
    circle1.setAttribute('fill', strokeColor);

    const circle2 = getElement('circle');
    circle2.setAttribute('cx', toLogical.x);
    circle2.setAttribute('cy', toLogical.y);
    circle2.setAttribute('r', '2.5');
    circle2.setAttribute('fill', strokeColor);

    // Store path for hit detection (screen coordinates)
    wirePaths.push({
      x1: fromRect.left + fromRect.width / 2,
      y1: fromRect.top + fromRect.height / 2,
      x2: toRect.left + toRect.width / 2,
      y2: toRect.top + toRect.height / 2,
      connIndex: i
    });
  });

  // Draw hint wire when connecting
  if (selectedOutput !== null) {
    const fromDiv = document.querySelector(`[data-id='${selectedOutput.id}']`);
    if (fromDiv) {
      let fromPort;
      if (selectedOutput.isInput) {
        const fromPorts = fromDiv.querySelectorAll('[data-type="input"]');
        fromPort = [...fromPorts].find(p => parseInt(p.dataset.index) === selectedOutput.inputIndex) || fromPorts[0];
      } else {
        const fromPorts = fromDiv.querySelectorAll('[data-type="output"]');
        fromPort = [...fromPorts].find(p => parseInt(p.dataset.index) === selectedOutput.outputIndex) || fromPorts[0];
      }

      if (fromPort) {
        if (isTouchDevice()) {
          fromPort.classList.add('port-highlighted');
        } else {
          const fromRect = fromPort.getBoundingClientRect();
          const fromLogical = screenToLogical(
            fromRect.left + fromRect.width / 2,
            fromRect.top + fromRect.height / 2
          );
          const toLogical = screenToLogical(mouseX, mouseY);

          const wireHintColor = rootStyles.getPropertyValue('--wire-hint-color')?.trim() || '#ff6b3570';

          const hintLine = getElement('line');
          hintLine.setAttribute('x1', fromLogical.x);
          hintLine.setAttribute('y1', fromLogical.y);
          hintLine.setAttribute('x2', toLogical.x);
          hintLine.setAttribute('y2', toLogical.y);
          hintLine.setAttribute('stroke', wireHintColor);
          hintLine.setAttribute('stroke-width', '3');
          hintLine.setAttribute('stroke-linecap', 'round');
          hintLine.setAttribute('stroke-dasharray', '6 8');
          hintLine.setAttribute('stroke-dashoffset', -dashOffset);

          const hintCircle1 = getElement('circle');
          hintCircle1.setAttribute('cx', fromLogical.x);
          hintCircle1.setAttribute('cy', fromLogical.y);
          hintCircle1.setAttribute('r', '2.5');
          hintCircle1.setAttribute('fill', wireHintColor);

          const hintCircle2 = getElement('circle');
          hintCircle2.setAttribute('cx', toLogical.x);
          hintCircle2.setAttribute('cy', toLogical.y);
          hintCircle2.setAttribute('r', '2.5');
          hintCircle2.setAttribute('fill', wireHintColor);
        }
      }
    }
  }

  // Hide unused elements
  while (elementIndex < wireElements.length) {
    wireElements[elementIndex].setAttribute('visibility', 'hidden');
    wireElements[elementIndex].setAttribute('stroke', 'none');
    wireElements[elementIndex].setAttribute('fill', 'none');
    elementIndex++;
  }
}

// Helper to convert screen coords to logical coords (inverse of transform)
function screenToLogical(screenX, screenY) {
  return {
    x: (screenX - viewState.offsetX) / viewState.scale,
    y: (screenY - viewState.offsetY) / viewState.scale
  };
}

let animationFrameId = null;
let needsRedraw = false;

function animate() {
  if (needsRedraw || selectedOutput !== null) {
    dashOffset += 0.2;
    drawWires();
    needsRedraw = false;
  }
  animationFrameId = requestAnimationFrame(animate);
}
animate();

// Add this helper function:
function requestWireRedraw() {
  needsRedraw = true;
}

// Prevent UI controls from clearing selection
document.querySelectorAll('.ui-controls, #toggle-controls, .iconify, #selectButton, #controls-container, .controls-page-toggle, .snippet-action-btn, .module-info-button',).forEach(element => {
  element.addEventListener('click', (e) => {
    e.stopPropagation();
  });

  element.addEventListener('mousedown', (e) => {
    e.stopPropagation();
  });
});

// moduleDesigner.js

// Module Designer Functions

// Global to track initial state for dirty check
window.designerInitialState = null;

// Helper to get a deterministic hash of the current designer state
function getDesignerStateHash() {
  const state = {
    // 1. Modules (Sorted by ID to be deterministic)
    modules: modules.map(m => ({
      id: m.id,
      type: m.type,
      // Precision rounding for positions to avoid float jitter
      gridX: Math.round(m.gridX * 100) / 100,
      gridY: Math.round(m.gridY * 100) / 100,
      freq: m.freq,
      label: m.label,
      memoryData: m.memoryData
    })).sort((a, b) => a.id - b.id),

    // 2. Connections (Sorted by from/to)
    connections: connections.map(c => ({
      from: c.from,
      to: c.to,
      inputIndex: c.inputIndex,
      fromOutputIndex: c.fromOutputIndex
    })).sort((a, b) => (a.from - b.from) || (a.to - b.to)),

    // 3. Name
    name: document.getElementById('customModuleName')?.value || '',

    // 4. Height
    height: document.getElementById('moduleHeight')?.value || '4',

    // 5. Controls
    controls: window.getModuleControls ? window.getModuleControls().sort((a, b) => a.moduleId - b.moduleId) : []
  };

  return JSON.stringify(state);
}

// Expose for other modules (e.g. preview/save logic)
window.getDesignerStateHash = getDesignerStateHash;

function enterModuleDesigner() {
  if (isModuleDesigner) return;
  if (dictionaryActive) closeDictionary();
  if (tutorialActive) exitTutorial();

  // 1. Save current patch to backup
  const patchData = {
    version: 2,
    modules: modules.map(m => ({
      id: m.id,
      type: m.type,
      gridX: m.gridX,
      gridY: m.gridY,
      freq: m.freq,
      assignedKey: m.assignedKey,
      memoryData: m.memoryData,
      // Save other properties as needed
    })),
    connections: connections,
    viewState: JSON.parse(JSON.stringify(viewState)),
    performanceAssignments: {
      oscillators: Array.from(performanceSnapshot.performanceOscillators.entries()),
      buttons: Array.from(performanceSnapshot.performanceButtons.entries())
    }
  };
  // if eeprom module exists close the programmer
  if (patchData.modules.some(m => m.type === 'EEPROM')) {
    closeAllEEPROMProgrammers();
  }
  localStorage.setItem('savedPatch_backup', JSON.stringify(patchData));

  // 2. Clear canvas
  modules = [];
  connections = [];
  ledElements = [];
  const container = document.getElementById('moduleContainer');
  if (container) container.innerHTML = '';

  // Reset output module state
  outModuleCreated = false;
  const button = document.getElementById('createOutputModuleButton');
  if (button) {
    button.classList.remove('fake-disabled');
  }
  syncMobileOutputButton();

  if (audioStarted) rebuildAudioGraph();
  requestWireRedraw();

  // 3. Switch UI
  isModuleDesigner = true;
  document.body.classList.add('module-designer-mode');

  const designerPanel = document.getElementById('moduleDesignerPanel');
  if (designerPanel) designerPanel.style.display = 'flex';

  // Specific controls to hide/shift as per user request
  const controlsToHide = [
    'saveLoadMenuButton',
    'performanceButton',
    'moduleDesignerButton',
    'startTutorialButton',
    'volume-slider-container',
    'sevenSegButton',
    'bomExportButton'
  ];

  controlsToHide.forEach(id => {
    const el = document.getElementById(id);
    if (el) el.classList.add('designer-hidden');
  });

  const rightControls = document.getElementById('saveLoadArea');
  if (rightControls) rightControls.classList.add('designer-shifted');

  const zoomArea = document.getElementById('zoomArea');
  if (zoomArea) zoomArea.classList.add('designer-shifted');

  // Reset view
  viewState.offsetX = -5000;
  viewState.offsetY = -5000;
  viewState.scale = 1.0;
  updateViewTransform();

  showGrid = false;
  const svg = document.getElementById('gridSvg');
  if (svg) {
    svg.innerHTML = ''; // Clear existing
  }
  document.body.style.background = 'var(--module-designer-bg)';

  // 4. Create default patch (One Inlet, One Outlet)
  // We use a timeout to ensure the view transform has applied and modules created correctly
  setTimeout(() => {
    // Check if we already have modules (e.g. from editing an existing module)
    // Only add defaults if empty
    if (modules.length === 0) {
      // Create Inlet (Input)
      createModule('Inlet');
      const inlet = modules[modules.length - 1];
      if (inlet && inlet.div) {
        // Position roughly center-left
        // View is centered at 0,0 relative? No, view is shifted.
        // Let's place it at grid coordinates.
        inlet.gridX = 10;
        inlet.gridY = 10;
        inlet.div.style.left = (inlet.gridX * 20) + 'px';
        inlet.div.style.top = (inlet.gridY * 20) + 'px';
      }

      // Create Outlet (Output)
      createModule('Outlet');
      const outlet = modules[modules.length - 1];
      if (outlet && outlet.div) {
        // Position roughly center-right
        outlet.gridX = 20;
        outlet.gridY = 10;
        outlet.div.style.left = (outlet.gridX * 20) + 'px';
        outlet.div.style.top = (outlet.gridY * 20) + 'px';
      }

      // Update preview
      if (typeof updateModulePreview === 'function') {
        updateModulePreview();
      }

      // Center view on these modules
      if (typeof fitToView === 'function') {
        fitToView(); // Using existing fit function
      } else {
        // Fallback view reset
        viewState.offsetX = -100; // Adjust as needed based on coordinate system
        viewState.offsetY = -100;
        viewState.scale = 1.0;
        updateViewTransform();
      }
    }

    // Capture initial state for dirty check
    window.designerInitialState = getDesignerStateHash();
  }, 50);
}

async function exitModuleDesigner() {
  if (!isModuleDesigner) return;

  // Check if there are changes (compare with initial state)
  const currentState = getDesignerStateHash();
  if (currentState !== window.designerInitialState) {
    const confirmed = await showConfirmDialog("Exit Module Designer? Unsaved changes will be lost.");
    if (!confirmed) return false;
  }

  // 2. Restore backup
  const backup = localStorage.getItem('savedPatch_backup');
  if (backup) {
    try {
      const patchData = JSON.parse(backup);
      loadPatchFromData(patchData); // Reuse loadTutorialPatch for clean loading
    } catch (e) {
      console.error("Failed to restore backup", e);
      loadDefaultPatch();
    }
  } else {
    loadDefaultPatch();
  }

  // 3. Switch UI
  isModuleDesigner = false;
  document.body.classList.remove('module-designer-mode');

  const designerPanel = document.getElementById('moduleDesignerPanel');
  if (designerPanel) designerPanel.style.display = 'none';

  // Restore specific controls
  const controlsToHide = [
    'saveLoadMenuButton',
    'performanceButton',
    'moduleDesignerButton',
    'startTutorialButton',
    'volume-slider-container',
    'sevenSegButton',
    'bomExportButton'
  ];

  controlsToHide.forEach(id => {
    const el = document.getElementById(id);
    if (el) el.classList.remove('designer-hidden');
  });

  const rightControls = document.getElementById('saveLoadArea');
  if (rightControls) rightControls.classList.remove('designer-shifted');

  const volumeSlider = document.getElementById('volume-slider-container');
  if (volumeSlider) volumeSlider.classList.remove('designer-shifted');

  const zoomArea = document.getElementById('zoomArea');
  if (zoomArea) zoomArea.classList.remove('designer-shifted');


  showGrid = true;
  document.body.style.background = 'var(--bg-quaternary)';

  drawGrid();
  setTimeout(() => fitToView(), 50);
  return true;
}

// Base save function (overridden by preview script usually)
async function saveCustomModule() {
  const nameInput = document.getElementById('customModuleName');
  const name = nameInput.value.trim();

  if (!name) {
    showAlert("Please enter a module name.");
    return;
  }

  // Check if module already exists before asking for confirmation
  const moduleExists = customModuleDefinitions.hasOwnProperty(name) ||
    await getCustomModuleFromDB(name);

  if (moduleExists) {
    const confirmed = await showConfirmDialog(`Module '${name}' already exists. Overwrite?`);
    if (!confirmed) return;
  }

  // Create definition
  const definition = {
    name: name,
    modules: modules.map(m => {
      const moduleDef = {
        id: m.id,
        type: m.type,
        gridX: m.gridX,
        gridY: m.gridY,
        label: m.label, // Save label for Inlets/Outlets
      };

      // Save oscillator frequency if present
      if (m.freq !== undefined) {
        moduleDef.freq = m.freq;
      }

      // Identify controls
      if (m.type === 'Oscillator' || m.type === 'Button') {
        moduleDef.isControl = true;
      }

      return moduleDef;
    }),
    connections: connections.map(c => ({
      fromModuleId: c.from,  // Map 'from' to 'fromModuleId'
      toModuleId: c.to,      // Map 'to' to 'toModuleId'
      inputIndex: c.inputIndex,
      outputIndex: c.fromOutputIndex || 0 // Map fromOutputIndex to outputIndex
    }))
  };

  // Save to DB
  try {
    await saveCustomModuleToDB(definition);
    customModuleDefinitions[name] = definition; // Update local cache
    showAlert(`Module '${name}' saved!`);
    updateCustomModuleMenu();
  } catch (e) {
    console.error("Failed to save custom module:", e);
    showAlert("Failed to save module.");
  }
}

function updateCustomModuleMenu() {
  // Find the "Custom" category or create it
  let customCategory = document.getElementById('customModuleCategory');

  if (!customCategory) {
    const controlsPage = document.querySelector('.custom-modules-list');
    if (controlsPage) {
      customCategory = document.createElement('div');
      customCategory.id = 'customModuleCategory';
      customCategory.style.marginTop = '0px';
      customCategory.style.paddingTop = '0px';
      customCategory.style.paddingBottom = '20px';
      customCategory.style.cursor = 'default';

      const title = document.createElement('div');
      title.classList.add('category-header');
      title.classList.add('category-title');
      title.style.paddingTop = '0';
      title.style.display = 'flex';
      title.style.alignItems = 'center';
      title.style.cursor = 'default';
      title.style.justifyContent = 'space-between';

      const titleText = document.createElement('span');
      titleText.innerText = 'Custom Modules';
      title.appendChild(titleText);

      // Import button
      const importBtn = document.createElement('button');
      importBtn.className = 'snippet-delete'; // Reuse existing button style
      importBtn.title = 'Import Custom Modules';
      importBtn.style.marginLeft = '10px';
      importBtn.innerHTML = `
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <path fill="currentColor"
              d="M6 20q-.825 0-1.412-.587T4 18v-2q0-.425.288-.712T5 15t.713.288T6 16v2h12v-2q0-.425.288-.712T19 15t.713.288T20 16v2q0 .825-.587 1.413T18 20zm5-12.15L9.125 9.725q-.3.3-.712.288T7.7 9.7q-.275-.3-.288-.7t.288-.7l3.6-3.6q.15-.15.325-.212T12 4.425t.375.063t.325.212l3.6 3.6q.3.3.288.7t-.288.7q-.3.3-.712.313t-.713-.288L13 7.85V15q0 .425-.288.713T12 16t-.712-.288T11 15z" />
          </svg>
      `;
      importBtn.onclick = (e) => {
        e.stopPropagation();
        importCustomModules();
      };
      title.appendChild(importBtn);

      customCategory.appendChild(title);

      const grid = document.createElement('div');
      // grid.className = 'module-grid'; // Changed to list style
      grid.className = 'snippets-list'; // Reuse snippets list style
      grid.id = 'customModuleGrid';
      customCategory.appendChild(grid);

      controlsPage.appendChild(customCategory);
    }
  }

  const grid = document.getElementById('customModuleGrid');
  if (grid) {
    grid.innerHTML = ''; // Clear existing

    const names = Object.keys(customModuleDefinitions).sort();

    if (names.length === 0) {
      grid.innerHTML = '<div class="snippets-empty">No custom modules created yet.</div>';
      return;
    }

    names.forEach(name => {
      const item = document.createElement('div');
      item.className = 'snippet-item'; // Reuse snippet item style
      item.innerHTML = `
        <svg class="snippet-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
          <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M22 12h-5M2 9h5m-5 6h5M7 5l10 7l-10 7z" />
        </svg>
        <span class="snippet-name">${name}</span>
      `;
      item.onclick = () => {
        if (!isModuleDesigner) {
          createModule(name);
        }
      };

      // Export Button
      const exportBtn = document.createElement('button');
      exportBtn.className = 'snippet-delete'; // Reuse delete button style for sizing
      exportBtn.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
          <path fill="currentColor"
            d="M12 15.575q-.2 0-.375-.062T11.3 15.3l-3.6-3.6q-.3-.3-.288-.7t.288-.7q.3-.3.713-.312t.712.287L11 12.15V5q0-.425.288-.712T12 4t.713.288T13 5v7.15l1.875-1.875q.3-.3.713-.288t.712.313q.275.3.288.7t-.288.7l-3.6 3.6q-.15.15-.325.213t-.375.062M6 20q-.825 0-1.412-.587T4 18v-2q0-.425.288-.712T5 15t.713.288T6 16v2h12v-2q0-.425.288-.712T19 15t.713.288T20 16v2q0 .825-.587 1.413T18 20z" />
        </svg>
      `;
      exportBtn.onclick = (e) => {
        e.stopPropagation();
        exportCustomModule(name);
      };

      // Edit Button
      const editBtn = document.createElement('button');
      editBtn.className = 'snippet-delete'; // Reuse delete button style for sizing
      editBtn.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 512 512">
          <path fill="currentColor" fill-rule="evenodd"
            d="M469.334 426.667v42.667H42.667v-42.667zM320 42.667l106.667 106.667L192 384H85.334V277.334zM249.747 173.25L128 294.998v46.336h46.336l121.747-121.748zM320 102.998l-40.083 40.082l46.336 46.336l40.083-40.082z" />
        </svg>
      `;
      editBtn.onclick = (e) => {
        e.stopPropagation();
        editCustomModule(name);
      };

      // Delete Button
      const deleteBtn = document.createElement('button');
      deleteBtn.className = 'snippet-delete';
      deleteBtn.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                  <g fill="none">
                    <path
                      d="m12.593 23.258l-.011.002l-.071.035l-.02.004l-.014-.004l-.071-.035q-.016-.005-.024.005l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427q-.004-.016-.017-.018m.265-.113l-.013.002l-.185.093l-.01.01l-.003.011l.018.43l.005.012l.008.007l.201.093q.019.005.029-.008l.004-.014l-.034-.614q-.005-.018-.02-.022m-.715.002a.02.02 0 0 0-.027.006l-.006.014l-.034.614q.001.018.017.024l.015-.002l.201-.093l.01-.008l.004-.011l.017-.43l-.003-.012l-.01-.01z" />
                    <path fill="currentColor"
                      d="M20 5a1 1 0 1 1 0 2h-1l-.003.071l-.933 13.071A2 2 0 0 1 16.069 22H7.93a2 2 0 0 1-1.995-1.858l-.933-13.07L5 7H4a1 1 0 0 1 0-2zm-6-3a1 1 0 1 1 0 2h-4a1 1 0 0 1 0-2z" />
                  </g>
        </svg>
      `;

      // Confirm delete logic
      let confirmTimeout;
      deleteBtn.onclick = (e) => {
        e.stopPropagation();
        if (deleteBtn.classList.contains('confirm-delete')) {
          deleteCustomModule(name);
        } else {
          deleteBtn.classList.add('confirm-delete');
          deleteBtn.innerHTML = `
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24">
              <path fill="currentColor" d="M9 16.17L4.83 12l-1.42 1.41L9 19L21 7l-1.41-1.41z"/>
            </svg>`
          confirmTimeout = setTimeout(() => {
            deleteBtn.classList.remove('confirm-delete');
            deleteBtn.innerHTML = `
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                  <g fill="none">
                    <path
                      d="m12.593 23.258l-.011.002l-.071.035l-.02.004l-.014-.004l-.071-.035q-.016-.005-.024.005l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427q-.004-.016-.017-.018m.265-.113l-.013.002l-.185.093l-.01.01l-.003.011l.018.43l.005.012l.008.007l.201.093q.019.005.029-.008l.004-.014l-.034-.614q-.005-.018-.02-.022m-.715.002a.02.02 0 0 0-.027.006l-.006.014l-.034.614q.001.018.017.024l.015-.002l.201-.093l.01-.008l.004-.011l.017-.43l-.003-.012l-.01-.01z" />
                    <path fill="currentColor"
                      d="M20 5a1 1 0 1 1 0 2h-1l-.003.071l-.933 13.071A2 2 0 0 1 16.069 22H7.93a2 2 0 0 1-1.995-1.858l-.933-13.07L5 7H4a1 1 0 0 1 0-2zm-6-3a1 1 0 1 1 0 2h-4a1 1 0 0 1 0-2z" />
                  </g>
        </svg>`
          }, 2000);
        }
      };

      item.appendChild(exportBtn);
      item.appendChild(editBtn);
      item.appendChild(deleteBtn);
      grid.appendChild(item);
    });
  }
}

async function deleteCustomModule(name) {
  try {
    await deleteCustomModuleFromDB(name);
    delete customModuleDefinitions[name];
    updateCustomModuleMenu();
  } catch (e) {
    console.error("Failed to delete custom module:", e);
    showAlert("Failed to delete module.");
  }
}

// Export a single custom module as JSON
function exportCustomModule(name) {
  const definition = customModuleDefinitions[name];
  if (!definition) {
    showAlert("Module not found.");
    return;
  }

  const jsonData = JSON.stringify(definition, null, 2);
  const blob = new Blob([jsonData], { type: 'application/json' });
  const url = URL.createObjectURL(blob);

  const a = document.createElement('a');
  a.href = url;
  a.download = `${name}.json`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

// Import custom modules from JSON files
async function importCustomModules() {
  const input = document.createElement('input');
  input.type = 'file';
  input.accept = '.json';
  input.multiple = true;

  input.onchange = async (e) => {
    const files = e.target.files;
    if (!files || files.length === 0) return;

    let importedCount = 0;
    let errorCount = 0;

    for (const file of files) {
      try {
        const text = await file.text();
        const definition = JSON.parse(text);

        // Validate the definition has required fields
        if (!definition.name || !definition.modules || !definition.connections) {
          console.error(`Invalid module definition in ${file.name}`);
          errorCount++;
          continue;
        }

        // Save to DB and update local cache
        await saveCustomModuleToDB(definition);
        customModuleDefinitions[definition.name] = definition;
        importedCount++;
      } catch (e) {
        console.error(`Failed to import ${file.name}:`, e);
        errorCount++;
      }
    }

    // Update the menu to show imported modules
    updateCustomModuleMenu();

    // Show result message
    if (importedCount > 0 && errorCount === 0) {
      showAlert(`Successfully imported ${importedCount} module${importedCount > 1 ? 's' : ''}.`);
    } else if (importedCount > 0 && errorCount > 0) {
      showAlert(`Imported ${importedCount} module${importedCount > 1 ? 's' : ''}, ${errorCount} failed.`);
    } else {
      showAlert("Failed to import modules.");
    }
  };

  input.click();
}


async function editCustomModule(name) {
  const definition = customModuleDefinitions[name];
  if (!definition) return;

  // Enter designer mode
  if (isModuleDesigner) {
    const exited = await exitModuleDesigner();
    if (exited === false) return;
  }
  enterModuleDesigner();

  // Set name input
  const nameInput = document.getElementById('customModuleName');
  if (nameInput) nameInput.value = name;

  const definitionInput = document.getElementById('customModuleDefinition');
  if (definitionInput) definitionInput.value = definition.definition || "";

  // Set height if saved
  if (definition.height) {
    const heightSelect = document.getElementById('moduleHeight');
    if (heightSelect) {
      heightSelect.value = definition.height;
      // Trigger change event to update preview state
      heightSelect.dispatchEvent(new Event('change'));
    }
  }

  // Clear existing modules (already done in enterModuleDesigner, but good to be safe)
  modules = [];
  connections = [];
  ledElements = [];

  // Reconstruct modules
  definition.modules.forEach(mDef => {
    const container = document.getElementById('moduleContainer');
    const div = document.createElement('div');
    div.dataset.id = mDef.id;
    div.dataset.type = mDef.type;
    div.style.left = (mDef.gridX * 20) + 'px';
    div.style.top = (mDef.gridY * 20) + 'px';

    // Add to modules array
    const newModule = {
      id: mDef.id,
      type: mDef.type,
      gridX: mDef.gridX,
      gridY: mDef.gridY,
      div: div,
      label: mDef.label
    };

    if (mDef.freq !== undefined) newModule.freq = mDef.freq;
    if (mDef.memoryData) newModule.memoryData = [...mDef.memoryData]; // Copy EEPROM data

    modules.push(newModule);
    container.appendChild(div);

    // Setup UI
    setupModuleUI(div, mDef.type, mDef.freq);

    // Restore label if Inlet/Outlet
    if (mDef.label) {
      const labelInput = div.querySelector('.module-name-input');
      if (labelInput) labelInput.value = mDef.label;
    }

    // Update max ID to avoid collisions with new modules added during edit
    if (mDef.id >= moduleId) {
      moduleId = mDef.id + 1;
    }
  });

  // Reconstruct connections
  definition.connections.forEach(cDef => {
    connections.push({
      from: cDef.fromModuleId,
      to: cDef.toModuleId,
      inputIndex: cDef.inputIndex,
      fromOutputIndex: cDef.outputIndex
    });
  });

  // Restore controls state
  if (definition.controls) {
    if (window.setModuleControls) {
      window.setModuleControls(definition.controls);
    }
  } else {
    // Legacy support: Reconstruct controls from isControl flag
    const reconstructedControls = definition.modules
      .filter(m => m.isControl)
      .map(m => {
        const ctrl = {
          moduleId: m.id,
          type: m.type
        };
        if (m.type === 'Oscillator' && m.freq !== undefined) {
          ctrl.freq = m.freq;
        }
        return ctrl;
      });

    if (window.setModuleControls) {
      window.setModuleControls(reconstructedControls);
    }
  }

  requestWireRedraw();

  // Trigger preview update
  if (window.updateModulePreview) window.updateModulePreview();
  if (window.updateOscillatorCheckboxes) window.updateOscillatorCheckboxes();
  if (window.updateButtonCheckboxes) window.updateButtonCheckboxes();

  setTimeout(() => {
    fitToView();
    // Capture initial state for dirty check (after loading setup is complete)
    window.designerInitialState = getDesignerStateHash();
  }, 3);
}


// Initialize menu and event listeners on load
window.addEventListener('load', () => {
  // Wait for DB to load (handled in main.js)
  // updateCustomModuleMenu(); 

  // Robustly attach exit listener, handling potential duplicate from main.js or other sources
  const exitBtn = document.getElementById('exitDesignerBtn');
  if (exitBtn) {
    // Clone node to strip existing listeners (like the one in main.jsMain, if any) 
    // to prevent double execution or propagation issues
    const newExitBtn = exitBtn.cloneNode(true);
    exitBtn.parentNode.replaceChild(newExitBtn, exitBtn);

    newExitBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      e.preventDefault();
      exitModuleDesigner();
    });
  }
});

// moduleDesignerPreview.js
// Module Designer Preview and Control Management

// State for controls added to the custom module
let moduleControls = [];
let moduleHeight = '4';

// Expose function to set controls (for edit mode)
window.setModuleControls = function (controls) {
  moduleControls = controls || [];
};

// Helper to calculate module dimensions (Unified Logic)
function calculateModuleDimensions(inlets, outlets, controls, heightSetting) {
  // Separate controls by type
  const oscillatorControls = controls.filter(c => c.type === 'Oscillator');
  const buttonControls = controls.filter(c => c.type === 'Button');
  const hasControls = controls.length > 0;



  // Determine button mode
  const singleButtonMode = buttonControls.length === 1;

  // Calculate effective height (rows)
  // Use the minimum of: heightSetting, max inlets, or max outlets
  const maxHeightSetting = parseInt(heightSetting);
  const maxPorts = Math.max(inlets.length, outlets.length);
  let effectiveHeight = Math.min(maxHeightSetting, maxPorts);

  // If no ports at all, use 1 as minimum
  if (maxPorts === 0) {
    effectiveHeight = 1;
  }

  // If single button mode, enforce minimum height of 2 to accommodate the button
  if (singleButtonMode && effectiveHeight < 2) {
    effectiveHeight = 2;
  }

  // Calculate number of columns needed
  let numInputColumns;
  if (singleButtonMode) {
    // If single button, it takes up TWO slots in the first column
    // First column capacity for inlets is effectiveHeight - 2
    // If effectiveHeight is less than 2, we still need to fit the button, so we might need to force height?
    // But effectiveHeight is based on user setting.
    // Let's assume user sets reasonable height.

    const firstColCapacity = Math.max(0, effectiveHeight - 2);
    const remainingInlets = Math.max(0, inlets.length - firstColCapacity);

    // If we have remaining inlets, they go into extra columns
    const extraCols = Math.ceil(remainingInlets / effectiveHeight);
    numInputColumns = 1 + extraCols;
  } else {
    numInputColumns = Math.ceil(inlets.length / effectiveHeight);
  }

  const numOutputColumns = Math.ceil(outlets.length / effectiveHeight);

  // Base width calculation
  // - Each column is approx 40-45px wide
  // - Gap between columns is 20px
  // - We use 60px per column to safely cover width + gap
  const totalColumns = numInputColumns + numOutputColumns;
  const columnOutWidth = 80;
  const columnInWidth = 60;
  let baseWidthPx = (numInputColumns * columnInWidth) + (numOutputColumns * columnOutWidth);

  // If no ports, use minimum width
  if (totalColumns === 0 || baseWidthPx < 140) {
    baseWidthPx = 140; // Minimum width
  }

  // Calculate button layout to see if it forces wider width
  let buttonRowHeight = 0;
  if (buttonControls.length > 0 && !singleButtonMode) {
    // Check if buttons fit in current width, if not, expand width?
    // For now, we'll let buttons wrap based on the column-determined width, 
    // but ensure a minimum width for at least one button.
    baseWidthPx = Math.max(baseWidthPx, 80);

    // Calculate available width for buttons (module width minus padding)
    // We estimate grid width here to calculate button rows
    let estimatedGridWidth = Math.ceil(baseWidthPx / 20);
    const availableWidthPx = (estimatedGridWidth * 20) - 32;

    // Each button is ~40px wide + 4px gap
    const buttonWidth = 44;
    const buttonsPerRow = Math.max(1, Math.floor(availableWidthPx / buttonWidth));
    const buttonRows = Math.ceil(buttonControls.length / buttonsPerRow);
    buttonRowHeight = buttonRows * 45; // ~45px per row of buttons
  }

  // Height calculation:
  // - Each port row is 20px
  // - Add height for oscillator controls (~60px each, they stack)
  // - Add calculated button row height
  // - Add 32px for module padding (16px each side)
  let baseHeightPx = (effectiveHeight * 24) + 32;

  if (hasControls) {
    // Oscillators stack vertically
    baseHeightPx += oscillatorControls.length * 70;
    // Buttons wrap horizontally (only if not single button mode)
    if (!singleButtonMode) {
      baseHeightPx += buttonRowHeight;
    }
    // Add some spacing between controls and ports
    baseHeightPx += 8;
  }

  // Add title bar height (20px)
  // baseHeightPx += 20;

  // Convert to grid units
  let gridWidth = Math.ceil(baseWidthPx / 20);
  let gridHeight = Math.ceil(baseHeightPx / 20);

  // Enforce minimums
  gridWidth = Math.max(gridWidth, 5);
  gridHeight = Math.max(gridHeight, 3);

  return {
    gridWidth,
    gridHeight,
    effectiveHeight,
    numInputColumns,
    numOutputColumns,
    singleButtonMode
  };
}

// Update preview when modules, connections, or height changes
function updateModulePreview() {
  const preview = document.getElementById('moduleDesignerModule');
  if (!preview) return;

  // Clear previous content
  preview.innerHTML = '';

  // Update preview title
  const nameInput = document.getElementById('customModuleName');
  const previewTitle = document.getElementById('previewTitle');
  if (previewTitle) {
    previewTitle.innerText = (nameInput && nameInput.value.trim()) ? nameInput.value.trim() : 'Module Name';
  }

  const title = document.getElementById('previewTitle');
  title.style.backgroundColor = 'var(--text-tertiary)';
  title.style.color = 'var(--module-bg)';

  // Expand to edges (counteract 16px padding of .module)
  title.style.marginTop = '-16px';
  title.style.marginLeft = '-16px';
  title.style.width = 'calc(100% + 32px)';
  title.style.paddingTop = '16px';
  title.style.borderTopLeftRadius = '11px';
  title.style.borderTopRightRadius = '11px';

  // Sort inlets and outlets to match CompositeModule logic
  const inlets = modules.filter(m => m.type === 'Inlet').sort((a, b) => a.gridY - b.gridY);
  const outlets = modules.filter(m => m.type === 'Outlet').sort((a, b) => a.gridY - b.gridY);

  // Filter controls based on moduleControls tracking (checkbox state)
  const controls = modules.filter(m =>
    moduleControls.find(c => c.moduleId === m.id)
  );

  // Calculate dimensions
  const dims = calculateModuleDimensions(inlets, outlets, controls, moduleHeight);

  // Apply dimensions to the outer container (modulePreview) which acts as the module
  const modulePreview = document.getElementById('modulePreview');
  if (modulePreview) {
    modulePreview.style.width = (dims.gridWidth * 20 + 32) + 'px';
    modulePreview.style.height = (dims.gridHeight * 20 + 32) + 'px';
    // modulePreview.style.minWidth = (dims.gridWidth * 20) + 'px';
    // modulePreview.style.minHeight = (dims.gridHeight * 20) + 'px';
  }

  // Ensure content container fills the rest (minus title bar)
  preview.style.width = '100%';
  preview.style.height = 'calc(100% - 20px)'; // Subtract title bar height
  preview.style.minWidth = '';
  preview.style.minHeight = '';

  // Separate controls
  const oscillatorControls = controls.filter(c => c.type === 'Oscillator');
  const buttonControls = controls.filter(c => c.type === 'Button');

  // Render controls with horizontal row layout (matching setupCompositeModuleUI)
  if (controls && controls.length > 0) {
    const controlsContainer = document.createElement('div');
    controlsContainer.style.display = 'flex';
    controlsContainer.style.flexDirection = 'row';
    controlsContainer.style.flexWrap = 'wrap';
    controlsContainer.style.gap = '4px';
    controlsContainer.style.padding = '4px';
    preview.appendChild(controlsContainer);

    // Render Oscillators first
    oscillatorControls.forEach(ctrl => {
      // Create oscillator control (matching setupCompositeModuleUI)
      const oscControl = document.createElement('div');
      oscControl.classList.add('freq-control-container');
      oscControl.style.padding = '4px';
      oscControl.style.flex = '1 1 auto';
      oscControl.style.minWidth = '80px';

      const freqLabel = document.createElement('div');
      freqLabel.classList.add('freq-label');
      freqLabel.innerText = `${(ctrl.freq || 220).toFixed(2)} Hz`;
      freqLabel.style.fontSize = '10px';
      oscControl.appendChild(freqLabel);

      const freqSlider = document.createElement('input');
      freqSlider.type = 'range';
      freqSlider.min = 0;
      freqSlider.max = 1500;
      freqSlider.classList.add('freq-slider');

      const freq = ctrl.freq || 220;
      const normalized = Math.log(freq / 10) / Math.log(300);
      freqSlider.value = Math.round(normalized * 1500);
      freqSlider.disabled = true; // Preview only

      oscControl.appendChild(freqSlider);
      controlsContainer.appendChild(oscControl);
    });

    // Render Buttons if NOT in single button mode
    if (!dims.singleButtonMode && buttonControls.length > 0) {
      // Use space-evenly for multiple buttons
      const buttonRow = document.createElement('div');
      buttonRow.style.display = 'flex';
      buttonRow.style.flexDirection = 'row';
      buttonRow.style.justifyContent = 'space-evenly';
      buttonRow.style.width = '100%';
      buttonRow.style.flexWrap = 'wrap';
      controlsContainer.appendChild(buttonRow);

      buttonControls.forEach(ctrl => {
        const button = document.createElement('div');
        button.classList.add('buttonModule');
        button.style.margin = '5px';
        button.style.cursor = 'not-allowed';
        button.style.opacity = '0.7';
        buttonRow.appendChild(button);
      });
    }
  }

  // Create columns container (matching setupCompositeModuleUI)
  const columnsContainer = document.createElement('div');
  columnsContainer.classList.add('columns-container');
  preview.appendChild(columnsContainer);

  // Create input columns with overflow
  let inletIndex = 0;
  for (let col = 0; col < dims.numInputColumns; col++) {
    const inputColumn = document.createElement('div');
    inputColumn.classList.add('input-column');
    columnsContainer.appendChild(inputColumn);

    let slotsInColumn = dims.effectiveHeight;

    // If single button mode and this is the first column, add the button first
    if (dims.singleButtonMode && col === 0 && buttonControls.length > 0) {
      const ctrl = buttonControls[0];
      const button = document.createElement('div');
      button.classList.add('buttonModule');
      button.style.margin = '5px';
      button.style.cursor = 'not-allowed';
      button.style.opacity = '0.7';
      inputColumn.appendChild(button);

      // Button takes up TWO slots
      slotsInColumn -= 2;
    }

    // Fill remaining slots with inlets
    for (let i = 0; i < slotsInColumn; i++) {
      if (inletIndex < inlets.length) {
        const inlet = inlets[inletIndex];
        const inputGroup = createPortGroup(inlet.label || 'IN', true, inletIndex);
        inputColumn.appendChild(inputGroup);
        inletIndex++;
      }
    }
  }

  // Create output columns with overflow
  for (let col = 0; col < dims.numOutputColumns; col++) {
    const outputColumn = document.createElement('div');
    outputColumn.classList.add('output-column');
    columnsContainer.appendChild(outputColumn);

    const startIdx = col * dims.effectiveHeight;
    const endIdx = Math.min(startIdx + dims.effectiveHeight, outlets.length);

    // Create output ports for this column
    for (let i = startIdx; i < endIdx; i++) {
      const outlet = outlets[i];
      const outputGroup = createPortGroup(outlet.label || 'OUT', false, i);
      const led = createLedElement();
      outputGroup.appendChild(led);
      outputColumn.appendChild(outputGroup);
    }
  }

  // Check if preview needs to be zoomed out to fit
  // We check the modulePreview container against its parent
  if (modulePreview) {
    // Wait for DOM to update, then check dimensions
    requestAnimationFrame(() => {
      const wrapper = document.getElementById('previewScaledWrapper');
      const parent = wrapper ? wrapper.parentElement : null;
      if (!parent) return;

      const parentWidth = parent.clientWidth - 24; // padding
      const parentHeight = parent.clientHeight - 24; // padding

      const previewWidth = dims.gridWidth * 20 + 32; // include padding
      const previewHeight = dims.gridHeight * 20 + 32; // include padding

      const scaleX = parentWidth / previewWidth;
      const scaleY = parentHeight / previewHeight;

      // Use the smaller scale to fit both dimensions, but max at 1
      const scale = Math.min(scaleX, scaleY, 1);

      if (scale < 1) {
        // Apply scale to the preview
        modulePreview.style.transform = `scale(${scale})`;
        modulePreview.style.transformOrigin = 'center center';

        // Set wrapper dimensions to the scaled size to prevent drift
        if (wrapper) {
          wrapper.style.width = `${previewWidth * scale}px`;
          wrapper.style.height = `${previewHeight * scale}px`;
        }
      } else {
        modulePreview.style.transform = 'scale(1)';
        modulePreview.style.transformOrigin = 'center center';

        // Reset wrapper to auto when not scaled
        if (wrapper) {
          wrapper.style.width = 'auto';
          wrapper.style.height = 'auto';
        }
      }
    });
  }
}

// Update oscillator checkboxes based on modules on canvas
function toggleModuleControlClass(moduleId, isControl) {
  const moduleEl = document.querySelector(`.module[data-id="${moduleId}"]`);
  if (moduleEl) {
    if (isControl) {
      moduleEl.classList.add('previewed-control');
    } else {
      moduleEl.classList.remove('previewed-control');
    }
  }
}

// Update oscillator checkboxes based on modules on canvas
function updateOscillatorCheckboxes() {
  const container = document.getElementById('oscillatorCheckboxes');
  if (!container) return;

  // Get all oscillators on the canvas
  const oscillators = modules.filter(m => m.type === 'Oscillator');

  // Clear existing content
  container.innerHTML = '';

  if (oscillators.length === 0) {
    container.innerHTML = '<div style="font-size: 10px; color: var(--text-secondary); padding: 5px;">No oscillators on canvas</div>';
    return;
  }

  // Create scrollable wrapper
  const scrollArea = document.createElement('div');
  scrollArea.className = 'designer-scroll-area';

  // Create grid container for two columns
  const grid = document.createElement('div');
  grid.className = 'designer-toggle-grid';

  oscillators.forEach((osc, index) => {
    const isChecked = moduleControls.some(c => c.moduleId === osc.id);

    toggleModuleControlClass(osc.id, isChecked);

    const toggleBtn = document.createElement('div');
    toggleBtn.className = `designer-toggle-button ${isChecked ? 'active' : ''}`;
    toggleBtn.textContent = `Osc ${index + 1} (${(osc.freq || 220).toFixed(1)} Hz)`;

    toggleBtn.addEventListener('click', () => {
      const currentlyChecked = moduleControls.some(c => c.moduleId === osc.id);

      if (currentlyChecked) {
        // Remove from controls
        const idx = moduleControls.findIndex(c => c.moduleId === osc.id);
        if (idx !== -1) {
          moduleControls.splice(idx, 1);
        }
        toggleBtn.classList.remove('active');
        toggleModuleControlClass(osc.id, false);
      } else {
        // Check limit (10)
        const currentOscCount = moduleControls.filter(c => c.type === 'Oscillator').length;
        if (currentOscCount >= 8) {
          showAlert("Maximum of 8 oscillators allowed.");
          return;
        }

        // Add to controls
        moduleControls.push({
          type: 'Oscillator',
          moduleId: osc.id,
          freq: osc.freq || 220
        });
        toggleBtn.classList.add('active');
        toggleModuleControlClass(osc.id, true);
      }
      updateModulePreview();
    });

    grid.appendChild(toggleBtn);
  });

  scrollArea.appendChild(grid);
  container.appendChild(scrollArea);
}

// Update button checkboxes based on modules on canvas
function updateButtonCheckboxes() {
  const container = document.getElementById('buttonCheckboxes');
  if (!container) return;

  // Get all buttons on the canvas
  const buttons = modules.filter(m => m.type === 'Button');

  // Clear existing content
  container.innerHTML = '';

  if (buttons.length === 0) {
    container.innerHTML = '<div style="font-size: 10px; color: var(--text-secondary); padding: 5px;">No buttons on canvas</div>';
    return;
  }

  // Create scrollable wrapper
  const scrollArea = document.createElement('div');
  scrollArea.className = 'designer-scroll-area';

  // Create grid container for two columns
  const grid = document.createElement('div');
  grid.className = 'designer-toggle-grid';

  buttons.forEach((btn, index) => {
    const isChecked = moduleControls.some(c => c.moduleId === btn.id);

    toggleModuleControlClass(btn.id, isChecked);

    const toggleBtn = document.createElement('div');
    toggleBtn.className = `designer-toggle-button ${isChecked ? 'active' : ''}`;
    toggleBtn.textContent = `Button ${index + 1}`;

    toggleBtn.addEventListener('click', () => {
      const currentlyChecked = moduleControls.some(c => c.moduleId === btn.id);

      if (currentlyChecked) {
        // Remove from controls
        const idx = moduleControls.findIndex(c => c.moduleId === btn.id);
        if (idx !== -1) {
          moduleControls.splice(idx, 1);
        }
        toggleBtn.classList.remove('active');
        toggleModuleControlClass(btn.id, false);
      } else {
        // Check limit (12)
        const currentBtnCount = moduleControls.filter(c => c.type === 'Button').length;
        if (currentBtnCount >= 10) {
          showAlert("Maximum of 10 buttons allowed.");
          return;
        }

        // Add to controls
        moduleControls.push({
          type: 'Button',
          moduleId: btn.id
        });
        toggleBtn.classList.add('active');
        toggleModuleControlClass(btn.id, true);
      }
      updateModulePreview();
    });

    grid.appendChild(toggleBtn);
  });

  scrollArea.appendChild(grid);
  container.appendChild(scrollArea);
}

// Enhanced save function to include controls and height
async function saveCustomModuleEnhanced() {
  const nameInput = document.getElementById('customModuleName');
  const name = nameInput.value.trim();

  if (!name) {
    showAlert("Please enter a module name.");
    return;
  }

  const definitionInput = document.getElementById('customModuleDefinition');
  const moduleDefinitionText = definitionInput ? definitionInput.value.trim() : "";

  // Provide default definition if empty
  const finalDefinition = moduleDefinitionText ||
    `This is a custom module that combines multiple components into a single reusable unit. Use it to simplify your patches and create complex behaviors.`;

  // Check if module already exists before asking for confirmation

  // Standard modules list to prevent duplicates
  const standardModules = [
    'AND', 'OR', 'NAND', 'NOR', 'XOR', 'XNOR', 'NOT',
    'Oscillator', 'Harmonic Oscillator', 'Noise',
    'Button', 'Output', 'Oscilloscope', 'EEPROM',
    'Flip-Flop', 'Binary Counter', 'Ring Counter',
    'Shift Register', 'Shift Register (PISO)',
    'Binary Rate Multiplier', 'Multiplexer', 'Demultiplexer',
    'BCD to 7-Segment', '7-Segment Display',
    'Inlet', 'Outlet'
  ];

  if (standardModules.includes(name)) {
    showAlert(`Cannot use name '${name}' as it is a reserved system module name.`);
    return;
  }

  const moduleExists = customModuleDefinitions.hasOwnProperty(name) ||
    await getCustomModuleFromDB(name);

  if (moduleExists) {
    const confirmed = await showConfirmDialog(`Module '${name}' already exists. Overwrite?`);
    if (!confirmed) return;
  }

  // Get inlets and outlets for dimension calculation
  const inlets = modules.filter(m => m.type === 'Inlet');
  const outlets = modules.filter(m => m.type === 'Outlet');

  if (outlets.length === 0) {
    showAlert("Module must have at least one outlet.");
    return;
  }

  // Filter controls based on moduleControls tracking
  const controls = modules.filter(m =>
    moduleControls.find(c => c.moduleId === m.id)
  );

  // Calculate dimensions using unified logic
  const dims = calculateModuleDimensions(inlets, outlets, controls, moduleHeight);

  // Create definition with calculated dimensions
  const definition = {
    name: name,
    definition: finalDefinition,
    height: moduleHeight,
    gridWidth: dims.gridWidth,
    gridHeight: dims.gridHeight,
    modules: modules
      .filter(m => m.type !== 'Output') // Exclude Output modules from saved definition
      .map(m => {
        const moduleDef = {
          id: m.id,
          type: m.type,
          gridX: m.gridX,
          gridY: m.gridY,
          label: m.label,
        };

        if (m.freq !== undefined) {
          moduleDef.freq = m.freq;
        }

        if (m.memoryData !== undefined) {
          moduleDef.memoryData = m.memoryData;
        }

        const isControl = moduleControls.find(c => c.moduleId === m.id);
        if (isControl) {
          moduleDef.isControl = true;
        }

        return moduleDef;
      }),
    connections: connections.map(c => ({
      fromModuleId: c.from,
      toModuleId: c.to,
      inputIndex: c.inputIndex,
      outputIndex: c.fromOutputIndex || 0
    })),
    controls: moduleControls
  };

  try {
    await saveCustomModuleToDB(definition);
    customModuleDefinitions[name] = definition;
    showAlert(`Module '${name}' saved!`);
    updateCustomModuleMenu();
    window.designerInitialState = getDesignerStateHash();
  } catch (e) {
    console.error("Failed to save custom module:", e);
    showAlert("Failed to save module.");
  }
}


// Initialize event listeners
window.addEventListener('load', () => {
  const heightSelect = document.getElementById('moduleHeight');

  if (heightSelect) {
    heightSelect.addEventListener('change', (e) => {
      moduleHeight = e.target.value;
      updateModulePreview();
    });
  }

  // Name input listener for preview
  const nameInput = document.getElementById('customModuleName');
  if (nameInput) {
    nameInput.addEventListener('input', updateModulePreview);
  }

  // Attach enhanced save handler
  const saveBtn = document.getElementById('saveCustomModuleBtn');
  if (saveBtn) {
    // Remove any existing listeners just in case (though we removed it from moduleDesigner.js)
    const newBtn = saveBtn.cloneNode(true);
    saveBtn.parentNode.replaceChild(newBtn, saveBtn);
    newBtn.addEventListener('click', saveCustomModuleEnhanced);
  }

  // Update preview and checkboxes when modules change
  // Hook into existing module creation/deletion
  const originalCreateModule = window.createModule;
  if (originalCreateModule) {
    window.createModule = function (...args) {
      const result = originalCreateModule.apply(this, args);
      if (isModuleDesigner) {
        updateOscillatorCheckboxes();
        updateButtonCheckboxes();
        updateModulePreview();
      }
      return result;
    };
  }
});

// Reset controls when entering designer
const originalEnterModuleDesigner = enterModuleDesigner;
enterModuleDesigner = function () {
  originalEnterModuleDesigner();
  moduleControls = [];

  // Clear any existing previewed-control classes
  document.querySelectorAll('.module.previewed-control').forEach(el => el.classList.remove('previewed-control'));

  moduleHeight = '4';

  // Clear name input
  const nameInput = document.getElementById('customModuleName');
  if (nameInput) nameInput.value = '';

  const definitionInput = document.getElementById('customModuleDefinition');
  if (definitionInput) definitionInput.value = '';

  updateOscillatorCheckboxes();
  updateButtonCheckboxes();
  updateModulePreview();
};

// Override the original save function
const originalSaveCustomModule = saveCustomModule;
saveCustomModule = saveCustomModuleEnhanced;

// tutorial.js
// tutorial.js - Interactive tutorial system for Logic Synth

let tutorialActive = false;
let currentTutorialStep = 0;
let tutorialHighlightElements = []; // Track highlighted elements for cleanup
let isMobileTutorial = false; // Track if we're showing mobile version

// Mobile breakpoint (in pixels)
const MOBILE_WIDTH_BREAKPOINT = 769;
const MOBILE_HEIGHT_BREAKPOINT = 500;
// Check if current viewport is mobile
function isMobileViewport() {
  if (window.innerWidth < MOBILE_WIDTH_BREAKPOINT || window.innerHeight < MOBILE_HEIGHT_BREAKPOINT) return true;
  return window.innerWidth < MOBILE_WIDTH_BREAKPOINT;
}

// Define mobile tutorial step
const mobileTutorialStep = {
  patchFile: null,
  title: "State Machine by Passepartout Duo",
  size: "large",
  textSections: [
    {
      text: "Getting Started on Mobile",
      style: "instruction"
    },
    {
      text: "State Machine works best on larger screens. For the full experience, try using a tablet or desktop computer.",
      style: "normal"
    },
    {
      text: "Explore the example patches from the Save/Load menu for inspiration, or start creating your own patches using the module menu.",
      style: "normal"
    },
    {
      text: "Tap ports to patch connection. Try opening patches in performance mode to explore playing patches through touch.",
      style: "normal"
    }
  ],
  highlightModules: [],
  highlightUI: [],
  viewConfig: {
    autoFit: true,
    padding: 100
  }
};

// Define tutorial steps with enhanced customization
const tutorialSteps = [
  {
    patchFile: "examples/tutorial/tutorial-intro.json",
    title: "State Machine",
    size: "large",
    textSections: [
      {
        text: "logic synthesizer made by Passepartout Duo",
        style: "intro"
      },
      {
        text: "State Machine is a browser-based modular synthesizer where every signal is either 0 or 1. Part instrument and part digital experiment, you patch together logic gates, counters, and shift registers to make sound.",
        style: "normal"
      }
    ],
    highlightModules: [], // Module IDs to highlight
    highlightUI: [], // CSS selectors for UI elements to highlight
    viewConfig: {
      autoFit: true,
      padding: 300 // pixels of padding around content
    }
  },
  {
    patchFile: "examples/tutorial/tutorial-1.json",
    title: "Getting Started",
    size: "normal",
    textSections: [
      {
        text: "Enable audio by clicking the audio toggle button.",
        style: "instruction"
      },
      {
        text: "This is the most basic patch possible, an oscillator connected to the output.",
        style: "tip"
      }
    ],
    highlightModules: [],
    highlightUI: ['#mobile-audio-fab', '#startAudioButton'],
    viewConfig: {
      autoFit: true,
      padding: 300
    }
  },
  {
    patchFile: "examples/tutorial/tutorial-1.json",
    title: "Connect Modules",
    size: "normal",
    textSections: [
      {
        text: "Patch modules together by clicking or tapping on a module's ports.",
        style: "instruction"
      },
      {
        text: "Add more modules to the screen using the + menu. Try patching by clicking/tapping ports, or disconnecting selecting and deleting existing connections.",
        style: "tip"
      },
    ],
    highlightModules: [], // Will highlight binary counter if we know its ID
    highlightUI: ['#mobile-add-module-fab', '#toggle-controls'],
    viewConfig: {
      autoFit: true,
      padding: 300
    }
  },
  {
    patchFile: "examples/tutorial/tutorial-2.json",
    title: "Logic Gates: AND",
    textSections: [
      {
        text: "Press the button to hear the oscillator.",
        style: "instruction"
      },
      {
        text: "Logic gates are the basis of the synthesizer. An AND gate only says 'yes' when both the A and B inputs agree. We can use the AND gate to make a simple on/off button",
        style: "tip"
      },
      {
        text: "Each gate changes its output state based on the state of its two inputs. When both A and B are 1, its output will also be 1.",
        style: "normal"
      }
    ],
    highlightModules: [157, 158],
    highlightUI: [],
    viewConfig: {
      autoFit: true,
      padding: 300
    }
  },
  {
    patchFile: "examples/tutorial/tutorial-4.json",
    title: "Logic Gates: XOR",
    size: "normal",
    textSections: [
      {
        text: "Move the oscillator sliders to hear ring modulation.",
        style: "instruction"
      },
      {
        text: "XOR gates can produce interesting results. Here they're being used to produce a ring modulation like effect using two oscillators",
        style: "tip"
      },
      {
        text: "XOR gates are 'difference detectors' they output 1 when the A and B inputs aren't the same. They can be used to produce LFSR pseudo random patterns when used with Shift Registers",
        style: "normal"
      }
    ],
    highlightModules: [156, 160],
    highlightUI: [],
    viewConfig: {
      autoFit: true,
      padding: 600
    }
  },
  {
    patchFile: "examples/tutorial/tutorial-5.json",
    title: "Binary Counter",
    size: "normal",
    textSections: [
      {
        text: "Repatch different outputs to hear different octaves",
        style: "instruction"
      },
      {
        text: "Binary Counters divde the input signal by powers of two, (2, 4, 8, 16, and so on.) We can use this to slow our oscillators to be rhythmic control signals, or to produce lower octave pitches.",
        style: "tip"
      },
      {
        text: "Each output of the top binary counter will play a different octave subdivision of the original oscillation. Instead the bottom one is slowed down to become a control signal for the and gate, making rhythmic repetitions.",
        style: "normal"
      }
    ],
    highlightModules: [169, 167],
    highlightUI: [],
    viewConfig: {
      autoFit: true,
      padding: 600
    }
  },
  {
    patchFile: "examples/tutorial/tutorial-6.json",
    title: "Ring Counter",
    size: "normal",
    textSections: [
      {
        text: "Repatch the reset bit to hear different rhythmic divisions",
        style: "instruction"
      },
      {
        text: "Ring Counters count up to eight, with the option to reset at any step.",
        style: "tip"
      },
      {
        text: "Depending on which output is sent to the reset, you can create different rhythmic subdivisions, or subharmonics of an oscillator.",
        style: "normal"
      }
    ],
    highlightModules: [170, 172],
    highlightUI: [],
    viewConfig: {
      autoFit: true,
      padding: 600
    }
  },
  {
    patchFile: "examples/tutorial/tutorial-7.json",
    title: "Multiplexer",
    size: "normal",
    textSections: [
      {
        text: "Repatch the A, B, and C inputs to hear different pattern combinations and speeds.",
        style: "instruction"
      },
      {
        text: "Multiplexers allow you to choose anything. Think of them like an eight-way selector switch.",
        style: "tip"
      },
      {
        text: "Which of the 8 inputs gets routed to the output depends on which binary number is present at bit inputs A, B, and C. Connecting the Binary Counter allows for an ordered sequential result.",
        style: "normal"
      }
    ],
    highlightModules: [177],
    highlightUI: [],
    viewConfig: {
      autoFit: true,
      padding: 600
    }
  },
  {
    patchFile: "examples/tutorial/tutorial-8.json",
    title: "Performance Mode",
    size: "normal",
    textSections: [
      {
        text: "Enter performance mode and explore your patch as an instrument",
        style: "instruction"
      },
      {
        text: "Buttons and oscillators can be assigned to performance mode using the performance assignment button. Performance mode also contains extra global effects: a filter and delay.",
        style: "tip"
      },
      {
        text: "Click to assign or unassign up to six buttons and six oscillators using the assign tool. In performance mode your changes to the patch are temporary, so you can always pick back up where you left off. Think of it like the front panel of an instrument you've designed through the patch.",
        style: "normal"
      }
    ],
    highlightModules: [169, 167],
    highlightUI: ['#performanceButton', '#assignPerformanceButton', '#assignButtonMobile', '#performanceButtonMobile','#mobilePerformanceButton', '#mobile-utility-fab'],
    viewConfig: {
      autoFit: true,
      padding: 600
    }
  },
  {
    patchFile: "examples/tutorial/tutorial-9.json",
    title: "Putting it All Together",
    size: "normal",
    textSections: [
      {
        text: "Experiment with what we've covered!",
        style: "instruction"
      },
      {
        text: "This example puts together all the modules covered so far, plus some extra.",
        style: "tip"
      },
      {
        text: "The three oscillators cover two voices, and one rhythm generator. Both voices use Ring Counters and Multiplexers to generate subharmonics which are chosen by a Shift Register in an LFSR configuration. When the button is pressed, it toggles the Flip-Flop and locks the Shift Register so that its pattern loops indefinitely.",
        style: "normal"
      }
    ],
    highlightModules: [169, 167],
    highlightUI: [],
    viewConfig: {
      autoFit: true,
      padding: 600
    }
  },
  {
    patchFile: null, // null means don't load a new patch, stay on current
    title: "You're Ready!",
    size: "large",
    textSections: [
      {
        text: "Enjoy exploring sound and logic.",
        style: "intro"
      },
      {
        text: "Start experimenting with the module menu, or load example patches from the Save/Load menu for inspiration.",
        style: "normal"
      },
      {
        text: "Key controls to remember:\n• Click ports to connect modules\n• Click wires to disconnect them\n• Drag modules to move them\n• Cmd/Ctrl + Click to select multiple modules\n• copy, paste, delete, undo, and redo using typical hot keys or through the edit bar\n",
        style: "list"
      }
    ],
    highlightModules: [],
    highlightUI: [],
    viewConfig: {
      // Keep current view for final step
      autoFit: true
    }
  }
];

// Initialize tutorial system
function initTutorial() {
  createTutorialUI();

  // Add tutorial button to main UI (if not already present)
  const existingTutorialBtn = document.getElementById('startTutorialButton');
  if (existingTutorialBtn) {
    existingTutorialBtn.addEventListener('click', startTutorial);
  }
}

// Create tutorial UI elements
function createTutorialUI() {
  const prevBtn = document.getElementById('tutorialPrevBtn');
  const nextBtn = document.getElementById('tutorialNextBtn');
  const exitBtn = document.getElementById('tutorialExitBtn');

  // Attach event listeners
  if (prevBtn) prevBtn.addEventListener('click', previousTutorialStep);
  if (nextBtn) nextBtn.addEventListener('click', nextTutorialStep);
  if (exitBtn) exitBtn.addEventListener('click', exitTutorial);
}

// Start tutorial
async function startTutorial() {
  if (tutorialActive) return;
  closeDictionary();

  const tutorialOverlay = document.getElementById('tutorialOverlay');
  const tutorialControls = document.getElementById('tutorialControls');

  // Check if mobile viewport
  isMobileTutorial = isMobileViewport();

  // Save current patch state
  const patchData = {
    version: 2,
    modules: modules.map(m => ({
      id: m.id,
      type: m.type,
      gridX: m.gridX,
      gridY: m.gridY,
      freq: m.freq,
      assignedKey: m.assignedKey,
      memoryData: m.memoryData
    })),
    connections: connections,
    viewState: { ...viewState },
    performanceAssignments: {
      oscillators: Array.from(performanceSnapshot.performanceOscillators.entries()),
      buttons: Array.from(performanceSnapshot.performanceButtons.entries())
    }
  };
  localStorage.setItem('savedPatch', JSON.stringify(patchData));

  tutorialActive = true;
  currentTutorialStep = 0;

  // Stop audio if playing
  if (audioStarted) {
    await toggleAudio();
  }

  // Show overlay and controls
  tutorialOverlay.classList.add('active');
  tutorialControls.classList.add('active');

  // Add mobile class if needed
  if (isMobileTutorial) {
    tutorialOverlay.classList.add('mobile-tutorial');
    tutorialControls.classList.add('mobile-tutorial');
  }

  // Hide other UI elements
  hideUIForTutorial();

  // Load appropriate tutorial
  if (isMobileTutorial) {
    await loadMobileTutorialStep();
  } else {
    await loadTutorialStep(currentTutorialStep);
  }
}

// Exit tutorial
function exitTutorial() {
  if (!tutorialActive) return;

  const tutorialOverlay = document.getElementById('tutorialOverlay');
  const tutorialControls = document.getElementById('tutorialControls');

  tutorialActive = false;
  isMobileTutorial = false;

  // Hide overlay and controls
  tutorialOverlay.classList.remove('active');
  tutorialControls.classList.remove('active');
  tutorialOverlay.classList.remove('mobile-tutorial');
  tutorialControls.classList.remove('mobile-tutorial');

  // Restore UI elements
  showUIAfterTutorial();

  // Clear any highlights
  clearAllHighlights();

  // Restore saved patch
  loadDefaultPatch();
}

// Load mobile tutorial step
async function loadMobileTutorialStep() {
  const step = mobileTutorialStep;
  
  clearAllHighlights();

  const textBox = document.getElementById('tutorialTextBox');

  // Apply large step styling
  textBox.classList.remove('first-step', 'large-step', 'normal-step');
  textBox.classList.add('large-step');

  renderTutorialText(step);

  // Hide progress indicator for mobile
  const progressElement = document.getElementById('tutorialProgress');
  if (progressElement) {
    progressElement.style.display = "none";
  }

  // Hide prev button, show only exit/finish
  const prevBtn = document.getElementById('tutorialPrevBtn');
  const nextBtn = document.getElementById('tutorialNextBtn');

  if (prevBtn) {
    prevBtn.style.display = 'none';
  }

  if (nextBtn) {
    // Show as finish button
    nextBtn.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
      <path fill="currentColor" d="M21.03 5.72a.75.75 0 0 1 0 1.06l-11.5 11.5a.747.747 0 0 1-1.072-.012l-5.5-5.75a.75.75 0 1 1 1.084-1.036l4.97 5.195L19.97 5.72a.75.75 0 0 1 1.06 0" />
    </svg>`;
  }

  // Load patch if specified
  if (step.patchFile) {
    try {
      const response = await fetch(step.patchFile);
      const patchData = await response.json();
      await loadTutorialPatch(patchData, step.viewConfig);
    } catch (error) {
      console.error('Error loading mobile tutorial patch:', error);
    }
  }

  // Apply highlights
  if (step.highlightModules && step.highlightModules.length > 0) {
    highlightTutorialModules(step.highlightModules);
  }

  if (step.highlightUI && step.highlightUI.length > 0) {
    highlightUIElements(step.highlightUI);
  }
}

function renderTutorialText(step) {
  const textElement = document.getElementById('tutorialText');
  textElement.innerHTML = '';

  // Determine if this is a large step
  const isLargeStep = step.size === 'large';

  // Title (always shown)
  if (step.title) {
    const title = document.createElement('div');
    title.className = 'tutorial-title';
    title.textContent = step.title;
    textElement.appendChild(title);
  }

  // Extract sections by style
  const introSection = step.textSections?.find(s => s.style === 'intro');
  const instructionSection = step.textSections?.find(s => s.style === 'instruction');
  const tipSection = step.textSections?.find(s => s.style === 'tip');
  const normalSections = step.textSections?.filter(s => s.style === 'normal');
  const listSections = step.textSections?.filter(s => s.style === 'list');

  // Subtitle/intro
  if (introSection) {
    const subtitle = document.createElement('div');
    subtitle.className = 'tutorial-subtitle';
    subtitle.textContent = introSection.text;
    textElement.appendChild(subtitle);
  }

  // Instruction (primary action)
  if (instructionSection) {
    const instruction = document.createElement('div');
    instruction.className = 'tutorial-instruction';
    instruction.textContent = instructionSection.text;
    textElement.appendChild(instruction);
  }

  // Tip (always visible if present)
  if (tipSection) {
    const tip = document.createElement('div');
    tip.className = 'tutorial-tip';
    tip.innerHTML = `<span><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
      <path fill="currentColor" fill-rule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75s-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12M12 8.25a.75.75 0 0 1 .75.75v3.75a.75.75 0 0 1-1.5 0V9a.75.75 0 0 1 .75-.75m0 8.25a.75.75 0 1 0 0-1.5a.75.75 0 0 0 0 1.5" clip-rule="evenodd" />
      </svg></span>`;
    tip.textContent = `${tipSection.text}`;
    textElement.appendChild(tip);
  }

  // For large steps, show all content directly without collapse
  if (isLargeStep) {
    // Add normal text
    normalSections.forEach(section => {
      const desc = document.createElement('div');
      desc.className = 'tutorial-description';
      desc.textContent = section.text;
      textElement.appendChild(desc);
    });

    // Add lists
    listSections.forEach(section => {
      const list = document.createElement('div');
      list.className = 'tutorial-list';
      list.style.whiteSpace = 'pre-line';
      list.textContent = section.text;
      textElement.appendChild(list);
    });
  } else {
    // For normal steps, use expandable details
    const hasDetails = normalSections.length > 0 || listSections.length > 0;

    if (hasDetails) {
      const detailsContainer = document.createElement('div');
      detailsContainer.className = 'tutorial-details';

      // Add normal text
      normalSections.forEach(section => {
        const desc = document.createElement('div');
        desc.className = 'tutorial-description';
        desc.textContent = section.text;
        detailsContainer.appendChild(desc);
      });

      // Add lists
      listSections.forEach(section => {
        const list = document.createElement('div');
        list.className = 'tutorial-list';
        list.style.whiteSpace = 'pre-line';
        list.textContent = section.text;
        detailsContainer.appendChild(list);
      });

      textElement.appendChild(detailsContainer);

      // Add expand/collapse hint
      const expandHint = document.createElement('div');
      expandHint.className = 'tutorial-expand-hint';
      expandHint.textContent = 'more...';
      textElement.appendChild(expandHint);

      // Setup expand/collapse for normal steps only
      setupExpandCollapse(textElement);
    }
  }
}

function setupExpandCollapse(textElement) {
  const details = textElement.querySelector('.tutorial-details');
  const hint = textElement.querySelector('.tutorial-expand-hint');

  if (!details || !hint) return;

  // Start collapsed
  details.classList.add('collapsed');

  // Toggle on click
  textElement.addEventListener('click', () => {
    const isCollapsed = details.classList.contains('collapsed');

    if (isCollapsed) {
      details.classList.remove('collapsed');
      hint.textContent = 'less...';
    } else {
      details.classList.add('collapsed');
      hint.textContent = 'more...';
    }
  });
}

// Navigate to next step
async function nextTutorialStep() {
  // If mobile tutorial, just exit
  if (isMobileTutorial) {
    exitTutorial();
    return;
  }

  if (currentTutorialStep < tutorialSteps.length - 1) {
    currentTutorialStep++;
    await loadTutorialStep(currentTutorialStep);
  } else {
    // Tutorial complete
    exitTutorial();
  }
}

// Navigate to previous step
async function previousTutorialStep() {
  // Mobile tutorial has no previous
  if (isMobileTutorial) return;

  if (currentTutorialStep > 0) {
    currentTutorialStep--;
    await loadTutorialStep(currentTutorialStep);
  }
}

// Load a specific tutorial step
async function loadTutorialStep(stepIndex) {
  const step = tutorialSteps[stepIndex];
  if (!step) return;

  clearAllHighlights();

  const textBox = document.getElementById('tutorialTextBox');

  // Apply size-specific classes
  textBox.classList.remove('first-step', 'large-step', 'normal-step');

  if (step.size === 'large') {
    textBox.classList.add('large-step');
  } else {
    textBox.classList.add('normal-step');
  }

  renderTutorialText(step);
  // Update progress
  const progressElement = document.getElementById('tutorialProgress');
  if (progressElement) {
    progressElement.textContent = `Step ${stepIndex} of ${tutorialSteps.length - 1}`;
  }

  if (stepIndex === 0) {
    progressElement.style.display = "none";
  } else {
    progressElement.style.display = "block";
  }

  // Update button states
  const prevBtn = document.getElementById('tutorialPrevBtn');
  const nextBtn = document.getElementById('tutorialNextBtn');

  if (prevBtn) {
    prevBtn.style.display = 'flex'; // Show for desktop
    prevBtn.disabled = stepIndex === 0;
    prevBtn.style.opacity = stepIndex === 0 ? '0.5' : '1';
    prevBtn.style.pointerEvents = stepIndex === 0 ? 'none' : 'auto';
  }

  if (nextBtn) {
    if (stepIndex === tutorialSteps.length - 1) {
      nextBtn.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <path fill="currentColor" d="M21.03 5.72a.75.75 0 0 1 0 1.06l-11.5 11.5a.747.747 0 0 1-1.072-.012l-5.5-5.75a.75.75 0 1 1 1.084-1.036l4.97 5.195L19.97 5.72a.75.75 0 0 1 1.06 0" />
      </svg>`;
    } else {
      nextBtn.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M4.5 12h15m0 0l-5.625-6m5.625 6l-5.625 6" />
      </svg>`;
    }
  }

  // Load patch if specified
  if (step.patchFile) {
    try {
      const response = await fetch(step.patchFile);
      const patchData = await response.json();
      await loadTutorialPatch(patchData, step.viewConfig);
    } catch (error) {
      console.error('Error loading tutorial patch:', error);
      if (textElement) {
        textElement.innerHTML = '<p class="tutorial-text-error">Error loading tutorial step. Please try again or exit the tutorial.</p>';
      }
    }
  } else if (step.viewConfig && step.viewConfig.autoFit) {
    // Apply view config even if not loading a new patch
    applyViewConfig(step.viewConfig);
  }

  // Apply highlights
  if (step.highlightModules && step.highlightModules.length > 0) {
    highlightTutorialModules(step.highlightModules);
  }

  if (step.highlightUI && step.highlightUI.length > 0) {
    highlightUIElements(step.highlightUI);
  }
}

// Load a patch specifically for tutorial (using new coordinate system)
async function loadTutorialPatch(patchData, viewConfig) {
  undoStack = [];
  redoStack = [];

  try {
    // Convert legacy format if needed
    patchData = convertLegacyPatch(patchData);

    // Clear existing modules and connections
    const container = document.getElementById('moduleContainer');
    if (container) {
      container.innerHTML = '';
    }
    modules = [];
    connections = [];
    ledElements = [];

    // Ensure containers exist
    const gridSvg = document.getElementById('gridSvg');
    const wireSvg = document.getElementById('wireSvg');

    if (!gridSvg || !wireSvg || !container) {
      console.error('Required containers not found, initializing...');
      initializeContainers();
      // Wait for next frame to ensure DOM is ready
      await new Promise(resolve => requestAnimationFrame(resolve));
    }

    let maxId = -1;

    // Create modules
    patchData.modules.forEach(module => {
      const div = document.createElement('div');
      div.className = 'module';
      div.style.position = 'absolute';
      div.dataset.id = module.id;
      div.dataset.type = module.type;

      if (module.type === 'Oscillator') {
        setupModuleUI(div, module.type, module.freq);
      } else {
        setupModuleUI(div, module.type);
      }

      if (module.type === 'Button' && module.assignedKey) {
        updateButtonKeyMapping(div, module.assignedKey);
      }

      if (module.type === 'EEPROM' && module.memoryData && workletNode) {
        // Small delay to ensure worklet is ready
        setTimeout(() => {
          workletNode.port.postMessage({
            type: 'programEEPROM',
            moduleId: module.id,
            memoryData: module.memoryData
          });
        }, 100);
      }

      // Position using grid coordinates
      const pixelPos = gridToPixels(module.gridX, module.gridY);
      div.style.position = 'absolute';
      div.style.left = `${pixelPos.x}px`;
      div.style.top = `${pixelPos.y}px`;
      div.style.transform = 'none';

      container.appendChild(div);

      const newModule = {
        id: module.id,
        type: module.type,
        gridX: module.gridX,
        gridY: module.gridY,
        freq: module.freq,
        assignedKey: module.assignedKey,
        memoryData: module.memoryData
      };

      // Attach definition for custom modules so audio worklet can process them
      if (module.definition) {
        newModule.definition = module.definition;
      } else if (customModuleDefinitions[module.type]) {
        newModule.definition = customModuleDefinitions[module.type];
      }
      
      modules.push(newModule);

      if (module.id > maxId) maxId = module.id;
    });

    moduleId = maxId + 1;

    // Check if output module exists
    outModuleCreated = modules.some(m => m.type.toLowerCase() === 'output');
    const button = document.getElementById('createOutputModuleButton');
    if (button) {
      if (outModuleCreated) {
        button.classList.add('fake-disabled');
      } else {
        button.classList.remove('fake-disabled');
      }
    }

    // Restore connections
    connections = patchData.connections || [];

    // Restore performance assignments (or clear if not present)
    performanceSnapshot.performanceOscillators.clear();
    performanceSnapshot.performanceButtons.clear();
    usedOscillatorSlots.clear();
    usedButtonSlots.clear();

    if (patchData.performanceAssignments) {
      // Restore oscillator assignments
      if (patchData.performanceAssignments.oscillators) {
        patchData.performanceAssignments.oscillators.forEach(([moduleId, slot]) => {
          performanceSnapshot.performanceOscillators.set(moduleId, slot);
          usedOscillatorSlots.add(slot);
        });
      }

      // Restore button assignments
      if (patchData.performanceAssignments.buttons) {
        patchData.performanceAssignments.buttons.forEach(([moduleId, slot]) => {
          performanceSnapshot.performanceButtons.set(moduleId, slot);
          usedButtonSlots.add(slot);
        });
      }

      rebuildSlotTracking();
    }

    // Update performance indicators to reflect cleared/restored state
    updatePerformanceIndicators();
    rebuildLedElements();
    closeAllEEPROMProgrammers();

    if (audioStarted) {
      rebuildAudioGraph();}

      // Wait for layout to complete before applying view config
      await new Promise(resolve => requestAnimationFrame(resolve));
  
      // Apply view configuration AFTER modules are in DOM
      applyViewConfig(viewConfig);
  
      // Draw wires AFTER view is configured
      await new Promise(resolve => requestAnimationFrame(resolve));
      drawWires();
  
      syncMobileOutputButton();
    } catch (error) {
      console.error("Error loading tutorial patch:", error);
      throw error;
    }
  }
  
  // Apply view configuration (auto-fit, specific zoom, etc.)
  function applyViewConfig(config) {
    if (!config) {
      return;
    }
  
    if (config.autoFit) {
      // Calculate bounding box of all modules
      if (modules.length === 0) {
        return;
      }
    
      let minX = Infinity, minY = Infinity;
      let maxX = -Infinity, maxY = -Infinity;
  
      modules.forEach(module => {
        const pixelPos = gridToPixels(module.gridX, module.gridY);
        const dims = getModuleGridDimensions(module.type);
        const moduleWidth = dims.width * viewState.gridSize;
        const moduleHeight = dims.height * viewState.gridSize;
  
        minX = Math.min(minX, pixelPos.x);
        minY = Math.min(minY, pixelPos.y);
        maxX = Math.max(maxX, pixelPos.x + moduleWidth);
        maxY = Math.max(maxY, pixelPos.y + moduleHeight);
      });
    
      // Get canvas size
      const canvas = document.getElementById('moduleContainer');
      if (!canvas) {
        return;
      }
  
      // Get full window dimensions
      const windowWidth = window.innerWidth;
      const windowHeight = window.innerHeight;
  
      // Determine available viewport based on tutorial mode
      let availableWidth, availableHeight;
      let viewportOffsetX = 0, viewportOffsetY = 0;
  
      if (isMobileTutorial) {
        // Mobile tutorial: use full window (text box overlays)
        availableWidth = windowWidth;
        availableHeight = windowHeight;
      } else {
        // Desktop tutorial: check step size
        const currentStep = tutorialSteps[currentTutorialStep];
        const isLargeStep = currentStep && currentStep.size === 'large';
  
        if (isLargeStep) {
          // Large step: use full window (text box is overlay)
          availableWidth = windowWidth;
          availableHeight = windowHeight;
        } else {
          // Normal step: subtract text box from available space
          const textBox = document.getElementById('tutorialTextBox');
  
          if (textBox) {
            const textBoxRect = textBox.getBoundingClientRect();
  
            // Text box is positioned on the right side
            // Available viewport is the area to the left of it
            availableWidth = textBoxRect.left;
            availableHeight = windowHeight;
            viewportOffsetX = 0; // Left-aligned viewport
            viewportOffsetY = 0;
  
          } else {
            // Fallback if text box not found
            availableWidth = windowWidth * 0.65; // Assume text box takes ~35% of width
            availableHeight = windowHeight;
          }
        }
      }
  
      // Calculate content dimensions
      const contentWidth = maxX - minX;
      const contentHeight = maxY - minY;
  
      // Prevent division by zero
      if (contentWidth === 0 || contentHeight === 0) {
        viewState.scale = 1.0;
        viewState.offsetX = 0;
        viewState.offsetY = 0;
        updateViewTransform();
        updateZoomText();
        return;
      }
  
      // Calculate padding based on available space
      const basePadding = config.padding || 100;
      const paddingX = Math.min(basePadding, availableWidth * 0.1);
      const paddingY = Math.min(basePadding, availableHeight * 0.1);
  
      // Calculate available space after padding
      const viewportWidthWithPadding = availableWidth - 2 * paddingX;
      const viewportHeightWithPadding = availableHeight - 2 * paddingY;
  
      // Calculate scale to fit content in available space
      const scaleX = viewportWidthWithPadding / contentWidth;
      const scaleY = viewportHeightWithPadding / contentHeight;
  
      // Use the smaller scale to ensure content fits in both dimensions
      let scale = Math.min(scaleX, scaleY);
  
      // Apply reasonable zoom limits (use your MIN_ZOOM/MAX_ZOOM constants if available)
      const MIN_ZOOM = 0.30;
      const MAX_ZOOM = 1.5;
      scale = Math.max(MIN_ZOOM, Math.min(MAX_ZOOM, scale));
  
      // Calculate offsets to center content in the AVAILABLE viewport
      const centerX = (minX + maxX) / 2;
      const centerY = (minY + maxY) / 2;
  
      // Center within the available viewport area
      const offsetX = viewportOffsetX + (availableWidth / 2) - centerX * scale;
      const offsetY = viewportOffsetY + (availableHeight / 2) - centerY * scale;
  
      // Apply view state
      viewState.scale = scale;
      viewState.offsetX = offsetX;
      viewState.offsetY = offsetY;
  
      updateViewTransform();
      updateZoomText();
  
    } else if (config.scale !== undefined || config.offsetX !== undefined || config.offsetY !== undefined) {
      // Apply specific scale/offset values if provided
      if (config.scale !== undefined) viewState.scale = config.scale;
      if (config.offsetX !== undefined) viewState.offsetX = config.offsetX;
      if (config.offsetY !== undefined) viewState.offsetY = config.offsetY;
  
      updateViewTransform();
      updateZoomText();
    }
  }
  
  
  // Highlight specific modules for tutorial
  function highlightTutorialModules(moduleIds) {
    moduleIds.forEach(id => {
      const module = document.querySelector(`[data-id='${id}']`);
      if (module) {
        module.classList.add('tutorial-highlight');
        tutorialHighlightElements.push(module);
      }
    });
  }
  
  // Highlight UI elements
  function highlightUIElements(selectors) {
    selectors.forEach(selector => {
      const elements = document.querySelectorAll(selector);
      elements.forEach(element => {
        element.classList.add('tutorial-highlight-ui');
        tutorialHighlightElements.push(element);
      });
    });
  }
  
  // Clear all tutorial highlights
  function clearAllHighlights() {
    tutorialHighlightElements.forEach(element => {
      element.classList.remove('tutorial-highlight');
      element.classList.remove('tutorial-highlight-ui');
    });
    tutorialHighlightElements = [];
  }
  
  // Hide UI elements during tutorial
  function hideUIForTutorial() {
    // Optionally hide UI elements - currently keeping them visible
    // but you can uncomment to hide specific elements during tutorial
  }
  
  // Show UI elements after tutorial
  function showUIAfterTutorial() {
    // Restore any hidden UI elements
  }
  
  // Keyboard navigation for tutorial
  document.addEventListener('keydown', (e) => {
    if (!tutorialActive) return;
  
    // Prevent default keyboard shortcuts during tutorial
    const isEditing = document.activeElement.tagName === 'INPUT' ||
      document.activeElement.tagName === 'TEXTAREA' ||
      document.activeElement.getAttribute('contenteditable') === 'true';
  
    if (isEditing) return;
  
    switch (e.key) {
      case 'ArrowRight':
      case 'Enter':
        e.preventDefault();
        nextTutorialStep();
        break;
      case 'ArrowLeft':
        e.preventDefault();
        previousTutorialStep();
        break;
      case 'Escape':
        e.preventDefault();
        exitTutorial();
        break;
    }
  });
  
  // Handle window resize during tutorial
  window.addEventListener('resize', () => {
    if (!tutorialActive) return;
  
    // Check if viewport size changed from mobile to desktop or vice versa
    const nowMobile = isMobileViewport();
    
    // If viewport type changed, restart tutorial with appropriate version
    if (nowMobile !== isMobileTutorial) {
      exitTutorial();
      // Small delay to ensure clean state
      setTimeout(() => {
        startTutorial();
      }, 100);
    }
  });
  
  // Initialize when page loads
  window.addEventListener('load', () => {
    initTutorial();
  });
  
  // Export functions for use in other files
  window.tutorialSystem = {
    start: startTutorial,
    exit: exitTutorial,
    isActive: () => tutorialActive,
    isMobile: () => isMobileTutorial
  };

// moduleUI.js
// Helper function to set up a module's UI based on type
function setupModuleUI(div, type, initialFreq) {
  // Add classes to the main container

  // div.style.transform = `scale(${zoomFactor})`;
  // div.style.transformOrigin = 'top left';

  div.classList.add('module');


  // Add title
  const title = document.createElement('div');
  title.innerText = type === 'Shift Register' ? 'Shift Register (SIPO)' : type;
  title.classList.add('module-title');
  div.appendChild(title);

  // Add close button if needed
  // const closeButton = document.createElement('div');
  // closeButton.innerHTML = '&times;';
  // closeButton.classList.add('close-button');
  // closeButton.addEventListener('click', (e) => {
  //     e.stopPropagation();
  //     deleteModule(parseInt(div.dataset.id));
  // });
  // div.appendChild(closeButton);

  // Set up module-specific UI based on type
  if (type === 'Oscillator') {
    setupOscillatorUI(div, initialFreq);
  } else if (['AND', 'OR', 'NAND', 'NOR', 'XOR', 'XNOR'].includes(type)) {
    setupLogicGateUI(div);
  } else if (type === 'NOT') {
    setupNotGateUI(div);
  } else if (type === 'Noise') {
    setupNoiseGateUI(div);
  } else if (type === 'Flip-Flop') {
    setupFlipFlopUI(div);
  } else if (type === 'Binary Counter' || type === 'Ring Counter') {
    setupCounterUI(div);
  } else if (type === 'Shift Register') {
    setupShiftRegisterUI(div);
  } else if (type === 'Multiplexer') {
    setupMultiplexerUI(div);
  } else if (type === 'Demultiplexer') {
    setupDemultiplexerUI(div);
  } else if (type === 'Shift Register (PISO)') {
    setupShiftRegisterPISOUI(div);
  } else if (type === 'Binary Rate Multiplier') {
    setupBinaryRateMultiplierUI(div);
  } else if (type === 'Output') {
    setupOutputUI(div);
  } else if (type === 'Button') {
    setupButtonUI(div);
  } else if (type === 'Harmonic Oscillator') {
    setupOscillatorPUI(div);
  } else if (type === 'Oscilloscope') {
    setupOscilloscopeUI(div);
  } else if (type === 'EEPROM') {
    setupEEPROMUI(div);
  } else if (type === 'BCD to 7-Segment') {
    setupBCDTo7SegmentUI(div);
  } else if (type === '7-Segment Display') {
    setup7SegmentDisplayUI(div);
  } else if (type === 'Inlet') {
    setupInletUI(div);
  } else if (type === 'Outlet') {
    setupOutletUI(div);
  } else if (type === 'ExportOutlet') {
    setupOutletExportUI(div);
  } else if (type === 'ExportInlet') {
    setupInletExportUI(div);
  } else if (type === 'ExportLed') {
    setupExportLedUI(div);
  } else if (customModuleDefinitions[type]) {
    setupCompositeModuleUI(div, customModuleDefinitions[type]);
  } else if (type !== 'Oscillator') {
    // Default input for other modules
    setupDefaultInputUI(div);
  }

  // Add port event listeners
  addPortEventListeners(div);

  // Add selection handler
  addModuleSelectionHandler(div);
}

// Helper function for oscillator UI
function setupOscillatorUI(div, initialFreq) {
  const freqControlContainer = document.createElement('div');
  freqControlContainer.classList.add('freq-control-container');

  // Use the provided frequency or default to 220 Hz
  const freq = initialFreq || 220;

  // Create a container for the frequency label and input field
  const freqLabelInputContainer = document.createElement('div');
  freqLabelInputContainer.classList.add('freq-label-input-container');

  // Create label that will also serve as a clickable element
  const freqLabel = document.createElement('div');
  freqLabel.classList.add('freq-label');
  freqLabel.innerText = `${freq.toFixed(2)} Hz`;

  // Create text input field for direct frequency entry
  const freqTextInput = document.createElement('input');
  freqTextInput.type = 'text';
  freqTextInput.classList.add('freq-text-input');
  freqTextInput.value = freq.toFixed(2);

  // Add interaction to switch between label and input
  freqLabel.addEventListener('click', () => {
    freqLabel.style.display = 'none';
    freqTextInput.style.display = 'block';
    freqTextInput.focus();
    freqTextInput.select();
    clearSelection(); // Clear module selection when entering edit mode
    updateSelectionHighlights();
  });

  // Track original frequency for undo
  let originalFreq = freq;
  let isEditing = false;

  // Set flag when starting to edit
  freqTextInput.addEventListener('focus', () => {
    isEditing = true;
    originalFreq = parseFloat(freqTextInput.value);
  });

  // Handle input field changes
  freqTextInput.addEventListener('blur', () => {
    if (isEditing) {
      updateFrequencyFromText();
      isEditing = false;
    }
  });

  // Prevent delete key from deleting module while editing
  freqTextInput.addEventListener('keydown', (e) => {
    // Stop propagation for all keydown events to prevent module deletion
    e.stopPropagation();

    if (e.key === 'Enter') {
      updateFrequencyFromText();
      freqTextInput.blur();
    }
  });

  function updateFrequencyFromText() {
    let newFreq = parseFloat(freqTextInput.value);

    // Validate input
    if (isNaN(newFreq) || newFreq <= 0) {
      newFreq = freq; // Revert to current frequency if invalid
    } else {
      // Clamp to min/max range
      newFreq = Math.max(10, Math.min(3000, newFreq));
    }

    // Get the module
    const moduleId = div.dataset.id;
    const mod = modules.find(m => m.id == moduleId);

    if (mod) {
      // Only record change if frequency actually changed
      if (mod.freq !== newFreq) {
        // Record action for undo/redo
        pushToUndoStack({
          type: 'changeFrequency',
          moduleId: moduleId,
          oldFrequency: mod.freq,
          newFrequency: newFreq
        });

        // Update the module frequency
        mod.freq = newFreq;
      }
    }

    // Update UI
    freqTextInput.value = newFreq.toFixed(2);
    freqLabel.innerText = `${newFreq.toFixed(2)} Hz`;

    // Update slider position to match
    const normalized = Math.log(newFreq / 10) / Math.log(300);
    freqControl.value = Math.round(normalized * 1500);

    // Switch back to label display
    freqTextInput.style.display = 'none';
    freqLabel.style.display = 'block';

    // Send message to worklet instead of rebuilding graph
    if (workletNode) {
      workletNode.port.postMessage({
        type: 'frequencyChange',
        moduleId: parseInt(div.dataset.id),
        frequency: newFreq
      });
    }
    if (isModuleDesigner) {
      updateOscillatorCheckboxes();
      updateModulePreview();
    }
  }

  freqLabelInputContainer.appendChild(freqLabel);
  freqLabelInputContainer.appendChild(freqTextInput);
  freqControlContainer.appendChild(freqLabelInputContainer);

  const freqControl = document.createElement('input');
  freqControl.type = 'range';
  freqControl.min = 0;
  freqControl.max = 1500;
  freqControl.classList.add('freq-slider');

  // Calculate slider value based on frequency
  const normalized = Math.log(freq / 10) / Math.log(300);
  freqControl.value = Math.round(normalized * 1500);

  // Variables to track slider movement
  let sliderStartFreq = freq;
  let isSliding = false;

  // Record the starting frequency when slider interaction begins
  freqControl.addEventListener('mousedown', () => {
    const mod = modules.find(m => m.id == div.dataset.id);
    sliderStartFreq = mod ? mod.freq : freq;
    isSliding = true;
  });

  // Handle continuous slider updates
  freqControl.addEventListener('input', () => {
    const normalized = freqControl.value / 1500;
    const newFreq = 10 * Math.pow(300, normalized);

    const mod = modules.find(m => m.id == div.dataset.id);
    if (mod) mod.freq = newFreq;

    freqLabel.innerText = `${newFreq.toFixed(2)} Hz`;
    freqTextInput.value = newFreq.toFixed(2);

    // Send targeted frequency update message
    if (workletNode) {
      workletNode.port.postMessage({
        type: 'frequencyChange',
        moduleId: parseInt(div.dataset.id),
        frequency: newFreq
      });
    }
    if (isModuleDesigner) {
      updateOscillatorCheckboxes();
      updateModulePreview();
    }
  });

  // Record undo action when slider interaction ends
  freqControl.addEventListener('mouseup', (e) => {
    if (isSliding) {
      const mod = modules.find(m => m.id == div.dataset.id);
      if (mod && mod.freq !== sliderStartFreq) {
        pushToUndoStack({
          type: 'changeFrequency',
          moduleId: div.dataset.id,
          oldFrequency: sliderStartFreq,
          newFrequency: mod.freq
        });
      }
      isSliding = false;
      e.stopPropagation();

      // Force blur on the slider element
      freqControl.blur();

      // Optionally, set focus elsewhere - like to the parent div or document body
      document.body.focus();
    }
    if (isModuleDesigner) {
      updateOscillatorCheckboxes();
      updateModulePreview();
    }
  });

  // Also handle case when mouse leaves slider during drag
  freqControl.addEventListener('mouseleave', (e) => {
    if (isSliding) {
      const mod = modules.find(m => m.id == div.dataset.id);
      if (mod && mod.freq !== sliderStartFreq) {
        pushToUndoStack({
          type: 'changeFrequency',
          moduleId: div.dataset.id,
          oldFrequency: sliderStartFreq,
          newFrequency: mod.freq
        });
      }
      isSliding = false;
      e.stopPropagation();

      // Force blur
      freqControl.blur();
      document.body.focus();
    }
    if (isModuleDesigner) {
      updateOscillatorCheckboxes();
      updateModulePreview();
    }
  });


  // Touch-specific handlers for mobile
  freqControl.addEventListener('touchstart', (e) => {
    const mod = modules.find(m => m.id == div.dataset.id);
    sliderStartFreq = mod ? mod.freq : freq;
    isSliding = true;
    e.stopPropagation(); // Prevent canvas panning
  });

  freqControl.addEventListener('touchend', (e) => {
    if (isSliding) {
      const mod = modules.find(m => m.id == div.dataset.id);
      if (mod && mod.freq !== sliderStartFreq) {
        pushToUndoStack({
          type: 'changeFrequency',
          moduleId: div.dataset.id,
          oldFrequency: sliderStartFreq,
          newFrequency: mod.freq
        });
      }
      isSliding = false;
      e.stopPropagation();

      // Force blur
      freqControl.blur();
      document.body.focus();
    }
    if (isModuleDesigner) {
      updateOscillatorCheckboxes();
      updateModulePreview();
    }
  });

  freqControl.addEventListener('touchcancel', (e) => {
    if (isSliding) {
      const mod = modules.find(m => m.id == div.dataset.id);
      if (mod && mod.freq !== sliderStartFreq) {
        pushToUndoStack({
          type: 'changeFrequency',
          moduleId: div.dataset.id,
          oldFrequency: sliderStartFreq,
          newFrequency: mod.freq
        });
      }
      isSliding = false;
      e.stopPropagation();

      freqControl.blur();
      document.body.focus();
    }
    if (isModuleDesigner) {
      updateOscillatorCheckboxes();
      updateModulePreview();
    }
  });

  freqControl.addEventListener('touchmove', (e) => {
    if (isSliding) {
      e.stopPropagation(); // Critical: prevent canvas panning
      // e.preventDefault(); // Prevent scrolling while sliding

      // The 'input' event should fire automatically, but if not:
      const normalized = freqControl.value / 1500;
      const newFreq = 10 * Math.pow(300, normalized);

      const mod = modules.find(m => m.id == div.dataset.id);
      if (mod) mod.freq = newFreq;

      freqLabel.innerText = `${newFreq.toFixed(2)} Hz`;
      freqTextInput.value = newFreq.toFixed(2);

      // Send targeted frequency update message
      if (workletNode) {
        workletNode.port.postMessage({
          type: 'frequencyChange',
          moduleId: parseInt(div.dataset.id),
          frequency: newFreq
        });
      }
    }
    if (isModuleDesigner) {
      updateOscillatorCheckboxes();
      updateModulePreview();
    }
  });

  freqControlContainer.appendChild(freqControl);
  div.appendChild(freqControlContainer);

  // Add output port
  const outputGroup = createPortGroup('OUT', false, 0);
  outputGroup.style.position = 'relative';
  outputGroup.style.right = '-80px';
  outputGroup.style.width = '60px';
  div.appendChild(outputGroup);
}

// Replace the setupFlipFlopUI function with this fixed version
function setupFlipFlopUI(div) {
  const columnsContainer = document.createElement('div');
  columnsContainer.classList.add('columns-container');
  div.appendChild(columnsContainer);

  const inputColumn = document.createElement('div');
  inputColumn.classList.add('input-column');
  columnsContainer.appendChild(inputColumn);

  const outputColumn = document.createElement('div');
  outputColumn.classList.add('output-column');
  columnsContainer.appendChild(outputColumn);

  // Create inputs CLK and DAT
  ['CLK', 'DAT'].forEach((label, i) => {
    const inputGroup = createPortGroup(label, true, i);
    inputColumn.appendChild(inputGroup);
  });

  const moduleId = parseInt(div.dataset.id);

  // Create Q output
  const qOutputGroup = createPortGroup('Q', false, 0, true);
  const qLed = createLedElement();
  qOutputGroup.appendChild(qLed);
  outputColumn.appendChild(qOutputGroup);

  // Correctly store the Q LED with the standard 'led' property name
  ledElements.push({ modId: moduleId, led: qLed, outputIndex: 0 });

  // Create Q' output
  const qBarOutputGroup = createPortGroup("Q'", false, 1, false);
  const qBarLed = createLedElement();
  qBarOutputGroup.appendChild(qBarLed);
  outputColumn.appendChild(qBarOutputGroup);

  // Correctly store the Q' LED with the standard 'led' property name
  ledElements.push({ modId: moduleId, led: qBarLed, outputIndex: 1 });

}

function setupOscilloscopeUI(div) {
  const columnsContainer = document.createElement('div');
  columnsContainer.classList.add('columns-container');
  div.appendChild(columnsContainer);

  const inputColumn = document.createElement('div');
  inputColumn.classList.add('input-column');
  columnsContainer.appendChild(inputColumn);

  const controlColumn = document.createElement('div');
  controlColumn.classList.add('output-column');
  columnsContainer.appendChild(controlColumn);

  // Create inputs A and B
  ['A', 'B'].forEach((label, i) => {
    const inputGroup = createPortGroup(label, true, i);
    inputColumn.appendChild(inputGroup);
  });

  // Create "Open" button
  const openButton = document.createElement('button');
  openButton.textContent = 'Open';
  openButton.classList.add('scope-open-button');
  openButton.style.padding = '6px 12px';
  openButton.style.fontSize = '11px';
  openButton.style.backgroundColor = 'var(--accent-primary)';
  openButton.style.color = 'var(--text-primary)';
  openButton.style.border = 'none';
  openButton.style.borderRadius = '4px';
  openButton.style.cursor = 'pointer';
  openButton.style.marginTop = '8px';

  openButton.addEventListener('click', (e) => {
    e.stopPropagation();
    toggleScopePanel();
  });

  controlColumn.appendChild(openButton);
}


// Helper function for logic gates (AND, OR, NAND, NOR, XOR, XNOR)
function setupLogicGateUI(div) {
  const columnsContainer = document.createElement('div');
  columnsContainer.classList.add('columns-container');
  div.appendChild(columnsContainer);

  const inputColumn = document.createElement('div');
  inputColumn.classList.add('input-column');
  columnsContainer.appendChild(inputColumn);

  const outputColumn = document.createElement('div');
  outputColumn.classList.add('output-column');
  columnsContainer.appendChild(outputColumn);

  // Create inputs A and B
  ['A', 'B'].forEach((label, i) => {
    const inputGroup = createPortGroup(label, true, i);
    inputColumn.appendChild(inputGroup);
  });

  // Create output
  const outputGroup = createPortGroup('OUT', false, 0);
  const led = createLedElement();
  div.appendChild(led);
  outputGroup.appendChild(led);
  outputColumn.appendChild(outputGroup);

  ledElements.push({ modId: parseInt(div.dataset.id), led, outputIndex: 0 });
}

// Helper function for NOT gate
function setupNotGateUI(div) {
  const columnsContainer = document.createElement('div');
  columnsContainer.classList.add('columns-container');
  div.appendChild(columnsContainer);

  const inputColumn = document.createElement('div');
  inputColumn.classList.add('input-column');
  columnsContainer.appendChild(inputColumn);

  const outputColumn = document.createElement('div');
  outputColumn.classList.add('output-column');
  columnsContainer.appendChild(outputColumn);

  // Create input
  const inputGroup = createPortGroup('IN', true, 0);
  inputColumn.appendChild(inputGroup);

  // Create output
  const outputGroup = createPortGroup('OUT', false, 0);
  const led = createLedElement();
  div.appendChild(led);
  outputGroup.appendChild(led);
  outputColumn.appendChild(outputGroup);

  ledElements.push({ modId: parseInt(div.dataset.id), led, outputIndex: 0 });
}

// Helper function for noise
function setupNoiseGateUI(div) {
  const columnsContainer = document.createElement('div');
  columnsContainer.classList.add('columns-container');
  div.appendChild(columnsContainer);

  const outputColumn = document.createElement('div');
  outputColumn.classList.add('output-column');
  columnsContainer.appendChild(outputColumn);

  // Create output
  const outputGroup = createPortGroup('OUT', false, 0);
  const led = createLedElement();
  // div.appendChild(led);
  // outputGroup.appendChild(led);
  outputGroup.style.position = 'relative';
  outputGroup.style.right = '-80px';
  outputGroup.style.width = '60px';
  outputColumn.appendChild(outputGroup);

  ledElements.push({ modId: parseInt(div.dataset.id), led, outputIndex: 0 });
}

// Helper function for counters
function setupCounterUI(div) {
  const columnsContainer = document.createElement('div');
  columnsContainer.classList.add('columns-container');
  div.appendChild(columnsContainer);

  const inputColumn = document.createElement('div');
  inputColumn.classList.add('input-column');
  columnsContainer.appendChild(inputColumn);

  const outputColumn1 = document.createElement('div');
  outputColumn1.classList.add('output-column');
  columnsContainer.appendChild(outputColumn1);

  const outputColumn2 = document.createElement('div');
  outputColumn2.classList.add('output-column');
  columnsContainer.appendChild(outputColumn2);

  // Add CLK input
  const clkGroup = createPortGroup('CLK', true, 0);
  inputColumn.appendChild(clkGroup);

  // Add RST input
  const rstGroup = createPortGroup('RST', true, 1);
  inputColumn.appendChild(rstGroup);

  // Add 8 outputs (Q0-Q7)
  const moduleId = parseInt(div.dataset.id);

  // First 4 outputs in column 1
  for (let i = 0; i < 4; i++) {
    const label = `Q${i}`;
    const outputGroup = createPortGroup(label, false, i, i === 1);
    const led = createLedElement();
    div.appendChild(led);
    outputGroup.appendChild(led);
    outputColumn1.appendChild(outputGroup);

    ledElements.push({ modId: moduleId, led, outputIndex: i });
  }

  // Next 4 outputs in column 2
  for (let i = 4; i < 8; i++) {
    const outputGroup = createPortGroup(`Q${i}`, false, i);
    const led = createLedElement();
    div.appendChild(led);
    outputGroup.appendChild(led);
    outputColumn2.appendChild(outputGroup);

    ledElements.push({ modId: moduleId, led, outputIndex: i });
  }
}

// Helper function for shift register
function setupShiftRegisterUI(div) {
  const columnsContainer = document.createElement('div');
  columnsContainer.classList.add('columns-container');
  div.appendChild(columnsContainer);

  const inputColumn = document.createElement('div');
  inputColumn.classList.add('input-column');
  columnsContainer.appendChild(inputColumn);

  const outputColumn1 = document.createElement('div');
  outputColumn1.classList.add('output-column');
  columnsContainer.appendChild(outputColumn1);

  const outputColumn2 = document.createElement('div');
  outputColumn2.classList.add('output-column');
  columnsContainer.appendChild(outputColumn2);

  // Add CLK input
  const clkGroup = createPortGroup('CLK', true, 0);
  inputColumn.appendChild(clkGroup);

  // Add DAT input
  const datGroup = createPortGroup('DAT', true, 1);
  inputColumn.appendChild(datGroup);

  // Add RST input
  const rstGroup = createPortGroup('RST', true, 2);
  inputColumn.appendChild(rstGroup);

  // Add 8 outputs (Q0-Q7)
  const moduleId = parseInt(div.dataset.id);

  // First 4 outputs in column 1
  for (let i = 0; i < 4; i++) {
    const label = `Q${i}`;
    const outputGroup = createPortGroup(label, false, i, i === 1);
    const led = createLedElement();
    div.appendChild(led);
    outputGroup.appendChild(led);
    outputColumn1.appendChild(outputGroup);

    ledElements.push({ modId: moduleId, led, outputIndex: i });
  }

  // Next 4 outputs in column 2
  for (let i = 4; i < 8; i++) {
    const outputGroup = createPortGroup(`Q${i}`, false, i);
    const led = createLedElement();
    div.appendChild(led);
    outputGroup.appendChild(led);
    outputColumn2.appendChild(outputGroup);

    ledElements.push({ modId: moduleId, led, outputIndex: i });
  }
}

function setupBinaryRateMultiplierUI(div) {
  const columnsContainer = document.createElement('div');
  columnsContainer.classList.add('columns-container');
  div.appendChild(columnsContainer);

  const inputColumn1 = document.createElement('div');
  inputColumn1.classList.add('input-column');
  columnsContainer.appendChild(inputColumn1);

  const inputColumn2 = document.createElement('div');
  inputColumn2.classList.add('input-column');
  columnsContainer.appendChild(inputColumn2);

  const outputColumn = document.createElement('div');
  outputColumn.classList.add('output-column');
  columnsContainer.appendChild(outputColumn);

  // Add CLK input
  const clkGroup = createPortGroup('CLK', true, 0);
  inputColumn1.appendChild(clkGroup);

  // Add RST input
  const rstGroup = createPortGroup('RST', true, 1);
  inputColumn1.appendChild(rstGroup);

  // Add CASCADE IN input
  const cascadeInGroup = createPortGroup('CAS', true, 2);
  inputColumn1.appendChild(cascadeInGroup);
  cascadeInGroup.style.display = 'none';

  // Add binary inputs B0-B3
  ['A', 'B', 'C', 'D'].forEach((label, i) => {
    const inputGroup = createPortGroup(label, true, i + 3);
    inputColumn2.appendChild(inputGroup);
  });


  const moduleId = parseInt(div.dataset.id);

  // Add OUT output
  const outGroup = createPortGroup('OUT', false, 0, false);
  const outLed = createLedElement();
  outGroup.appendChild(outLed);
  outputColumn.appendChild(outGroup);
  ledElements.push({ modId: moduleId, led: outLed, outputIndex: 0 });

  // // Add CASCADE OUT output
  // const cascadeOutGroup = createPortGroup('CAS', false, 1);
  // const cascadeLed = createLedElement();
  // cascadeOutGroup.appendChild(cascadeLed);
  // outputColumn.appendChild(cascadeOutGroup);
  // ledElements.push({ modId: moduleId, led: cascadeLed, outputIndex: 1 });
}

// Helper function for multiplexer
function setupMultiplexerUI(div) {
  const columnsContainer = document.createElement('div');
  columnsContainer.classList.add('columns-container');
  div.appendChild(columnsContainer);

  const inputColumn1 = document.createElement('div');
  inputColumn1.classList.add('input-column');
  columnsContainer.appendChild(inputColumn1);

  const inputColumn2 = document.createElement('div');
  inputColumn2.classList.add('input-column');
  columnsContainer.appendChild(inputColumn2);

  const inputColumn3 = document.createElement('div');
  inputColumn3.classList.add('input-column');
  columnsContainer.appendChild(inputColumn3);

  const outputColumn = document.createElement('div');
  outputColumn.classList.add('output-column');
  columnsContainer.appendChild(outputColumn);

  // Add select inputs A, B, C
  [' A ', ' B ', ' C '].forEach((label, i) => {
    const inputGroup = createPortGroup(label, true, i);
    inputColumn1.appendChild(inputGroup);
  });

  // Add data inputs D0-D3
  ['D0', 'D1', 'D2', 'D3'].forEach((label, i) => {
    const inputGroup = createPortGroup(label, true, i + 3, label === 'D1');
    inputColumn2.appendChild(inputGroup);
  });

  // Add data inputs D4-D7
  ['D4', 'D5', 'D6', 'D7'].forEach((label, i) => {
    const inputGroup = createPortGroup(label, true, i + 7);
    inputColumn3.appendChild(inputGroup);
  });

  // Add output
  const outputGroup = createPortGroup('OUT', false, 0);
  const led = createLedElement();
  div.appendChild(led);
  outputGroup.appendChild(led);
  outputColumn.appendChild(outputGroup);

  ledElements.push({ modId: parseInt(div.dataset.id), led, outputIndex: 0 });
}

// Helper function for Demultiplexer
function setupDemultiplexerUI(div) {
  const columnsContainer = document.createElement('div');
  columnsContainer.classList.add('columns-container');
  div.appendChild(columnsContainer);

  const inputColumn = document.createElement('div');
  inputColumn.classList.add('input-column');
  columnsContainer.appendChild(inputColumn);

  const outputColumn1 = document.createElement('div');
  outputColumn1.classList.add('output-column');
  columnsContainer.appendChild(outputColumn1);

  const outputColumn2 = document.createElement('div');
  outputColumn2.classList.add('output-column');
  columnsContainer.appendChild(outputColumn2);

  // Add select inputs A, B, C
  [' A ', ' B ', ' C '].forEach((label, i) => {
    const inputGroup = createPortGroup(label, true, i);
    inputColumn.appendChild(inputGroup);
  });

  // Add Data In
  const dataInGroup = createPortGroup('IN', true, 3);
  inputColumn.appendChild(dataInGroup);

  const moduleId = parseInt(div.dataset.id);

  // Add outputs Q0-Q3
  for (let i = 0; i < 4; i++) {
    const label = `Q${i}`;
    const outputGroup = createPortGroup(label, false, i);
    const led = createLedElement();
    div.appendChild(led);
    outputGroup.appendChild(led);
    outputColumn1.appendChild(outputGroup);

    ledElements.push({ modId: moduleId, led, outputIndex: i });
  }

  // Add outputs Q4-Q7
  for (let i = 4; i < 8; i++) {
    const label = `Q${i}`;
    const outputGroup = createPortGroup(label, false, i);
    const led = createLedElement();
    div.appendChild(led);
    outputGroup.appendChild(led);
    outputColumn2.appendChild(outputGroup);

    ledElements.push({ modId: moduleId, led, outputIndex: i });
  }
}

// Helper function for Shift Register (PISO)
function setupShiftRegisterPISOUI(div) {
  const columnsContainer = document.createElement('div');
  columnsContainer.classList.add('columns-container');
  div.appendChild(columnsContainer);

  const inputColumn1 = document.createElement('div');
  inputColumn1.classList.add('input-column');
  columnsContainer.appendChild(inputColumn1);

  const inputColumn2 = document.createElement('div');
  inputColumn2.classList.add('input-column');
  columnsContainer.appendChild(inputColumn2);

  const inputColumn3 = document.createElement('div');
  inputColumn3.classList.add('input-column');
  columnsContainer.appendChild(inputColumn3);

  const outputColumn = document.createElement('div');
  outputColumn.classList.add('output-column');
  columnsContainer.appendChild(outputColumn);

  // Column 1: CLK, LOAD
  const clkGroup = createPortGroup('CLK', true, 0);
  inputColumn1.appendChild(clkGroup);

  const loadGroup = createPortGroup('LD', true, 1);
  inputColumn1.appendChild(loadGroup);

  // Column 2: D0-D3
  for (let i = 0; i < 4; i++) {
    const inputGroup = createPortGroup(`D${i}`, true, 2 + i);
    inputColumn2.appendChild(inputGroup);
  }

  // Column 3: D4-D7
  for (let i = 4; i < 8; i++) {
    const inputGroup = createPortGroup(`D${i}`, true, 2 + i);
    inputColumn3.appendChild(inputGroup);
  }

  // Output Column: Q7 (Serial Out)
  const outputGroup = createPortGroup('OUT', false, 0);
  const led = createLedElement();
  div.appendChild(led);
  outputGroup.appendChild(led);
  outputColumn.appendChild(outputGroup);

  ledElements.push({ modId: parseInt(div.dataset.id), led, outputIndex: 0 });
}

function setupInletUI(div) {
  const title = div.querySelector('.module-title');
  if (title) {
    title.remove();
  }

  const columnsContainer = document.createElement('div');
  columnsContainer.classList.add('columns-container');
  div.appendChild(columnsContainer);

  const outputColumn = document.createElement('div');
  outputColumn.classList.add('output-column');
  columnsContainer.appendChild(outputColumn);

  // Name input
  const nameInput = document.createElement('input');
  nameInput.type = 'text';
  nameInput.value = 'IN';
  nameInput.className = 'module-name-input';
  nameInput.maxLength = 4;
  nameInput.addEventListener('input', (e) => {
    e.target.value = e.target.value.toUpperCase();
  });
  nameInput.addEventListener('change', (e) => {
    const mod = modules.find(m => m.id == div.dataset.id);
    if (mod) mod.label = e.target.value;
    updateModulePreview();
  });
  // Prevent keydown propagation to avoid triggering global shortcuts
  nameInput.addEventListener('keydown', (e) => e.stopPropagation());

  // Add touch listener to ensure focus works on mobile and doesn't drag canvas
  nameInput.addEventListener('touchstart', (e) => {
    e.stopPropagation();
    nameInput.focus();
  });

  div.insertBefore(nameInput, columnsContainer);
  // Output port (this acts as a source)
  const outputGroup = createPortGroup('OUT', false, 0);

  outputGroup.style.position = 'relative';
  outputGroup.style.right = '-40px';
  outputGroup.style.top = '3px';
  outputGroup.style.width = '60px';
  outputColumn.appendChild(outputGroup);
}

function setupInletExportUI(div) {
  const title = div.querySelector('.module-title');
  if (title) {
    title.remove();
  }

  const columnsContainer = document.createElement('div');
  columnsContainer.classList.add('columns-container');
  div.appendChild(columnsContainer);

  const outputColumn = document.createElement('div');
  outputColumn.classList.add('output-column');
  columnsContainer.appendChild(outputColumn);

  // Name input
  const nameInput = document.createElement('input');
  nameInput.type = 'text';
  nameInput.value = 'IN';
  nameInput.className = 'module-name-input';
  nameInput.maxLength = 4;
  nameInput.addEventListener('input', (e) => {
    e.target.value = e.target.value.toUpperCase();
  });
  nameInput.addEventListener('change', (e) => {
    const mod = modules.find(m => m.id == div.dataset.id);
    if (mod) mod.label = e.target.value;
    // updateModulePreview();
  });
  // Prevent keydown propagation to avoid triggering global shortcuts
  nameInput.addEventListener('keydown', (e) => e.stopPropagation());

  // Add touch listener to ensure focus works on mobile and doesn't drag canvas
  nameInput.addEventListener('touchstart', (e) => {
    e.stopPropagation();
    nameInput.focus();
  });

  div.insertBefore(nameInput, columnsContainer);
  // Output port (this acts as a source)
  const outputGroup = createPortGroup('OUT', false, 0);

  outputGroup.style.position = 'relative';
  outputGroup.style.right = '-40px';
  outputGroup.style.top = '3px';
  outputGroup.style.width = '60px';
  outputColumn.appendChild(outputGroup);
}

function setupOutletUI(div) {
  const title = div.querySelector('.module-title');
  if (title) {
    title.remove();
  }

  const columnsContainer = document.createElement('div');
  columnsContainer.classList.add('columns-container');
  div.appendChild(columnsContainer);

  const inputColumn = document.createElement('div');
  inputColumn.classList.add('input-column');
  columnsContainer.appendChild(inputColumn);

  // Name input
  const nameInput = document.createElement('input');
  nameInput.type = 'text';
  nameInput.value = 'OUT';
  nameInput.className = 'module-name-input';
  nameInput.maxLength = 4;
  nameInput.addEventListener('input', (e) => {
    e.target.value = e.target.value.toUpperCase();
  });
  nameInput.addEventListener('change', (e) => {
    const mod = modules.find(m => m.id == div.dataset.id);
    if (mod) mod.label = e.target.value;
    updateModulePreview();
  });
  nameInput.addEventListener('keydown', (e) => e.stopPropagation());

  // Add touch listener to ensure focus works on mobile and doesn't drag canvas
  nameInput.addEventListener('touchstart', (e) => {
    e.stopPropagation();
    nameInput.focus();
  });

  div.insertBefore(nameInput, columnsContainer);

  // Input port (this acts as a sink)
  const inputGroup = createPortGroup('IN', true, 0);
  inputColumn.appendChild(inputGroup);

  inputGroup.style.position = 'relative';
  inputGroup.style.top = '3px';

  // LED for output visualization
  const led = createLedElement();
  inputGroup.appendChild(led);

  // Register LED
  ledElements.push({ modId: parseInt(div.dataset.id), led, outputIndex: 0 });
}


function setupOutletExportUI(div) {
  const title = div.querySelector('.module-title');
  if (title) {
    title.remove();
  }

  const columnsContainer = document.createElement('div');
  columnsContainer.classList.add('columns-container');
  div.appendChild(columnsContainer);

  const inputColumn = document.createElement('div');
  inputColumn.classList.add('input-column');
  columnsContainer.appendChild(inputColumn);

  // Name input
  const nameInput = document.createElement('input');
  nameInput.type = 'text';
  nameInput.value = 'OUT';
  nameInput.className = 'module-name-input';
  nameInput.maxLength = 4;
  nameInput.addEventListener('input', (e) => {
    e.target.value = e.target.value.toUpperCase();
  });
  nameInput.addEventListener('change', (e) => {
    const mod = modules.find(m => m.id == div.dataset.id);
    if (mod) mod.label = e.target.value;
    // updateModulePreview();
  });
  nameInput.addEventListener('keydown', (e) => e.stopPropagation());

  // Add touch listener to ensure focus works on mobile and doesn't drag canvas
  nameInput.addEventListener('touchstart', (e) => {
    e.stopPropagation();
    nameInput.focus();
  });

  div.insertBefore(nameInput, columnsContainer);

  // Input port (this acts as a sink)
  const inputGroup = createPortGroup('IN', true, 0);
  inputColumn.appendChild(inputGroup);

  inputGroup.style.position = 'relative';
  inputGroup.style.top = '3px';

  // LED for output visualization
  // const led = createLedElement();
  // inputGroup.appendChild(led);

  // Register LED
  // ledElements.push({ modId: parseInt(div.dataset.id), led, outputIndex: 0 });
}

function setupExportLedUI(div) {
  const title = div.querySelector('.module-title');
  if (title) {
    title.remove();
  }

  const columnsContainer = document.createElement('div');
  columnsContainer.classList.add('columns-container');
  div.appendChild(columnsContainer);

  const inputColumn = document.createElement('div');
  inputColumn.classList.add('input-column');
  columnsContainer.appendChild(inputColumn);

  // Name input
  const nameInput = document.createElement('input');
  nameInput.type = 'text';
  nameInput.value = 'LED';
  nameInput.className = 'module-name-input';
  nameInput.maxLength = 4;
  nameInput.addEventListener('input', (e) => {
    e.target.value = e.target.value.toUpperCase();
  });
  nameInput.addEventListener('change', (e) => {
    const mod = modules.find(m => m.id == div.dataset.id);
    if (mod) mod.label = e.target.value;
    // updateModulePreview();
  });
  nameInput.addEventListener('keydown', (e) => e.stopPropagation());

  // Add touch listener to ensure focus works on mobile and doesn't drag canvas
  nameInput.addEventListener('touchstart', (e) => {
    e.stopPropagation();
    nameInput.focus();
  });

  div.insertBefore(nameInput, columnsContainer);

  // Input port (this acts as a sink)
  const inputGroup = createPortGroup('IN', true, 0);
  inputColumn.appendChild(inputGroup);

  inputGroup.style.position = 'relative';
  inputGroup.style.top = '3px';

  // LED for output visualization
  const led = createLedElement();
  inputGroup.appendChild(led);

  // Register LED
  ledElements.push({ modId: parseInt(div.dataset.id), led, outputIndex: 0 });
}

// Helper function for output module
function setupOutputUI(div) {
  const columnsContainer = document.createElement('div');
  columnsContainer.classList.add('columns-container');
  div.appendChild(columnsContainer);

  const inputColumn = document.createElement('div');
  inputColumn.classList.add('input-column');
  columnsContainer.appendChild(inputColumn);
  ['A', 'B', 'C', 'D'].forEach((label, i) => {
    const inputGroup = createPortGroup(label, true, i);
    inputGroup.querySelector('.port-label').style.width = '20px';
    inputGroup.querySelector('.port-label').style.textAlign = 'right';
    inputColumn.appendChild(inputGroup);
  });
}

// Helper function for default input
function setupDefaultInputUI(div) {
  const inputGroup = createPortGroup('IN', true, 0);
  div.appendChild(inputGroup);
}

// Helper function to create port groups (label + port)
function createPortGroup(label, isInput, index, needsSpacing = false) {
  const group = document.createElement('div');
  group.classList.add('port-group');

  const labelElement = document.createElement('div');
  labelElement.classList.add('port-label');

  if (needsSpacing) {
    labelElement.innerHTML = `${label}&nbsp;`;
  } else {
    labelElement.innerText = label;
  }

  labelElement.style.width = '20px';
  labelElement.style.textAlign = 'right';

  const port = document.createElement('div');
  port.className = isInput ? 'port' : 'portOut';
  port.dataset.type = isInput ? 'input' : 'output';
  port.dataset.index = index;

  group.appendChild(labelElement);
  group.appendChild(port);

  return group;
}

// Helper function to create LED element
function createLedElement() {
  const led = document.createElement('div');

  led.classList.add('led');
  led.className = 'led';
  led.style.backgroundColor = 'var(--led-off)';  // Default to off (0)
  return led;
}

// Helper function to add port event listeners
function addPortEventListeners(div) {
  div.querySelectorAll('.port, .portOut').forEach(port => {
    port.addEventListener('click', (e) => {
      e.stopPropagation();
      const modId = parseInt(div.dataset.id);
      const portType = port.dataset.type;
      const portIndex = parseInt(port.dataset.index) || 0;

      if (portType === 'output') {
        if (selectedOutput) {
          const fromIsInput = selectedOutput.isInput;

          if (fromIsInput) {
            // if (fromIsInput && selectedOutput.id !== modId) {
            // Check if a connection already exists TO the selected input
            const existingConnection = connections.find(conn =>
              conn.to === selectedOutput.id && conn.inputIndex === selectedOutput.inputIndex);
            if (!existingConnection) {
              // No existing connection, safe to create
              const newConnection = {
                from: modId,
                fromOutputIndex: portIndex,
                to: selectedOutput.id,
                inputIndex: selectedOutput.inputIndex
              };
              connections.push(newConnection);

              // Record for undo history
              if (typeof pushToUndoStack === 'function') {
                pushToUndoStack({
                  type: 'addConnection',
                  connection: { ...newConnection }
                });
              }

              selectedOutput = null;
              rebuildAudioGraph();
              requestWireRedraw();
            } else {
              // Input is already connected, maybe give feedback to the user
              selectedOutput = null; // clear selection
              requestWireRedraw();
            }
          } else {
            // Selecting an output normally
            selectedOutput = { id: modId, outputIndex: portIndex, isInput: false };
            requestWireRedraw();
          }
        } else {
          selectedOutput = { id: modId, outputIndex: portIndex, isInput: false };
          requestWireRedraw();
        }
      } else if (portType === 'input') {
        if (selectedOutput) {
          const fromIsInput = selectedOutput.isInput;
          if (!fromIsInput) {

            // if (fromIsInput && selectedOutput.id !== modId) {
            // Check if a connection already exists from any output to this input
            const existingConnection = connections.find(conn =>
              conn.to === modId && conn.inputIndex === portIndex);
            if (!existingConnection) {
              const newConnection = {
                from: selectedOutput.id,
                fromOutputIndex: selectedOutput.outputIndex,
                to: modId,
                inputIndex: portIndex
              };
              connections.push(newConnection);

              // Record for undo history
              if (typeof pushToUndoStack === 'function') {
                pushToUndoStack({
                  type: 'addConnection',
                  connection: { ...newConnection }
                });
              }

              selectedOutput = null;
              rebuildAudioGraph();
              requestWireRedraw();
            } else {
              // Input is already connected, clear selection
              selectedOutput = null;
              requestWireRedraw();
            }
          } else {
            selectedOutput = { id: modId, inputIndex: portIndex, isInput: true };
            requestWireRedraw();
          }
        } else {
          selectedOutput = { id: modId, inputIndex: portIndex, isInput: true };
          requestWireRedraw();
        }
      }

      // Update visual indicators for selected ports
      updatePortSelectionVisuals();
    });
  });
}

// Helper function to update port selection visuals
function updatePortSelectionVisuals() {
  // Clear all selections
  document.querySelectorAll('.port.selected, .portOut.selected').forEach(el => {
    el.classList.remove('selected');
  });

  // Add selected class to currently selected port
  if (selectedOutput) {
    const selector = selectedOutput.isInput ?
      `.port[data-index="${selectedOutput.inputIndex}"]` :
      `.portOut[data-index="${selectedOutput.outputIndex}"]`;

    const modules = document.querySelectorAll(`.module[data-id="${selectedOutput.id}"]`);
    modules.forEach(mod => {
      const port = mod.querySelector(selector);
      if (port) {
        port.classList.add('selected');
      }
    });
  }
}

// Helper function for Button module
function setupButtonUI(div) {
  const columnsContainer = document.createElement('div');
  columnsContainer.classList.add('columns-container');
  div.appendChild(columnsContainer);

  const inputColumn = document.createElement('div');
  inputColumn.classList.add('input-column');
  columnsContainer.appendChild(inputColumn);

  const outputColumn = document.createElement('div');
  outputColumn.classList.add('output-column');
  columnsContainer.appendChild(outputColumn);

  // Get module data and initialize with saved key if available
  const moduleId = parseInt(div.dataset.id);
  const moduleData = modules.find(m => m.id === moduleId);

  // Initialize key state (we'll still need this for UI setup)
  let assignedKey = moduleData?.assignedKey || null;

  // Create button
  const button = document.createElement('div');
  button.classList.add('buttonModule');

  // Add button press/release handlers for mouse (keep these as is)
  button.addEventListener('mousedown', (e) => {
    e.preventDefault();
    button.style.backgroundColor = 'var(--button-module-pressed)';
    const moduleId = parseInt(div.dataset.id);
    if (workletNode) {
      workletNode.port.postMessage({
        type: 'buttonPress',
        moduleId: moduleId
      });
    }
  });

  button.addEventListener('mouseup', (e) => {
    e.preventDefault();
    button.style.backgroundColor = 'var(--button-module-off)';
    const moduleId = parseInt(div.dataset.id);
    if (workletNode) {
      workletNode.port.postMessage({
        type: 'buttonRelease',
        moduleId: moduleId
      });
    }
  });

  button.addEventListener('mouseleave', (e) => {
    if (e.buttons === 1) { // If mouse button is still pressed
      button.style.backgroundColor = 'var(--button-module-off)';
      const moduleId = parseInt(div.dataset.id);
      if (workletNode) {
        workletNode.port.postMessage({
          type: 'buttonRelease',
          moduleId: moduleId
        });
      }
    }
  });

  inputColumn.appendChild(button);

  // Create assign button
  const assignButton = document.createElement('button');
  assignButton.textContent = assignedKey
    ? `assign: ${assignedKey === ' ' ? 'spc' : assignedKey}`
    : 'assign';
  assignButton.classList.add('assign-button');
  assignButton.style.padding = '4px 8px';
  assignButton.style.fontSize = '10px';
  assignButton.style.margin = '4px 0';
  assignButton.style.backgroundColor = 'var(--button-module-off)';
  assignButton.style.color = 'var(--button-module-pressed)';
  assignButton.style.flexWrap = 'nowrap';
  assignButton.style.border = 'none';
  assignButton.style.borderRadius = '4px';
  assignButton.style.cursor = 'pointer';
  assignButton.style.outline = 'none'; // Remove focus outline
  assignButton.style.whiteSpace = 'nowrap';          // Prevent text from wrapping
  assignButton.style.overflow = 'visible';           // Allow it to overflow container
  assignButton.style.textOverflow = 'clip';          // Optional: don't show "..." when text is too long
  assignButton.style.flexShrink = '0';               // Prevent it from shrinking in flex containers

  // List of off-limits keys
  const offLimitsKeys = [
    'Backspace', 'Delete', 'Meta', 'Control', 'Alt', 'Option', 'Escape',
    'Tab', 'CapsLock', 'Shift', 'ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'
  ];

  // Add assign button handler
  let listeningForKey = false;

  assignButton.addEventListener('click', () => {
    if (listeningForKey) {
      // Cancel assignment mode
      listeningForKey = false;
      assignButton.style.backgroundColor = 'var(--button-module-off)';
      assignButton.style.color = 'var(--button-module-pressed)';
      assignButton.textContent = assignedKey
        ? `assign: ${assignedKey === ' ' ? 'spc' : assignedKey}`
        : 'assign';
    } else {
      // Enter assignment mode
      listeningForKey = true;
      assignButton.style.backgroundColor = 'var(--accent-primary)';
      assignButton.style.color = 'var(--text-primary)';
    }
  });

  // Key assignment listener in setupButtonUI
  const keydownHandler = (e) => {
    if (listeningForKey) {
      if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA' || e.target.isContentEditable) {
        return;
      }

      // Handle ESC to cancel and remove current mapping
      if (e.key === 'Escape') {
        e.preventDefault();

        const moduleId = parseInt(div.dataset.id);
        const module = modules.find(m => m.id === moduleId);
        const currentAssignedKey = module ? module.assignedKey : assignedKey;

        if (currentAssignedKey) {
          pushToUndoStack({
            type: 'changeButtonKey',
            moduleId: moduleId,
            oldKey: currentAssignedKey,
            newKey: null
          });
        }

        updateButtonKeyMapping(div, null);
        assignedKey = null;

        listeningForKey = false;
        assignButton.style.backgroundColor = 'var(--button-module-off)';
        assignButton.style.color = 'var(--button-module-pressed)';

        return;
      }

      // Skip off-limits keys
      if (offLimitsKeys.includes(e.key)) {
        return;
      }

      // Normalize the key to alphanumeric lowercase
      let normalizedKey = e.key;

      // Only accept single character keys
      if (normalizedKey.length !== 1) {
        return;
      }

      // Check if it's alphanumeric
      if (!/^[a-zA-Z0-9]$/.test(normalizedKey)) {
        return;
      }

      // Convert to lowercase
      normalizedKey = normalizedKey.toLowerCase();

      e.preventDefault();

      const moduleId = parseInt(div.dataset.id);
      const module = modules.find(m => m.id === moduleId);
      const currentAssignedKey = module ? module.assignedKey : assignedKey;

      // Record this key assignment for undo/redo
      pushToUndoStack({
        type: 'changeButtonKey',
        moduleId: moduleId,
        oldKey: currentAssignedKey,
        newKey: normalizedKey  // Use normalized key
      });

      // Use the helper function to set up new key mapping
      updateButtonKeyMapping(div, normalizedKey);  // Use normalized key
      assignedKey = normalizedKey;  // Use normalized key

      listeningForKey = false;
      assignButton.style.backgroundColor = 'var(--button-module-off)';
      assignButton.style.color = 'var(--button-module-pressed)';
    }
  };

  document.addEventListener('keydown', keydownHandler);

  // Store the event handler on the div for potential cleanup
  div.assignKeyHandler = keydownHandler;

  // Add cleanup method for the assignment listener
  const originalCleanupMethod = div.cleanupKeyHandlers || (() => { });
  div.cleanupKeyHandlers = () => {
    document.removeEventListener('keydown', div.assignKeyHandler);

    // Execute the updateButtonKeyMapping cleanup if it exists
    if (div.keyHandlers) {
      document.removeEventListener('keydown', div.keyHandlers.keydown);
      document.removeEventListener('keyup', div.keyHandlers.keyup);
      window.removeEventListener('blur', div.keyHandlers.blur);
    }

    // Remove key assignment from module data when module is deleted
    const moduleId = parseInt(div.dataset.id);
    const module = modules.find(m => m.id === moduleId);
    if (module) {
      delete module.assignedKey;
    }
  };

  // Create output
  const outputGroup = createPortGroup('OUT', false, 0);
  const led = createLedElement();
  div.appendChild(led);
  outputGroup.appendChild(led);
  outputColumn.appendChild(assignButton);
  outputColumn.appendChild(outputGroup);

  ledElements.push({ modId: parseInt(div.dataset.id), led, outputIndex: 0 });

  // Initialize key mapping with the helper function
  updateButtonKeyMapping(div, assignedKey);
}



/**
 * Helper function to set or update a button module's key mapping
 * This can be called after loading, undoing/redoing, or pasting modules
 * @param {HTMLElement} moduleDiv - The module's container div element
 * @param {string|null} keyToAssign - The key to assign, or null to clear assignment
 */
function updateButtonKeyMapping(moduleDiv, keyToAssign) {
  // Validate input
  if (!moduleDiv || moduleDiv.dataset.type !== 'Button') return;

  const moduleId = parseInt(moduleDiv.dataset.id);
  const assignButton = moduleDiv.querySelector('.assign-button');
  if (!assignButton) return;

  // Remove existing key handlers if they exist
  if (moduleDiv.keyHandlers) {
    document.removeEventListener('keydown', moduleDiv.keyHandlers.keydown);
    document.removeEventListener('keyup', moduleDiv.keyHandlers.keyup);
    window.removeEventListener('blur', moduleDiv.keyHandlers.blur);
  }

  // Update the module data
  const module = modules.find(m => m.id === moduleId);
  if (module) {
    module.assignedKey = keyToAssign; // Update or clear assigned key
  }

  // Update UI
  moduleDiv.assignedKey = keyToAssign; // Store at module level for undo/redo access
  assignButton.textContent = keyToAssign
    ? `assign: ${keyToAssign === ' ' ? 'spc' : keyToAssign}`
    : 'assign';

  // Store button reference for event handlers
  const button = moduleDiv.querySelector('.buttonModule');
  if (!button) return;

  // Define key state
  let keyCurrentlyPressed = false;

  // Reset button state function
  const resetButtonState = () => {
    keyCurrentlyPressed = false;
    button.style.backgroundColor = 'var(--button-module-off)';
    if (workletNode) {
      workletNode.port.postMessage({
        type: 'buttonRelease',
        moduleId: moduleId
      });
    }
  };

  // Create key handlers
  const keydownHandler = (e) => {
    if (keyToAssign && e.key === keyToAssign && !keyCurrentlyPressed) {
      if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA' || e.target.isContentEditable) {
        return;
      }

      // Only trigger if the key isn't already pressed
      // Avoid handling if modifier keys are pressed
      if (e.metaKey || e.ctrlKey || e.altKey) {
        return;
      }

      e.preventDefault();
      keyCurrentlyPressed = true;
      button.style.backgroundColor = 'var(--button-module-pressed)';
      if (workletNode) {
        workletNode.port.postMessage({
          type: 'buttonPress',
          moduleId: moduleId
        });
      }
    }
  };

  const keyupHandler = (e) => {
    if (keyToAssign && e.key === keyToAssign) {
      if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA' || e.target.isContentEditable) {
        return;
      }

      e.preventDefault();
      keyCurrentlyPressed = false;
      button.style.backgroundColor = 'var(--button-module-off)';
      if (workletNode) {
        workletNode.port.postMessage({
          type: 'buttonRelease',
          moduleId: moduleId
        });
      }
    }
  };

  const blurHandler = () => {
    if (keyCurrentlyPressed) {
      resetButtonState();
    }
  };

  // Attach the key handlers
  document.addEventListener('keydown', keydownHandler);
  document.addEventListener('keyup', keyupHandler);
  window.addEventListener('blur', blurHandler);

  // Store the event handlers on the div for potential cleanup
  moduleDiv.keyHandlers = {
    keydown: keydownHandler,
    keyup: keyupHandler,
    blur: blurHandler
  };

  // Update the cleanup method
  moduleDiv.cleanupKeyHandlers = () => {
    document.removeEventListener('keydown', moduleDiv.keyHandlers.keydown);
    document.removeEventListener('keyup', moduleDiv.keyHandlers.keyup);
    window.removeEventListener('blur', moduleDiv.keyHandlers.blur);
  };
}

function setupOscillatorPUI(div) {
  const columnsContainer = document.createElement('div');
  columnsContainer.classList.add('columns-container');
  div.appendChild(columnsContainer);

  const inputColumn1 = document.createElement('div');
  inputColumn1.classList.add('input-column');
  columnsContainer.appendChild(inputColumn1);

  const inputColumn2 = document.createElement('div');
  inputColumn2.classList.add('input-column');
  columnsContainer.appendChild(inputColumn2);

  const outputColumn = document.createElement('div');
  outputColumn.classList.add('output-column');
  columnsContainer.appendChild(outputColumn);

  // Add select inputs A, B, C
  ['2x', '3x', '4x', '5x'].forEach((label, i) => {
    const inputGroup = createPortGroup(label, true, i, false);
    inputColumn1.appendChild(inputGroup);
  });

  // Add data inputs D0-D3
  ['6x', '7x', '8x', '9x'].forEach((label, i) => {
    const inputGroup = createPortGroup(label, true, i + 4, false);
    inputColumn2.appendChild(inputGroup);
  });

  // Add output
  const outputGroup = createPortGroup('OUT', false, 0);
  const led = createLedElement();
  outputColumn.appendChild(outputGroup);

  ledElements.push({ modId: parseInt(div.dataset.id), led, outputIndex: 0 });
}

function setupEEPROMUI(div) {
  const columnsContainer = document.createElement('div');
  columnsContainer.classList.add('columns-container');
  div.appendChild(columnsContainer);

  const inputColumn = document.createElement('div');
  inputColumn.classList.add('input-column');
  columnsContainer.appendChild(inputColumn);

  const outputColumn1 = document.createElement('div');
  outputColumn1.classList.add('output-column');
  columnsContainer.appendChild(outputColumn1);

  const outputColumn2 = document.createElement('div');
  outputColumn2.classList.add('output-column');
  columnsContainer.appendChild(outputColumn2);

  // Add CE input
  const ceGroup = createPortGroup(
    '<span style="text-decoration: overline;">CE</span>',
    true,
    0,
    true
  );  
  inputColumn.appendChild(ceGroup);

  // Add address inputs A0-A3
  ['A', 'B', 'C', 'D'].forEach((label, i) => {
    const inputGroup = createPortGroup(label, true, i + 1);
    inputColumn.appendChild(inputGroup);
  });

  // Add 8 data outputs (Q0-Q7)
  const moduleId = parseInt(div.dataset.id);

  // First 4 outputs in column 1
  for (let i = 0; i < 4; i++) {
    const label = `Q${i}`;
    const outputGroup = createPortGroup(label, false, i, i === 1);
    const led = createLedElement();
    div.appendChild(led);
    outputGroup.appendChild(led);
    outputColumn1.appendChild(outputGroup);

    ledElements.push({ modId: moduleId, led, outputIndex: i });
  }

  // Next 4 outputs in column 2
  for (let i = 4; i < 8; i++) {
    const outputGroup = createPortGroup(`Q${i}`, false, i);
    const led = createLedElement();
    div.appendChild(led);
    outputGroup.appendChild(led);
    outputColumn2.appendChild(outputGroup);

    ledElements.push({ modId: moduleId, led, outputIndex: i });
  }

  // Add circular program button to header
  const header = div.querySelector('.module-title');
  if (header) {
    const programButton = document.createElement('button');
    programButton.textContent = 'P';
    programButton.classList.add('eeprom-program-button-circle');
    programButton.title = 'Program EEPROM';

    programButton.addEventListener('click', (e) => {
      e.stopPropagation();
      const moduleId = parseInt(div.dataset.id);
      openEEPROMProgrammer(moduleId);
    });

    header.appendChild(programButton);
  }
}

// EEPROM Programming Interface
function openEEPROMProgrammer(moduleId) {
  let programmer = document.getElementById('eeprom-programmer');

  // Create it if missing
  if (!programmer) {
    programmer = document.createElement('div');
    programmer.id = 'eeprom-programmer';
    document.body.appendChild(programmer);
  }

  // FORCE reflow so transition works each time
  void programmer.offsetWidth;

  // Adjust position if in designer mode
  if (document.body.classList.contains('module-designer-mode')) {
    programmer.style.right = '300px'; // Width of designer panel
  } else {
    programmer.style.right = '0';
  }

  // Then open with animation
  programmer.classList.add('open');

  // Get current memory data from module
  const module = modules.find(m => m.id === moduleId);
  const memoryData = module?.memoryData || new Array(16).fill(0);

  // Create programmer UI
  programmer.innerHTML = `
    <div class="eeprom-header">
      <h2>EEPROM DATA</h2>

      <div class="eeprom-buttons">
        <button id="eeprom-clear-all" class="eeprom-btn eeprom-btn-clear">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 25 24">
          <path fill="currentColor" d="M2.226 2h20v9h-20zm6.002 3.5H6.224v2.004h2.004zM2.226 13h20v1.6a5.5 5.5 0 0 0-7.4 7.4h-12.6zm6.002 3.5H6.224v2.004h2.004z" />
          <path fill="currentColor" d="M19.722 18.081L17.6 15.96l-1.414 1.414l2.122 2.122l-2.122 2.12l1.415 1.415l2.12-2.121l2.122 2.121l1.414-1.414l-2.121-2.122l2.121-2.12l-1.414-1.415z" />
        </svg>
        </button>
        <button id="eeprom-close-save" class="eeprom-btn eeprom-btn-save">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
          <path fill="currentColor" fill-rule="evenodd"
            d="M17 6H8a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h11c1.1 0 2-.9 2-2v-9zM8 8h7v3H8zm5.5 11a2.5 2.5 0 1 0 0-5a2.5 2.5 0 0 0 0 5"
            clip-rule="evenodd" />
          <path fill="currentColor" d="M2 4a2 2 0 0 1 2-2h10v2H4v10H2z" />
        </svg>
        </button>
        <button id="eeprom-close" class="eeprom-btn eeprom-btn-clear">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
              <path fill="currentColor" d="m12 13.4l-4.9 4.9q-.275.275-.7.275t-.7-.275t-.275-.7t.275-.7l4.9-4.9l-4.9-4.9q-.275-.275-.275-.7t.275-.7t.7-.275t.7.275l4.9 4.9l4.9-4.9q.275-.275.7-.275t.7.275t.275.7t-.275.7L13.4 12l4.9 4.9q.275.275.275.7t-.275.7t-.7.275t-.7-.275z" />
            </svg></button>
      </div>
    </div>
    
    <div class="eeprom-columns">
      <table class="eeprom-table">
        <thead>
          <tr>
            <th>Addr</th>
            <th>Bits</th>
          </tr>
        </thead>
        <tbody id="eeprom-memory-table-1">
        </tbody>
      </table>
      
      <table class="eeprom-table">
        <thead>
          <tr>
            <th>Addr</th>
            <th>Bits</th>
          </tr>
        </thead>
        <tbody id="eeprom-memory-table-2">
        </tbody>
      </table>
    </div>
    
  `;

  // Populate memory tables (split into two columns)
  const tableBody1 = programmer.querySelector('#eeprom-memory-table-1');
  const tableBody2 = programmer.querySelector('#eeprom-memory-table-2');

  for (let addr = 0; addr < 16; addr++) {
    const row = document.createElement('tr');

    // Address column (remove trailing 0)
    const addrCell = document.createElement('td');
    addrCell.className = 'eeprom-addr-cell';
    const binaryAddr = addr.toString(2).padStart(4, '0'); // 4 bits instead of 5
    addrCell.textContent = binaryAddr;
    row.appendChild(addrCell);

    // Binary column (editable bits)
    const binaryCell = document.createElement('td');
    const binaryContainer = document.createElement('div');
    binaryContainer.className = 'eeprom-binary-container';

    for (let bit = 7; bit >= 0; bit--) {
      const bitButton = document.createElement('button');
      bitButton.className = 'eeprom-bit';
      bitButton.dataset.addr = addr;
      bitButton.dataset.bit = bit;

      const bitValue = (memoryData[addr] >> bit) & 1;
      bitButton.textContent = bitValue;
      bitButton.dataset.value = bitValue;

      bitButton.addEventListener('click', () => {
        const currentValue = parseInt(bitButton.textContent);
        const newValue = currentValue ^ 1;
        bitButton.textContent = newValue;
        bitButton.dataset.value = newValue;
      });

      binaryContainer.appendChild(bitButton);
    }

    binaryCell.appendChild(binaryContainer);
    row.appendChild(binaryCell);

    // Append to appropriate table (first 8 in column 1, last 8 in column 2)
    if (addr < 8) {
      tableBody1.appendChild(row);
    } else {
      tableBody2.appendChild(row);
    }
  }

  // Clear All button
  programmer.querySelector('#eeprom-clear-all').addEventListener('click', () => {
    programmer.querySelectorAll('.eeprom-bit').forEach(bit => {
      bit.textContent = '0';
      bit.dataset.value = '0';
    });
  });

  // Close and Save button
  programmer.querySelector('#eeprom-close-save').addEventListener('click', () => {
    // Collect all memory data
    const newMemoryData = [];

    for (let addr = 0; addr < 16; addr++) {
      const bits = programmer.querySelectorAll(`.eeprom-bit[data-addr="${addr}"]`);
      let value = 0;

      bits.forEach(bit => {
        const bitIndex = parseInt(bit.dataset.bit);
        const bitValue = parseInt(bit.textContent);
        value |= (bitValue << bitIndex);
      });

      newMemoryData.push(value);
    }

    // Update module data
    if (module) {
      module.memoryData = newMemoryData;
    }

    // Send to worklet
    if (workletNode) {
      workletNode.port.postMessage({
        type: 'programEEPROM',
        moduleId: moduleId,
        memoryData: newMemoryData
      });
    }

    // Close programmer
    programmer.classList.remove('open');

    // Wait for transition end OR fallback timeout
    const cleanup = () => {
      programmer.remove();
      programmer.removeEventListener('transitionend', cleanup);
    };

    programmer.addEventListener('transitionend', cleanup);

    // Fallback if transition is interrupted
    setTimeout(cleanup, 350);

  });

  // Clear All button
  programmer.querySelector('#eeprom-close').addEventListener('click', () => {
    // Close programmer
    programmer.classList.remove('open');

    // Wait for transition end OR fallback timeout
    const cleanup = () => {
      programmer.remove();
      programmer.removeEventListener('transitionend', cleanup);
    };

    programmer.addEventListener('transitionend', cleanup);

    // Fallback if transition is interrupted
    setTimeout(cleanup, 350);
    document.removeEventListener('keydown', escapeHandler);
  });

  // Close on Escape key
  const escapeHandler = (e) => {
    if (e.key === 'Escape') {

      // Close programmer
      programmer.classList.remove('open');

      // Wait for transition end OR fallback timeout
      const cleanup = () => {
        programmer.remove();
        programmer.removeEventListener('transitionend', cleanup);
      };

      programmer.addEventListener('transitionend', cleanup);

      // Fallback if transition is interrupted
      setTimeout(cleanup, 350);
      document.removeEventListener('keydown', escapeHandler);
    }
  };
  document.addEventListener('keydown', escapeHandler);
}

function closeAllEEPROMProgrammers() {
  const programmers = document.querySelectorAll('#eeprom-programmer');
  if (!programmers.length) return;

  programmers.forEach(programmer => {
    // Stop animation
    programmer.classList.remove('open');

    // Remove any transitionend from previous opens
    const cleanup = () => {
      if (programmer && programmer.parentNode) {
        programmer.remove();
      }
      programmer.removeEventListener('transitionend', cleanup);
    };

    programmer.addEventListener('transitionend', cleanup);

    // Fallback timeout (in case animation was interrupted)
    setTimeout(cleanup, 350);
  });

  // // Remove all Escape key listeners safely
  // document.querySelectorAll('*').forEach(el => {
  //   document.removeEventListener('keydown', handleEEPROMEscapeClose);
  // });
}

function setupBCDTo7SegmentUI(div) {
  const columnsContainer = document.createElement('div');
  columnsContainer.classList.add('columns-container');
  div.appendChild(columnsContainer);

  const inputColumn = document.createElement('div');
  inputColumn.classList.add('input-column');
  columnsContainer.appendChild(inputColumn);

  const outputColumn1 = document.createElement('div');
  outputColumn1.classList.add('output-column');
  columnsContainer.appendChild(outputColumn1);

  const outputColumn2 = document.createElement('div');
  outputColumn2.classList.add('output-column');
  columnsContainer.appendChild(outputColumn2);

  // Add BCD inputs A, B, C, D
  ['A', 'B', 'C', 'D'].forEach((label, i) => {
    const inputGroup = createPortGroup(label, true, i);
    inputColumn.appendChild(inputGroup);
  });

  // Add LATCH input
  const latchGroup = createPortGroup('LT', true, 4);
  outputColumn1.appendChild(latchGroup);

  const moduleId = parseInt(div.dataset.id);

  // First 4 segment outputs (a, b, c, d)
  ['Q0', 'Q1', 'Q2'].forEach((label, i) => {
    const outputGroup = createPortGroup(label, false, i, i === 1);
    const led = createLedElement();
    div.appendChild(led);
    outputGroup.appendChild(led);
    outputColumn1.appendChild(outputGroup);

    ledElements.push({ modId: moduleId, led, outputIndex: i });
  });

  // Last 3 segment outputs (e, f, g)
  ['Q3', 'Q4', 'Q5', 'Q6'].forEach((label, i) => {
    const outputGroup = createPortGroup(label, false, i + 3);
    const led = createLedElement();
    div.appendChild(led);
    outputGroup.appendChild(led);
    outputColumn2.appendChild(outputGroup);

    ledElements.push({ modId: moduleId, led, outputIndex: i + 3 });
  });
}

function setup7SegmentDisplayUI(div) {
  // Remove the standard title for this module
  const title = div.querySelector('.module-title');
  if (title) {
    title.remove();
  }

  const columnsContainer = document.createElement('div');
  columnsContainer.classList.add('columns-container');
  columnsContainer.style.gap = '0';
  columnsContainer.style.padding = '0';
  columnsContainer.style.height = '100%';
  div.appendChild(columnsContainer);

  const inputColumn = document.createElement('div');
  inputColumn.classList.add('input-column');
  inputColumn.style.position = 'absolute';
  inputColumn.style.left = '4px';
  inputColumn.style.top = '50%';
  inputColumn.style.transform = 'translateY(-50%)';
  inputColumn.style.gap = '10px';
  columnsContainer.appendChild(inputColumn);

  const displayColumn = document.createElement('div');
  displayColumn.classList.add('output-column');
  displayColumn.style.position = 'relative';
  displayColumn.style.left = '16px';
  displayColumn.style.top = '26px';
  displayColumn.style.width = '90%';
  displayColumn.style.height = '100%';
  displayColumn.style.display = 'flex';
  displayColumn.style.alignItems = 'center';
  displayColumn.style.justifyContent = 'center';
  columnsContainer.appendChild(displayColumn);

  const moduleId = parseInt(div.dataset.id);

  // Add segment inputs with subtle labels only for 'a' and 'g'
  ['a', '', ' ', ' ', ' ', ' ', 'g'].forEach((label, i) => {
    const inputGroup = createPortGroup(label, true, i);
    const portLabel = inputGroup.querySelector('.port-label');

    // Reverse the flex direction to put label after port
    inputGroup.style.flexDirection = 'row-reverse';
    inputGroup.style.gap = '2px';

    portLabel.style.opacity = '0.3';
    portLabel.style.fontSize = '10px';
    portLabel.style.width = '10px';
    portLabel.style.textAlign = 'left';
    portLabel.style.paddingLeft = '0px';

    inputColumn.appendChild(inputGroup);
  });

  // Create SVG 7-segment display
  const svgNS = "http://www.w3.org/2000/svg";
  const svg = document.createElementNS(svgNS, 'svg');
  svg.setAttribute('viewBox', '0 0 306.91667 476.25');
  svg.setAttribute('width', '124');
  svg.setAttribute('height', '164');
  svg.style.display = 'block';

  const g = document.createElementNS(svgNS, 'g');
  svg.appendChild(g);

  // Define segment paths (from the SVG, in order: g, a, e, d, f, b, c)
  const segmentPaths = [
    "m 90.335771,198.81993 c -0.40438,0.50132 -0.84808,1.00717 -1.23404,1.50637 -1.06131,1.37269 -2.05311,2.73736 -2.97656,4.09484 -0.92345,1.35748 -1.77868,2.70752 -2.56625,4.05092 -0.78757,1.3434 -1.50745,2.68014 -2.16111,4.0106 -0.65366,1.33046 -1.24096,2.65475 -1.76268,3.9734 -0.52172,1.31866 -0.97819,2.63183 -1.36995,3.93982 -0.39175,1.30798 -0.71913,2.61087 -0.98288,3.90932 -0.26376,1.29845 -0.46378,2.5924 -0.60151,3.88245 -0.13773,1.29005 -0.21459,2.58007 -0.22945,3.87108 -0.0148,1.29101 0.0324,2.58324 0.14211,3.8778 0.1097,1.29455 0.28187,2.59106 0.5178,3.89175 0.23593,1.30069 0.53532,2.60559 0.89917,3.91501 0.36384,1.30942 0.79227,2.62372 1.28571,3.94446 0.49344,1.32074 1.05219,2.64754 1.6769,3.98219 0.62471,1.33464 1.3156,2.67703 2.07326,4.02817 0.49345,0.87997 1.06084,1.77036 1.61127,2.65824 1.62566,-0.72358 3.44066,-1.15549 5.43429,-1.15549 H 214.79122 c 1.67523,0 3.18131,0.28037 4.49378,0.79789 0.77859,-0.93242 1.57144,-1.86649 2.28668,-2.79156 1.06132,-1.37269 2.0536,-2.73737 2.97708,-4.09484 0.92348,-1.35748 1.77813,-2.70752 2.56574,-4.05092 0.7876,-1.3434 1.50793,-2.68015 2.16162,-4.01061 0.65369,-1.33046 1.24093,-2.65474 1.76268,-3.9734 0.52175,-1.31865 0.97817,-2.63183 1.36995,-3.93981 0.39177,-1.30798 0.71911,-2.61087 0.98288,-3.90932 0.26377,-1.29845 0.46379,-2.5924 0.60151,-3.88245 0.13774,-1.29005 0.21459,-2.58008 0.22945,-3.87108 0.0148,-1.29101 -0.0324,-2.58325 -0.14211,-3.8778 -0.1097,-1.29456 -0.28187,-2.59106 -0.5178,-3.89175 -0.23593,-1.3007 -0.53532,-2.60559 -0.89917,-3.91501 -0.36385,-1.30942 -0.79227,-2.62373 -1.28571,-3.94446 -0.49344,-1.32074 -1.05219,-2.64754 -1.6769,-3.98219 -0.62471,-1.33464 -1.3156,-2.67703 -2.07326,-4.02818 -0.18831,-0.33581 -0.41836,-0.67747 -0.61495,-1.0144 -0.79038,0.2007 -1.62214,0.33693 -2.52853,0.33693 h -3.49591 -124.699359 -3.49384 c -0.90747,0 -1.71105,-0.1368 -2.45928,-0.33797 z",
    "m 33.016271,224.21115 h 36.25773 c 0.24226,-1.40528 0.54527,-2.80725 0.90847,-4.20647 0.3632,-1.39921 0.78655,-2.7959 1.26969,-4.1894 0.48315,-1.39351 1.02624,-2.7842 1.62833,-4.17236 0.60209,-1.38816 1.2633,-2.77369 1.98334,-4.15685 0.72004,-1.38316 1.49879,-2.76386 2.33577,-4.14238 0.83699,-1.37853 1.73217,-2.75471 2.68511,-4.12895 0.95294,-1.37424 1.96345,-2.74624 3.03134,-4.11654 0.84393,-1.08293 1.75186,-2.1641 2.66702,-3.24477 0.0102,-0.16425 -0.005,-0.31279 0.0129,-0.48162 L 98.299621,74.255961 43.863151,56.648251 c -1.83599,5.082319 -3.16268,10.35912 -3.74396,15.80369 L 27.422811,191.37181 c -1.27289,11.92255 0.89038,23.13167 5.59346,32.83934 z",
    "M 6.4597502,419.75528 63.647991,399.72653 c 0.0101,-0.37425 -0.0189,-0.72876 0.0227,-1.11828 l 13.89476,-130.14502 c 0.17336,-1.62381 0.60881,-3.11011 1.24643,-4.44418 -0.83462,-1.28542 -1.62367,-2.57335 -2.35903,-3.86384 -0.75295,-1.32137 -1.4534,-2.64529 -2.10116,-3.97134 -0.64776,-1.32605 -1.24245,-2.65416 -1.78387,-3.98425 -0.54142,-1.33009 -1.02955,-2.66213 -1.46348,-3.99562 -0.43393,-1.3335 -0.81417,-2.66867 -1.13946,-4.00493 -0.3253,-1.33625 -0.59581,-2.67326 -0.81132,-4.01164 -0.21552,-1.33838 -0.37601,-2.67798 -0.48059,-4.01784 -0.10459,-1.33986 -0.15322,-2.68024 -0.14573,-4.02094 h -34.85679 c -7.80656,10.60715 -13.0615,23.04511 -14.47818,36.31458 L 5.2975472,398.60825 c -0.785631,7.35862 -0.32282,14.45977 1.162203,21.14703 z",
    "m 214.88992,464.17066 -11.37657,-55.25916 c -1.51928,0.60806 -3.19983,0.95705 -5.0214,0.95705 H 73.792591 c -3.12523,0 -5.63659,-0.99538 -7.40472,-2.69131 L 8.7123262,427.37549 c 8.5838578,23.77164 31.0707148,40.53809 58.8832248,40.53809 H 192.29492 c 7.74686,0 15.34259,-1.35611 22.595,-3.74292 z",
    "m 276.56419,232.14865 h -35.29242 c -0.25979,1.36967 -0.57774,2.73657 -0.95291,4.10052 -0.37517,1.36395 -0.80759,2.72492 -1.29708,4.08347 -0.48949,1.35856 -1.03593,2.71447 -1.63866,4.06797 -0.60273,1.3535 -1.26171,2.70472 -1.97662,4.0535 -0.71491,1.34878 -1.48547,2.69515 -2.31149,4.03955 -0.82602,1.3444 -1.70771,2.68679 -2.64377,4.02714 -1.74367,2.49679 -3.71874,4.9854 -5.83892,7.46983 0.35872,1.34087 0.47736,2.83785 0.30283,4.4726 l -13.89476,130.14502 c -0.12897,1.20793 -0.44043,2.31415 -0.83148,3.3662 l 12.20339,59.26977 c 24.85444,-11.15546 44.06757,-35.15755 47.00127,-62.63597 l 13.89476,-130.14502 c 1.41668,-13.26944 -1.18246,-25.70744 -6.72414,-36.31458 z",
    "m 245.79242,72.914961 -12.64677,118.456849 c -0.0644,0.60341 -0.17289,1.17757 -0.32246,1.72082 0.4906,0.79557 1.00224,1.59 1.45469,2.38745 0.76903,1.35543 1.483,2.71333 2.14096,4.07366 0.65796,1.36033 1.2603,2.72306 1.80609,4.0876 0.54579,1.36454 1.03508,2.73092 1.46761,4.09898 0.43252,1.36806 0.80786,2.7379 1.12603,4.10879 0.31816,1.37089 0.57915,2.743 0.78186,4.11603 0.20271,1.37302 0.34741,2.74672 0.43357,4.12119 0.0861,1.37448 0.11366,2.74959 0.0822,4.12482 h 36.79621 c 6.77594,-9.70772 11.33359,-20.91699 12.60646,-32.83934 L 304.21521,72.451941 C 307.0477,45.921454 293.15803,22.756706 271.17227,12.40444 Z",
    "m 263.78667,9.4883385 c -5.85447,-1.8478 -12.13953,-2.865458 -18.74665,-2.865458 H 113.35038 c -27.999869,0 -54.164889,17.9237745 -66.369069,42.6909345 l 54.149659,17.515206 c 1.50236,-1.38786 3.56036,-2.16266 6.02289,-2.16266 h 131.68912 c 0.61689,0 1.19669,0.0507 1.74098,0.1447 z"
  ];

  // Map SVG path indices to segment names (a-g order for inputs 0-6)
  const segmentOrder = ['g', 'f', 'e', 'd', 'c', 'b', 'a'];
  const pathToInput = { 'a': 0, 'b': 1, 'c': 2, 'd': 3, 'e': 4, 'f': 5, 'g': 6 };

  segmentPaths.forEach((pathData, i) => {
    const path = document.createElementNS(svgNS, 'path');
    path.setAttribute('d', pathData);
    path.style.fill = 'var(--led-off)';
    path.style.transition = 'fill 0.05s';
    path.classList.add('svg-segment'); // Add a class to identify SVG segments
    g.appendChild(path);

    const segmentName = segmentOrder[i];
    const inputIndex = pathToInput[segmentName];

    ledElements.push({
      modId: moduleId,
      led: path,
      outputIndex: inputIndex
    });
  });

  displayColumn.appendChild(svg);
}

// Helper function for Composite Modules
function setupCompositeModuleUI(div, definition) {
  const title = div.querySelector('.module-title');
  title.style.backgroundColor = 'var(--text-tertiary)';
  title.style.color = 'var(--module-bg)';

  // Expand to edges (counteract 16px padding of .module)
  title.style.marginTop = '-16px';
  title.style.marginLeft = '-16px';
  title.style.width = 'calc(100% + 32px)';
  title.style.paddingTop = '16px';
  title.style.borderTopLeftRadius = '11px';
  title.style.borderTopRightRadius = '11px';
  // Sort inlets and outlets to match CompositeModule logic
  const inlets = definition.modules.filter(m => m.type === 'Inlet').sort((a, b) => a.gridY - b.gridY);
  const outlets = definition.modules.filter(m => m.type === 'Outlet').sort((a, b) => a.gridY - b.gridY);
  // Get the module instance
  const mod = modules.find(m => m.id == div.dataset.id);

  // Initialize controls if they don't exist on the instance
  if (mod && !mod.controls) {
    // Deep copy controls from definition
    const defControls = definition.modules.filter(m => m.isControl);
    mod.controls = JSON.parse(JSON.stringify(defControls));
  }

  // Use instance controls if available, otherwise fall back to definition (shouldn't happen with above fix)
  const controls = mod && mod.controls ? mod.controls : definition.modules.filter(m => m.isControl);

  // Get module height setting from definition
  let heightSetting;
  if (definition.height === 'auto' || !definition.height) {
    heightSetting = Math.max(inlets.length, outlets.length, 4);
  } else {
    heightSetting = parseInt(definition.height);
  }

  // Separate controls
  const oscillatorControls = controls.filter(c => c.type === 'Oscillator');
  const buttonControls = controls.filter(c => c.type === 'Button');
  const singleButtonMode = buttonControls.length === 1;

  // Calculate effective height (matching moduleDesignerPreview.js)
  const maxPorts = Math.max(inlets.length, outlets.length);
  let effectiveHeight = Math.min(heightSetting, maxPorts);
  if (maxPorts === 0) effectiveHeight = 1;

  // If single button mode, enforce minimum height of 2 to accommodate the button
  if (singleButtonMode && effectiveHeight < 2) {
    effectiveHeight = 2;
  }

  // Apply stored grid dimensions if available
  if (definition.gridWidth && definition.gridHeight) {
    div.style.width = (definition.gridWidth * 20) + 'px';
    div.style.height = (definition.gridHeight * 20) + 'px';
    div.style.minWidth = (definition.gridWidth * 20) + 'px';
    div.style.minHeight = (definition.gridHeight * 20) + 'px';
    // Remove CSS max-width/height constraints
    div.style.maxWidth = 'none';
    div.style.maxHeight = 'none';
    // Ensure box-sizing is border-box to include padding in width/height
    // div.style.boxSizing = 'border-box';
  }

  // Render controls with horizontal row layout (buttons populate in rows first)
  if (controls && controls.length > 0) {
    const controlsContainer = document.createElement('div');
    controlsContainer.style.display = 'flex';
    controlsContainer.style.flexDirection = 'row';
    controlsContainer.style.flexWrap = 'wrap';
    controlsContainer.style.gap = '4px';
    controlsContainer.style.padding = '4px';
    div.appendChild(controlsContainer);

    // Render Oscillators first
    // Render Oscillators first
    oscillatorControls.forEach(ctrl => {
      // Create a simplified oscillator control
      const oscControl = document.createElement('div');
      oscControl.classList.add('freq-control-container');
      oscControl.dataset.controlId = ctrl.id; // Add ID for targeting
      oscControl.style.padding = '4px';
      oscControl.style.flex = '1 1 auto';
      oscControl.style.minWidth = '80px';

      // Ensure ctrl has a frequency
      if (!ctrl.freq) ctrl.freq = 220;

      // Create a container for the frequency label and input field
      const freqLabelInputContainer = document.createElement('div');
      freqLabelInputContainer.classList.add('freq-label-input-container');

      // Create label that will also serve as a clickable element
      const freqLabel = document.createElement('div');
      freqLabel.classList.add('freq-label');
      freqLabel.innerText = `${ctrl.freq.toFixed(2)} Hz`;
      freqLabel.style.fontSize = '10px';

      // Create text input field for direct frequency entry
      const freqTextInput = document.createElement('input');
      freqTextInput.type = 'text';
      freqTextInput.classList.add('freq-text-input');
      freqTextInput.value = ctrl.freq.toFixed(2);
      freqTextInput.style.fontSize = '10px';
      freqTextInput.style.width = '60px'; // Adjust width as needed

      // Add interaction to switch between label and input
      freqLabel.addEventListener('click', () => {
        freqLabel.style.display = 'none';
        freqTextInput.style.display = 'block';
        freqTextInput.focus();
        freqTextInput.select();
        clearSelection(); // Clear module selection when entering edit mode
        updateSelectionHighlights();
      });

      // Track original frequency for undo
      let originalFreq = ctrl.freq;
      let isEditing = false;

      // Set flag when starting to edit
      freqTextInput.addEventListener('focus', () => {
        isEditing = true;
        originalFreq = parseFloat(freqTextInput.value);
      });

      // Handle input field changes
      freqTextInput.addEventListener('blur', () => {
        if (isEditing) {
          updateFrequencyFromText();
          isEditing = false;
        }
      });

      // Prevent delete key from deleting module while editing
      freqTextInput.addEventListener('keydown', (e) => {
        // Stop propagation for all keydown events to prevent module deletion
        e.stopPropagation();

        if (e.key === 'Enter') {
          updateFrequencyFromText();
          freqTextInput.blur();
        }
      });

      function updateFrequencyFromText() {
        let newFreq = parseFloat(freqTextInput.value);

        // Validate input
        if (isNaN(newFreq) || newFreq <= 0) {
          newFreq = ctrl.freq; // Revert to current frequency if invalid
        } else {
          // Clamp to min/max range
          newFreq = Math.max(10, Math.min(3000, newFreq));
        }

        // Only record change if frequency actually changed
        if (ctrl.freq !== newFreq) {
          // Record action for undo/redo
          pushToUndoStack({
            type: 'changeCompositeFrequency',
            moduleId: parseInt(div.dataset.id),
            controlId: ctrl.id,
            oldFrequency: ctrl.freq,
            newFrequency: newFreq
          });

          ctrl.freq = newFreq;
        }

        // Update UI
        freqTextInput.value = newFreq.toFixed(2);
        freqLabel.innerText = `${newFreq.toFixed(2)} Hz`;

        // Update slider position to match
        const normalized = Math.log(newFreq / 10) / Math.log(300);
        freqSlider.value = Math.round(normalized * 1500);

        // Switch back to label display
        freqTextInput.style.display = 'none';
        freqLabel.style.display = 'block';

        // Send message to worklet
        if (workletNode) {
          workletNode.port.postMessage({
            type: 'compositeControlChange',
            moduleId: parseInt(div.dataset.id),
            controlId: ctrl.id,
            frequency: newFreq
          });
        }
      }

      freqLabelInputContainer.appendChild(freqLabel);
      freqLabelInputContainer.appendChild(freqTextInput);
      oscControl.appendChild(freqLabelInputContainer);

      const freqSlider = document.createElement('input');
      freqSlider.type = 'range';
      freqSlider.min = 0;
      freqSlider.max = 1500;
      freqSlider.classList.add('freq-slider');

      // Calculate slider value based on frequency
      const normalized = Math.log(ctrl.freq / 10) / Math.log(300);
      freqSlider.value = Math.round(normalized * 1500);

      // Variables to track slider movement
      let sliderStartFreq = ctrl.freq;
      let isSliding = false;

      // Record the starting frequency when slider interaction begins
      freqSlider.addEventListener('mousedown', () => {
        sliderStartFreq = ctrl.freq;
        isSliding = true;
      });

      freqSlider.addEventListener('input', () => {
        const normalized = freqSlider.value / 1500;
        const newFreq = 10 * Math.pow(300, normalized);

        ctrl.freq = newFreq;

        freqLabel.innerText = `${newFreq.toFixed(2)} Hz`;
        freqTextInput.value = newFreq.toFixed(2);

        // Update the internal oscillator frequency via worklet
        if (workletNode) {
          workletNode.port.postMessage({
            type: 'compositeControlChange',
            moduleId: parseInt(div.dataset.id),
            controlId: ctrl.id,
            frequency: newFreq
          });
        }
      });

      // Record undo action when slider interaction ends
      freqSlider.addEventListener('mouseup', (e) => {
        if (isSliding) {
          if (ctrl.freq !== sliderStartFreq) {
            pushToUndoStack({
              type: 'changeCompositeFrequency',
              moduleId: parseInt(div.dataset.id),
              controlId: ctrl.id,
              oldFrequency: sliderStartFreq,
              newFrequency: ctrl.freq
            });
          }
          isSliding = false;
          e.stopPropagation();
          freqSlider.blur();
          document.body.focus();
        }
      });

      // Also handle case when mouse leaves slider during drag
      freqSlider.addEventListener('mouseleave', (e) => {
        if (isSliding) {
          if (ctrl.freq !== sliderStartFreq) {
            pushToUndoStack({
              type: 'changeCompositeFrequency',
              moduleId: parseInt(div.dataset.id),
              controlId: ctrl.id,
              oldFrequency: sliderStartFreq,
              newFrequency: ctrl.freq
            });
          }
          isSliding = false;
          e.stopPropagation();
          freqSlider.blur();
          document.body.focus();
        }
      });

      // Touch handlers
      freqSlider.addEventListener('touchstart', (e) => {
        sliderStartFreq = ctrl.freq;
        isSliding = true;
        e.stopPropagation();
      });

      freqSlider.addEventListener('touchend', (e) => {
        if (isSliding) {
          if (ctrl.freq !== sliderStartFreq) {
            pushToUndoStack({
              type: 'changeCompositeFrequency',
              moduleId: parseInt(div.dataset.id),
              controlId: ctrl.id,
              oldFrequency: sliderStartFreq,
              newFrequency: ctrl.freq
            });
          }
          isSliding = false;
          e.stopPropagation();
          freqSlider.blur();
          document.body.focus();
        }
      });

      freqSlider.addEventListener('touchcancel', (e) => {
        if (isSliding) {
          if (ctrl.freq !== sliderStartFreq) {
            pushToUndoStack({
              type: 'changeCompositeFrequency',
              moduleId: parseInt(div.dataset.id),
              controlId: ctrl.id,
              oldFrequency: sliderStartFreq,
              newFrequency: ctrl.freq
            });
          }
          isSliding = false;
          e.stopPropagation();
          freqSlider.blur();
          document.body.focus();
        }
      });

      freqSlider.addEventListener('touchmove', (e) => {
        if (isSliding) {
          e.stopPropagation();

          const normalized = freqSlider.value / 1500;
          const newFreq = 10 * Math.pow(300, normalized);

          ctrl.freq = newFreq;

          freqLabel.innerText = `${newFreq.toFixed(2)} Hz`;
          freqTextInput.value = newFreq.toFixed(2);

          if (workletNode) {
            workletNode.port.postMessage({
              type: 'compositeControlChange',
              moduleId: parseInt(div.dataset.id),
              controlId: ctrl.id,
              frequency: newFreq
            });
          }
        }
      });

      oscControl.appendChild(freqSlider);
      controlsContainer.appendChild(oscControl);
    });

    // Render Buttons if NOT in single button mode
    if (!singleButtonMode && buttonControls.length > 0) {
      // Use space-evenly for multiple buttons
      const buttonRow = document.createElement('div');
      buttonRow.style.display = 'flex';
      buttonRow.style.flexDirection = 'row';
      buttonRow.style.justifyContent = 'space-evenly';
      buttonRow.style.width = '100%';
      buttonRow.style.flexWrap = 'wrap';
      controlsContainer.appendChild(buttonRow);

      buttonControls.forEach(ctrl => {
        const button = document.createElement('div');
        button.classList.add('buttonModule');
        button.style.margin = '5px';
        button.style.cursor = 'pointer';

        button.addEventListener('mousedown', (e) => {
          e.preventDefault();
          button.style.backgroundColor = 'var(--button-module-pressed)';
          if (workletNode) {
            workletNode.port.postMessage({
              type: 'compositeControlPress',
              moduleId: parseInt(div.dataset.id),
              controlId: ctrl.id
            });
          }
        });

        button.addEventListener('mouseup', (e) => {
          e.preventDefault();
          button.style.backgroundColor = 'var(--button-module-off)';
          if (workletNode) {
            workletNode.port.postMessage({
              type: 'compositeControlRelease',
              moduleId: parseInt(div.dataset.id),
              controlId: ctrl.id
            });
          }
        });

        buttonRow.appendChild(button);
      });
    }
  }

  const columnsContainer = document.createElement('div');
  columnsContainer.classList.add('columns-container');
  div.appendChild(columnsContainer);

  // Calculate number of input columns needed
  let numInputColumns;
  if (singleButtonMode) {
    // If single button, it takes up TWO slots in the first column
    const firstColCapacity = Math.max(0, effectiveHeight - 2);
    const remainingInlets = Math.max(0, inlets.length - firstColCapacity);
    const extraCols = Math.ceil(remainingInlets / effectiveHeight);
    numInputColumns = 1 + extraCols;
  } else {
    numInputColumns = Math.ceil(inlets.length / effectiveHeight);
  }

  // Create input columns with overflow
  let inletIndex = 0;
  for (let col = 0; col < numInputColumns; col++) {
    const inputColumn = document.createElement('div');
    inputColumn.classList.add('input-column');
    columnsContainer.appendChild(inputColumn);

    let slotsInColumn = effectiveHeight;

    // If single button mode and this is the first column, add the button first
    if (singleButtonMode && col === 0 && buttonControls.length > 0) {
      const ctrl = buttonControls[0];
      const button = document.createElement('div');
      button.classList.add('buttonModule');
      button.style.margin = '5px';
      button.style.cursor = 'pointer';

      button.addEventListener('mousedown', (e) => {
        e.preventDefault();
        button.style.backgroundColor = 'var(--button-module-pressed)';
        if (workletNode) {
          workletNode.port.postMessage({
            type: 'compositeControlPress',
            moduleId: parseInt(div.dataset.id),
            controlId: ctrl.id
          });
        }
      });

      button.addEventListener('mouseup', (e) => {
        e.preventDefault();
        button.style.backgroundColor = 'var(--button-module-off)';
        if (workletNode) {
          workletNode.port.postMessage({
            type: 'compositeControlRelease',
            moduleId: parseInt(div.dataset.id),
            controlId: ctrl.id
          });
        }
      });

      inputColumn.appendChild(button);
      slotsInColumn -= 2;
    }

    // Fill remaining slots with inlets
    for (let i = 0; i < slotsInColumn; i++) {
      if (inletIndex < inlets.length) {
        const inlet = inlets[inletIndex];
        const inputGroup = createPortGroup(inlet.label || 'In', true, inletIndex);
        inputColumn.appendChild(inputGroup);
        inletIndex++;
      }
    }
  }

  // Calculate number of outlet columns needed
  const numOutletColumns = Math.ceil(outlets.length / effectiveHeight);

  // Create output columns with overflow
  for (let col = 0; col < numOutletColumns; col++) {
    const outputColumn = document.createElement('div');
    outputColumn.classList.add('output-column');
    columnsContainer.appendChild(outputColumn);

    const startIdx = col * effectiveHeight;
    const endIdx = Math.min(startIdx + effectiveHeight, outlets.length);

    // Create output ports for this column
    for (let i = startIdx; i < endIdx; i++) {
      const outlet = outlets[i];
      const outputGroup = createPortGroup(outlet.label || 'Out', false, i);
      const led = createLedElement();
      div.appendChild(led);
      outputGroup.appendChild(led);
      outputColumn.appendChild(outputGroup);

      ledElements.push({ modId: parseInt(div.dataset.id), led, outputIndex: i });
    }
  }
}

// performance.js
// Performance Mode Implementation - Canvas-based with Multi-Touch
const MAX_OSCILLATOR_CONTROLS = 6;
const MAX_BUTTON_CONTROLS = 6;

// Track next available performance slots
let nextOscillatorSlot = 1;
let nextButtonSlot = 1;

// Track which slots are currently used
let usedOscillatorSlots = new Set();
let usedButtonSlots = new Set();

// Link states
let performanceLinked = false;
let fxLinked = false;
let sevenSegPerformanceMode = false;
let performanceDisplaysPerRow = 0; // 0 = auto (based on spatial layout), or 2, 3, 4 for manual
let performanceRowSizes = new Map(); // Map of row index -> size multiplier (0.7, 1.0, 1.3 for small/medium/large)
let selectedPerformanceRow = 'all'; // 'all' or row index number
let performanceCanvasScale = 0.5; // Global canvas scale factor (0.7, 1.0, 1.3) - affects entire container with inset

// Get CSS variable values
function getCSSVariable(name) {
  return getComputedStyle(document.documentElement).getPropertyValue(name).trim();
}

// Canvas state
let performanceCanvas = null;
let performanceCtx = null;
let canvasControls = [];
let activeTouches = new Map();

// State snapshot for restoring after performance mode
let performanceSnapshot = {
  oscillators: new Map(),
  buttons: new Map(),
  effects: {
    filterCutoff: 20000,
    filterResonance: 0,
    delayTime: 0.25,
    delayFeedback: 0.3,
    delayMix: 0
  },
  performanceOscillators: new Map(),
  performanceButtons: new Map()
};

// Current FX state (always persists visually in performance mode)
let currentPerformanceFX = {
  filterCutoff: 20000,
  filterResonance: 0,
  delayTime: 0.25,
  delayFeedback: 0.3,
  delayMix: 0
};

// Update performance indicators on modules
function updatePerformanceIndicators() {
  // Remove all existing indicators
  document.querySelectorAll('.performance-indicator').forEach(el => el.remove());

  // Add indicators to oscillators
  performanceSnapshot.performanceOscillators.forEach((performanceIndex, moduleId) => {
    const moduleElement = document.querySelector(`[data-id='${moduleId}']`);
    if (moduleElement) {
      const indicator = document.createElement('div');
      indicator.className = 'performance-indicator';
      indicator.textContent = performanceIndex;
      indicator.title = `Performance Oscillator ${performanceIndex}`;
      moduleElement.appendChild(indicator);
    }
  });

  // Add indicators to buttons
  performanceSnapshot.performanceButtons.forEach((performanceIndex, moduleId) => {
    const moduleElement = document.querySelector(`[data-id='${moduleId}']`);
    if (moduleElement) {
      const indicator = document.createElement('div');
      indicator.className = 'performance-indicator';
      indicator.textContent = performanceIndex;
      indicator.title = `Performance Button ${performanceIndex}`;
      moduleElement.appendChild(indicator);
    }
  });
}

function updateLinkButtonStates() {
  const performanceLinkBtn = document.getElementById('performance-link-btn');
  const fxLinkBtn = document.getElementById('fx-link-btn');

  if (performanceLinkBtn) {
    if (performanceLinked) {
      performanceLinkBtn.classList.add('linked');
    } else {
      performanceLinkBtn.classList.remove('linked');
    }
  }

  if (fxLinkBtn) {
    if (fxLinked) {
      fxLinkBtn.classList.add('linked');
    } else {
      fxLinkBtn.classList.remove('linked');
    }
  }
}

function enterPerformanceMode() {
  performanceMode = true;

  // Snapshot current state (for oscillators and buttons)
  snapshotModuleState();
  applyPerformanceFX();

  // Hide main UI elements
  document.getElementById('topBar').style.display = 'none';
  if (document.getElementById('mobile-edit-bar')) {
    document.getElementById('mobile-edit-bar').style.display = 'none';
  }
  if (document.querySelector('.mobile-fab-container')) {
    document.querySelector('.mobile-fab-container').style.display = 'none';
  }
  if (document.getElementById('mobile-audio-fab')) {
    document.getElementById('mobile-audio-fab').style.display = 'none';
  }
  if (document.getElementById('mobile-performance-fab')) {
    document.getElementById('mobile-performance-fab').style.display = 'none';
  }

  // Hide all modules and wires (but NOT performance canvas)
  document.querySelectorAll('.module').forEach(el => el.style.display = 'none');
  document.querySelectorAll('canvas:not(.performance-canvas)').forEach(el => el.style.display = 'none');

  // Setup canvas controls
  setupPerformanceCanvas();

  // Populate performance controls (will use currentPerformanceFX values)
  populatePerformanceControls();

  // Update link button states
  updateLinkButtonStates();

  // Show performance overlay

  if (sevenSegPerformanceMode) {
    // Show seven-seg displays and hide canvas
    setTimeout(() => {
      showSevenSegInPerformance();
    }, 10);
  }

  document.getElementById('performance-overlay').style.display = 'flex';

}

function applyPerformanceFX() {
  if (!workletNode) return;

  // Apply the saved performance FX values to the audio engine
  workletNode.port.postMessage({
    type: 'filterCutoff',
    value: currentPerformanceFX.filterCutoff
  });
  workletNode.port.postMessage({
    type: 'filterResonance',
    value: currentPerformanceFX.filterResonance
  });
  workletNode.port.postMessage({
    type: 'delayTime',
    value: currentPerformanceFX.delayTime
  });
  workletNode.port.postMessage({
    type: 'delayFeedback',
    value: currentPerformanceFX.delayFeedback
  });
  workletNode.port.postMessage({
    type: 'delayMix',
    value: currentPerformanceFX.delayMix
  });
}


function exitPerformanceMode() {
  // Hide seven-seg displays and show canvas
  hideSevenSegInPerformance();

  performanceMode = false;

  // Clear all active touches
  activeTouches.clear();

  // Save current performance FX values before exiting
  saveCurrentPerformanceFX();

  // Restore snapshotted state (respecting link states)
  restoreModuleState();

  // Clean up performance controls
  cleanupPerformanceControls();

  // Hide performance overlay
  document.getElementById('performance-overlay').style.display = 'none';

  // Show main UI elements
  document.getElementById('topBar').style.display = 'flex';
  if (document.getElementById('mobile-edit-bar')) {
    document.getElementById('mobile-edit-bar').style.display = 'flex';
  }
  if (document.querySelector('.mobile-fab-container')) {
    document.querySelector('.mobile-fab-container').style.display = 'flex';
  }
  if (document.getElementById('mobile-audio-fab')) {
    document.getElementById('mobile-audio-fab').style.display = 'flex';
  }
  if (document.getElementById('mobile-performance-fab')) {
    document.getElementById('mobile-performance-fab').style.display = 'flex';
  }

  // Show all modules and wires
  document.querySelectorAll('.module').forEach(el => el.style.display = 'block');
  document.querySelectorAll('canvas').forEach(el => el.style.display = 'block');

  // Update performance indicators
  updatePerformanceIndicators();

  // Update oscillator UIs to reflect their current frequencies
  updateOscillatorUIs();

  // Redraw wires
  drawWires();
}


// New function to update oscillator UIs after exiting performance mode
function updateOscillatorUIs() {
  performanceSnapshot.performanceOscillators.forEach((performanceIndex, moduleId) => {
    const module = modules.find(m => m.id === moduleId);
    const moduleElement = document.querySelector(`[data-id='${moduleId}']`);

    if (module && moduleElement) {
      // Update frequency label
      const freqLabel = moduleElement.querySelector('.freq-label');
      if (freqLabel) {
        freqLabel.innerText = `${module.freq.toFixed(2)} Hz`;
      }

      // Update frequency text input
      const freqTextInput = moduleElement.querySelector('.freq-text-input');
      if (freqTextInput) {
        freqTextInput.value = module.freq.toFixed(2);
      }

      // Update frequency slider
      const freqSlider = moduleElement.querySelector('.freq-slider');
      if (freqSlider) {
        const normalized = Math.log(module.freq / 10) / Math.log(300);
        freqSlider.value = Math.round(normalized * 1500);
      }
    }
  });
}

// New function to save current performance FX values
function saveCurrentPerformanceFX() {
  const cutoffControl = canvasControls.find(c => c.id === 'filterCutoff');
  const delayTimeControl = canvasControls.find(c => c.id === 'delayTime');
  const delayFeedbackControl = canvasControls.find(c => c.id === 'delayFeedback');
  const delayMixControl = canvasControls.find(c => c.id === 'delayMix');

  if (cutoffControl) currentPerformanceFX.filterCutoff = cutoffControl.value;
  if (delayTimeControl) currentPerformanceFX.delayTime = delayTimeControl.value;
  if (delayFeedbackControl) currentPerformanceFX.delayFeedback = delayFeedbackControl.value;
  if (delayMixControl) currentPerformanceFX.delayMix = delayMixControl.value;
}

// Update the initialization section:
document.addEventListener('DOMContentLoaded', () => {
  const performanceButton = document.getElementById('performanceButton');
  if (performanceButton) {
    performanceButton.addEventListener('click', enterPerformanceMode);
  }

  const exitButton = document.getElementById('exit-performance');
  if (exitButton) {
    exitButton.addEventListener('click', exitPerformanceMode);
    exitButton.addEventListener('touchend', (e) => {
      e.preventDefault();
      exitPerformanceMode();
    });
  }

  // Performance link button
  const performanceLinkBtn = document.getElementById('performance-link-btn');
  if (performanceLinkBtn) {
    const togglePerformanceLink = (e) => {
      e.preventDefault();
      performanceLinked = !performanceLinked;
      updateLinkButtonStates();
    };

    performanceLinkBtn.addEventListener('click', togglePerformanceLink);
    performanceLinkBtn.addEventListener('touchend', togglePerformanceLink);
  }

  // FX link button
  const fxLinkBtn = document.getElementById('fx-link-btn');
  if (fxLinkBtn) {
    const toggleFxLink = (e) => {
      e.preventDefault();
      fxLinked = !fxLinked;
      updateLinkButtonStates();
    };

    fxLinkBtn.addEventListener('click', toggleFxLink);
    fxLinkBtn.addEventListener('touchend', toggleFxLink);
  }

  // Seven-seg toggle button
  const sevenSegToggleBtn = document.getElementById('seven-seg-toggle-btn');
  if (sevenSegToggleBtn) {
    const toggleSevenSeg = (e) => {
      e.preventDefault();
      sevenSegPerformanceMode = !sevenSegPerformanceMode;

      // Update button state
      if (sevenSegPerformanceMode) {
        sevenSegToggleBtn.classList.add('active');
        // Show seven-seg displays and hide canvas
        showSevenSegInPerformance();
      } else {
        sevenSegToggleBtn.classList.remove('active');
        // Hide seven-seg displays and show canvas
        hideSevenSegInPerformance();
      }
    };

    sevenSegToggleBtn.addEventListener('click', toggleSevenSeg);
    sevenSegToggleBtn.addEventListener('touchend', toggleSevenSeg);
  }

  // Performance seven-seg displays-per-row control (like sevenseg.js)
  const rowIconBtn = document.getElementById('performance-sevenseg-row-icon');
  if (rowIconBtn) {
    const toggleDisplaysPerRow = (e) => {
      e.preventDefault();
      e.stopPropagation();
      
      // Cycle through: auto (0) -> 2 -> 3 -> 4 -> auto
      if (performanceDisplaysPerRow === 0) {
        performanceDisplaysPerRow = 2;
      } else if (performanceDisplaysPerRow === 2) {
        performanceDisplaysPerRow = 3;
      } else if (performanceDisplaysPerRow === 3) {
        performanceDisplaysPerRow = 4;
      } else {
        performanceDisplaysPerRow = 0; // back to auto
      }
      
      // Update button title to show current setting
      if (performanceDisplaysPerRow === 0) {
        rowIconBtn.innerHTML = 'Auto';
        rowIconBtn.classList.remove('row-selected');
        rowIconBtn.removeAttribute('data-displays-per-row');
      } else {
        rowIconBtn.innerHTML = `${performanceDisplaysPerRow}`;
        rowIconBtn.classList.add('row-selected');
        rowIconBtn.setAttribute('data-displays-per-row', performanceDisplaysPerRow);
      }
      
      // Re-setup displays if in performance mode with seven-seg active
      if (performanceMode && sevenSegPerformanceMode) {
        const sevenSegModules = modules.filter(m => m.type === '7-Segment Display');
        setupPerformanceSevenSegDisplays(sevenSegModules);
      }
    };
    
    rowIconBtn.addEventListener('click', toggleDisplaysPerRow);
    rowIconBtn.addEventListener('touchend', toggleDisplaysPerRow);
  }

  // Performance seven-seg size controls
  // Use event delegation since controls may be hidden initially
  document.addEventListener('click', (e) => {
    const sizeBtn = e.target.closest('.sevenseg-size-btn');
    if (sizeBtn) {
      e.preventDefault();
      const size = parseFloat(sizeBtn.dataset.size);
      const rowTarget = sizeBtn.dataset.row;
      
      // Remove active class from all buttons in the same group
      sizeBtn.parentElement.querySelectorAll('.sevenseg-size-btn').forEach(b => b.classList.remove('active'));
      sizeBtn.classList.add('active');
      
      // Check if this is a canvas scale button (data-row="all")
      if (rowTarget === 'all') {
        // Set global canvas scale
        performanceCanvasScale = size;
        // Update canvas scale button states
        updatePerformanceCanvasScaleButtons();
      } else {
        // Apply to selected row (or all rows)
        if (selectedPerformanceRow === 'all') {
          // Apply to all rows
          const layout = calculatePerformanceGridLayout(modules.filter(m => m.type === '7-Segment Display'));
          for (let i = 0; i < layout.rows; i++) {
            performanceRowSizes.set(i, size);
          }
        } else {
          // Apply to specific row
          performanceRowSizes.set(selectedPerformanceRow, size);
        }
        
        // Update size buttons to reflect change
        updatePerformanceRowSizeButtons();
      }
      
      // Re-setup displays if in performance mode with seven-seg active
      if (performanceMode && sevenSegPerformanceMode) {
        // Use requestAnimationFrame to ensure layout is settled before recalculating
        requestAnimationFrame(() => {
          const sevenSegModules = modules.filter(m => m.type === '7-Segment Display');
          setupPerformanceSevenSegDisplays(sevenSegModules);
        });
      }
    }
  });
  
  // Also handle touch events
  document.addEventListener('touchend', (e) => {
    const sizeBtn = e.target.closest('.sevenseg-size-btn');
    if (sizeBtn) {
      e.preventDefault();
      sizeBtn.click();
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && performanceMode) {
      exitPerformanceMode();
    }
  });
});

function snapshotModuleState() {
  performanceSnapshot.oscillators.clear();
  performanceSnapshot.buttons.clear();

  modules.filter(m => m.type === 'Oscillator').forEach(module => {
    performanceSnapshot.oscillators.set(module.id, {
      freq: module.freq
    });
  });

  modules.filter(m => m.type === 'Button').forEach(module => {
    performanceSnapshot.buttons.set(module.id, {});
  });

  // Always snapshot current FX state for normal mode restoration
  performanceSnapshot.effects = {
    filterCutoff: 20000,
    filterResonance: 0,
    delayTime: 0.25,
    delayFeedback: 0.3,
    delayMix: 0
  };
}

function restoreModuleState() {
  // Restore oscillator parameters only if NOT linked
  if (!performanceLinked) {
    performanceSnapshot.oscillators.forEach((state, moduleId) => {
      const module = modules.find(m => m.id === moduleId);
      if (module) {
        module.freq = state.freq;

        if (workletNode) {
          workletNode.port.postMessage({
            type: 'frequencyChange',
            moduleId: module.id,
            frequency: state.freq
          });
        }
      }
    });
  }
  // If linked, oscillator parameters remain as they were in performance mode

  // Restore button state (buttons don't have persistent state, so this is unchanged)
  performanceSnapshot.buttons.forEach((state, moduleId) => {
    const module = modules.find(m => m.id === moduleId);
    if (module) {
      // Restore any button state
    }
  });

  // Restore FX parameters only if NOT linked
  if (!fxLinked && workletNode) {
    workletNode.port.postMessage({ type: 'filterCutoff', value: performanceSnapshot.effects.filterCutoff });
    workletNode.port.postMessage({ type: 'filterResonance', value: performanceSnapshot.effects.filterResonance });
    workletNode.port.postMessage({ type: 'delayTime', value: performanceSnapshot.effects.delayTime });
    workletNode.port.postMessage({ type: 'delayFeedback', value: performanceSnapshot.effects.delayFeedback });
    workletNode.port.postMessage({ type: 'delayMix', value: performanceSnapshot.effects.delayMix });
  }
  // If FX linked, effects remain as they were in performance mode (already applied)
}

function setupPerformanceCanvas() {
  const container = document.getElementById('performance-canvas-container');

  // Create canvas if it doesn't exist
  if (!performanceCanvas) {
    performanceCanvas = document.createElement('canvas');
    performanceCanvas.id = 'performance-canvas';
    performanceCanvas.className = 'performance-canvas';
    container.appendChild(performanceCanvas);
    performanceCtx = performanceCanvas.getContext('2d');
  }

  // Size canvas - use setTimeout to ensure layout is complete
  setTimeout(() => {
    resizePerformanceCanvas();
  }, 0);

  // Add event listeners to CANVAS for start
  performanceCanvas.addEventListener('mousedown', handleCanvasStart, { passive: false });
  performanceCanvas.addEventListener('touchstart', handleCanvasStart, { passive: false });

  // Add event listeners to DOCUMENT for move/end so they work outside canvas
  document.addEventListener('mousemove', handleCanvasMove, { passive: false });
  document.addEventListener('mouseup', handleCanvasEnd, { passive: false });
  document.addEventListener('touchmove', handleCanvasMove, { passive: false });
  document.addEventListener('touchend', handleCanvasEnd, { passive: false });
  document.addEventListener('touchcancel', handleCanvasEnd, { passive: false });
}

function resizePerformanceCanvas() {
  if (!performanceCanvas) return;

  const container = document.getElementById('performance-canvas-container');
  const rect = container.getBoundingClientRect();

  // Set canvas size to match container
  performanceCanvas.width = rect.width * 2;
  performanceCanvas.height = rect.height * 2;

  // Rebuild layout and redraw
  if (canvasControls.length > 0) {
    layoutCanvasControls();
    drawCanvas();
  }
}

function populatePerformanceControls() {
  const buttonsContainer = document.getElementById('performance-buttons-container');
  buttonsContainer.innerHTML = '';

  // Check if any modules are manually assigned
  const hasManualAssignments = performanceSnapshot.performanceOscillators.size > 0 ||
    performanceSnapshot.performanceButtons.size > 0;

  let oscillatorsToShow = [];
  let buttonsToShow = [];

  if (hasManualAssignments) {
    // Use manually assigned modules
    const oscillators = modules.filter(m =>
      m.type === 'Oscillator' && performanceSnapshot.performanceOscillators.has(m.id)
    );

    const buttons = modules.filter(m =>
      m.type === 'Button' && performanceSnapshot.performanceButtons.has(m.id)
    );

    // Sort by performance index
    oscillatorsToShow = oscillators.sort((a, b) =>
      performanceSnapshot.performanceOscillators.get(a.id) -
      performanceSnapshot.performanceOscillators.get(b.id)
    );

    buttonsToShow = buttons.sort((a, b) =>
      performanceSnapshot.performanceButtons.get(a.id) -
      performanceSnapshot.performanceButtons.get(b.id)
    );

  } else {
    // Auto-populate with first N modules
    const oscillators = modules.filter(m => m.type === 'Oscillator');
    const buttons = modules.filter(m => m.type === 'Button');

    oscillatorsToShow = oscillators.slice(0, MAX_OSCILLATOR_CONTROLS);
    buttonsToShow = buttons.slice(0, MAX_BUTTON_CONTROLS);

    // Temporarily assign them for this session
    performanceSnapshot.performanceOscillators.clear();
    performanceSnapshot.performanceButtons.clear();

    oscillatorsToShow.forEach((module, index) => {
      performanceSnapshot.performanceOscillators.set(module.id, index + 1);
    });

    buttonsToShow.forEach((module, index) => {
      performanceSnapshot.performanceButtons.set(module.id, index + 1);
    });
  }

  // Setup buttons
  buttonsToShow.forEach(module => {
    buttonsContainer.appendChild(createPerformanceButtonControl(module));
  });

  // Setup canvas controls
  canvasControls = [];

  // Add oscillator controls
  oscillatorsToShow.forEach((module) => {
    const perfIndex = performanceSnapshot.performanceOscillators.get(module.id);
    canvasControls.push({
      type: 'oscillator',
      module: module,
      value: module.freq,
      min: 10,
      max: 3000,
      logarithmic: true,
      label: `OSC ${perfIndex}`,
      formatValue: (v) => `${v.toFixed(1)}Hz`,
      onChange: (value) => {
        module.freq = value;
        if (workletNode) {
          workletNode.port.postMessage({
            type: 'frequencyChange',
            moduleId: module.id,
            frequency: value
          });
        }
      }
    });
  });

  // Add effect controls - ALWAYS use currentPerformanceFX values
  canvasControls.push({
    type: 'effect',
    id: 'filterCutoff',
    value: currentPerformanceFX.filterCutoff,
    min: 20,
    max: 20000,
    logarithmic: true,
    label: 'Cutoff',
    formatValue: (v) => `${v.toFixed(0)}Hz`,
    onChange: (value) => {
      if (workletNode) {
        workletNode.port.postMessage({ type: 'filterCutoff', value: value });
      }
    }
  });

  canvasControls.push({
    type: 'effect',
    id: 'delayTime',
    value: currentPerformanceFX.delayTime,
    min: 0.001,
    max: 5.0,
    logarithmic: true,
    label: 'Time',
    formatValue: (v) => {
      if (v < 1) return `${(v * 1000).toFixed(1)}ms`;
      else return `${v.toFixed(2)}s`;
    },
    onChange: (value) => {
      if (workletNode) {
        workletNode.port.postMessage({ type: 'delayTime', value: value });
      }
    }
  });

  canvasControls.push({
    type: 'effect',
    id: 'delayFeedback',
    value: currentPerformanceFX.delayFeedback,
    min: 0,
    max: 0.99,
    logarithmic: false,
    label: 'Feedback',
    formatValue: (v) => `${(v * 100).toFixed(0)}%`,
    onChange: (value) => {
      if (workletNode) {
        workletNode.port.postMessage({ type: 'delayFeedback', value: value });
      }
    }
  });

  canvasControls.push({
    type: 'effect',
    id: 'delayMix',
    value: currentPerformanceFX.delayMix,
    min: 0,
    max: 1,
    logarithmic: false,
    label: 'Mix',
    formatValue: (v) => `${(v * 100).toFixed(0)}%`,
    onChange: (value) => {
      if (workletNode) {
        workletNode.port.postMessage({ type: 'delayMix', value: value });
      }
    }
  });

  setTimeout(() => {
    layoutCanvasControls();
    drawCanvas();
  }, 10);
}

function rebuildSlotTracking() {
  usedOscillatorSlots.clear();
  usedButtonSlots.clear();

  performanceSnapshot.performanceOscillators.forEach((slot, moduleId) => {
    usedOscillatorSlots.add(slot);
  });

  performanceSnapshot.performanceButtons.forEach((slot, moduleId) => {
    usedButtonSlots.add(slot);
  });

  // Find next available slots
  nextOscillatorSlot = 1;
  while (usedOscillatorSlots.has(nextOscillatorSlot) && nextOscillatorSlot <= MAX_OSCILLATOR_CONTROLS) {
    nextOscillatorSlot++;
  }

  nextButtonSlot = 1;
  while (usedButtonSlots.has(nextButtonSlot) && nextButtonSlot <= MAX_BUTTON_CONTROLS) {
    nextButtonSlot++;
  }
}

function layoutCanvasControls() {
  if (!performanceCanvas) return;

  const width = performanceCanvas.width;
  const height = performanceCanvas.height;
  const isPortrait = height > width;

  const oscillators = canvasControls.filter(c => c.type === 'oscillator');
  const effects = canvasControls.filter(c => c.type === 'effect');

  const gap = 16; // Increased gap for cleaner spacing

  if (isPortrait) {
    // Portrait: 2/3 height for oscillators (horizontal), 1/3 for effects
    const oscHeight = (height * 2 / 3);
    const fxHeight = height - oscHeight;

    // Oscillators - horizontal sliders stacked vertically
    const oscSlotHeight = (oscHeight - (oscillators.length + 1) * gap) / oscillators.length;
    oscillators.forEach((control, i) => {
      control.x = gap;
      control.y = gap + i * (oscSlotHeight + gap);
      control.width = width - gap * 2;
      control.height = oscSlotHeight;
    });

    // Effects - two rows
    // Row 1: Cutoff (full width)
    const cutoff = effects.find(e => e.id === 'filterCutoff');
    if (cutoff) {
      cutoff.x = gap;
      cutoff.y = oscHeight + gap;
      cutoff.width = width - gap * 2;
      cutoff.height = (fxHeight / 2) - gap * 1.5;
    }

    // Row 2: Three delay params horizontally
    const delayEffects = effects.filter(e => e.id !== 'filterCutoff');
    const delayWidth = (width - gap * 4) / 3;
    delayEffects.forEach((control, i) => {
      control.x = gap + i * (delayWidth + gap);
      control.y = oscHeight + (fxHeight / 2) + gap * 0.5;
      control.width = delayWidth;
      control.height = (fxHeight / 2) - gap * 1.5;
    });

  } else {
    // Landscape: 2/3 width for oscillators (vertical), 1/3 for effects
    const oscWidth = (width * 2 / 3);
    const fxWidth = width - oscWidth;

    // Oscillators - vertical sliders side by side
    const oscSlotWidth = (oscWidth - (oscillators.length + 1) * gap) / oscillators.length;
    oscillators.forEach((control, i) => {
      control.x = gap + i * (oscSlotWidth + gap);
      control.y = gap;
      control.width = oscSlotWidth;
      control.height = height - gap * 2;
    });

    // Effects - two columns
    // Column 1: Cutoff only
    const cutoff = effects.find(e => e.id === 'filterCutoff');
    if (cutoff) {
      cutoff.x = oscWidth + gap;
      cutoff.y = gap;
      cutoff.width = (fxWidth / 2) - gap * 1.5;
      cutoff.height = height - gap * 2;
    }

    // Column 2: Three delay params stacked vertically
    const delayEffects = effects.filter(e => e.id !== 'filterCutoff');
    const delayHeight = (height - gap * 4) / 3;
    delayEffects.forEach((control, i) => {
      control.x = oscWidth + (fxWidth / 2) + gap * 0.5;
      control.y = gap + i * (delayHeight + gap);
      control.width = (fxWidth / 2) - gap * 1.5;
      control.height = delayHeight;
    });
  }
}

function drawCanvas() {
  if (!performanceCtx) {
    console.log('No canvas context!');
    return;
  }

  const ctx = performanceCtx;
  const width = performanceCanvas.width;
  const height = performanceCanvas.height;
  const isPortrait = height > width;

  // Get CSS colors
  const bgTertiary = getCSSVariable('--bg-tertiary');
  const bgSecondary = getCSSVariable('--bg-secondary');
  const accentPrimary = getCSSVariable('--accent-primary');
  const borderPrimary = getCSSVariable('--border-primary');
  const textPrimary = getCSSVariable('--text-primary');

  // Clear with background color
  ctx.fillStyle = bgTertiary;
  ctx.fillRect(0, 0, width, height);

  // Draw each control
  canvasControls.forEach((control, i) => {
    drawControl(ctx, control, isPortrait);
  });
}

function drawControl(ctx, control, isPortrait) {
  const { x, y, width, height, value, min, max, logarithmic, label, formatValue } = control;

  // Get CSS colors
  const bgSecondary = getCSSVariable('--bg-secondary');
  const bgTertiary = getCSSVariable('--bg-tertiary');
  const accentPrimary = getCSSVariable('--accent-primary');
  const borderPrimary = getCSSVariable('--border-primary');
  const textPrimary = getCSSVariable('--text-primary');
  const textSecondary = getCSSVariable('--text-secondary');

  // Calculate normalized value
  let normalized;
  if (logarithmic) {
    normalized = Math.log(value / min) / Math.log(max / min);
  } else {
    normalized = (value - min) / (max - min);
  }
  normalized = Math.max(0, Math.min(1, normalized));

  // Determine orientation
  const isOscillator = control.type === 'oscillator';
  const isCutoff = control.id === 'filterCutoff';

  const isVertical = isPortrait ? false : (isOscillator || isCutoff);

  // Background
  ctx.fillStyle = isOscillator ? bgSecondary : bgTertiary;
  ctx.fillRect(x, y, width, height);

  // Fill bar with gradient effect
  const gradient = isVertical
    ? ctx.createLinearGradient(x, y + height, x, y)
    : ctx.createLinearGradient(x, y, x + width, y);

  // Parse RGB from hex
  const hex = accentPrimary.replace('#', '');
  const r = parseInt(hex.substr(0, 2), 16);
  const g = parseInt(hex.substr(2, 2), 16);
  const b = parseInt(hex.substr(4, 2), 16);

  gradient.addColorStop(0, `rgba(${r}, ${g}, ${b}, 0.70)`);
  gradient.addColorStop(1, `rgba(${r}, ${g}, ${b}, 0.90)`);

  ctx.fillStyle = gradient;

  if (isVertical) {
    const fillHeight = height * normalized;
    ctx.fillRect(x, y + height - fillHeight, width, fillHeight);
  } else {
    const fillWidth = width * normalized;
    ctx.fillRect(x, y, fillWidth, height);
  }

  // Border - rounded corners
  ctx.strokeStyle = borderPrimary;
  ctx.lineWidth = 2;
  ctx.strokeRect(x, y, width, height);

  // Text - label and value
  ctx.fillStyle = textPrimary;
  ctx.font = '500 32px Inter, -apple-system, BlinkMacSystemFont, sans-serif';
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';
  ctx.shadowColor = 'rgba(0, 0, 0, 0.3)';
  ctx.shadowBlur = 8;

  const displayText = formatValue(value);
  ctx.fillText(displayText, x + width / 2, y + height / 2 + 8);

  // Label (smaller, above value)
  ctx.font = '500 18px Inter, -apple-system, BlinkMacSystemFont, sans-serif';
  ctx.fillStyle = textSecondary;
  ctx.fillText(label, x + width / 2, y + height / 2 - 24);

  ctx.shadowBlur = 0;
}

// Check if a control is already claimed by another touch
function isControlClaimed(control) {
  for (const [touchId, touch] of activeTouches) {
    if (touch.control === control) {
      return true;
    }
  }
  return false;
}

function handleCanvasStart(e) {
  e.preventDefault();

  // Handle multiple touches
  const touches = e.type.startsWith('touch') ? Array.from(e.changedTouches) : [e];

  touches.forEach(touch => {
    const pos = getCanvasPositionFromTouch(touch);
    const control = findControlAtPosition(pos.x, pos.y);

    if (control && !isControlClaimed(control)) {
      const touchId = e.type.startsWith('touch') ? `touch-${touch.identifier}` : 'mouse';
      activeTouches.set(touchId, { control, startPos: pos });
      updateControlValue(control, pos.x, pos.y);
    }
  });
}

function handleCanvasMove(e) {
  e.preventDefault();

  // Handle multiple touches
  const touches = e.type.startsWith('touch') ? Array.from(e.changedTouches) : [e];

  touches.forEach(touch => {
    const touchId = e.type.startsWith('touch') ? `touch-${touch.identifier}` : 'mouse';
    const activeTouch = activeTouches.get(touchId);

    if (activeTouch) {
      const pos = getCanvasPositionFromTouch(touch);
      updateControlValue(activeTouch.control, pos.x, pos.y);
    }
  });
}

function handleCanvasEnd(e) {
  e.preventDefault();

  // Handle multiple touches
  const touches = e.type.startsWith('touch') ? Array.from(e.changedTouches) : [e];

  touches.forEach(touch => {
    const touchId = e.type.startsWith('touch') ? `touch-${touch.identifier}` : 'mouse';
    activeTouches.delete(touchId);
  });
}

function getCanvasPosition(e) {
  const rect = performanceCanvas.getBoundingClientRect();
  const scaleX = performanceCanvas.width / rect.width;
  const scaleY = performanceCanvas.height / rect.height;

  let clientX, clientY;
  if (e.touches && e.touches.length > 0) {
    clientX = e.touches[0].clientX;
    clientY = e.touches[0].clientY;
  } else {
    clientX = e.clientX;
    clientY = e.clientY;
  }

  return {
    x: (clientX - rect.left) * scaleX,
    y: (clientY - rect.top) * scaleY
  };
}

// New helper function to get position from a specific touch object
function getCanvasPositionFromTouch(touch) {
  const rect = performanceCanvas.getBoundingClientRect();
  const scaleX = performanceCanvas.width / rect.width;
  const scaleY = performanceCanvas.height / rect.height;

  return {
    x: (touch.clientX - rect.left) * scaleX,
    y: (touch.clientY - rect.top) * scaleY
  };
}

function findControlAtPosition(x, y) {
  return canvasControls.find(control => {
    return x >= control.x && x <= control.x + control.width &&
      y >= control.y && y <= control.y + control.height;
  });
}

function updateControlValue(control, x, y) {
  const isPortrait = performanceCanvas.height > performanceCanvas.width;
  const isOscillator = control.type === 'oscillator';
  const isCutoff = control.id === 'filterCutoff';

  // Same logic as drawControl
  const isVertical = isPortrait ? false : (isOscillator || isCutoff);

  let normalized;
  if (isVertical) {
    // Vertical: bottom = 0, top = 1
    normalized = 1 - ((y - control.y) / control.height);
  } else {
    // Horizontal: left = 0, right = 1
    normalized = (x - control.x) / control.width;
  }

  normalized = Math.max(0, Math.min(1, normalized));

  // Calculate actual value
  let value;
  if (control.logarithmic) {
    value = control.min * Math.pow(control.max / control.min, normalized);
  } else {
    value = control.min + normalized * (control.max - control.min);
  }

  // Update control
  control.value = value;
  control.onChange(value);

  // Redraw
  drawCanvas();
}

function createPerformanceButtonControl(module) {
  const wrapper = document.createElement('div');
  wrapper.style.display = 'flex';
  wrapper.style.flexDirection = 'column';
  wrapper.style.alignItems = 'center';
  wrapper.style.gap = '8px';
  wrapper.dataset.moduleId = module.id;

  const button = document.createElement('div');
  button.className = 'performance-button';
  button.textContent = '⬤';

  const label = document.createElement('div');
  label.className = 'performance-button-key';
  label.textContent = module.assignedKey ?
    (module.assignedKey === ' ' ? 'SPACE' : module.assignedKey.toUpperCase()) :
    `BTN ${module.id}`;

  wrapper.appendChild(button);
  wrapper.appendChild(label);

  const pressButton = () => {
    button.classList.add('active');
    if (workletNode) {
      workletNode.port.postMessage({
        type: 'buttonPress',
        moduleId: module.id
      });
    }
  };

  const releaseButton = () => {
    button.classList.remove('active');
    if (workletNode) {
      workletNode.port.postMessage({
        type: 'buttonRelease',
        moduleId: module.id
      });
    }
  };

  button.addEventListener('mousedown', pressButton);
  button.addEventListener('mouseup', releaseButton);
  button.addEventListener('mouseleave', releaseButton);

  button.addEventListener('touchstart', (e) => {
    e.preventDefault();
    pressButton();
  });
  button.addEventListener('touchend', (e) => {
    e.preventDefault();
    releaseButton();
  });
  button.addEventListener('touchcancel', (e) => {
    e.preventDefault();
    releaseButton();
  });

  wrapper.cleanup = () => {
    button.removeEventListener('mousedown', pressButton);
    button.removeEventListener('mouseup', releaseButton);
    button.removeEventListener('mouseleave', releaseButton);
  };

  return wrapper;
}

function cleanupPerformanceControls() {
  const buttonsContainer = document.getElementById('performance-buttons-container');

  buttonsContainer.querySelectorAll('[data-module-id]').forEach(control => {
    if (control.cleanup) {
      control.cleanup();
    }
  });

  buttonsContainer.innerHTML = '';

  // Clean up canvas
  if (performanceCanvas) {
    performanceCanvas.removeEventListener('mousedown', handleCanvasStart);
    performanceCanvas.removeEventListener('touchstart', handleCanvasStart);
  }

  // Remove document-level listeners
  document.removeEventListener('mousemove', handleCanvasMove);
  document.removeEventListener('mouseup', handleCanvasEnd);
  document.removeEventListener('touchmove', handleCanvasMove);
  document.removeEventListener('touchend', handleCanvasEnd);
  document.removeEventListener('touchcancel', handleCanvasEnd);

  canvasControls = [];
  activeTouches.clear();
}

function shuffleArray(array) {
  const shuffled = [...array];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
}

// Initialize performance mode button
document.addEventListener('DOMContentLoaded', () => {
  const performanceButton = document.getElementById('performanceButton');
  if (performanceButton) {
    performanceButton.addEventListener('click', enterPerformanceMode);
  }

  const exitButton = document.getElementById('exit-performance');
  if (exitButton) {
    exitButton.addEventListener('click', exitPerformanceMode);
    exitButton.addEventListener('touchend', (e) => {
      e.preventDefault();
      exitPerformanceMode();
    });
  }

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && performanceMode) {
      exitPerformanceMode();
    }
  });
});

// Handle window resize
window.addEventListener('resize', () => {
  if (performanceMode) {
    if (performanceCanvas && !sevenSegPerformanceMode) {
      resizePerformanceCanvas();
    }
    if (sevenSegPerformanceMode && performanceSevenSegContainer) {
      // Recalculate display sizes on resize
      // Use requestAnimationFrame to ensure layout is settled
      requestAnimationFrame(() => {
        const sevenSegModules = modules.filter(m => m.type === '7-Segment Display');
        setupPerformanceSevenSegDisplays(sevenSegModules);
      });
    }
  }
});

// Seven-segment display integration for performance mode
let performanceSevenSegDisplays = [];
let performanceSevenSegContainer = null;

function updatePerformanceRowSizeButtons() {
  // Update size buttons to show active state based on selected row's size
  const sizeControls = document.querySelector('.sevenseg-size-controls');
  if (!sizeControls) return;
  
  let currentSize = 1.0; // default
  if (selectedPerformanceRow === 'all') {
    // For 'all', check if all rows have the same size
    const layout = calculatePerformanceGridLayout(modules.filter(m => m.type === '7-Segment Display'));
    if (layout.rows > 0) {
      const firstRowSize = performanceRowSizes.get(0) || 1.0;
      let allSame = true;
      for (let i = 1; i < layout.rows; i++) {
        if ((performanceRowSizes.get(i) || 1.0) !== firstRowSize) {
          allSame = false;
          break;
        }
      }
      if (allSame) {
        currentSize = firstRowSize;
      }
    }
  } else {
    currentSize = performanceRowSizes.get(selectedPerformanceRow) || 1.0;
  }
  
  // Update active state for row-specific buttons (not canvas scale buttons)
  sizeControls.querySelectorAll('.sevenseg-size-btn').forEach(btn => {
    // Only update buttons that are NOT canvas scale buttons (data-row="all")
    if (btn.dataset.row !== 'all') {
      btn.classList.remove('active');
      if (parseFloat(btn.dataset.size) === currentSize) {
        btn.classList.add('active');
      }
    }
  });
}

function updatePerformanceCanvasScaleButtons() {
  // Update canvas scale buttons (data-row="all") to show active state
  const sizeControls = document.querySelector('.sevenseg-size-controls');
  if (!sizeControls) return;
  
  // Update active state for canvas scale buttons
  sizeControls.querySelectorAll('.sevenseg-size-btn[data-row="all"]').forEach(btn => {
    btn.classList.remove('active');
    if (parseFloat(btn.dataset.size) === performanceCanvasScale) {
      btn.classList.add('active');
    }
  });
}

function showSevenSegInPerformance() {
  if (!performanceMode) return;

  // Ensure LED update hook is installed
  setupPerformanceSevenSegLEDUpdates();

  // Show per-row control
  const perRowControl = document.getElementById('performance-sevenseg-per-row');
  if (perRowControl) perRowControl.style.display = 'flex';
  
  // Update displays-per-row button title and visual state
  const rowIconBtn = document.getElementById('performance-sevenseg-row-icon');
  if (rowIconBtn) {
    if (performanceDisplaysPerRow === 0) {
      rowIconBtn.innerHTML = 'Auto';
      rowIconBtn.classList.remove('row-selected');
      rowIconBtn.removeAttribute('data-displays-per-row');
    } else {
      rowIconBtn.innerHTML = `${performanceDisplaysPerRow}`;
      rowIconBtn.classList.add('row-selected');
      rowIconBtn.setAttribute('data-displays-per-row', performanceDisplaysPerRow);
    }
  }
  
  // Update size buttons to reflect current selection
  updatePerformanceRowSizeButtons();
  // Update canvas scale buttons
  updatePerformanceCanvasScaleButtons();

  // Hide canvas controls
  const canvasContainer = document.getElementById('performance-canvas-container');
  const buttonsContainer = document.getElementById('performance-buttons-container');
  if (canvasContainer) canvasContainer.style.display = 'none';
  if (buttonsContainer) buttonsContainer.style.display = 'none';

  // Create container for seven-seg displays if it doesn't exist
  const performanceContent = document.getElementById('performance-content');
  if (!performanceSevenSegContainer) {
    performanceSevenSegContainer = document.createElement('div');
    performanceSevenSegContainer.id = 'performance-sevenseg-container';
    // Grid layout will be set in setupPerformanceSevenSegDisplays
    performanceContent.appendChild(performanceSevenSegContainer);
  }

  // Get seven-segment display modules
  const sevenSegModules = modules.filter(m => m.type === '7-Segment Display');

  // Ensure container is visible
  if (performanceSevenSegContainer) {
    performanceSevenSegContainer.style.display = 'grid';
  }

  // Setup displays using logic from sevenseg.js
  // Use requestAnimationFrame to ensure layout is settled before calculating sizes
  requestAnimationFrame(() => {
    setupPerformanceSevenSegDisplays(sevenSegModules);
  });
}

function hideSevenSegInPerformance() {
  if (!performanceMode) return;

  // Hide per-row control
  const perRowControl = document.getElementById('performance-sevenseg-per-row');
  if (perRowControl) perRowControl.style.display = 'none';

  // Show canvas controls - always ensure they're visible regardless of previous state
  const canvasContainer = document.getElementById('performance-canvas-container');
  const buttonsContainer = document.getElementById('performance-buttons-container');
  if (canvasContainer) {
    canvasContainer.style.display = 'block';
    // Force canvas resize to ensure controls are visible
    if (performanceCanvas) {
      setTimeout(() => {
        resizePerformanceCanvas();
      }, 10);
    }
  }
  if (buttonsContainer) buttonsContainer.style.display = 'grid';

  // Hide seven-seg displays (but don't remove container, just hide it)
  if (performanceSevenSegContainer) {
    performanceSevenSegContainer.style.display = 'none';
    performanceSevenSegContainer.innerHTML = '';
  }
  performanceSevenSegDisplays = [];
}

function calculatePerformanceGridLayout(sevenSegModules) {
  // Handle empty case
  if (sevenSegModules.length === 0) {
    return { displays: [], rows: 0, cols: 0 };
  }

  // Get module positions with their canvas coordinates
  // Convert grid coordinates to pixel coordinates for proper distance calculation
  const positions = sevenSegModules.map(m => {
    const gridPos = gridToPixels(m.gridX || 0, m.gridY || 0);
    const pos = {
      module: m,
      x: gridPos.x,
      y: gridPos.y
    };
    return pos;
  });

  let displays = [];
  let rows, cols;

  if (performanceDisplaysPerRow > 0) {
    // Manual row wrapping mode
    // First, sort all positions by Y, then by X to get natural reading order
    positions.sort((a, b) => {
      const yDiff = a.y - b.y;
      if (Math.abs(yDiff) < 10) { // Essentially same Y position
        return a.x - b.x;
      }
      return yDiff;
    });

    cols = performanceDisplaysPerRow;
    rows = Math.ceil(positions.length / performanceDisplaysPerRow);

    // In manual mode, use the sorted positions directly
    positions.forEach((pos, index) => {
      displays.push({
        module: pos.module,
        row: Math.floor(index / performanceDisplaysPerRow),
        col: index % performanceDisplaysPerRow
      });
    });
  } else {
    // Auto mode - intelligently detect spatial layout based on canvas positions

    // Step 1: Sort by Y position to get a rough top-to-bottom ordering
    positions.sort((a, b) => a.y - b.y);

    // Step 2: Group positions into rows based on Y-coordinate clustering
    // Use a fixed tolerance for Y-coordinate similarity
    const Y_TOLERANCE = 100; // Displays within 100px vertically are considered same row

    const detectedRows = [];

    if (positions.length > 0) {
      let currentRow = [positions[0]];
      let currentRowY = positions[0].y;

      for (let i = 1; i < positions.length; i++) {
        const yDiff = Math.abs(positions[i].y - currentRowY);

        if (yDiff < Y_TOLERANCE) {
          // Same row - add to current row
          currentRow.push(positions[i]);
        } else {
          // New row detected - save current row and start new one
          detectedRows.push(currentRow);
          currentRow = [positions[i]];
          currentRowY = positions[i].y;
        }
      }

      // Add the last row
      if (currentRow.length > 0) {
        detectedRows.push(currentRow);
      }
    }

    // Step 3: Within each row, sort left-to-right by X position
    // This preserves the user's left-to-right arrangement
    detectedRows.forEach(row => {
      row.sort((a, b) => a.x - b.x);
    });

    // Step 4: Calculate grid dimensions
    cols = Math.max(...detectedRows.map(row => row.length));
    rows = detectedRows.length;

    // Step 5: Assign grid positions based on spatial layout
    // Each display gets placed in its detected row and column
    detectedRows.forEach((row, rowIndex) => {
      row.forEach((pos, colIndex) => {
        displays.push({
          module: pos.module,
          row: rowIndex,
          col: colIndex
        });
      });
    });

  }

  return {
    displays,
    rows,
    cols
  };
}

function setupPerformanceSevenSegDisplays(sevenSegModules) {
  if (!performanceSevenSegContainer) return;

  performanceSevenSegContainer.innerHTML = '';
  performanceSevenSegDisplays = [];

  // Calculate grid layout based on module positions
  const layout = calculatePerformanceGridLayout(sevenSegModules);

  if (layout.displays.length === 0) {
    // Show empty state message
    const emptyMessage = document.createElement('div');
    emptyMessage.className = 'performance-sevenseg-empty';
    emptyMessage.innerHTML = `
      <div class="empty-text">add 7-segment displays to your patch to view them here</div>
    `;
    performanceSevenSegContainer.appendChild(emptyMessage);
    return;
  }

  // Get actual container dimensions
  // The container will be a flex child of performance-content
  // Measure the parent container's available space
  const performanceContent = document.getElementById('performance-content');
  if (!performanceContent) return;
  
  const contentRect = performanceContent.getBoundingClientRect();
  
  // Container has 24px padding set inline in the CSS
  const containerPadding = 24;
  // Calculate available space within the container (accounting for its padding)
  // Use Math.max to ensure we don't get negative values
  const availableWidth = Math.max(100, contentRect.width - (containerPadding * 2));
  const availableHeight = Math.max(100, contentRect.height - (containerPadding * 2));

  // Calculate aspect ratio of seven-segment display (from viewBox)
  const displayAspectRatio = 306.91667 / 476.25; // width / height

  // Calculate the gap size
  const gapSize = layout.cols > 1 || layout.rows > 1 ? 20 : 0;

  // Group displays by row to handle centering and size adjustments
  const displaysByRow = new Map();
  layout.displays.forEach(displayInfo => {
    if (!displaysByRow.has(displayInfo.row)) {
      displaysByRow.set(displayInfo.row, []);
    }
    displaysByRow.get(displayInfo.row).push(displayInfo);
  });

  // Find the maximum row size multiplier across all rows
  const maxRowSizeMultiplier = layout.rows > 0 
    ? Math.max(...Array.from({ length: layout.rows }, (_, i) => performanceRowSizes.get(i) || 1.0))
    : 1.0;

  // Calculate the maximum number of columns in any row
  const maxColsInRow = Math.max(...Array.from(displaysByRow.values()).map(row => row.length));
  const effectiveCols = Math.max(layout.cols, maxColsInRow);

  // Calculate total gaps
  const totalGapHeight = (layout.rows - 1) * gapSize;
  const totalGapWidth = (effectiveCols - 1) * gapSize;

  // Calculate base display size assuming all rows are at size 1.0
  // We'll account for row size multipliers later
  const maxHeightPerRow = (availableHeight - totalGapHeight) / layout.rows;
  const maxWidthPerCol = (availableWidth - totalGapWidth) / effectiveCols;

  // Determine base size based on aspect ratio (at size 1.0)
  let baseDisplayHeight, baseDisplayWidth;

  // Calculate what height would be needed if width is limiting factor
  const heightIfWidthLimited = maxWidthPerCol / displayAspectRatio;
  // Calculate what width would be needed if height is limiting factor
  const widthIfHeightLimited = maxHeightPerRow * displayAspectRatio;

  if (heightIfWidthLimited <= maxHeightPerRow) {
    // Width is the limiting factor
    baseDisplayWidth = maxWidthPerCol;
    baseDisplayHeight = heightIfWidthLimited;
  } else {
    // Height is the limiting factor
    baseDisplayHeight = maxHeightPerRow;
    baseDisplayWidth = widthIfHeightLimited;
  }

  // Now calculate what the actual dimensions would be with real row sizes
  // and find the scale factor needed to prevent overflow
  let maxRowWidth = 0;
  let totalRowHeight = 0;

  displaysByRow.forEach((rowDisplays, rowIndex) => {
    const rowSize = performanceRowSizes.get(rowIndex) || 1.0;
    // Calculate width of this row (all displays + gaps)
    const rowWidth = rowDisplays.length * (baseDisplayWidth * rowSize) + (rowDisplays.length - 1) * gapSize;
    // Calculate height of this row
    const rowHeight = baseDisplayHeight * rowSize;
    
    maxRowWidth = Math.max(maxRowWidth, rowWidth);
    totalRowHeight += rowHeight;
  });
  // Add gaps between rows
  totalRowHeight += totalGapHeight;

  // Calculate scale factor needed to prevent overflow
  // Start at 1.0 and only scale down if needed
  let finalScaleFactor = 0.75;
  if (maxRowWidth > availableWidth) {
    finalScaleFactor = Math.min(finalScaleFactor, availableWidth / maxRowWidth);
  }
  if (totalRowHeight > availableHeight) {
    finalScaleFactor = Math.min(finalScaleFactor, availableHeight / totalRowHeight);
  }

  // Apply final scale to base dimensions
  baseDisplayWidth *= finalScaleFactor;
  baseDisplayHeight *= finalScaleFactor;

  const basePaddingForScale = containerPadding * (2 - performanceCanvasScale) / performanceCanvasScale;
  
  // Set container to use grid layout with subgrid for centering incomplete rows
  // Apply transform scale to create the scaling effect
  performanceSevenSegContainer.style.cssText = `
    flex: 1;
    display: grid;
    grid-template-columns: repeat(${effectiveCols}, auto);
    grid-template-rows: repeat(${layout.rows}, auto);
    gap: 0;
    align-items: center;
    justify-content: center;
    padding: 0;
    box-sizing: border-box;
    transform: scale(${performanceCanvasScale});
    transform-origin: center center;
  `;

  // Group displays by row and create row containers for centering incomplete rows
  const rowContainers = new Map();
  displaysByRow.forEach((rowDisplays, rowIndex) => {
    if (rowDisplays.length < effectiveCols) {
      // Create a sub-container for this row to center it
      const rowContainer = document.createElement('div');
      rowContainer.className = 'sevenseg-row-container';
      rowContainer.style.cssText = `
        grid-column: 1 / -1;
        grid-row: ${rowIndex + 1};
        display: flex;
        justify-content: center;
        align-items: center;
        gap: ${gapSize}px;
      `;
      performanceSevenSegContainer.appendChild(rowContainer);
      rowContainers.set(rowIndex, rowContainer);
    }
  });

  // Create display elements with explicit sizing
  layout.displays.forEach((displayInfo) => {
    const rowSize = performanceRowSizes.get(displayInfo.row) || 1.0; // Default to medium (1.0)
    
    // Calculate container size based on row size multiplier
    const containerWidth = baseDisplayWidth * rowSize;
    const containerHeight = baseDisplayHeight * rowSize;

    // Create outer wrapper (the "canvas" container)
    const displayWrapper = document.createElement('div');
    displayWrapper.className = 'sevenseg-display-wrapper';
    displayWrapper.style.width = `${containerWidth}px`;
    displayWrapper.style.height = `${containerHeight}px`;
    displayWrapper.style.display = 'flex';
    displayWrapper.style.alignItems = 'center';
    displayWrapper.style.justifyContent = 'center';
    displayWrapper.style.overflow = 'hidden';
    displayWrapper.style.flexShrink = '0';
    
    // Check if this row needs centering
    const rowContainer = rowContainers.get(displayInfo.row);
    if (rowContainer) {
      // Add to row container for centering
      rowContainer.appendChild(displayWrapper);
    } else {
      // Normal grid placement
      displayWrapper.style.gridColumn = displayInfo.col + 1;
      displayWrapper.style.gridRow = displayInfo.row + 1;
      performanceSevenSegContainer.appendChild(displayWrapper);
    }

    // Create inner container for the SVG (scaled proportionally with rowSize)
    // This creates the "inset canvas" effect while maintaining consistent gap widths
    const svgContainer = document.createElement('div');
    svgContainer.style.width = `${containerWidth}px`;
    svgContainer.style.height = `${containerHeight}px`;
    svgContainer.style.display = 'flex';
    svgContainer.style.alignItems = 'center';
    svgContainer.style.justifyContent = 'center';
    svgContainer.style.flexShrink = '0';
    displayWrapper.appendChild(svgContainer);

    // Create SVG at normal size - it will scale with its container
    // This ensures gap widths remain visually consistent
    const svg = createPerformanceSevenSegSVG();
    svgContainer.appendChild(svg);

    // Store reference
    performanceSevenSegDisplays.push({
      moduleId: displayInfo.module.id,
      svg: svg,
      segments: Array.from(svg.querySelectorAll('path')),
      row: displayInfo.row
    });
  });
}

function createPerformanceSevenSegSVG() {
  const svgNS = "http://www.w3.org/2000/svg";
  const svg = document.createElementNS(svgNS, 'svg');
  svg.setAttribute('viewBox', '0 0 306.91667 476.25');
  svg.style.width = '100%';
  svg.style.height = '100%';
  svg.style.display = 'block';

  const g = document.createElementNS(svgNS, 'g');
  svg.appendChild(g);

  // Segment paths from sevenseg.js
  const SEGMENT_PATHS = [
    "m 90.335771,198.81993 c -0.40438,0.50132 -0.84808,1.00717 -1.23404,1.50637 -1.06131,1.37269 -2.05311,2.73736 -2.97656,4.09484 -0.92345,1.35748 -1.77868,2.70752 -2.56625,4.05092 -0.78757,1.3434 -1.50745,2.68014 -2.16111,4.0106 -0.65366,1.33046 -1.24096,2.65475 -1.76268,3.9734 -0.52172,1.31866 -0.97819,2.63183 -1.36995,3.93982 -0.39175,1.30798 -0.71913,2.61087 -0.98288,3.90932 -0.26376,1.29845 -0.46378,2.5924 -0.60151,3.88245 -0.13773,1.29005 -0.21459,2.58007 -0.22945,3.87108 -0.0148,1.29101 0.0324,2.58324 0.14211,3.8778 0.1097,1.29455 0.28187,2.59106 0.5178,3.89175 0.23593,1.30069 0.53532,2.60559 0.89917,3.91501 0.36384,1.30942 0.79227,2.62372 1.28571,3.94446 0.49344,1.32074 1.05219,2.64754 1.6769,3.98219 0.62471,1.33464 1.3156,2.67703 2.07326,4.02817 0.49345,0.87997 1.06084,1.77036 1.61127,2.65824 1.62566,-0.72358 3.44066,-1.15549 5.43429,-1.15549 H 214.79122 c 1.67523,0 3.18131,0.28037 4.49378,0.79789 0.77859,-0.93242 1.57144,-1.86649 2.28668,-2.79156 1.06132,-1.37269 2.0536,-2.73737 2.97708,-4.09484 0.92348,-1.35748 1.77813,-2.70752 2.56574,-4.05092 0.7876,-1.3434 1.50793,-2.68015 2.16162,-4.01061 0.65369,-1.33046 1.24093,-2.65474 1.76268,-3.9734 0.52175,-1.31865 0.97817,-2.63183 1.36995,-3.93981 0.39177,-1.30798 0.71911,-2.61087 0.98288-3.90932 0.26377,-1.29845 0.46379,-2.5924 0.60151-3.88245 0.13774,-1.29005 0.21459,-2.58008 0.22945-3.87108 0.0148,-1.29101 -0.0324,-2.58325 -0.14211,-3.8778 -0.1097,-1.29456 -0.28187,-2.59106 -0.5178,-3.89175 -0.23593,-1.3007 -0.53532,-2.60559 -0.89917,-3.91501 -0.36385,-1.30942 -0.79227,-2.62373 -1.28571,-3.94446 -0.49344,-1.32074 -1.05219,-2.64754 -1.6769,-3.98219 -0.62471,-1.33464 -1.3156,-2.67703 -2.07326,-4.02818 -0.18831,-0.33581 -0.41836,-0.67747 -0.61495,-1.0144 -0.79038,0.2007 -1.62214,0.33693 -2.52853,0.33693 h -3.49591 -124.699359 -3.49384 c -0.90747,0 -1.71105,-0.1368 -2.45928,-0.33797 z",
    "m 33.016271,224.21115 h 36.25773 c 0.24226,-1.40528 0.54527,-2.80725 0.90847,-4.20647 0.3632,-1.39921 0.78655,-2.7959 1.26969,-4.1894 0.48315,-1.39351 1.02624,-2.7842 1.62833,-4.17236 0.60209,-1.38816 1.2633,-2.77369 1.98334,-4.15685 0.72004,-1.38316 1.49879,-2.76386 2.33577,-4.14238 0.83699,-1.37853 1.73217,-2.75471 2.68511,-4.12895 0.95294,-1.37424 1.96345,-2.74624 3.03134,-4.11654 0.84393,-1.08293 1.75186,-2.1641 2.66702,-3.24477 0.0102,-0.16425 -0.005,-0.31279 0.0129,-0.48162 L 98.299621,74.255961 43.863151,56.648251 c -1.83599,5.082319 -3.16268,10.35912 -3.74396,15.80369 L 27.422811,191.37181 c -1.27289,11.92255 0.89038,23.13167 5.59346,32.83934 z",
    "M 6.4597502,419.75528 63.647991,399.72653 c 0.0101,-0.37425 -0.0189,-0.72876 0.0227,-1.11828 l 13.89476,-130.14502 c 0.17336,-1.62381 0.60881,-3.11011 1.24643,-4.44418 -0.83462,-1.28542 -1.62367,-2.57335 -2.35903,-3.86384 -0.75295,-1.32137 -1.4534,-2.64529 -2.10116,-3.97134 -0.64776,-1.32605 -1.24245,-2.65416 -1.78387,-3.98425 -0.54142,-1.33009 -1.02955,-2.66213 -1.46348,-3.99562 -0.43393,-1.3335 -0.81417,-2.66867 -1.13946,-4.00493 -0.3253,-1.33625 -0.59581,-2.67326 -0.81132,-4.01164 -0.21552,-1.33838 -0.37601,-2.67798 -0.48059,-4.01784 -0.10459,-1.33986 -0.15322,-2.68024 -0.14573,-4.02094 h -34.85679 c -7.80656,10.60715 -13.0615,23.04511 -14.47818,36.31458 L 5.2975472,398.60825 c -0.785631,7.35862 -0.32282,14.45977 1.162203,21.14703 z",
    "m 214.88992,464.17066 -11.37657,-55.25916 c -1.51928,0.60806 -3.19983,0.95705 -5.0214,0.95705 H 73.792591 c -3.12523,0 -5.63659,-0.99538 -7.40472,-2.69131 L 8.7123262,427.37549 c 8.5838578,23.77164 31.0707148,40.53809 58.8832248,40.53809 H 192.29492 c 7.74686,0 15.34259,-1.35611 22.595,-3.74292 z",
    "m 276.56419,232.14865 h -35.29242 c -0.25979,1.36967 -0.57774,2.73657 -0.95291,4.10052 -0.37517,1.36395 -0.80759,2.72492 -1.29708,4.08347 -0.48949,1.35856 -1.03593,2.71447 -1.63866,4.06797 -0.60273,1.3535 -1.26171,2.70472 -1.97662,4.0535 -0.71491,1.34878 -1.48547,2.69515 -2.31149,4.03955 -0.82602,1.3444 -1.70771,2.68679 -2.64377,4.02714 -1.74367,2.49679 -3.71874,4.9854 -5.83892,7.46983 0.35872,1.34087 0.47736,2.83785 0.30283,4.4726 l -13.89476,130.14502 c -0.12897,1.20793 -0.44043,2.31415 -0.83148,3.3662 l 12.20339,59.26977 c 24.85444,-11.15546 44.06757,-35.15755 47.00127,-62.63597 l 13.89476,-130.14502 c 1.41668,-13.26944 -1.18246,-25.70744 -6.72414,-36.31458 z",
    "m 245.79242,72.914961 -12.64677,118.456849 c -0.0644,0.60341 -0.17289,1.17757 -0.32246,1.72082 0.4906,0.79557 1.00224,1.59 1.45469,2.38745 0.76903,1.35543 1.483,2.71333 2.14096,4.07366 0.65796,1.36033 1.2603,2.72306 1.80609,4.0876 0.54579,1.36454 1.03508,2.73092 1.46761,4.09898 0.43252,1.36806 0.80786,2.7379 1.12603,4.10879 0.31816,1.37089 0.57915,2.743 0.78186,4.11603 0.20271,1.37302 0.34741,2.74672 0.43357,4.12119 0.0861,1.37448 0.11366,2.74959 0.0822,4.12482 h 36.79621 c 6.77594,-9.70772 11.33359,-20.91699 12.60646,-32.83934 L 304.21521,72.451941 C 307.0477,45.921454 293.15803,22.756706 271.17227,12.40444 Z",
    "m 263.78667,9.4883385 c -5.85447,-1.8478 -12.13953,-2.865458 -18.74665,-2.865458 H 113.35038 c -27.999869,0 -54.164889,17.9237745 -66.369069,42.6909345 l 54.149659,17.515206 c 1.50236,-1.38786 3.56036,-2.16266 6.02289,-2.16266 h 131.68912 c 0.61689,0 1.19669,0.0507 1.74098,0.1447 z"
  ];

  SEGMENT_PATHS.forEach((pathData, i) => {
    const path = document.createElementNS(svgNS, 'path');
    path.setAttribute('d', pathData);
    path.style.fill = 'var(--led-off)';
    path.style.transition = 'fill 0.05s';
    path.dataset.segmentIndex = i;
    g.appendChild(path);
  });

  return svg;
}

// Hook into LED update system for performance mode seven-seg
let performanceSevenSegLEDHookInstalled = false;

function setupPerformanceSevenSegLEDUpdates() {
  if (performanceSevenSegLEDHookInstalled) {
    return;
  }

  if (typeof workletNode !== 'undefined' && workletNode && workletNode.port) {
    const originalHandler = workletNode.port.onmessage;

    workletNode.port.onmessage = function (event) {
      // Call original handler first with proper context
      if (originalHandler) {
        originalHandler.call(this, event);
      }

      // Handle performance seven-seg updates
      const { ledData } = event.data;
      if (ledData && Array.isArray(ledData) && performanceMode && sevenSegPerformanceMode) {
        updatePerformanceSevenSegDisplays(ledData);
      }
    };

    performanceSevenSegLEDHookInstalled = true;
  }
}

// Update performance seven-seg displays based on LED states
function updatePerformanceSevenSegDisplays(ledData) {
  if (!performanceMode || !sevenSegPerformanceMode) return;

  // Use same segment mapping as sevenseg.js
  const SEGMENT_ORDER = ['g', 'f', 'e', 'd', 'c', 'b', 'a'];
  const PATH_TO_INPUT = { 'a': 0, 'b': 1, 'c': 2, 'd': 3, 'e': 4, 'f': 5, 'g': 6 };

  ledData.forEach(led => {
    const display = performanceSevenSegDisplays.find(d => d.moduleId === led.moduleId);
    if (display && led.outputIndex < 7) {
      const segmentName = SEGMENT_ORDER.find((name, idx) =>
        PATH_TO_INPUT[name] === led.outputIndex
      );

      if (segmentName) {
        const pathIndex = SEGMENT_ORDER.indexOf(segmentName);
        const segment = display.segments[pathIndex];
        if (segment) {
          segment.style.fill = led.state ? 'var(--led-on)' : 'var(--led-off)';
        }
      }
    }
  });
}

// Try to setup immediately if workletNode already exists
if (typeof workletNode !== 'undefined' && workletNode) {
  setupPerformanceSevenSegLEDUpdates();
}

// Also setup when audio is started
window.addEventListener('load', () => {
  setTimeout(() => {
    if (typeof workletNode !== 'undefined' && workletNode) {
      setupPerformanceSevenSegLEDUpdates();
    }
  }, 1500); // Slightly later than sevenseg.js
});

// sevenseg.js
// Seven-Segment Display Mode Implementation

// Mode state
let sevenSegMode = false;
let sevenSegDisplays = [];
let sevenSegContainer = null;
let displaysPerRow = 0; // 0 = auto (based on spatial layout)

// SVG segment paths (same as in moduleUI.js)
const SEGMENT_PATHS = [
  "m 90.335771,198.81993 c -0.40438,0.50132 -0.84808,1.00717 -1.23404,1.50637 -1.06131,1.37269 -2.05311,2.73736 -2.97656,4.09484 -0.92345,1.35748 -1.77868,2.70752 -2.56625,4.05092 -0.78757,1.3434 -1.50745,2.68014 -2.16111,4.0106 -0.65366,1.33046 -1.24096,2.65475 -1.76268,3.9734 -0.52172,1.31866 -0.97819,2.63183 -1.36995,3.93982 -0.39175,1.30798 -0.71913,2.61087 -0.98288,3.90932 -0.26376,1.29845 -0.46378,2.5924 -0.60151,3.88245 -0.13773,1.29005 -0.21459,2.58007 -0.22945,3.87108 -0.0148,1.29101 0.0324,2.58324 0.14211,3.8778 0.1097,1.29455 0.28187,2.59106 0.5178,3.89175 0.23593,1.30069 0.53532,2.60559 0.89917,3.91501 0.36384,1.30942 0.79227,2.62372 1.28571,3.94446 0.49344,1.32074 1.05219,2.64754 1.6769,3.98219 0.62471,1.33464 1.3156,2.67703 2.07326,4.02817 0.49345,0.87997 1.06084,1.77036 1.61127,2.65824 1.62566,-0.72358 3.44066,-1.15549 5.43429,-1.15549 H 214.79122 c 1.67523,0 3.18131,0.28037 4.49378,0.79789 0.77859,-0.93242 1.57144,-1.86649 2.28668,-2.79156 1.06132,-1.37269 2.0536,-2.73737 2.97708,-4.09484 0.92348,-1.35748 1.77813,-2.70752 2.56574,-4.05092 0.7876,-1.3434 1.50793,-2.68015 2.16162,-4.01061 0.65369,-1.33046 1.24093,-2.65474 1.76268,-3.9734 0.52175,-1.31865 0.97817,-2.63183 1.36995,-3.93981 0.39177,-1.30798 0.71911,-2.61087 0.98288-3.90932 0.26377,-1.29845 0.46379,-2.5924 0.60151,-3.88245 0.13774,-1.29005 0.21459,-2.58008 0.22945,-3.87108 0.0148,-1.29101 -0.0324,-2.58325 -0.14211,-3.8778 -0.1097,-1.29456 -0.28187,-2.59106 -0.5178,-3.89175 -0.23593,-1.3007 -0.53532,-2.60559 -0.89917,-3.91501 -0.36385,-1.30942 -0.79227,-2.62373 -1.28571,-3.94446 -0.49344,-1.32074 -1.05219,-2.64754 -1.6769,-3.98219 -0.62471,-1.33464 -1.3156,-2.67703 -2.07326,-4.02818 -0.18831,-0.33581 -0.41836,-0.67747 -0.61495,-1.0144 -0.79038,0.2007 -1.62214,0.33693 -2.52853,0.33693 h -3.49591 -124.699359 -3.49384 c -0.90747,0 -1.71105,-0.1368 -2.45928,-0.33797 z",
  "m 33.016271,224.21115 h 36.25773 c 0.24226,-1.40528 0.54527,-2.80725 0.90847,-4.20647 0.3632,-1.39921 0.78655,-2.7959 1.26969,-4.1894 0.48315,-1.39351 1.02624,-2.7842 1.62833,-4.17236 0.60209,-1.38816 1.2633,-2.77369 1.98334,-4.15685 0.72004,-1.38316 1.49879,-2.76386 2.33577,-4.14238 0.83699,-1.37853 1.73217,-2.75471 2.68511,-4.12895 0.95294,-1.37424 1.96345,-2.74624 3.03134,-4.11654 0.84393,-1.08293 1.75186,-2.1641 2.66702,-3.24477 0.0102,-0.16425 -0.005,-0.31279 0.0129,-0.48162 L 98.299621,74.255961 43.863151,56.648251 c -1.83599,5.082319 -3.16268,10.35912 -3.74396,15.80369 L 27.422811,191.37181 c -1.27289,11.92255 0.89038,23.13167 5.59346,32.83934 z",
  "M 6.4597502,419.75528 63.647991,399.72653 c 0.0101,-0.37425 -0.0189,-0.72876 0.0227,-1.11828 l 13.89476,-130.14502 c 0.17336,-1.62381 0.60881,-3.11011 1.24643,-4.44418 -0.83462,-1.28542 -1.62367,-2.57335 -2.35903,-3.86384 -0.75295,-1.32137 -1.4534,-2.64529 -2.10116,-3.97134 -0.64776,-1.32605 -1.24245,-2.65416 -1.78387,-3.98425 -0.54142,-1.33009 -1.02955,-2.66213 -1.46348,-3.99562 -0.43393,-1.3335 -0.81417,-2.66867 -1.13946,-4.00493 -0.3253,-1.33625 -0.59581,-2.67326 -0.81132,-4.01164 -0.21552,-1.33838 -0.37601,-2.67798 -0.48059,-4.01784 -0.10459,-1.33986 -0.15322,-2.68024 -0.14573,-4.02094 h -34.85679 c -7.80656,10.60715 -13.0615,23.04511 -14.47818,36.31458 L 5.2975472,398.60825 c -0.785631,7.35862 -0.32282,14.45977 1.162203,21.14703 z",
  "m 214.88992,464.17066 -11.37657,-55.25916 c -1.51928,0.60806 -3.19983,0.95705 -5.0214,0.95705 H 73.792591 c -3.12523,0 -5.63659,-0.99538 -7.40472,-2.69131 L 8.7123262,427.37549 c 8.5838578,23.77164 31.0707148,40.53809 58.8832248,40.53809 H 192.29492 c 7.74686,0 15.34259,-1.35611 22.595,-3.74292 z",
  "m 276.56419,232.14865 h -35.29242 c -0.25979,1.36967 -0.57774,2.73657 -0.95291,4.10052 -0.37517,1.36395 -0.80759,2.72492 -1.29708,4.08347 -0.48949,1.35856 -1.03593,2.71447 -1.63866,4.06797 -0.60273,1.3535 -1.26171,2.70472 -1.97662,4.0535 -0.71491,1.34878 -1.48547,2.69515 -2.31149,4.03955 -0.82602,1.3444 -1.70771,2.68679 -2.64377,4.02714 -1.74367,2.49679 -3.71874,4.9854 -5.83892,7.46983 0.35872,1.34087 0.47736,2.83785 0.30283,4.4726 l -13.89476,130.14502 c -0.12897,1.20793 -0.44043,2.31415 -0.83148,3.3662 l 12.20339,59.26977 c 24.85444,-11.15546 44.06757,-35.15755 47.00127,-62.63597 l 13.89476,-130.14502 c 1.41668,-13.26944 -1.18246,-25.70744 -6.72414,-36.31458 z",
  "m 245.79242,72.914961 -12.64677,118.456849 c -0.0644,0.60341 -0.17289,1.17757 -0.32246,1.72082 0.4906,0.79557 1.00224,1.59 1.45469,2.38745 0.76903,1.35543 1.483,2.71333 2.14096,4.07366 0.65796,1.36033 1.2603,2.72306 1.80609,4.0876 0.54579,1.36454 1.03508,2.73092 1.46761,4.09898 0.43252,1.36806 0.80786,2.7379 1.12603,4.10879 0.31816,1.37089 0.57915,2.743 0.78186,4.11603 0.20271,1.37302 0.34741,2.74672 0.43357,4.12119 0.0861,1.37448 0.11366,2.74959 0.0822,4.12482 h 36.79621 c 6.77594,-9.70772 11.33359,-20.91699 12.60646,-32.83934 L 304.21521,72.451941 C 307.0477,45.921454 293.15803,22.756706 271.17227,12.40444 Z",
  "m 263.78667,9.4883385 c -5.85447,-1.8478 -12.13953,-2.865458 -18.74665,-2.865458 H 113.35038 c -27.999869,0 -54.164889,17.9237745 -66.369069,42.6909345 l 54.149659,17.515206 c 1.50236,-1.38786 3.56036,-2.16266 6.02289,-2.16266 h 131.68912 c 0.61689,0 1.19669,0.0507 1.74098,0.1447 z"
];

// Segment order mapping (SVG path index to segment name)
const SEGMENT_ORDER = ['g', 'f', 'e', 'd', 'c', 'b', 'a'];
const PATH_TO_INPUT = { 'a': 0, 'b': 1, 'c': 2, 'd': 3, 'e': 4, 'f': 5, 'g': 6 };

// Get CSS variable values
function getCSSVariable(name) {
  return getComputedStyle(document.documentElement).getPropertyValue(name).trim();
}

function enterSevenSegMode() {
  sevenSegMode = true;

  // Find all seven-segment display modules
  const sevenSegModules = modules.filter(m => m.type === '7-Segment Display');

  // if (sevenSegModules.length === 0) {
  //   showAlert('No seven-segment displays found in the current patch.');
  //   sevenSegMode = false;
  //   return;
  // }

  // Hide main UI elements
  document.getElementById('topBar').style.display = 'none';
  if (document.getElementById('mobile-edit-bar')) {
    document.getElementById('mobile-edit-bar').style.display = 'none';
  }
  if (document.querySelector('.mobile-fab-container')) {
    document.querySelector('.mobile-fab-container').style.display = 'none';
  }
  if (document.getElementById('mobile-audio-fab')) {
    document.getElementById('mobile-audio-fab').style.display = 'none';
  }

  // Hide all modules and wires
  document.querySelectorAll('.module').forEach(el => el.style.display = 'none');
  document.querySelectorAll('canvas:not(.sevenseg-canvas)').forEach(el => el.style.display = 'none');


  // Ensure LED update hook is installed
  setupSevenSegLEDUpdates();

  // Show overlay
  document.getElementById('sevenseg-overlay').style.display = 'flex';

  // Setup seven-segment displays
  setupSevenSegDisplays(sevenSegModules);
}

function exitSevenSegMode() {
  sevenSegMode = false;

  // Clean up displays
  cleanupSevenSegDisplays();

  // Hide overlay
  document.getElementById('sevenseg-overlay').style.display = 'none';

  // Show main UI elements
  document.getElementById('topBar').style.display = 'flex';
  if (document.getElementById('mobile-edit-bar')) {
    document.getElementById('mobile-edit-bar').style.display = 'flex';
  }
  if (document.querySelector('.mobile-fab-container')) {
    document.querySelector('.mobile-fab-container').style.display = 'flex';
  }
  if (document.getElementById('mobile-audio-fab')) {
    document.getElementById('mobile-audio-fab').style.display = 'flex';
  }

  // Show all modules and wires
  document.querySelectorAll('.module').forEach(el => el.style.display = 'block');
  document.querySelectorAll('canvas').forEach(el => el.style.display = 'block');

  // Redraw wires
  drawWires();
}

function setupSevenSegDisplays(sevenSegModules) {
  sevenSegContainer = document.getElementById('sevenseg-grid-container');
  sevenSegContainer.innerHTML = '';
  sevenSegDisplays = [];

  // Calculate grid layout based on module positions
  const layout = calculateGridLayout(sevenSegModules);

  // Calculate available space with accurate header measurement
  const header = document.getElementById('sevenseg-header');
  const headerHeight = header ? header.getBoundingClientRect().height : 60;
  const contentPadding = 48; // Total padding (24px top + 24px bottom from CSS)
  const safetyBuffer = 60; // Extra buffer to prevent overflow

  const availableHeight = window.innerHeight - headerHeight - contentPadding - safetyBuffer;
  const availableWidth = window.innerWidth - contentPadding;

  // Calculate aspect ratio of seven-segment display (from viewBox)
  const displayAspectRatio = 306.91667 / 476.25; // width / height

  // Calculate the gap size
  const gapSize = layout.cols > 1 || layout.rows > 1 ? 20 : 0;
  const totalGapHeight = (layout.rows - 1) * gapSize;
  const totalGapWidth = (layout.cols - 1) * gapSize;

  // Calculate max dimensions per display to fit all rows
  const maxHeightPerDisplay = (availableHeight - totalGapHeight) / layout.rows;
  const maxWidthPerDisplay = (availableWidth - totalGapWidth) / layout.cols;

  // Determine actual size based on aspect ratio constraints
  let displayWidth, displayHeight;

  const heightBasedWidth = maxHeightPerDisplay * displayAspectRatio;
  const widthBasedHeight = maxWidthPerDisplay / displayAspectRatio;

  if (heightBasedWidth <= maxWidthPerDisplay) {
    // Height is the limiting factor
    displayHeight = maxHeightPerDisplay;
    displayWidth = heightBasedWidth;
  } else {
    // Width is the limiting factor
    displayWidth = maxWidthPerDisplay;
    displayHeight = widthBasedHeight;
  }

  // Create display elements with explicit sizing
  layout.displays.forEach((displayInfo, index) => {
    const displayWrapper = document.createElement('div');
    displayWrapper.className = 'sevenseg-display-wrapper';
    displayWrapper.style.gridColumn = displayInfo.col + 1;
    displayWrapper.style.gridRow = displayInfo.row + 1;

    // Apply explicit size to each wrapper
    displayWrapper.style.width = `${displayWidth}px`;
    displayWrapper.style.height = `${displayHeight}px`;

    // Create SVG
    const svg = createSevenSegSVG();
    displayWrapper.appendChild(svg);

    sevenSegContainer.appendChild(displayWrapper);

    // Store reference
    sevenSegDisplays.push({
      moduleId: displayInfo.module.id,
      svg: svg,
      segments: Array.from(svg.querySelectorAll('path'))
    });
  });

  // Set grid template with auto sizing (wrappers now have explicit sizes)
  sevenSegContainer.style.gridTemplateColumns = `repeat(${layout.cols}, auto)`;
  sevenSegContainer.style.gridTemplateRows = `repeat(${layout.rows}, auto)`;
  sevenSegContainer.style.gap = `${gapSize}px`;
}

function calculateGridLayout(sevenSegModules) {
  // Handle empty case
  if (sevenSegModules.length === 0) {
    return { displays: [], rows: 0, cols: 0 };
  }

  // Get module positions with their canvas coordinates
  // Convert grid coordinates to pixel coordinates for proper distance calculation
  const positions = sevenSegModules.map(m => {
    const gridPos = gridToPixels(m.gridX || 0, m.gridY || 0);
    const pos = {
      module: m,
      x: gridPos.x,
      y: gridPos.y
    };
    return pos;
  });

  let displays = [];
  let rows, cols;

  if (displaysPerRow > 0) {
    // Manual row wrapping mode
    // First, sort all positions by Y, then by X to get natural reading order
    positions.sort((a, b) => {
      const yDiff = a.y - b.y;
      if (Math.abs(yDiff) < 10) { // Essentially same Y position
        return a.x - b.x;
      }
      return yDiff;
    });

    cols = displaysPerRow;
    rows = Math.ceil(positions.length / displaysPerRow);

    // In manual mode, use the sorted positions directly
    positions.forEach((pos, index) => {
      displays.push({
        module: pos.module,
        row: Math.floor(index / displaysPerRow),
        col: index % displaysPerRow
      });
    });
  } else {
    // Auto mode - intelligently detect spatial layout based on canvas positions

    // Step 1: Sort by Y position to get a rough top-to-bottom ordering
    positions.sort((a, b) => a.y - b.y);

    // Step 2: Group positions into rows based on Y-coordinate clustering
    // Use a fixed tolerance for Y-coordinate similarity
    const Y_TOLERANCE = 100; // Displays within 100px vertically are considered same row

    const detectedRows = [];

    if (positions.length > 0) {
      let currentRow = [positions[0]];
      let currentRowY = positions[0].y;

      for (let i = 1; i < positions.length; i++) {
        const yDiff = Math.abs(positions[i].y - currentRowY);

        if (yDiff < Y_TOLERANCE) {
          // Same row - add to current row
          currentRow.push(positions[i]);
        } else {
          // New row detected - save current row and start new one
          detectedRows.push(currentRow);
          currentRow = [positions[i]];
          currentRowY = positions[i].y;
        }
      }

      // Add the last row
      if (currentRow.length > 0) {
        detectedRows.push(currentRow);
      }
    }

    // Step 3: Within each row, sort left-to-right by X position
    // This preserves the user's left-to-right arrangement
    detectedRows.forEach(row => {
      row.sort((a, b) => a.x - b.x);
    });

    // Step 4: Calculate grid dimensions
    cols = Math.max(...detectedRows.map(row => row.length));
    rows = detectedRows.length;

    // Step 5: Assign grid positions based on spatial layout
    // Each display gets placed in its detected row and column
    detectedRows.forEach((row, rowIndex) => {
      row.forEach((pos, colIndex) => {
        displays.push({
          module: pos.module,
          row: rowIndex,
          col: colIndex
        });
      });
    });

  }

  return {
    displays,
    rows,
    cols
  };
}

function createSevenSegSVG() {
  const svgNS = "http://www.w3.org/2000/svg";
  const svg = document.createElementNS(svgNS, 'svg');
  svg.setAttribute('viewBox', '0 0 306.91667 476.25');
  svg.classList.add('sevenseg-svg');

  const g = document.createElementNS(svgNS, 'g');
  svg.appendChild(g);

  // Create segment paths
  SEGMENT_PATHS.forEach((pathData, i) => {
    const path = document.createElementNS(svgNS, 'path');
    path.setAttribute('d', pathData);
    path.style.fill = 'var(--led-off)';
    path.style.transition = 'fill 0.05s';
    path.dataset.segmentIndex = i;
    g.appendChild(path);
  });

  return svg;
}

function cleanupSevenSegDisplays() {
  if (sevenSegContainer) {
    sevenSegContainer.innerHTML = '';
  }
  sevenSegDisplays = [];
}

// Update display based on LED states
function updateSevenSegDisplays(ledData) {
  if (!sevenSegMode) return;

  ledData.forEach(led => {
    const display = sevenSegDisplays.find(d => d.moduleId === led.moduleId);
    if (display && led.outputIndex < 7) {
      const segmentName = SEGMENT_ORDER.find((name, idx) =>
        PATH_TO_INPUT[name] === led.outputIndex
      );

      if (segmentName) {
        const pathIndex = SEGMENT_ORDER.indexOf(segmentName);
        const segment = display.segments[pathIndex];
        if (segment) {
          segment.style.fill = led.state ? 'var(--led-on)' : 'var(--led-off)';
        }
      }
    }
  });
}

// Initialize event listeners
document.addEventListener('DOMContentLoaded', () => {
  const sevenSegButton = document.getElementById('sevenSegButton');
  if (sevenSegButton) {
    sevenSegButton.addEventListener('click', enterSevenSegMode);
  }

  const exitButton = document.getElementById('exit-sevenseg');
  if (exitButton) {
    exitButton.addEventListener('click', exitSevenSegMode);
    exitButton.addEventListener('touchend', (e) => {
      e.preventDefault();
      exitSevenSegMode();
    });
  }

  // Displays-per-row control
  const perRowSelect = document.getElementById('sevenseg-per-row');
  if (perRowSelect) {
    perRowSelect.addEventListener('change', (e) => {
      displaysPerRow = parseInt(e.target.value);

      // Re-setup displays if in seven-seg mode
      if (sevenSegMode) {
        const sevenSegModules = modules.filter(m => m.type === '7-Segment Display');
        setupSevenSegDisplays(sevenSegModules);
      }
    });
  }

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && sevenSegMode) {
      exitSevenSegMode();
    }
  });

  // Handle window resize to recalculate display sizes
  let resizeTimeout;
  window.addEventListener('resize', () => {
    if (!sevenSegMode) return;

    // Debounce resize events
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      const sevenSegModules = modules.filter(m => m.type === '7-Segment Display');
      setupSevenSegDisplays(sevenSegModules);
    }, 100);
  });
});

// Hook into LED update system by extending the worklet message handler
// This will be called after the workletNode is created in main.js
let sevenSegLEDHookInstalled = false;

function setupSevenSegLEDUpdates() {
  if (sevenSegLEDHookInstalled) {
    return; // Already installed
  }

  if (typeof workletNode !== 'undefined' && workletNode && workletNode.port) {
    const originalHandler = workletNode.port.onmessage;

    workletNode.port.onmessage = function (event) {
      // Call original handler first with proper context
      if (originalHandler) {
        originalHandler.call(this, event);
      }

      // Then handle seven-seg updates
      const { ledData } = event.data;
      if (ledData && Array.isArray(ledData)) {
        if (sevenSegMode) {
          updateSevenSegDisplays(ledData);
        }
        // Also update performance mode displays if active
        if (typeof updatePerformanceSevenSegDisplays === 'function') {
          updatePerformanceSevenSegDisplays(ledData);
        }
      }
    };

    sevenSegLEDHookInstalled = true;
  } else {
    console.log('[SevenSeg] workletNode not available yet');
  }
}

// Try to setup immediately if workletNode already exists
if (typeof workletNode !== 'undefined' && workletNode) {
  setupSevenSegLEDUpdates();
}

// Also setup when audio is started (workletNode is created)
window.addEventListener('load', () => {
  // Wait a bit for audio initialization
  setTimeout(() => {
    if (typeof workletNode !== 'undefined' && workletNode) {
      setupSevenSegLEDUpdates();
    }
  }, 1000);
});


// mobile.js
// Mobile UI handlers

let updateButtonsTimeout = null;
let isUpdatingButtons = false;

function throttledUpdateMobileEditBarButtons() {
  if (isUpdatingButtons) return;

  if (updateButtonsTimeout) clearTimeout(updateButtonsTimeout);

  updateButtonsTimeout = setTimeout(() => {
    isUpdatingButtons = true;
    updateMobileEditBarButtons();
    isUpdatingButtons = false;
  }, 150); // Only update every 150ms max
}

function closeMobileModuleMenu() {
  document.getElementById('mobile-module-menu').classList.remove('open');
  document.getElementById('mobile-add-module-fab').classList.remove('active');
}

function closeMobileUtilityMenu() {
  document.getElementById('mobile-utility-menu').classList.remove('open');
  document.getElementById('mobile-utility-fab').classList.remove('active');
}

// Add mobile FAB event listeners when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  // Module menu FAB
  const addModuleFab = document.getElementById('mobile-add-module-fab');
  const moduleMenu = document.getElementById('mobile-module-menu');

  if (addModuleFab) {
    addModuleFab.addEventListener('click', () => {
      const isOpen = moduleMenu.classList.contains('open');
      if (isOpen) {
        closeMobileModuleMenu();
      } else {
        closeMobileUtilityMenu(); // Close other menu
        moduleMenu.classList.add('open');
        addModuleFab.classList.add('active');
        // Check scroll indicators when menu opens
        if (window.updateMobileScrollIndicators) {
          setTimeout(window.updateMobileScrollIndicators, 100);
        }
      }
    });
  }

  // Utility menu FAB
  const utilityFab = document.getElementById('mobile-utility-fab');
  const utilityMenu = document.getElementById('mobile-utility-menu');

  if (utilityFab) {
    utilityFab.addEventListener('click', () => {
      const isOpen = utilityMenu.classList.contains('open');
      if (isOpen) {
        closeMobileUtilityMenu();
      } else {
        closeMobileModuleMenu(); // Close other menu
        utilityMenu.classList.add('open');
        utilityFab.classList.add('active');
      }
    });
  }

  // Audio FAB
  const audioFab = document.getElementById('mobile-audio-fab');
  if (audioFab) {
    audioFab.addEventListener('click', toggleAudio);
  }

  const performanceFab = document.getElementById('mobile-performance-fab');
  if (performanceFab) {
    performanceFab.addEventListener('click', enterPerformanceMode);
  }

  // Close menus when clicking outside
  document.addEventListener('click', (e) => {
    if (!e.target.closest('#mobile-module-menu') &&
      !e.target.closest('#mobile-add-module-fab')) {
      closeMobileModuleMenu();
    }
    if (!e.target.closest('#mobile-utility-menu') &&
      !e.target.closest('#mobile-utility-fab')) {
      closeMobileUtilityMenu();
    }
  });

  // Update mobile edit bar button states
  const observer = new MutationObserver((mutations) => {
    // Only update if the mutation is not from our own mobile edit bar changes
    const isFromMobileEditBar = mutations.some(mutation =>
      mutation.target.closest('#mobile-edit-bar')
    );

    if (!isFromMobileEditBar) {
      throttledUpdateMobileEditBarButtons();
    }
  });


  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class']
  });

  // Initialize mobile scroll indicators (only if on mobile)
  initializeMobileScrollIndicators();
});

// Add this to mobile-ui.js, after the DOMContentLoaded event listener

// // Handle window resize to properly show/hide mobile/desktop UI
// let resizeTimeout;
// window.addEventListener('resize', () => {
//   clearTimeout(resizeTimeout);
//   resizeTimeout = setTimeout(() => {
//     const isMobile = window.innerWidth <= 1000;
    
//     if (isMobile) {
//       // Close desktop menus when switching to mobile
//       const controlsContainer = document.getElementById('controls-container');
//       if (controlsContainer && controlsContainer.classList.contains('expanded')) {
//         controlsContainer.classList.remove('expanded');
//         const toggleButton = document.getElementById('toggle-controls');
//         if (toggleButton) toggleButton.textContent = '+';
//       }
      
//       // Ensure mobile FABs are visible
//       const fabContainer = document.querySelector('.mobile-fab-container');
//       if (fabContainer) {
//         fabContainer.style.display = 'flex';
//       }
      
//       // Close any open mobile menus
//       closeMobileModuleMenu();
//       closeMobileUtilityMenu();
//     } else {
//       // Hide mobile FABs when switching to desktop
//       const fabContainer = document.querySelector('.mobile-fab-container');
//       if (fabContainer) {
//         fabContainer.style.display = 'none';
//       }
      
//       // Close mobile menus
//       closeMobileModuleMenu();
//       closeMobileUtilityMenu();
//     }
    
//     // Redraw wires after resize
//     if (typeof requestWireRedraw === 'function') {
//       requestWireRedraw();
//     }
//   }, 150); // Debounce resize events
// });

// Mobile scroll indicators function
function initializeMobileScrollIndicators() {
  const mobileModuleMenu = document.getElementById('mobile-module-menu');
  const mobileMenuContent = mobileModuleMenu?.querySelector('.mobile-menu-content');

  if (!mobileModuleMenu || !mobileMenuContent) {
    return; // Silently fail if elements don't exist
  }

  function updateMobileScrollIndicators() {
    if (!mobileMenuContent) return;

    const scrollTop = mobileMenuContent.scrollTop;
    const scrollHeight = mobileMenuContent.scrollHeight;
    const clientHeight = mobileMenuContent.clientHeight;
    const scrollBottom = scrollHeight - scrollTop - clientHeight;

    // Show top indicator if scrolled down (not at top)
    if (scrollTop > 20) {
      mobileModuleMenu.classList.add('scrolled-top');
    } else {
      mobileModuleMenu.classList.remove('scrolled-top');
    }

    // Show bottom indicator if there's more content below
    if (scrollBottom > 20) {
      mobileModuleMenu.classList.add('scrolled-bottom');
    } else {
      mobileModuleMenu.classList.remove('scrolled-bottom');
    }
  }

  // Listen for scroll events
  mobileMenuContent.addEventListener('scroll', updateMobileScrollIndicators);

  // Check initially
  updateMobileScrollIndicators();

  // Make function available globally for the menu open handler
  window.updateMobileScrollIndicators = updateMobileScrollIndicators;
}

function updateMobileEditBarButtons() {
  if (window.innerWidth <= 768) {
    const editBar = document.getElementById('mobile-edit-bar');
    if (!editBar) return;

    // Sync disabled states from desktop buttons
    const buttons = [
      { mobile: editBar.children[3], desktop: document.getElementById('cutButton') },
      { mobile: editBar.children[4], desktop: document.getElementById('copyButton') },
      { mobile: editBar.children[5], desktop: document.getElementById('pasteButton') },
      { mobile: editBar.children[6], desktop: document.getElementById('deleteButton') }
    ];

    buttons.forEach(({ mobile, desktop }) => {
      if (mobile && desktop) {
        if (desktop.classList.contains('disabled')) {
          mobile.classList.add('disabled');
        } else {
          mobile.classList.remove('disabled');
        }
      }
    });

    // Sync active states for select/marquee and paste tools
    const selectButton = document.getElementById('selectButton');
    const pasteButton = document.getElementById('pasteButton');
    const mobileSelectButton = editBar.children[2]; // Select button (index 2)
    const mobilePasteButton = editBar.children[5]; // Paste button (index 5)

    // Sync select button active state
    if (selectButton && mobileSelectButton) {
      if (selectButton.classList.contains('active')) {
        mobileSelectButton.classList.add('active');
      } else {
        mobileSelectButton.classList.remove('active');
      }
    }

    // Sync paste button active state
    if (pasteButton && mobilePasteButton) {
      if (pasteButton.classList.contains('active')) {
        mobilePasteButton.classList.add('active');
      } else {
        mobilePasteButton.classList.remove('active');
      }
    }

    // Sync undo/redo button disabled states
    const undoButton = editBar.children[0]; // Undo button (index 0)
    const redoButton = editBar.children[1]; // Redo button (index 1)

    // Check if undo/redo stacks are empty to determine disabled state
    if (undoButton) {
      if (undoStack.length === 0) {
        undoButton.classList.add('undoDisabled');
      } else {
        undoButton.classList.remove('undoDisabled');
      }
    }

    if (redoButton) {
      if (redoStack.length === 0) {
        redoButton.classList.add('undoDisabled');
      } else {
        redoButton.classList.remove('undoDisabled');
      }
    }
  }
}

// Mobile zoom handling - use pinch gestures instead of wheel events
let initialDistance = 0;
let initialZoom = 1.0;

function getDistance(touches) {
  const dx = touches[0].clientX - touches[1].clientX;
  const dy = touches[0].clientY - touches[1].clientY;
  return Math.sqrt(dx * dx + dy * dy);
}

function handleTouchStart(e) {
  if (e.target.type === 'range' || e.target.classList.contains('freq-slider')) {
    return;
  }

  if (e.touches.length === 2) {
    e.preventDefault();
    initialDistance = getDistance(e.touches);
    initialZoom = viewState.scale;
  }
}

function handleTouchMove(e) {
  if (e.target.type === 'range' || e.target.classList.contains('freq-slider')) {
    return;
  }

  if (e.touches.length === 2) {
    e.preventDefault();
    const currentDistance = getDistance(e.touches);
    const scale = currentDistance / initialDistance;
    const newZoom = Math.max(MIN_ZOOM, Math.min(MAX_ZOOM, initialZoom * scale));

    if (newZoom !== viewState.scale) { 
      // Use center of the two touches as zoom center
      const centerX = (e.touches[0].clientX + e.touches[1].clientX) / 2;
      const centerY = (e.touches[0].clientY + e.touches[1].clientY) / 2;

      const oldScale = viewState.scale;
      viewState.offsetX = centerX - (centerX - viewState.offsetX) * (newZoom / oldScale);
      viewState.offsetY = centerY - (centerY - viewState.offsetY) * (newZoom / oldScale);
      viewState.scale = newZoom;

      updateViewTransform();
      updateZoomText();
      drawWires();
    }
  }
}

// Add mobile touch zoom handlers
document.addEventListener('touchstart', handleTouchStart, { passive: false });
document.addEventListener('touchmove', handleTouchMove, { passive: false });


// Sync Output module button state on mobile
function syncMobileOutputButton() {
  const desktopButton = document.getElementById('createOutputModuleButton');
  const mobileButton = document.getElementById('mobile-createOutputModuleButton');
  const desktopScope = document.getElementById('createOscilloscopeButton');
  const mobileScope = document.getElementById('mobile-createOscilloscopeButton');

  if (desktopButton && mobileButton) {
    if (desktopButton.classList.contains('fake-disabled')) {
      mobileButton.classList.add('fake-disabled');
      mobileButton.disabled = true;
    } else {
      mobileButton.classList.remove('fake-disabled');
      mobileButton.disabled = false;
    }
  }


  if (desktopScope && mobileScope) {
    if (desktopScope.classList.contains('fake-disabled')) {
      mobileScope.classList.add('fake-disabled');
      mobileScope.disabled = true;
    } else {
      mobileScope.classList.remove('fake-disabled');
      mobileScope.disabled = false;
    }
  }
}

const originalCreateModule = createModule;
createModule = function (...args) {
  const result = originalCreateModule(...args);
  const type = args[0];
  if (type === 'Output' || type === 'Oscilloscope') {
    syncMobileOutputButton();
  }
  return result;
};

// scroll-indicators.js

// Add this to detect scroll position and update classes
const controlsContainer = document.getElementById('controls-container');
const controlsContent = controlsContainer.querySelector('.controls-content');

function setupScrollIndicators(container) {
  const content = container.querySelector('.controls-content');
  if (!content) return;

  function update() {
    const scrollTop = content.scrollTop;
    const scrollHeight = content.scrollHeight;
    const clientHeight = content.clientHeight;
    const scrollBottom = scrollHeight - scrollTop - clientHeight;

    // Toggle classes based on scroll position
    container.classList.toggle('scrolled-top', scrollTop > 20);
    container.classList.toggle('scrolled-bottom', scrollBottom > 20);
  }

  // --- Run on scroll ---
  content.addEventListener('scroll', update);

  // --- Run on resize / layout change ---
  const resizeObserver = new ResizeObserver(() => update());
  resizeObserver.observe(content);

  // --- Run on DOM mutation (e.g., folder open/close, page change) ---
  const mutationObserver = new MutationObserver(() => {
    // Delay a bit so layout settles
    setTimeout(update, 100);
  });
  mutationObserver.observe(content, { childList: true, subtree: true });

  // --- Run periodically (optional safety net) ---
  let lastHeight = 0;
  setInterval(() => {
    const newHeight = content.scrollHeight;
    if (newHeight !== lastHeight) {
      lastHeight = newHeight;
      update();
    }
  }, 200); // every 1s, adjust as needed

  // --- Initial check ---
  update();
}

// === Initialize both containers ===
setupScrollIndicators(document.getElementById('controls-container'));

// Mobile menu scroll indicators
const mobileModuleMenu = document.getElementById('mobile-module-menu');
const mobileMenuContent = mobileModuleMenu.querySelector('.mobile-menu-content');

function updateMobileScrollIndicators() {
  const scrollTop = mobileMenuContent.scrollTop;
  const scrollHeight = mobileMenuContent.scrollHeight;
  const clientHeight = mobileMenuContent.clientHeight;
  const scrollBottom = scrollHeight - scrollTop - clientHeight;

  // Show top indicator if scrolled down (not at top)
  if (scrollTop > 20) {
    mobileModuleMenu.classList.add('scrolled-top');
  } else {
    mobileModuleMenu.classList.remove('scrolled-top');
  }

  // Show bottom indicator if there's more content below
  if (scrollBottom > 20) {
    mobileModuleMenu.classList.add('scrolled-bottom');
  } else {
    mobileModuleMenu.classList.remove('scrolled-bottom');
  }
}

// Listen for scroll events
mobileMenuContent.addEventListener('scroll', updateMobileScrollIndicators);

// Check initially and when content changes
updateMobileScrollIndicators();

// Also check when menu opens
const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    if (mutation.attributeName === 'class' && mobileModuleMenu.classList.contains('open')) {
      // Small delay to ensure layout is complete
      setTimeout(updateMobileScrollIndicators, 100);
    }
  });
});

observer.observe(mobileModuleMenu, { attributes: true });

// snippets.js
// snippets.js - Snippet management system

// Add a flag to distinguish default vs user snippets
const DEFAULT_SNIPPETS = [
  {
    name: "Toggle Button",
    isDefault: true, // Add this flag
    data: {
      modules: [
        {
          "id": 39,
          "type": "Flip-Flop",
          "gridX": 236,
          "gridY": 252
        },
        {
          "id": 44,
          "type": "Button",
          "gridX": 227,
          "gridY": 250,
          "assignedKey": null
        }
      ], connections: [
        {
          "from": 44,
          "fromOutputIndex": 0,
          "to": 39,
          "inputIndex": 0
        },
        {
          "from": 39,
          "fromOutputIndex": 1,
          "to": 39,
          "inputIndex": 1
        }
      ]
    }
  },
  {
    name: "8-Bit LFSR",
    isDefault: true, // Add this flag
    data: {
      "modules": [
        {
          "id": 173,
          "type": "Shift Register",
          "gridX": 275,
          "gridY": 254
        },
        {
          "id": 174,
          "type": "XNOR",
          "gridX": 288,
          "gridY": 248
        },
        {
          "id": 175,
          "type": "XOR",
          "gridX": 288,
          "gridY": 260
        },
        {
          "id": 176,
          "type": "XOR",
          "gridX": 288,
          "gridY": 254
        }
      ],
      "connections": [
        {
          "from": 173,
          "fromOutputIndex": 3,
          "to": 175,
          "inputIndex": 1
        },
        {
          "from": 173,
          "fromOutputIndex": 7,
          "to": 175,
          "inputIndex": 0
        },
        {
          "from": 173,
          "fromOutputIndex": 5,
          "to": 176,
          "inputIndex": 1
        },
        {
          "from": 173,
          "fromOutputIndex": 4,
          "to": 176,
          "inputIndex": 0
        },
        {
          "from": 175,
          "fromOutputIndex": 0,
          "to": 174,
          "inputIndex": 1
        },
        {
          "from": 176,
          "fromOutputIndex": 0,
          "to": 174,
          "inputIndex": 0
        },
        {
          "from": 174,
          "fromOutputIndex": 0,
          "to": 173,
          "inputIndex": 1
        }
      ]
    },
  },
  {
    name: "16-Bit LFSR",
    isDefault: true, // Add this flag
    data: {
      "modules": [
        {
          "id": 201,
          "type": "Shift Register",
          "gridX": 257,
          "gridY": 243
        },
        {
          "id": 202,
          "type": "Shift Register",
          "gridX": 257,
          "gridY": 252
        },
        {
          "id": 204,
          "type": "XOR",
          "gridX": 270,
          "gridY": 246
        },
        {
          "id": 205,
          "type": "XOR",
          "gridX": 270,
          "gridY": 252
        },
        {
          "id": 210,
          "type": "XNOR",
          "gridX": 270,
          "gridY": 240
        },
        {
          "id": 211,
          "type": "Oscillator",
          "gridX": 248,
          "gridY": 241,
          "freq": 10
        }
      ],
      "connections": [
        {
          "from": 202,
          "fromOutputIndex": 2,
          "to": 204,
          "inputIndex": 0
        },
        {
          "from": 202,
          "fromOutputIndex": 4,
          "to": 204,
          "inputIndex": 1
        },
        {
          "from": 202,
          "fromOutputIndex": 5,
          "to": 205,
          "inputIndex": 0
        },
        {
          "from": 202,
          "fromOutputIndex": 7,
          "to": 205,
          "inputIndex": 1
        },
        {
          "from": 205,
          "fromOutputIndex": 0,
          "to": 210,
          "inputIndex": 1
        },
        {
          "from": 204,
          "fromOutputIndex": 0,
          "to": 210,
          "inputIndex": 0
        },
        {
          "from": 210,
          "fromOutputIndex": 0,
          "to": 201,
          "inputIndex": 1
        },
        {
          "from": 211,
          "fromOutputIndex": 0,
          "to": 201,
          "inputIndex": 0
        },
        {
          "from": 201,
          "fromOutputIndex": 7,
          "to": 202,
          "inputIndex": 1
        },
        {
          "from": 211,
          "fromOutputIndex": 0,
          "to": 202,
          "inputIndex": 0
        }
      ]
    }
  },
  // {
  //   name: "24-bit LFSR",
  //   isDefault: true, // Add this flag
  //   data: {
  //     "modules": [
  //       {
  //         "id": 213,
  //         "type": "Shift Register",
  //         "gridX": 288,
  //         "gridY": 232
  //       },
  //       {
  //         "id": 214,
  //         "type": "Shift Register",
  //         "gridX": 288,
  //         "gridY": 250
  //       },
  //       {
  //         "id": 215,
  //         "type": "XOR",
  //         "gridX": 301,
  //         "gridY": 247
  //       },
  //       {
  //         "id": 216,
  //         "type": "XOR",
  //         "gridX": 301,
  //         "gridY": 253
  //       },
  //       {
  //         "id": 217,
  //         "type": "XNOR",
  //         "gridX": 301,
  //         "gridY": 241
  //       },
  //       {
  //         "id": 218,
  //         "type": "Oscillator",
  //         "gridX": 279,
  //         "gridY": 232,
  //         "freq": 3000
  //       },
  //       {
  //         "id": 219,
  //         "type": "Shift Register",
  //         "gridX": 288,
  //         "gridY": 241
  //       }
  //     ],
  //     "connections": [
  //       {
  //         "from": 216,
  //         "fromOutputIndex": 0,
  //         "to": 217,
  //         "inputIndex": 1
  //       },
  //       {
  //         "from": 215,
  //         "fromOutputIndex": 0,
  //         "to": 217,
  //         "inputIndex": 0
  //       },
  //       {
  //         "from": 217,
  //         "fromOutputIndex": 0,
  //         "to": 213,
  //         "inputIndex": 1
  //       },
  //       {
  //         "from": 218,
  //         "fromOutputIndex": 0,
  //         "to": 213,
  //         "inputIndex": 0
  //       },
  //       {
  //         "from": 219,
  //         "fromOutputIndex": 7,
  //         "to": 214,
  //         "inputIndex": 1
  //       },
  //       {
  //         "from": 218,
  //         "fromOutputIndex": 0,
  //         "to": 219,
  //         "inputIndex": 0
  //       },
  //       {
  //         "from": 218,
  //         "fromOutputIndex": 0,
  //         "to": 214,
  //         "inputIndex": 0
  //       },
  //       {
  //         "from": 214,
  //         "fromOutputIndex": 0,
  //         "to": 215,
  //         "inputIndex": 0
  //       },
  //       {
  //         "from": 214,
  //         "fromOutputIndex": 5,
  //         "to": 215,
  //         "inputIndex": 1
  //       },
  //       {
  //         "from": 213,
  //         "fromOutputIndex": 7,
  //         "to": 219,
  //         "inputIndex": 1
  //       },
  //       {
  //         "from": 214,
  //         "fromOutputIndex": 6,
  //         "to": 216,
  //         "inputIndex": 0
  //       },
  //       {
  //         "from": 214,
  //         "fromOutputIndex": 7,
  //         "to": 216,
  //         "inputIndex": 1
  //       }
  //     ]
  //   }
  // },
  {
    name: "Subharmonic Generator",
    isDefault: true, // Add this flag
    data: {
      "modules": [
        {
          "id": 182,
          "type": "Multiplexer",
          "gridX": 281,
          "gridY": 262
        },
        {
          "id": 183,
          "type": "Ring Counter",
          "gridX": 285,
          "gridY": 253
        },
        {
          "id": 184,
          "type": "Oscillator",
          "gridX": 276,
          "gridY": 254,
          "freq": 1500
        },
        {
          "id": 188,
          "type": "Binary Counter",
          "gridX": 268,
          "gridY": 262
        },
        {
          "id": 189,
          "type": "Oscillator",
          "gridX": 267,
          "gridY": 254,
          "freq": 20
        }
      ],
      "connections": [
        {
          "from": 184,
          "fromOutputIndex": 0,
          "to": 183,
          "inputIndex": 0
        },
        {
          "from": 182,
          "fromOutputIndex": 0,
          "to": 183,
          "inputIndex": 1
        },
        {
          "from": 183,
          "fromOutputIndex": 7,
          "to": 182,
          "inputIndex": 8
        },
        {
          "from": 183,
          "fromOutputIndex": 6,
          "to": 182,
          "inputIndex": 7
        },
        {
          "from": 183,
          "fromOutputIndex": 5,
          "to": 182,
          "inputIndex": 6
        },
        {
          "from": 183,
          "fromOutputIndex": 4,
          "to": 182,
          "inputIndex": 5
        },
        {
          "from": 183,
          "fromOutputIndex": 3,
          "to": 182,
          "inputIndex": 4
        },
        {
          "from": 183,
          "fromOutputIndex": 2,
          "to": 182,
          "inputIndex": 3
        },
        {
          "from": 189,
          "fromOutputIndex": 0,
          "to": 188,
          "inputIndex": 0
        },
        {
          "from": 188,
          "fromOutputIndex": 1,
          "to": 182,
          "inputIndex": 0
        },
        {
          "from": 188,
          "fromOutputIndex": 2,
          "to": 182,
          "inputIndex": 1
        },
        {
          "from": 188,
          "fromOutputIndex": 3,
          "to": 182,
          "inputIndex": 2
        }
      ],
    },
  },
  {
    name: "Harmonic Generator",
    isDefault: true, // Add this flag
    data: {
      "modules": [
        {
          "id": 188,
          "type": "Binary Rate Multiplier",
          "gridX": 250,
          "gridY": 244
        },
        {
          "id": 190,
          "type": "Binary Counter",
          "gridX": 248,
          "gridY": 253
        },
        {
          "id": 191,
          "type": "Binary Counter",
          "gridX": 254,
          "gridY": 235
        },
        {
          "id": 193,
          "type": "NOT",
          "gridX": 241,
          "gridY": 245
        },
        {
          "id": 197,
          "type": "Oscillator",
          "gridX": 245,
          "gridY": 233,
          "freq": 30
        }
      ],
      "connections": [
        {
          "from": 188,
          "fromOutputIndex": 0,
          "to": 190,
          "inputIndex": 0
        },
        {
          "from": 191,
          "fromOutputIndex": 5,
          "to": 188,
          "inputIndex": 4
        },
        {
          "from": 191,
          "fromOutputIndex": 6,
          "to": 188,
          "inputIndex": 5
        },
        {
          "from": 191,
          "fromOutputIndex": 7,
          "to": 188,
          "inputIndex": 6
        },
        {
          "from": 193,
          "fromOutputIndex": 0,
          "to": 193,
          "inputIndex": 0
        },
        {
          "from": 193,
          "fromOutputIndex": 0,
          "to": 188,
          "inputIndex": 0
        },
        {
          "from": 191,
          "fromOutputIndex": 4,
          "to": 188,
          "inputIndex": 3
        },
        {
          "from": 197,
          "fromOutputIndex": 0,
          "to": 191,
          "inputIndex": 0
        }
      ],
    },
  },
  {
    name: "Random Pulse",
    isDefault: true, // Add this flag
    data: {
      "modules": [
        {
          "id": 179,
          "type": "Noise",
          "gridX": 286,
          "gridY": 277
        },
        {
          "id": 180,
          "type": "Flip-Flop",
          "gridX": 286,
          "gridY": 271
        },
        {
          "id": 181,
          "type": "Oscillator",
          "gridX": 277,
          "gridY": 271,
          "freq": 10
        }
      ],
      "connections": [
        {
          "from": 179,
          "fromOutputIndex": 0,
          "to": 180,
          "inputIndex": 1
        },
        {
          "from": 181,
          "fromOutputIndex": 0,
          "to": 180,
          "inputIndex": 0
        }
      ],
    },
  },
  {
    name: "XOR Noise",
    isDefault: true, // Add this flag
    data: {
      "modules": [
        {
          "id": 191,
          "type": "XOR",
          "gridX": 286,
          "gridY": 260
        },
        {
          "id": 192,
          "type": "XOR",
          "gridX": 286,
          "gridY": 266
        },
        {
          "id": 193,
          "type": "XOR",
          "gridX": 286,
          "gridY": 254
        },
        {
          "id": 195,
          "type": "Oscillator",
          "gridX": 277,
          "gridY": 260,
          "freq": 1415
        },
        {
          "id": 196,
          "type": "Oscillator",
          "gridX": 268,
          "gridY": 257,
          "freq": 2621
        },
        {
          "id": 197,
          "type": "Oscillator",
          "gridX": 277,
          "gridY": 252,
          "freq": 420
        }
      ],
      "connections": [
        {
          "from": 197,
          "fromOutputIndex": 0,
          "to": 193,
          "inputIndex": 0
        },
        {
          "from": 196,
          "fromOutputIndex": 0,
          "to": 193,
          "inputIndex": 1
        },
        {
          "from": 193,
          "fromOutputIndex": 0,
          "to": 191,
          "inputIndex": 0
        },
        {
          "from": 195,
          "fromOutputIndex": 0,
          "to": 192,
          "inputIndex": 0
        },
        {
          "from": 191,
          "fromOutputIndex": 0,
          "to": 192,
          "inputIndex": 1
        },
        {
          "from": 192,
          "fromOutputIndex": 0,
          "to": 191,
          "inputIndex": 1
        }
      ],
    }
  },
  {
    name: "Noise Filter",
    isDefault: true, // Add this flag
    data: {
      "modules": [
        {
          "id": 200,
          "type": "Noise",
          "gridX": 293,
          "gridY": 245
        },
        {
          "id": 201,
          "type": "Binary Counter",
          "gridX": 302,
          "gridY": 245
        }
      ],
      "connections": [
        {
          "from": 200,
          "fromOutputIndex": 0,
          "to": 201,
          "inputIndex": 0
        }
      ],
    },
  },

];

function showSnippetTooltip(snippetName) {
  // Hide performance tooltip when showing snippet tooltip
  if (typeof hidePerformanceTooltip === 'function') {
    hidePerformanceTooltip();
  }

  const tooltip = document.getElementById('snippet-tooltip');
  const nameElement = document.getElementById('snippet-tooltip-name');

  if (tooltip) {
    if (nameElement && snippetName) {
      nameElement.textContent = `"${snippetName}"`;
    }

    tooltip.classList.remove('hidden');
    tooltip.classList.add('visible');
  }
}


function hideSnippetTooltip() {
  const tooltip = document.getElementById('snippet-tooltip');
  if (tooltip) {
    tooltip.classList.remove('visible');
    tooltip.classList.add('hidden');
  }
}

let snippetsDB = null;
let activeSnippet = null;

// Initialize IndexedDB for snippets
async function initSnippetsDB() {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open('StateMachineSnippets', 2);

    request.onerror = () => reject(request.error);
    request.onsuccess = async () => {
      snippetsDB = request.result;
      // Remove the default snippet addition code
      resolve(snippetsDB);
    };

    request.onupgradeneeded = (event) => {
      const db = event.target.result;
      if (!db.objectStoreNames.contains('snippets')) {
        const store = db.createObjectStore('snippets', { keyPath: 'id', autoIncrement: true });
        store.createIndex('name', 'name', { unique: false });
        store.createIndex('created', 'created', { unique: false });
      }
    };
  });
}

// Save a snippet to IndexedDB
async function saveSnippet(name, clipboardData) {
  if (!snippetsDB) await initSnippetsDB();

  // Check for duplicate names
  const existingSnippets = await loadSnippets();
  if (existingSnippets.some(s => s.name === name)) {
    throw new Error('A snippet with this name already exists');
  }

  return new Promise((resolve, reject) => {
    const transaction = snippetsDB.transaction(['snippets'], 'readwrite');
    const store = transaction.objectStore('snippets');

    const snippet = {
      name: name,
      data: clipboardData,
      created: Date.now()
    };

    const request = store.add(snippet);

    request.onsuccess = () => {
      resolve(request.result);
    };

    request.onerror = () => reject(request.error);
  });
}


// Load all snippets from IndexedDB
async function loadSnippets() {
  if (!snippetsDB) await initSnippetsDB();

  return new Promise((resolve, reject) => {
    const transaction = snippetsDB.transaction(['snippets'], 'readonly');
    const store = transaction.objectStore('snippets');
    const request = store.getAll();

    request.onsuccess = () => {
      // Combine defaults with user snippets
      const userSnippets = request.result;
      const allSnippets = [...DEFAULT_SNIPPETS, ...userSnippets];
      resolve(allSnippets);
    };
    request.onerror = () => reject(request.error);
  });
}

// Delete a snippet from IndexedDB
async function deleteSnippet(id) {
  if (!snippetsDB) await initSnippetsDB();

  return new Promise((resolve, reject) => {
    const transaction = snippetsDB.transaction(['snippets'], 'readwrite');
    const store = transaction.objectStore('snippets');
    const request = store.delete(id);

    request.onsuccess = () => resolve();
    request.onerror = () => reject(request.error);
  });
}

// Update snippet name
async function renameSnippet(id, newName) {
  if (!snippetsDB) await initSnippetsDB();

  // Check for duplicate names (excluding current snippet)
  const existingSnippets = await loadSnippets();
  if (existingSnippets.some(s => s.name === newName && s.id !== id)) {
    throw new Error('A snippet with this name already exists');
  }

  return new Promise((resolve, reject) => {
    const transaction = snippetsDB.transaction(['snippets'], 'readwrite');
    const store = transaction.objectStore('snippets');
    const getRequest = store.get(id);

    getRequest.onsuccess = () => {
      const snippet = getRequest.result;
      if (snippet) {
        snippet.name = newName;
        const updateRequest = store.put(snippet);
        updateRequest.onsuccess = () => resolve();
        updateRequest.onerror = () => reject(updateRequest.error);
      } else {
        reject(new Error('Snippet not found'));
      }
    };

    getRequest.onerror = () => reject(getRequest.error);
  });
}

// Render snippets list
async function renderSnippetsList() {
  const snippetsList = document.getElementById('snippetsList');
  const snippets = await loadSnippets();

  if (snippets.length === 0) {
    snippetsList.innerHTML = '<div class="snippets-empty">Select modules and click "New Snippet" to save them</div>';
    return;
  }

  snippetsList.innerHTML = '';

  snippets.forEach(snippet => {
    const item = document.createElement('div');
    item.className = 'snippet-item';
    item.dataset.id = snippet.id;

    // Only show delete button for user snippets
    const deleteButtonHtml = snippet.isDefault ? '' : `
      <button class="snippet-delete" data-snippet-id="${snippet.id}">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                  <g fill="none">
                    <path
                      d="m12.593 23.258l-.011.002l-.071.035l-.02.004l-.014-.004l-.071-.035q-.016-.005-.024.005l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427q-.004-.016-.017-.018m.265-.113l-.013.002l-.185.093l-.01.01l-.003.011l.018.43l.005.012l.008.007l.201.093q.019.005.029-.008l.004-.014l-.034-.614q-.005-.018-.02-.022m-.715.002a.02.02 0 0 0-.027.006l-.006.014l-.034.614q.001.018.017.024l.015-.002l.201-.093l.01-.008l.004-.011l.017-.43l-.003-.012l-.01-.01z" />
                    <path fill="currentColor"
                      d="M20 5a1 1 0 1 1 0 2h-1l-.003.071l-.933 13.071A2 2 0 0 1 16.069 22H7.93a2 2 0 0 1-1.995-1.858l-.933-13.07L5 7H4a1 1 0 0 1 0-2zm-6-3a1 1 0 1 1 0 2h-4a1 1 0 0 1 0-2z" />
                  </g>
        </svg>
      </button>
    `;

    item.innerHTML = `
      <span class="snippet-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="256" height="256" viewBox="0 0 256 256">
          <path fill="currentColor" d="M216 40H40a16 16 0 0 0-16 16v160a8 8 0 0 0 11.58 7.15L64 208.94l28.42 14.21a8 8 0 0 0 7.16 0L128 208.94l28.42 14.21a8 8 0 0 0 7.16 0L192 208.94l28.42 14.21A8 8 0 0 0 232 216V56a16 16 0 0 0-16-16M116 160a4 4 0 0 1-4 4H64a4 4 0 0 1-4-4V96a4 4 0 0 1 4-4h48a4 4 0 0 1 4 4Zm76-8h-48a8 8 0 0 1 0-16h48a8 8 0 0 1 0 16m0-32h-48a8 8 0 0 1 0-16h48a8 8 0 0 1 0 16" />
        </svg>
      </span>
      <span class="snippet-name">${snippet.name}</span>
      ${deleteButtonHtml}
    `;

    // Only add delete button handler for user snippets
    if (!snippet.isDefault) {
      const deleteBtn = item.querySelector('.snippet-delete');

      deleteBtn.addEventListener('click', async (e) => {
        e.stopPropagation();
        e.stopImmediatePropagation();
        e.preventDefault();

        const snippetId = parseInt(deleteBtn.dataset.snippetId);
        const snippetToDelete = snippets.find(s => s.id === snippetId);

        if (!snippetToDelete) return;

        if (!deleteBtn.classList.contains('confirm-delete')) {
          deleteBtn.classList.add('confirm-delete');
          deleteBtn.innerHTML = `
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24">
              <path fill="currentColor" d="M9 16.17L4.83 12l-1.42 1.41L9 19L21 7l-1.41-1.41z"/>
            </svg>
          `;
          deleteBtn.title = "Click again to confirm";

          setTimeout(() => {
            deleteBtn.classList.remove('confirm-delete');
            deleteBtn.innerHTML = `
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24">
                <path fill="currentColor" d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6zM19 4h-3.5l-1-1h-5l-1 1H5v2h14z"/>
              </svg>
            `;
            deleteBtn.title = "Delete snippet";
          }, 3000);
        } else {
          await deleteSnippet(snippetId);
          hideSnippetTooltip();
          await renderSnippetsList();
          if (activeSnippet === snippetToDelete.data) {
            activeSnippet = null;
          }
        }
      }, true);

      deleteBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        e.stopImmediatePropagation();
        e.preventDefault();
      }, true);
    }

    // Click to activate snippet (same for all)
    item.addEventListener('click', (e) => {
      if (e.target.classList.contains('snippet-delete') ||
        e.target.closest('.snippet-delete')) {
        return;
      }

      e.stopPropagation();

      if (item.classList.contains('active')) {
        item.classList.remove('active');
        activeSnippet = null;
        hideSnippetTooltip();
        return;
      }

      document.querySelectorAll('.snippet-item').forEach(i => i.classList.remove('active'));
      item.classList.add('active');
      activeSnippet = snippet.data;
      showSnippetTooltip(snippet.name);
    });

    // Double-click to rename (only for user snippets)
    const nameSpan = item.querySelector('.snippet-name');
    if (!snippet.isDefault) {
      nameSpan.addEventListener('dblclick', async (e) => {
        e.stopPropagation();

        const newName = await showInputDialog('Rename snippet:', snippet.name);
        if (newName && newName.trim() && newName !== snippet.name) {
          try {
            await renameSnippet(snippet.id, newName.trim());
            await renderSnippetsList();
          } catch (error) {
            console.error('Failed to rename snippet:', error);
            if (error.message === 'A snippet with this name already exists') {
              showAlert('A snippet with this name already exists. Please choose a different name.');
            } else {
              showAlert('Failed to rename snippet');
            }
          }
        }
      });
    }

    snippetsList.appendChild(item);
  });
}


// Create new snippet from selection
async function createSnippetFromSelection() {
  if (selectedModules.size === 0) return;

  const modulesToCopy = modules.filter(m =>
    selectedModules.has(m.id) && m.type !== 'Output' && m.type !== 'Oscilloscope'
  );

  const validModuleIds = new Set(modulesToCopy.map(m => m.id));

  const connectionsToCopy = connections.filter(conn =>
    validModuleIds.has(conn.from) && validModuleIds.has(conn.to)
  );

  const minGridX = Math.min(...modulesToCopy.map(m => m.gridX));
  const minGridY = Math.min(...modulesToCopy.map(m => m.gridY));

  const clipboardData = {
    modules: modulesToCopy.map(m => ({ ...m })),
    connections: connectionsToCopy,
    offsetGridX: minGridX,
    offsetGridY: minGridY
  };

  // Prompt for name
  const name = await showInputDialog('Enter snippet name:', 'New Snippet');
  if (!name || !name.trim()) return;

  try {
    await saveSnippet(name.trim(), clipboardData);
    await renderSnippetsList();
  } catch (error) {
    console.error('Failed to save snippet:', error);
    if (error.message === 'A snippet with this name already exists') {
      showAlert('A snippet with this name already exists. Please choose a different name.');
    } else {
      showAlert('Failed to save snippet');
    }
  }
}

function hasOnlyOutputModules() {
  if (selectedModules.size === 0) return false;

  // Find selected modules
  const selected = modules.filter(m => selectedModules.has(m.id));
  // Return true if all selected are output-type
  return selected.length > 0 && selected.every(m => m.type === 'Output' || m.type === 'Oscilloscope');
}

// Update create snippet button state
function updateSnippetButtonState() {
  const createBtn = document.getElementById('createSnippetBtn');
  if (createBtn) {
    if (selectedModules.size === 0 || hasOnlyOutputModules()) {
      createBtn.disabled = true;
      createBtn.innerHTML = `<svg class="snippet-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
      <path fill="currentColor" d="M11 13H5v-2h6V5h2v6h6v2h-6v6h-2z" />
                    </svg > Select modules to make a new snippet.`
    } else if (selectedModules.size >= 15) {
      createBtn.disabled = true;
      createBtn.innerHTML = `<svg class="snippet-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
      <path fill="currentColor" d="M11 13H5v-2h6V5h2v6h6v2h-6v6h-2z" />
                    </svg > Select less than 15 modules.`
    } else {
      createBtn.disabled = false;
      createBtn.innerHTML = `<svg class="snippet-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
      <path fill="currentColor" d="M11 13H5v-2h6V5h2v6h6v2h-6v6h-2z" />
                    </svg > New Snippet`
    }
  }
}

// Initialize snippets system
async function initSnippets() {
  try {
    await initSnippetsDB();
    await renderSnippetsList();

    // Page toggle buttons
    const modulesBtn = document.getElementById('modulesPageBtn');
    const snippetsBtn = document.getElementById('snippetsPageBtn');
    const modulesPage = document.getElementById('modulesPage');
    const snippetsPage = document.getElementById('snippetsPage');

    modulesBtn?.addEventListener('click', (e) => {
      e.stopPropagation(); // Add this
      modulesBtn.classList.add('active');
      snippetsBtn.classList.remove('active');
      modulesPage.classList.add('active');
      snippetsPage.classList.remove('active');
    });

    snippetsBtn?.addEventListener('click', (e) => {
      e.stopPropagation(); // Add this
      snippetsBtn.classList.add('active');
      modulesBtn.classList.remove('active');
      snippetsPage.classList.add('active');
      modulesPage.classList.remove('active');
    });

    // Create snippet button
    const createBtn = document.getElementById('createSnippetBtn');
    createBtn?.addEventListener('click', (e) => {
      e.stopPropagation(); // Add this to prevent deselection
      createSnippetFromSelection();
    });

    const cancelBtn = document.getElementById('snippet-tooltip-cancel');
    cancelBtn?.addEventListener('click', () => {
      activeSnippet = null;
      document.querySelectorAll('.snippet-item').forEach(i => i.classList.remove('active'));
      hideSnippetTooltip();
    });

  } catch (error) {
    console.error('Failed to initialize snippets:', error);
  }
}

// Handle canvas clicks for snippet placement
document.addEventListener('mousedown', (e) => {
  if (activeSnippet) {
    // Check if clicking inside controls or on a snippet item
    if (e.target.closest('#controls-container') ||
      e.target.closest('.snippet-item') ||
      e.target.closest('.ui-controls')) {
      return; // Don't place snippet
    }

    const moduleElement = e.target.closest('.module');
    const isPort = e.target.dataset && (e.target.dataset.type === 'input' || e.target.dataset.type === 'output');

    if (!moduleElement && !isPort) {
      // Place the snippet
      const tempClipboard = clipboard;
      clipboard = activeSnippet;
      pasteModules(e.clientX, e.clientY);
      clipboard = tempClipboard;

      // Deactivate snippet
      activeSnippet = null;
      document.querySelectorAll('.snippet-item').forEach(i => i.classList.remove('active'));
      hideSnippetTooltip();

      e.stopPropagation();
      e.preventDefault();
      return;
    }
  }
});

// Also hide tooltip when escape is pressed
document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape' && activeSnippet) {
    activeSnippet = null;
    document.querySelectorAll('.snippet-item').forEach(i => i.classList.remove('active'));
    hideSnippetTooltip();
  }
});


// Initialize on load
window.addEventListener('load', initSnippets);

// bomArrays.js

// KiCad footprint library mappings
const kiCadFootprints = {
  // Logic ICs (DIP packages)
  'CD4081': { footprint: 'Package_DIP:DIP-14_W7.62mm', pins: 14, vcc: 14, gnd: 7 },
  'CD4071': { footprint: 'Package_DIP:DIP-14_W7.62mm', pins: 14, vcc: 14, gnd: 7 },
  'CD4011': { footprint: 'Package_DIP:DIP-14_W7.62mm', pins: 14, vcc: 14, gnd: 7 },
  'CD4001': { footprint: 'Package_DIP:DIP-14_W7.62mm', pins: 14, vcc: 14, gnd: 7 },
  'CD4070': { footprint: 'Package_DIP:DIP-14_W7.62mm', pins: 14, vcc: 14, gnd: 7 },
  'CD4077': { footprint: 'Package_DIP:DIP-14_W7.62mm', pins: 14, vcc: 14, gnd: 7 },
  'CD4069': { footprint: 'Package_DIP:DIP-14_W7.62mm', pins: 14, vcc: 14, gnd: 7 },
  'CD40106': { footprint: 'Package_DIP:DIP-14_W7.62mm', pins: 14, vcc: 14, gnd: 7 },
  'CD4040': { footprint: 'DIP-16_W7.62mm', pins: 16, vcc: 16, gnd: 8 },
  'CD4017': { footprint: 'DIP-16_W7.62mm', pins: 16, vcc: 16, gnd: 8 },
  'CD4015': { footprint: 'DIP-16_W7.62mm', pins: 16, vcc: 16, gnd: 8 },
  'CD4051': { footprint: 'DIP-16_W7.62mm', pins: 16, vcc: 16, gnd: 8 },
  'CD4013': { footprint: 'Package_DIP:DIP-14_W7.62mm', pins: 14, vcc: 14, gnd: 7 },
  'LM324': { footprint: 'Package_DIP:DIP-14_W7.62mm', pins: 14, vcc: 4, gnd: 11 },

  // Transistors
  '2N3904': { footprint: 'TO-92L_Inline_Wide', pins: 3 },

  // Passive components
  'LED': { footprint: 'LED_D3.0mm', pins: 2 },
  'Jack': { footprint: 'Jack_3.5mm_QingPu_WQP-PJ398SM_Vertical_CircularHoles', pins: 3 },
  '100k Potentiometer': { footprint: 'Potentiometer_Alps_RK09K_Single_Vertical', pins: 3 },

  // Resistors (standard 1/4W through-hole)
  '1k Resistor': { footprint: 'R_Axial_DIN0207_L6.3mm_D2.5mm_P10.16mm_Horizontal', pins: 2 },
  '4.7k Resistor': { footprint: 'R_Axial_DIN0207_L6.3mm_D2.5mm_P10.16mm_Horizontal', pins: 2 },
  '10k Resistor': { footprint: 'R_Axial_DIN0207_L6.3mm_D2.5mm_P10.16mm_Horizontal', pins: 2 },
  '47k Resistor': { footprint: 'R_Axial_DIN0207_L6.3mm_D2.5mm_P10.16mm_Horizontal', pins: 2 },
  '100k Resistor': { footprint: 'R_Axial_DIN0207_L6.3mm_D2.5mm_P10.16mm_Horizontal', pins: 2 },

  // Capacitors
  '10nF Capacitor': { footprint: 'C_Disc_D5.0mm_W2.5mm_P5.00mm', pins: 2 },
  '100nF Capacitor': { footprint: 'C_Disc_D5.0mm_W2.5mm_P5.00mm', pins: 2 },
  '1uF Capacitor': { footprint: 'CP_Radial_D6.3mm_P2.50mm', pins: 2, polarized: true },
  '10uF Capacitor': { footprint: 'CP_Radial_D6.3mm_P2.50mm', pins: 2, polarized: true },
  'Timing Capacitor': { footprint: 'C_Disc_D5.0mm_W2.5mm_P5.00mm', pins: 2 }
};

const footprintTemplates = {
  'Package_DIP:DIP-14_W7.62mm': `
    (footprint "DIP-14_W7.62mm"
    (version 20241229)
    (generator "pcbnew")
    (generator_version "9.0")
    (layer "F.Cu")
    (descr "14-lead though-hole mounted DIP package, row spacing 7.62mm (300 mils)")
    (tags "THT DIP DIL PDIP 2.54mm 7.62mm 300mil")
    (property "Reference" "REF**"
      (at 3.81 -2.33 0)
      (layer "F.SilkS")
      (uuid "d560ff7e-7056-43af-9c2a-06831056ec43")
      (effects
        (font (size 1 1) (thickness 0.15))
      )
    )
    (property "Value" "DIP-14_W7.62mm"
      (at 3.81 17.57 0)
      (layer "F.Fab")
      (uuid "0379dafc-5e51-4d68-a4cc-44f3cf0cfe71")
      (effects
        (font (size 1 1) (thickness 0.15))
      )
    )
    (property "Datasheet" ""
      (at 0 0 0)
      (layer "F.Fab")
      (hide yes)
      (uuid "0aad1f51-5a7d-4e86-b715-9fd0cc528a90")
      (effects
        (font (size 1.27 1.27) (thickness 0.15))
      )
    )
    (property "Description" ""
      (at 0 0 0)
      (layer "F.Fab")
      (hide yes)
      (uuid "bc868366-ce03-453d-9d6f-f77fb77c47a2")
      (effects
        (font (size 1.27 1.27) (thickness 0.15))
      )
    )
    (attr through_hole)
    (fp_line
      (start 1.16 -1.33)
      (end 1.16 16.57)
      (stroke (width 0.12) (type solid))
      (layer "F.SilkS")
      (uuid "e027a643-e478-4cfd-b12f-ea3bce82e6b9")
    )
    (fp_line
      (start 1.16 16.57)
      (end 6.46 16.57)
      (stroke (width 0.12) (type solid))
      (layer "F.SilkS")
      (uuid "16e30d71-2c7f-4baf-b0a5-6988c2728f8a")
    )
    (fp_line
      (start 2.81 -1.33)
      (end 1.16 -1.33)
      (stroke (width 0.12) (type solid))
      (layer "F.SilkS")
      (uuid "3aaddef7-69c7-41c1-b1d4-61850dfaaeb1")
    )
    (fp_line
      (start 6.46 -1.33)
      (end 4.81 -1.33)
      (stroke (width 0.12) (type solid))
      (layer "F.SilkS")
      (uuid "7313a5de-5490-4f95-9403-f20a8410ae49")
    )
    (fp_line
      (start 6.46 16.57)
      (end 6.46 -1.33)
      (stroke (width 0.12) (type solid))
      (layer "F.SilkS")
      (uuid "4114f9da-2312-4838-9b70-690f3c18db58")
    )
    (fp_arc
      (start 4.81 -1.33)
      (mid 3.81 -0.33)
      (end 2.81 -1.33)
      (stroke (width 0.12) (type solid))
      (layer "F.SilkS")
      (uuid "4a32efaa-b285-4a60-8e94-df126d551212")
    )
    (fp_rect
      (start -1.06 -1.53)
      (end 8.67 16.77)
      (stroke (width 0.05) (type solid))
      (fill no)
      (layer "F.CrtYd")
      (uuid "4f5980ee-7eaf-4769-82d5-9c9dd3c23aa7")
    )
    (fp_line
      (start 0.635 -0.27)
      (end 1.635 -1.27)
      (stroke (width 0.1) (type solid))
      (layer "F.Fab")
      (uuid "ffa5cfe0-d908-40f7-a1e7-7b78ae9808dc")
    )
    (fp_line
      (start 0.635 16.51)
      (end 0.635 -0.27)
      (stroke (width 0.1) (type solid))
      (layer "F.Fab")
      (uuid "be45ff11-6d15-4fe1-a38c-228fbe3ffda7")
    )
    (fp_line
      (start 1.635 -1.27)
      (end 6.985 -1.27)
      (stroke (width 0.1) (type solid))
      (layer "F.Fab")
      (uuid "cb601241-3ff8-43e6-b560-d63dde2a5d0e")
    )
    (fp_line
      (start 6.985 -1.27)
      (end 6.985 16.51)
      (stroke (width 0.1) (type solid))
      (layer "F.Fab")
      (uuid "de0cb342-44a2-4ffd-a54e-be102aa40e48")
    )
    (fp_line
      (start 6.985 16.51)
      (end 0.635 16.51)
      (stroke (width 0.1) (type solid))
      (layer "F.Fab")
      (uuid "59d7f9c5-372a-4231-a6fd-22eec4456b77")
    )
    (fp_text user "\${REFERENCE}"
      (at 3.81 7.62 90)
      (layer "F.Fab")
      (uuid "e21523e8-e5cd-4fc1-b7ce-430488d817cb")
      (effects
        (font (size 1 1) (thickness 0.15))
      )
    )
    (pad "1" thru_hole roundrect
      (at 0 0)
      (size 1.6 1.6)
      (drill 0.8)
      (layers "*.Cu" "*.Mask")
      (remove_unused_layers no)
      (roundrect_rratio 0.15625)
      (uuid "42f058bf-b1f3-442c-9d67-a104058d6cb0")
    )
    (pad "2" thru_hole circle
      (at 0 2.54)
      (size 1.6 1.6)
      (drill 0.8)
      (layers "*.Cu" "*.Mask")
      (remove_unused_layers no)
      (uuid "8e44d580-817d-467f-ad88-412d670efef4")
    )
    (pad "3" thru_hole circle
      (at 0 5.08)
      (size 1.6 1.6)
      (drill 0.8)
      (layers "*.Cu" "*.Mask")
      (remove_unused_layers no)
      (uuid "d21034cb-f53a-42c4-9227-8b48608bee0e")
    )
    (pad "4" thru_hole circle
      (at 0 7.62)
      (size 1.6 1.6)
      (drill 0.8)
      (layers "*.Cu" "*.Mask")
      (remove_unused_layers no)
      (uuid "0d223afd-4cf4-48ad-8df0-ba53451c3612")
    )
    (pad "5" thru_hole circle
      (at 0 10.16)
      (size 1.6 1.6)
      (drill 0.8)
      (layers "*.Cu" "*.Mask")
      (remove_unused_layers no)
      (uuid "133649c3-9ded-4bba-aa90-abd54e6a8d8f")
    )
    (pad "6" thru_hole circle
      (at 0 12.7)
      (size 1.6 1.6)
      (drill 0.8)
      (layers "*.Cu" "*.Mask")
      (remove_unused_layers no)
      (uuid "1b303baa-2f0d-4d60-90ee-6b48cb0c0fe2")
    )
    (pad "7" thru_hole circle
      (at 0 15.24)
      (size 1.6 1.6)
      (drill 0.8)
      (layers "*.Cu" "*.Mask")
      (remove_unused_layers no)
      (uuid "e4ab2b69-19cd-44f1-9631-2c8ef744febf")
    )
    (pad "8" thru_hole circle
      (at 7.62 15.24)
      (size 1.6 1.6)
      (drill 0.8)
      (layers "*.Cu" "*.Mask")
      (remove_unused_layers no)
      (uuid "2cd5164b-f9fe-4ec8-9475-dc9209566623")
    )
    (pad "9" thru_hole circle
      (at 7.62 12.7)
      (size 1.6 1.6)
      (drill 0.8)
      (layers "*.Cu" "*.Mask")
      (remove_unused_layers no)
      (uuid "bffe68d1-70f4-4968-a036-e2c76b993e5e")
    )
    (pad "10" thru_hole circle
      (at 7.62 10.16)
      (size 1.6 1.6)
      (drill 0.8)
      (layers "*.Cu" "*.Mask")
      (remove_unused_layers no)
      (uuid "b9a27018-d392-4e81-a9ae-e1ac245bbe4c")
    )
    (pad "11" thru_hole circle
      (at 7.62 7.62)
      (size 1.6 1.6)
      (drill 0.8)
      (layers "*.Cu" "*.Mask")
      (remove_unused_layers no)
      (uuid "1e21093f-fd19-4e11-98a5-e307f88c9590")
    )
    (pad "12" thru_hole circle
      (at 7.62 5.08)
      (size 1.6 1.6)
      (drill 0.8)
      (layers "*.Cu" "*.Mask")
      (remove_unused_layers no)
      (uuid "5bb75151-5d17-4c01-b0d3-f9d17986792c")
    )
    (pad "13" thru_hole circle
      (at 7.62 2.54)
      (size 1.6 1.6)
      (drill 0.8)
      (layers "*.Cu" "*.Mask")
      (remove_unused_layers no)
      (uuid "c73e6f1c-e918-4275-9ed1-c0cb92cf09c6")
    )
    (pad "14" thru_hole circle
      (at 7.62 0)
      (size 1.6 1.6)
      (drill 0.8)
      (layers "*.Cu" "*.Mask")
      (remove_unused_layers no)
      (uuid "347ddc4a-a38f-4117-b89c-b3f1e5a8de0a")
    )
    (embedded_fonts no)
    (model "\${KICAD9_3DMODEL_DIR}/Package_DIP.3dshapes/DIP-14_W7.62mm.step"
      (offset (xyz 0 0 0))
      (scale (xyz 1 1 1))
      (rotate (xyz 0 0 0))
    )
  )

  `,
  'R_Axial_DIN0207_L6.3mm_D2.5mm_P10.16mm_Horizontal': `
  (footprint "R_Axial_DIN0207_L6.3mm_D2.5mm_P10.16mm_Horizontal"
	(version 20241229)
	(generator "pcbnew")
	(generator_version "9.0")
	(layer "F.Cu")
	(descr "Resistor, Axial_DIN0207 series, Axial, Horizontal, pin pitch=10.16mm, 0.25W = 1/4W, length*diameter=6.3*2.5mm^2, http://cdn-reichelt.de/documents/datenblatt/B400/1_4W%23YAG.pdf")
	(tags "Resistor Axial_DIN0207 series Axial Horizontal pin pitch 10.16mm 0.25W = 1/4W length 6.3mm diameter 2.5mm")
	(property "Reference" "REF**"
		(at 5.08 -2.37 0)
		(layer "F.SilkS")
		(uuid "9a7009a4-1c66-4247-a58d-4e223e4e055a")
		(effects
			(font (size 1 1) (thickness 0.15))
		)
	)
	(property "Value" "R_Axial_DIN0207_L6.3mm_D2.5mm_P10.16mm_Horizontal"
		(at 5.08 2.37 0)
		(layer "F.Fab")
		(uuid "803a2155-4080-45f2-a505-8a61d43122ff")
		(effects
			(font (size 1 1) (thickness 0.15))
		)
	)
	(property "Datasheet" ""
		(at 0 0 0)
		(layer "F.Fab")
		(hide yes)
		(uuid "afb775cf-1e7d-4654-a73d-f1116eda0104")
		(effects
			(font (size 1.27 1.27) (thickness 0.15))
		)
	)
	(property "Description" ""
		(at 0 0 0)
		(layer "F.Fab")
		(hide yes)
		(uuid "70c1b6c3-5371-4e71-a235-9aa36f70502f")
		(effects
			(font (size 1.27 1.27) (thickness 0.15))
		)
	)
	(attr through_hole)
	(fp_line
		(start 1.04 0)
		(end 1.81 0)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "a87c2f35-72f4-43f2-be75-1f9be881338a")
	)
	(fp_line
		(start 9.12 0)
		(end 8.35 0)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "2950daf2-5943-46a0-9f3e-29e565438d80")
	)
	(fp_rect
		(start 1.81 -1.37)
		(end 8.35 1.37)
		(stroke (width 0.12) (type solid))
		(fill no)
		(layer "F.SilkS")
		(uuid "ba8037f6-15df-4e48-9d92-32db8c6388f3")
	)
	(fp_rect
		(start -1.05 -1.5)
		(end 11.21 1.5)
		(stroke (width 0.05) (type solid))
		(fill no)
		(layer "F.CrtYd")
		(uuid "609a693f-454a-493c-86e4-a667993ac86d")
	)
	(fp_line
		(start 0 0)
		(end 1.93 0)
		(stroke (width 0.1) (type solid))
		(layer "F.Fab")
		(uuid "6e2a41c4-b9f9-4546-899c-8c17bb6ea401")
	)
	(fp_line
		(start 10.16 0)
		(end 8.23 0)
		(stroke (width 0.1) (type solid))
		(layer "F.Fab")
		(uuid "00bbe1bf-f9d8-4ce5-bbfa-75209924d87b")
	)
	(fp_rect
		(start 1.93 -1.25)
		(end 8.23 1.25)
		(stroke (width 0.1) (type solid))
		(fill no)
		(layer "F.Fab")
		(uuid "bfd4b892-1bd4-4981-9f3d-b421015217e9")
	)
	(fp_text user "\${REFERENCE}"
		(at 5.08 0 0)
		(layer "F.Fab")
		(uuid "97c0ea77-b41c-4136-bebe-d1bbac24891d")
		(effects
			(font (size 1 1) (thickness 0.15))
		)
	)
	(pad "1" thru_hole circle
		(at 0 0)
		(size 1.6 1.6)
		(drill 0.8)
		(layers "*.Cu" "*.Mask")
		(remove_unused_layers no)
		(uuid "478f73dd-a6ce-4506-8432-f9187c2e8eb0")
	)
	(pad "2" thru_hole circle
		(at 10.16 0)
		(size 1.6 1.6)
		(drill 0.8)
		(layers "*.Cu" "*.Mask")
		(remove_unused_layers no)
		(uuid "1b7f1cf2-8948-4800-b669-a75f71f16d6e")
	)
	(embedded_fonts no)
	(model "\${KICAD9_3DMODEL_DIR}/Resistor_THT.3dshapes/R_Axial_DIN0207_L6.3mm_D2.5mm_P10.16mm_Horizontal.step"
		(offset (xyz 0 0 0))
		(scale (xyz 1 1 1))
		(rotate (xyz 0 0 0))
	)
)
`,
  'TO-92L_Inline_Wide': `
(footprint "TO-92L_Inline_Wide"
	(version 20241229)
	(generator "pcbnew")
	(generator_version "9.0")
	(layer "F.Cu")
	(descr "TO-92L leads in-line (large body variant of TO-92), also known as TO-226, wide, drill 0.75mm (see https://www.diodes.com/assets/Package-Files/TO92L.pdf and http://www.ti.com/lit/an/snoa059/snoa059.pdf)")
	(tags "TO-92L Inline Wide transistor")
	(property "Reference" "REF**"
		(at 2.54 -3.56 0)
		(layer "F.SilkS")
		(uuid "a0275656-ee77-4ef6-961d-741829c6d5ae")
		(effects
			(font (size 1 1) (thickness 0.15))
		)
	)
	(property "Value" "TO-92L_Inline_Wide"
		(at 2.54 2.79 0)
		(layer "F.Fab")
		(uuid "e50d001f-74a7-42a5-ab94-bf49f0f74536")
		(effects
			(font (size 1 1) (thickness 0.15))
		)
	)
	(property "Datasheet" ""
		(at 0 0 0)
		(unlocked yes)
		(layer "F.Fab")
		(hide yes)
		(uuid "f3f9f1ba-2ea3-400c-ace9-8d1c0b7563f5")
		(effects
			(font (size 1.27 1.27) (thickness 0.15))
		)
	)
	(property "Description" ""
		(at 0 0 0)
		(unlocked yes)
		(layer "F.Fab")
		(hide yes)
		(uuid "4fbc8fb5-c0f7-435b-9c79-dd7efa041166")
		(effects
			(font (size 1.27 1.27) (thickness 0.15))
		)
	)
	(attr through_hole)
	(fp_line
		(start 0.6 1.7)
		(end 4.45 1.7)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "f126d3a4-46cc-4e4d-8027-a401199d6ab1")
	)
	(fp_arc
		(start 0.1836 -1.098807)
		(mid 1.143021 -2.192817)
		(end 2.54 -2.6)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "fd60bfec-c6b3-46c7-89e2-b474fac7f1dc")
	)
	(fp_arc
		(start 0.6 1.7)
		(mid 0.389183 1.423933)
		(end 0.217369 1.122045)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "47f0026f-5cad-48c2-aeca-1b29d953fc78")
	)
	(fp_arc
		(start 2.54 -2.6)
		(mid 3.936979 -2.192818)
		(end 4.8964 -1.098807)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "7a5556ba-6610-45df-b3a5-7dc94232fd45")
	)
	(fp_arc
		(start 4.842383 1.112264)
		(mid 4.666594 1.419753)
		(end 4.45 1.7)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "93dced74-f871-4b17-9e71-652900ddaed5")
	)
	(fp_line
		(start -1 -2.75)
		(end -1 1.85)
		(stroke (width 0.05) (type solid))
		(layer "F.CrtYd")
		(uuid "e51508ef-1469-4fbd-8d54-8491abfe77ee")
	)
	(fp_line
		(start -1 -2.75)
		(end 6.1 -2.75)
		(stroke (width 0.05) (type solid))
		(layer "F.CrtYd")
		(uuid "c2e0f346-2e56-4639-9a70-7f8d9c062a85")
	)
	(fp_line
		(start 6.1 1.85)
		(end -1 1.85)
		(stroke (width 0.05) (type solid))
		(layer "F.CrtYd")
		(uuid "4a12f13d-1d86-4f86-8e92-09ffea8e913e")
	)
	(fp_line
		(start 6.1 1.85)
		(end 6.1 -2.75)
		(stroke (width 0.05) (type solid))
		(layer "F.CrtYd")
		(uuid "bec29c0c-a07c-439f-90da-e7d2678b5363")
	)
	(fp_line
		(start 0.65 1.6)
		(end 4.4 1.6)
		(stroke (width 0.1) (type solid))
		(layer "F.Fab")
		(uuid "ee2d6428-4913-4489-bc39-4c1d2876070a")
	)
	(fp_arc
		(start 0.647182 1.602385)
		(mid 0.290076 -1.043188)
		(end 2.54 -2.48)
		(stroke (width 0.1) (type solid))
		(layer "F.Fab")
		(uuid "aeba7c26-fc1f-4359-84a0-3ce28a60c01f")
	)
	(fp_arc
		(start 2.54 -2.48)
		(mid 4.787211 -1.049019)
		(end 4.441103 1.592547)
		(stroke (width 0.1) (type solid))
		(layer "F.Fab")
		(uuid "dc70415b-f762-4a23-ad26-ed875be953c9")
	)
	(fp_text user "\${REFERENCE}"
		(at 2.54 0 0)
		(layer "F.Fab")
		(uuid "21e757ea-d962-4cde-a7b7-98ef2a198c54")
		(effects
			(font (size 1 1) (thickness 0.15))
		)
	)
	(pad "1" thru_hole rect
		(at 0 0)
		(size 1.5 1.5)
		(drill 0.8)
		(layers "*.Cu" "*.Mask")
		(remove_unused_layers no)
		(uuid "220ba17f-7d70-48c8-9ccc-f61fa998466c")
	)
	(pad "2" thru_hole circle
		(at 2.54 0)
		(size 1.5 1.5)
		(drill 0.8)
		(layers "*.Cu" "*.Mask")
		(remove_unused_layers no)
		(uuid "e88a7ef4-c85f-4a13-b36e-b0ce7b1f22c2")
	)
	(pad "3" thru_hole circle
		(at 5.08 0)
		(size 1.5 1.5)
		(drill 0.8)
		(layers "*.Cu" "*.Mask")
		(remove_unused_layers no)
		(uuid "97a12d3e-04b3-446c-bb2c-53b3da20f8af")
	)
	(embedded_fonts no)
	(model "\${KICAD9_3DMODEL_DIR}/Package_TO_SOT_THT.3dshapes/TO-92L_Inline_Wide.step"
		(offset (xyz 0 0 0))
		(scale (xyz 1 1 1))
		(rotate (xyz 0 0 0))
	)
)`,
  'CP_Radial_D6.3mm_P2.50mm': `
(footprint "CP_Radial_D6.3mm_P2.50mm"
	(version 20241229)
	(generator "pcbnew")
	(generator_version "9.0")
	(layer "F.Cu")
	(descr "CP, Radial series, Radial, pin pitch=2.50mm, diameter=6.3mm, height=7mm, Electrolytic Capacitor")
	(tags "CP Radial series Radial pin pitch 2.50mm diameter 6.3mm height 7mm Electrolytic Capacitor")
	(property "Reference" "REF**"
		(at 1.25 -4.4 0)
		(layer "F.SilkS")
		(uuid "9c283e96-c14a-439a-b632-17be60fed0b4")
		(effects
			(font (size 1 1) (thickness 0.15))
		)
	)
	(property "Value" "CP_Radial_D6.3mm_P2.50mm"
		(at 1.25 4.4 0)
		(layer "F.Fab")
		(uuid "6ffd2a7b-79ee-47d2-8cf0-2c2d3a8ff949")
		(effects
			(font (size 1 1) (thickness 0.15))
		)
	)
	(property "Datasheet" ""
		(at 0 0 0)
		(layer "F.Fab")
		(hide yes)
		(uuid "e780fd21-f122-4d62-a6a9-109ea103cbd2")
		(effects
			(font (size 1.27 1.27) (thickness 0.15))
		)
	)
	(property "Description" ""
		(at 0 0 0)
		(layer "F.Fab")
		(hide yes)
		(uuid "8cb5bfa5-85b7-4cd4-8c9b-360f985f7b32")
		(effects
			(font (size 1.27 1.27) (thickness 0.15))
		)
	)
	(attr through_hole)
	(fp_line
		(start -2.250241 -1.839)
		(end -1.620241 -1.839)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "1c5c9d38-d7e0-4f36-89e6-9f3f97809356")
	)
	(fp_line
		(start -1.935241 -2.154)
		(end -1.935241 -1.524)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "2372b20d-0321-490a-bb1f-fb375a565e0b")
	)
	(fp_line
		(start 1.25 -3.23)
		(end 1.25 3.23)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "7e0241d1-1a00-4157-9f31-2d4d73dcf822")
	)
	(fp_line
		(start 1.29 -3.23)
		(end 1.29 3.23)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "3eb62d8d-1803-4d87-8cff-1533b10f09ad")
	)
	(fp_line
		(start 1.33 -3.229)
		(end 1.33 3.229)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "c5c6c855-0fd2-497a-911b-83da0178635a")
	)
	(fp_line
		(start 1.37 -3.228)
		(end 1.37 3.228)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "365874b0-cf8d-4c39-832b-b23921c4b93f")
	)
	(fp_line
		(start 1.41 -3.226)
		(end 1.41 3.226)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "f553cb58-6bff-4531-aa68-126e4f306301")
	)
	(fp_line
		(start 1.45 -3.224)
		(end 1.45 3.224)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "e6c83c95-678a-40b1-9135-16b190b19452")
	)
	(fp_line
		(start 1.49 -3.221)
		(end 1.49 -1.04)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "beed79eb-edae-4d14-bab0-63a6f11549d1")
	)
	(fp_line
		(start 1.49 1.04)
		(end 1.49 3.221)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "e4dc2ca9-8f85-452d-91f0-645562e1e391")
	)
	(fp_line
		(start 1.53 -3.218)
		(end 1.53 -1.04)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "0fcc4c6c-8a55-4f4f-b45d-07218a8cb2f7")
	)
	(fp_line
		(start 1.53 1.04)
		(end 1.53 3.218)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "983e5679-b084-45b5-950a-35881394d9c4")
	)
	(fp_line
		(start 1.57 -3.214)
		(end 1.57 -1.04)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "558d272b-23a8-4685-a3b1-b53c11cdecde")
	)
	(fp_line
		(start 1.57 1.04)
		(end 1.57 3.214)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "bfcde463-965c-4410-a060-880e4729d1ea")
	)
	(fp_line
		(start 1.61 -3.21)
		(end 1.61 -1.04)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "7fe63d75-f8b7-45e6-a3a9-4d6cafaa90f5")
	)
	(fp_line
		(start 1.61 1.04)
		(end 1.61 3.21)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "5a2ff374-dedd-465b-9e3f-c238716832b2")
	)
	(fp_line
		(start 1.65 -3.205)
		(end 1.65 -1.04)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "5bc2eaac-abaa-4165-b555-b7cacc4191eb")
	)
	(fp_line
		(start 1.65 1.04)
		(end 1.65 3.205)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "a6aee647-74bd-45cc-aeb2-dea9fceb7a15")
	)
	(fp_line
		(start 1.69 -3.2)
		(end 1.69 -1.04)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "062ea0e0-783d-47d6-8b59-cb0a4442ccee")
	)
	(fp_line
		(start 1.69 1.04)
		(end 1.69 3.2)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "d19a1569-5c52-4532-bddd-28124d949d6f")
	)
	(fp_line
		(start 1.73 -3.195)
		(end 1.73 -1.04)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "1b68440d-d613-47a8-ae71-e7d06ea6abef")
	)
	(fp_line
		(start 1.73 1.04)
		(end 1.73 3.195)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "c9b80636-4123-49c6-8d2a-77fefefb3a05")
	)
	(fp_line
		(start 1.77 -3.188)
		(end 1.77 -1.04)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "34f260c2-3462-4444-8d2f-1ccef3e3f90e")
	)
	(fp_line
		(start 1.77 1.04)
		(end 1.77 3.188)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "bc273659-ffb9-4cda-b399-ccc9ac6205a4")
	)
	(fp_line
		(start 1.81 -3.182)
		(end 1.81 -1.04)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "cb49ee6f-08b2-4fb1-adda-1b190a8cfab0")
	)
	(fp_line
		(start 1.81 1.04)
		(end 1.81 3.182)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "0fec773a-e145-492b-b444-a8c8c3b0c375")
	)
	(fp_line
		(start 1.85 -3.174)
		(end 1.85 -1.04)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "4ea19201-c81e-4fa0-9bd3-e559567dbf23")
	)
	(fp_line
		(start 1.85 1.04)
		(end 1.85 3.174)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "8cd15905-d85a-451a-9044-a519c9465cd7")
	)
	(fp_line
		(start 1.89 -3.167)
		(end 1.89 -1.04)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "3eea8a32-0bed-4fa4-b003-8acaf80c50b2")
	)
	(fp_line
		(start 1.89 1.04)
		(end 1.89 3.167)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "5fb8c145-5112-4de7-a329-469250ad771d")
	)
	(fp_line
		(start 1.93 -3.159)
		(end 1.93 -1.04)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "6af449d5-932a-42d5-ac27-a96a7cf3dfd4")
	)
	(fp_line
		(start 1.93 1.04)
		(end 1.93 3.159)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "b8bc2f39-2ee3-4f48-ba49-ddccab176767")
	)
	(fp_line
		(start 1.97 -3.15)
		(end 1.97 -1.04)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "5e57afea-4a06-42d4-9d2e-40d84b06dc4d")
	)
	(fp_line
		(start 1.97 1.04)
		(end 1.97 3.15)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "ea82d242-1e7d-4d35-8b15-f62f87cd03ee")
	)
	(fp_line
		(start 2.01 -3.14)
		(end 2.01 -1.04)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "11f37fb0-79ec-4d81-8039-d3adfcd34c85")
	)
	(fp_line
		(start 2.01 1.04)
		(end 2.01 3.14)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "9a607cfd-14b6-49a7-9dfa-c7fdde6e9a4e")
	)
	(fp_line
		(start 2.05 -3.131)
		(end 2.05 -1.04)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "7a04574e-d0c5-468b-b470-aa0a848d51a7")
	)
	(fp_line
		(start 2.05 1.04)
		(end 2.05 3.131)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "712bd14e-28c7-4fc4-a54a-f79c2440aca5")
	)
	(fp_line
		(start 2.09 -3.12)
		(end 2.09 -1.04)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "31f065f4-e994-447d-a4b0-4dec69c04eff")
	)
	(fp_line
		(start 2.09 1.04)
		(end 2.09 3.12)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "2e046aea-1f71-4cb5-8413-664a6d9baa20")
	)
	(fp_line
		(start 2.13 -3.109)
		(end 2.13 -1.04)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "2c1c4fa2-c766-4d19-a9f2-230119e7eb2f")
	)
	(fp_line
		(start 2.13 1.04)
		(end 2.13 3.109)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "57e743a4-37c6-4933-9933-7603cbcb1a5e")
	)
	(fp_line
		(start 2.17 -3.098)
		(end 2.17 -1.04)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "eab4b71a-2969-4c3c-a01d-3a5a7f11ff50")
	)
	(fp_line
		(start 2.17 1.04)
		(end 2.17 3.098)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "fca2b0a6-128b-4bd8-b17d-2e11df9867d4")
	)
	(fp_line
		(start 2.21 -3.086)
		(end 2.21 -1.04)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "c3006bfb-5744-45fc-b77c-cd1a4d751d1f")
	)
	(fp_line
		(start 2.21 1.04)
		(end 2.21 3.086)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "70429ae3-0100-4259-ae75-8198dddfd5ae")
	)
	(fp_line
		(start 2.25 -3.073)
		(end 2.25 -1.04)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "55738605-8f47-4116-9e31-1ce638a2a19a")
	)
	(fp_line
		(start 2.25 1.04)
		(end 2.25 3.073)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "dcbeb90e-8d51-4e81-9375-840cc2222834")
	)
	(fp_line
		(start 2.29 -3.06)
		(end 2.29 -1.04)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "7c2ae3a0-87c0-46e8-8939-f5362fce2857")
	)
	(fp_line
		(start 2.29 1.04)
		(end 2.29 3.06)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "c9d5c02b-9628-4bdb-a481-6098cc01464f")
	)
	(fp_line
		(start 2.33 -3.047)
		(end 2.33 -1.04)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "d1fc8dce-122a-42d3-bcb3-731c42d7c1fd")
	)
	(fp_line
		(start 2.33 1.04)
		(end 2.33 3.047)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "9853a49b-5ca7-41a1-a85c-5bb40e37bd24")
	)
	(fp_line
		(start 2.37 -3.032)
		(end 2.37 -1.04)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "639cfdff-a045-409e-9057-5fe1decc2f06")
	)
	(fp_line
		(start 2.37 1.04)
		(end 2.37 3.032)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "f661722f-4401-4d54-8da0-587617d26f49")
	)
	(fp_line
		(start 2.41 -3.017)
		(end 2.41 -1.04)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "a783d771-5032-43ac-93b8-11363347189e")
	)
	(fp_line
		(start 2.41 1.04)
		(end 2.41 3.017)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "50e4f0e3-2849-4806-a1e1-760d29cf98c5")
	)
	(fp_line
		(start 2.45 -3.002)
		(end 2.45 -1.04)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "21b0c59d-ddaa-4d30-a1ff-46b1c9efb08f")
	)
	(fp_line
		(start 2.45 1.04)
		(end 2.45 3.002)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "0224dacd-b80b-41ec-9467-809f94a87860")
	)
	(fp_line
		(start 2.49 -2.986)
		(end 2.49 -1.04)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "4024d887-4cd9-4822-96b2-46bc88f85d54")
	)
	(fp_line
		(start 2.49 1.04)
		(end 2.49 2.986)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "901963a5-e4b1-45bc-8d1b-961e25853be4")
	)
	(fp_line
		(start 2.53 -2.969)
		(end 2.53 -1.04)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "57dc74cc-f7c1-4281-93df-a004fdb3e69b")
	)
	(fp_line
		(start 2.53 1.04)
		(end 2.53 2.969)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "d40cdab4-2a72-4544-b707-44ee16cded85")
	)
	(fp_line
		(start 2.57 -2.952)
		(end 2.57 -1.04)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "414943b6-a562-464d-8a79-d77814ef8996")
	)
	(fp_line
		(start 2.57 1.04)
		(end 2.57 2.952)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "2c02a292-04c0-4ef3-a0bf-c158db52a0ae")
	)
	(fp_line
		(start 2.61 -2.934)
		(end 2.61 -1.04)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "a53206fb-eddd-4812-8528-2eef845fd05e")
	)
	(fp_line
		(start 2.61 1.04)
		(end 2.61 2.934)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "b228755b-7330-46be-b67e-d5d784621957")
	)
	(fp_line
		(start 2.65 -2.915)
		(end 2.65 -1.04)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "a6d3a419-6708-4536-9c4e-e3e771ef0bf0")
	)
	(fp_line
		(start 2.65 1.04)
		(end 2.65 2.915)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "7711e512-e24b-4590-9d60-ffd1201160bc")
	)
	(fp_line
		(start 2.69 -2.896)
		(end 2.69 -1.04)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "3862db5e-bcb2-4143-b008-4a0254e5fcb2")
	)
	(fp_line
		(start 2.69 1.04)
		(end 2.69 2.896)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "bd6317d6-4462-482a-96bc-dc62c989e05a")
	)
	(fp_line
		(start 2.73 -2.876)
		(end 2.73 -1.04)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "d42aac5a-7a6f-4113-bde5-8f63842b8173")
	)
	(fp_line
		(start 2.73 1.04)
		(end 2.73 2.876)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "86f3dd9e-007f-4ce2-b733-14aa898fac28")
	)
	(fp_line
		(start 2.77 -2.855)
		(end 2.77 -1.04)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "42472fe7-108f-454e-aa5a-12663689e29d")
	)
	(fp_line
		(start 2.77 1.04)
		(end 2.77 2.855)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "0a836fdf-73f3-406e-bf8c-1316d0661385")
	)
	(fp_line
		(start 2.81 -2.834)
		(end 2.81 -1.04)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "c5977fe1-d386-432e-b221-e65e265a091c")
	)
	(fp_line
		(start 2.81 1.04)
		(end 2.81 2.834)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "f8179cb9-30b5-4dda-99ca-850d8d577fb8")
	)
	(fp_line
		(start 2.85 -2.812)
		(end 2.85 -1.04)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "539c5847-ba36-4cae-b77d-0fca44cc576b")
	)
	(fp_line
		(start 2.85 1.04)
		(end 2.85 2.812)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "f096561e-544a-49e7-be50-cdecc0b69314")
	)
	(fp_line
		(start 2.89 -2.789)
		(end 2.89 -1.04)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "a855f4c3-a4a4-45d0-8f92-6ed6f96cb622")
	)
	(fp_line
		(start 2.89 1.04)
		(end 2.89 2.789)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "5d11cecd-cd1f-4493-bfa0-2c0a6e9c61f4")
	)
	(fp_line
		(start 2.93 -2.765)
		(end 2.93 -1.04)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "16b30895-b9a1-42d6-a4e2-ab5fdd08add5")
	)
	(fp_line
		(start 2.93 1.04)
		(end 2.93 2.765)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "ca238085-fbc3-494d-99df-123ecbaa4139")
	)
	(fp_line
		(start 2.97 -2.741)
		(end 2.97 -1.04)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "5a8c1c85-3397-4308-bd51-81d607958b44")
	)
	(fp_line
		(start 2.97 1.04)
		(end 2.97 2.741)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "eb9d3238-3220-4ca7-b6d4-3ae36b60d1ea")
	)
	(fp_line
		(start 3.01 -2.716)
		(end 3.01 -1.04)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "4d06f7fc-f1b4-4d6f-854d-8c6bf9307c05")
	)
	(fp_line
		(start 3.01 1.04)
		(end 3.01 2.716)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "26eb7847-796d-4451-8b5e-8e6fe0ad79f5")
	)
	(fp_line
		(start 3.05 -2.69)
		(end 3.05 -1.04)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "c7151c10-6ab7-431f-aa07-3e6679ee14a0")
	)
	(fp_line
		(start 3.05 1.04)
		(end 3.05 2.69)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "b86a0852-b91a-4430-b6b5-1e2a18ff6cc6")
	)
	(fp_line
		(start 3.09 -2.663)
		(end 3.09 -1.04)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "42ff121a-1747-4237-af3e-f7b3a7d7fd67")
	)
	(fp_line
		(start 3.09 1.04)
		(end 3.09 2.663)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "f991ce61-4b68-45a4-b250-b6f1a374a565")
	)
	(fp_line
		(start 3.13 -2.636)
		(end 3.13 -1.04)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "556f4965-7b76-4948-a350-2078fcd060ad")
	)
	(fp_line
		(start 3.13 1.04)
		(end 3.13 2.636)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "183e8ec7-49b0-4430-badb-133a242aeae0")
	)
	(fp_line
		(start 3.17 -2.607)
		(end 3.17 -1.04)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "95c441e9-36b9-4d6d-bf68-f775b72769fb")
	)
	(fp_line
		(start 3.17 1.04)
		(end 3.17 2.607)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "44f8b504-6ccc-4333-bc03-67b1a9e5548e")
	)
	(fp_line
		(start 3.21 -2.577)
		(end 3.21 -1.04)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "db9d6cff-1ceb-4a31-a557-138d42a0edf1")
	)
	(fp_line
		(start 3.21 1.04)
		(end 3.21 2.577)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "53e43ec6-7b2f-4683-ab4f-e60d90e366fd")
	)
	(fp_line
		(start 3.25 -2.547)
		(end 3.25 -1.04)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "884a5844-81f6-440d-9acf-04e894e04270")
	)
	(fp_line
		(start 3.25 1.04)
		(end 3.25 2.547)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "5e7ef656-4b1a-49b1-be16-285e3871c212")
	)
	(fp_line
		(start 3.29 -2.516)
		(end 3.29 -1.04)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "204c978d-f050-4bde-bcb5-15c0f0b6bfff")
	)
	(fp_line
		(start 3.29 1.04)
		(end 3.29 2.516)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "855f4734-36d1-4adb-8086-002847ef584e")
	)
	(fp_line
		(start 3.33 -2.483)
		(end 3.33 -1.04)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "a5a869ff-80c9-4646-9f60-ab7a1433686e")
	)
	(fp_line
		(start 3.33 1.04)
		(end 3.33 2.483)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "12ee2902-f1f0-40a4-94d3-4e657cf078d2")
	)
	(fp_line
		(start 3.37 -2.45)
		(end 3.37 -1.04)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "464137f3-050e-4556-a8bd-054d4f56de59")
	)
	(fp_line
		(start 3.37 1.04)
		(end 3.37 2.45)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "05f0f0d7-e685-4566-b2b2-829e4e17c04a")
	)
	(fp_line
		(start 3.41 -2.415)
		(end 3.41 -1.04)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "d7c6b0b9-98a0-4660-9aef-bd2293d48392")
	)
	(fp_line
		(start 3.41 1.04)
		(end 3.41 2.415)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "c8445a82-5d01-464a-a7ed-ad4c49c9a05f")
	)
	(fp_line
		(start 3.45 -2.379)
		(end 3.45 -1.04)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "c5d29a3d-e68e-424f-8b32-43ba33df2aa9")
	)
	(fp_line
		(start 3.45 1.04)
		(end 3.45 2.379)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "fa8c2b78-5b02-49e2-8f97-351872f32a59")
	)
	(fp_line
		(start 3.49 -2.342)
		(end 3.49 -1.04)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "1f6f8afd-1172-4e60-b06c-6f86d4b78194")
	)
	(fp_line
		(start 3.49 1.04)
		(end 3.49 2.342)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "82affbc1-4844-458e-9985-3af03775ca58")
	)
	(fp_line
		(start 3.53 -2.304)
		(end 3.53 -1.04)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "a31430ef-cf4a-4f17-9a09-68625cff54c7")
	)
	(fp_line
		(start 3.53 1.04)
		(end 3.53 2.304)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "ed0ced8a-2059-4f9f-9bb2-5c3158c1f280")
	)
	(fp_line
		(start 3.57 -2.264)
		(end 3.57 2.264)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "b7698758-f55c-4d19-9d3e-cb8f187e2246")
	)
	(fp_line
		(start 3.61 -2.223)
		(end 3.61 2.223)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "e4e1e6ee-68c1-4148-b8f7-242258bf7da5")
	)
	(fp_line
		(start 3.65 -2.181)
		(end 3.65 2.181)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "e604ac40-1048-4510-9515-408b72a40762")
	)
	(fp_line
		(start 3.69 -2.137)
		(end 3.69 2.137)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "c90ace32-fb8c-4a26-8ba5-fb92e461d219")
	)
	(fp_line
		(start 3.73 -2.091)
		(end 3.73 2.091)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "4d15cc26-5278-4100-a8a4-baf55e0333e4")
	)
	(fp_line
		(start 3.77 -2.044)
		(end 3.77 2.044)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "5ed8ddc6-5afa-452f-83e1-ba240f10ff0d")
	)
	(fp_line
		(start 3.81 -1.995)
		(end 3.81 1.995)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "c5ae6ea1-e1f7-4665-9506-44bab873993e")
	)
	(fp_line
		(start 3.85 -1.943)
		(end 3.85 1.943)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "3755f286-5621-47d3-a7be-a2da43c93ab1")
	)
	(fp_line
		(start 3.89 -1.89)
		(end 3.89 1.89)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "12d68d3e-5b71-43f1-8a44-178bbd2711fb")
	)
	(fp_line
		(start 3.93 -1.834)
		(end 3.93 1.834)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "5acf6c6c-ef86-44bb-a1bd-407ed1c7b33a")
	)
	(fp_line
		(start 3.97 -1.775)
		(end 3.97 1.775)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "30deb8e6-3dce-40ee-bd13-f2d26961f81c")
	)
	(fp_line
		(start 4.01 -1.714)
		(end 4.01 1.714)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "c1f2d7db-6c79-4835-9b2d-9ba37e22f65e")
	)
	(fp_line
		(start 4.05 -1.649)
		(end 4.05 1.649)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "8db724b6-aa0c-4439-b6e5-b140b6a71481")
	)
	(fp_line
		(start 4.09 -1.581)
		(end 4.09 1.581)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "2583370b-98a3-4b9c-844a-96028bf88ce5")
	)
	(fp_line
		(start 4.13 -1.509)
		(end 4.13 1.509)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "35d3f9bd-4d19-4f21-b1cb-88615a1889b1")
	)
	(fp_line
		(start 4.17 -1.432)
		(end 4.17 1.432)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "07fd83a7-ddcc-4744-a4db-84c4f419e730")
	)
	(fp_line
		(start 4.21 -1.35)
		(end 4.21 1.35)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "2dd0be77-6dd5-43b4-8502-d4199fcb5f42")
	)
	(fp_line
		(start 4.25 -1.261)
		(end 4.25 1.261)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "18d00857-98a6-4819-9e95-405fc1a45b3c")
	)
	(fp_line
		(start 4.29 -1.165)
		(end 4.29 1.165)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "4c26faca-e3d1-4cdc-8536-774827545309")
	)
	(fp_line
		(start 4.33 -1.058)
		(end 4.33 1.058)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "74654e0c-eb67-4483-9697-c957d29cc2ee")
	)
	(fp_line
		(start 4.37 -0.939)
		(end 4.37 0.939)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "c497fba6-ada1-457f-ae0d-023e1414e3d3")
	)
	(fp_line
		(start 4.41 -0.801)
		(end 4.41 0.801)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "97c2aaf3-26ce-4ba2-8034-296bf24e1668")
	)
	(fp_line
		(start 4.45 -0.633)
		(end 4.45 0.633)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "41177e89-96d0-49d6-8b00-62f7aea42ad1")
	)
	(fp_line
		(start 4.49 -0.402)
		(end 4.49 0.402)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "c011fa06-4e42-405b-9669-a945fd7f7792")
	)
	(fp_circle
		(center 1.25 0)
		(end 4.52 0)
		(stroke (width 0.12) (type solid))
		(fill no)
		(layer "F.SilkS")
		(uuid "57834409-6785-4bba-8cc5-b794e8fa7518")
	)
	(fp_circle
		(center 1.25 0)
		(end 4.65 0)
		(stroke (width 0.05) (type solid))
		(fill no)
		(layer "F.CrtYd")
		(uuid "1f2f161a-52bc-47f9-a9c8-8890619ce21a")
	)
	(fp_line
		(start -1.443972 -1.3735)
		(end -0.813972 -1.3735)
		(stroke (width 0.1) (type solid))
		(layer "F.Fab")
		(uuid "1655159b-65ef-42d6-b234-0220d90e8f25")
	)
	(fp_line
		(start -1.128972 -1.6885)
		(end -1.128972 -1.0585)
		(stroke (width 0.1) (type solid))
		(layer "F.Fab")
		(uuid "f03c07ab-e6c3-4403-b35c-31e29bd3ab81")
	)
	(fp_circle
		(center 1.25 0)
		(end 4.4 0)
		(stroke (width 0.1) (type solid))
		(fill no)
		(layer "F.Fab")
		(uuid "8f53caf7-1a0f-4624-89ac-df22b7f71197")
	)
	(fp_text user "\${REFERENCE}"
		(at 1.25 0 0)
		(layer "F.Fab")
		(uuid "6f2aea56-5a0d-45a5-88c2-dd8a400a41c6")
		(effects
			(font (size 1 1) (thickness 0.15))
		)
	)
	(pad "1" thru_hole roundrect
		(at 0 0)
		(size 1.6 1.6)
		(drill 0.8)
		(layers "*.Cu" "*.Mask")
		(remove_unused_layers no)
		(roundrect_rratio 0.15625)
		(uuid "76cc1e70-3153-47f5-8258-164f8221c1ca")
	)
	(pad "2" thru_hole circle
		(at 2.5 0)
		(size 1.6 1.6)
		(drill 0.8)
		(layers "*.Cu" "*.Mask")
		(remove_unused_layers no)
		(uuid "960b1b09-e311-41f8-b508-bd67c1593c57")
	)
	(embedded_fonts no)
	(model "\${KICAD9_3DMODEL_DIR}/Capacitor_THT.3dshapes/CP_Radial_D6.3mm_P2.50mm.step"
		(offset (xyz 0 0 0))
		(scale (xyz 1 1 1))
		(rotate (xyz 0 0 0))
	)
)

`,
  'DIP-16_W7.62mm': `
  (footprint "DIP-16_W7.62mm"
	(version 20241229)
	(generator "pcbnew")
	(generator_version "9.0")
	(layer "F.Cu")
	(descr "16-lead though-hole mounted DIP package, row spacing 7.62mm (300 mils)")
	(tags "THT DIP DIL PDIP 2.54mm 7.62mm 300mil")
	(property "Reference" "REF**"
		(at 3.81 -2.33 0)
		(layer "F.SilkS")
		(uuid "01c5789c-02b0-4962-a22c-9039d34bf0f9")
		(effects
			(font (size 1 1) (thickness 0.15))
		)
	)
	(property "Value" "DIP-16_W7.62mm"
		(at 3.81 20.11 0)
		(layer "F.Fab")
		(uuid "ef115231-072a-4b2c-83d5-ddfef9642f43")
		(effects
			(font (size 1 1) (thickness 0.15))
		)
	)
	(property "Datasheet" ""
		(at 0 0 0)
		(layer "F.Fab")
		(hide yes)
		(uuid "052133d7-c7c7-4df2-a109-7707fd12ad28")
		(effects
			(font (size 1.27 1.27) (thickness 0.15))
		)
	)
	(property "Description" ""
		(at 0 0 0)
		(layer "F.Fab")
		(hide yes)
		(uuid "cbbb5a36-e970-4962-ac5e-298338beffba")
		(effects
			(font (size 1.27 1.27) (thickness 0.15))
		)
	)
	(attr through_hole)
	(fp_line
		(start 1.16 -1.33)
		(end 1.16 19.11)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "b1500388-8cbd-41b3-acac-947321b5a078")
	)
	(fp_line
		(start 1.16 19.11)
		(end 6.46 19.11)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "e20044fe-03f9-44c9-a9e7-a092446461e3")
	)
	(fp_line
		(start 2.81 -1.33)
		(end 1.16 -1.33)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "0247fd86-e5eb-4eb5-9d6b-d39c60910b20")
	)
	(fp_line
		(start 6.46 -1.33)
		(end 4.81 -1.33)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "211ac33b-fbb2-4875-9531-570ce04947b5")
	)
	(fp_line
		(start 6.46 19.11)
		(end 6.46 -1.33)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "45f88339-90fd-4221-a404-f5fe59b7ea23")
	)
	(fp_arc
		(start 4.81 -1.33)
		(mid 3.81 -0.33)
		(end 2.81 -1.33)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "38901089-4a42-44e9-86ca-bd2ff599f1c5")
	)
	(fp_rect
		(start -1.06 -1.52)
		(end 8.67 19.3)
		(stroke (width 0.05) (type solid))
		(fill no)
		(layer "F.CrtYd")
		(uuid "b20c4562-cd61-4a7c-85ab-1b38d02b0c54")
	)
	(fp_line
		(start 0.635 -0.27)
		(end 1.635 -1.27)
		(stroke (width 0.1) (type solid))
		(layer "F.Fab")
		(uuid "2f213135-4bfd-441f-88c8-5423e3c54e4f")
	)
	(fp_line
		(start 0.635 19.05)
		(end 0.635 -0.27)
		(stroke (width 0.1) (type solid))
		(layer "F.Fab")
		(uuid "59a20bd5-0f66-4d5a-a871-6cf25787e183")
	)
	(fp_line
		(start 1.635 -1.27)
		(end 6.985 -1.27)
		(stroke (width 0.1) (type solid))
		(layer "F.Fab")
		(uuid "1a9436d4-ab0b-4237-87f9-e14dc7650432")
	)
	(fp_line
		(start 6.985 -1.27)
		(end 6.985 19.05)
		(stroke (width 0.1) (type solid))
		(layer "F.Fab")
		(uuid "130b0272-7ff9-4a58-b783-faff6a1e2494")
	)
	(fp_line
		(start 6.985 19.05)
		(end 0.635 19.05)
		(stroke (width 0.1) (type solid))
		(layer "F.Fab")
		(uuid "5a7cc06d-6abc-4766-969c-1045366cb8ac")
	)
	(fp_text user "\${REFERENCE}"
		(at 3.81 8.89 90)
		(layer "F.Fab")
		(uuid "4927286e-9694-46f5-9ead-9ad8be60443a")
		(effects
			(font (size 1 1) (thickness 0.15))
		)
	)
	(pad "1" thru_hole roundrect
		(at 0 0)
		(size 1.6 1.6)
		(drill 0.8)
		(layers "*.Cu" "*.Mask")
		(remove_unused_layers no)
		(roundrect_rratio 0.15625)
		(uuid "3cc552e8-90f5-412e-bb8c-fdc1fb063055")
	)
	(pad "2" thru_hole circle
		(at 0 2.54)
		(size 1.6 1.6)
		(drill 0.8)
		(layers "*.Cu" "*.Mask")
		(remove_unused_layers no)
		(uuid "f2ac1835-3ff0-435a-a922-2e29d950c700")
	)
	(pad "3" thru_hole circle
		(at 0 5.08)
		(size 1.6 1.6)
		(drill 0.8)
		(layers "*.Cu" "*.Mask")
		(remove_unused_layers no)
		(uuid "a203d08e-7bb5-413f-aad0-2a39cacc753d")
	)
	(pad "4" thru_hole circle
		(at 0 7.62)
		(size 1.6 1.6)
		(drill 0.8)
		(layers "*.Cu" "*.Mask")
		(remove_unused_layers no)
		(uuid "c70c4e99-8807-4b56-904d-af397418d5eb")
	)
	(pad "5" thru_hole circle
		(at 0 10.16)
		(size 1.6 1.6)
		(drill 0.8)
		(layers "*.Cu" "*.Mask")
		(remove_unused_layers no)
		(uuid "e6e727e0-fa29-41d5-85c5-a6d4d58c6deb")
	)
	(pad "6" thru_hole circle
		(at 0 12.7)
		(size 1.6 1.6)
		(drill 0.8)
		(layers "*.Cu" "*.Mask")
		(remove_unused_layers no)
		(uuid "eb498725-6c94-4610-bf95-34b52661ca9d")
	)
	(pad "7" thru_hole circle
		(at 0 15.24)
		(size 1.6 1.6)
		(drill 0.8)
		(layers "*.Cu" "*.Mask")
		(remove_unused_layers no)
		(uuid "68019dd6-883b-4880-9f15-cc1a6af2b817")
	)
	(pad "8" thru_hole circle
		(at 0 17.78)
		(size 1.6 1.6)
		(drill 0.8)
		(layers "*.Cu" "*.Mask")
		(remove_unused_layers no)
		(uuid "eff1594d-a325-48b2-ad5e-a43e2d3f0028")
	)
	(pad "9" thru_hole circle
		(at 7.62 17.78)
		(size 1.6 1.6)
		(drill 0.8)
		(layers "*.Cu" "*.Mask")
		(remove_unused_layers no)
		(uuid "b48acf86-7bb2-4d9c-92da-0118e27c789b")
	)
	(pad "10" thru_hole circle
		(at 7.62 15.24)
		(size 1.6 1.6)
		(drill 0.8)
		(layers "*.Cu" "*.Mask")
		(remove_unused_layers no)
		(uuid "7ec56226-3a0b-43d6-9829-1a176941275b")
	)
	(pad "11" thru_hole circle
		(at 7.62 12.7)
		(size 1.6 1.6)
		(drill 0.8)
		(layers "*.Cu" "*.Mask")
		(remove_unused_layers no)
		(uuid "f8c47743-ac23-4aea-98b3-ac5cd25e7d96")
	)
	(pad "12" thru_hole circle
		(at 7.62 10.16)
		(size 1.6 1.6)
		(drill 0.8)
		(layers "*.Cu" "*.Mask")
		(remove_unused_layers no)
		(uuid "13b30475-7500-41d6-8a15-c469e20bf094")
	)
	(pad "13" thru_hole circle
		(at 7.62 7.62)
		(size 1.6 1.6)
		(drill 0.8)
		(layers "*.Cu" "*.Mask")
		(remove_unused_layers no)
		(uuid "27ab58c2-8fb4-4a5b-8be4-cf749355d486")
	)
	(pad "14" thru_hole circle
		(at 7.62 5.08)
		(size 1.6 1.6)
		(drill 0.8)
		(layers "*.Cu" "*.Mask")
		(remove_unused_layers no)
		(uuid "6fa03d2b-f749-4b6e-9b72-3248058eb546")
	)
	(pad "15" thru_hole circle
		(at 7.62 2.54)
		(size 1.6 1.6)
		(drill 0.8)
		(layers "*.Cu" "*.Mask")
		(remove_unused_layers no)
		(uuid "22ccbb6b-6eef-406e-a62e-1dc4527f9f87")
	)
	(pad "16" thru_hole circle
		(at 7.62 0)
		(size 1.6 1.6)
		(drill 0.8)
		(layers "*.Cu" "*.Mask")
		(remove_unused_layers no)
		(uuid "0f9c903e-88dc-41d0-8054-501941e24b49")
	)
	(embedded_fonts no)
	(model "\${KICAD9_3DMODEL_DIR}/Package_DIP.3dshapes/DIP-16_W7.62mm.step"
		(offset (xyz 0 0 0))
		(scale (xyz 1 1 1))
		(rotate (xyz 0 0 0))
	)
)

`,
  'LED_D3.0mm': `
  (footprint "LED_D3.0mm"
	(version 20241229)
	(generator "pcbnew")
	(generator_version "9.0")
	(layer "F.Cu")
	(descr "LED, diameter 3.0mm, 2 pins, generated by kicad-footprint-generator")
	(tags "LED")
	(property "Reference" "REF**"
		(at 1.27 -2.96 0)
		(layer "F.SilkS")
		(uuid "05ed2b1e-2f4f-44f0-98fa-d7721d21687e")
		(effects
			(font (size 1 1) (thickness 0.15))
		)
	)
	(property "Value" "LED_D3.0mm"
		(at 1.27 2.96 0)
		(layer "F.Fab")
		(uuid "52ee1b70-dea3-4c30-aa5e-4fa1c3ee6111")
		(effects
			(font (size 1 1) (thickness 0.15))
		)
	)
	(property "Datasheet" ""
		(at 0 0 0)
		(layer "F.Fab")
		(hide yes)
		(uuid "4b50209f-4eec-4f6c-9d2b-42c187537347")
		(effects
			(font (size 1.27 1.27) (thickness 0.15))
		)
	)
	(property "Description" ""
		(at 0 0 0)
		(layer "F.Fab")
		(hide yes)
		(uuid "0e2ad428-d85b-4326-895f-00a8b7376342")
		(effects
			(font (size 1.27 1.27) (thickness 0.15))
		)
	)
	(attr through_hole)
	(fp_line
		(start -0.29 -1.236)
		(end -0.29 -1.08)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "5e150d7b-9c27-4501-bc8c-efbb013b4215")
	)
	(fp_line
		(start -0.29 1.08)
		(end -0.29 1.236)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "0a252cac-92e3-4661-ac30-793109149e96")
	)
	(fp_arc
		(start -0.29 -1.235516)
		(mid 1.36566 -1.987699)
		(end 2.941437 -1.08)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "dfe4aaf5-0ffc-4283-9a97-ed4b04dd5b33")
	)
	(fp_arc
		(start 0.229039 -1.08)
		(mid 1.27 -1.5)
		(end 2.310961 -1.08)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "01c1a1b2-dd98-4c25-85a3-34bdf8aa836e")
	)
	(fp_arc
		(start 2.310961 1.08)
		(mid 1.27 1.5)
		(end 0.229039 1.08)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "e7f3f3bd-b692-4a9d-8696-bdce3ac68e84")
	)
	(fp_arc
		(start 2.941437 1.08)
		(mid 1.36566 1.987699)
		(end -0.29 1.235516)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "1c943ef1-6784-4d20-a335-eaf63f60dc26")
	)
	(fp_line
		(start -1.15 -2.21)
		(end -1.15 2.21)
		(stroke (width 0.05) (type solid))
		(layer "F.CrtYd")
		(uuid "be598ba9-9352-4af2-ac6b-a81b8f7d8201")
	)
	(fp_line
		(start -1.15 2.21)
		(end 3.69 2.21)
		(stroke (width 0.05) (type solid))
		(layer "F.CrtYd")
		(uuid "3725263b-86f0-492d-aade-9eb6bee9e264")
	)
	(fp_line
		(start 3.69 -2.21)
		(end -1.15 -2.21)
		(stroke (width 0.05) (type solid))
		(layer "F.CrtYd")
		(uuid "1e5defc6-8609-4a79-b1f3-0cc0d8c242d3")
	)
	(fp_line
		(start 3.69 2.21)
		(end 3.69 -2.21)
		(stroke (width 0.05) (type solid))
		(layer "F.CrtYd")
		(uuid "d9a1071e-2487-4edf-ac44-f95ad2f83d13")
	)
	(fp_line
		(start -0.23 -1.16619)
		(end -0.23 1.16619)
		(stroke (width 0.1) (type solid))
		(layer "F.Fab")
		(uuid "e5382b17-14ae-4e8c-9f62-ea64077dbff1")
	)
	(fp_arc
		(start -0.23 -1.16619)
		(mid 3.17 0)
		(end -0.23 1.16619)
		(stroke (width 0.1) (type solid))
		(layer "F.Fab")
		(uuid "9c6a257a-0306-4823-a7b0-d8a911944570")
	)
	(fp_circle
		(center 1.27 0)
		(end 2.77 0)
		(stroke (width 0.1) (type solid))
		(fill no)
		(layer "F.Fab")
		(uuid "1d9f0767-c98e-4b1d-a731-ed38e07583ff")
	)
	(fp_text user "\${REFERENCE}"
		(at 1.27 0 0)
		(layer "F.Fab")
		(uuid "bc9e06e3-e46d-4734-964b-377a5fe0c955")
		(effects
			(font (size 0.8 0.8) (thickness 0.12))
		)
	)
	(pad "1" thru_hole rect
		(at 0 0)
		(size 1.8 1.8)
		(drill 0.9)
		(layers "*.Cu" "*.Mask")
		(remove_unused_layers no)
		(uuid "cd170a17-08d4-449e-8eda-37a0378dfb47")
	)
	(pad "2" thru_hole circle
		(at 2.54 0)
		(size 1.8 1.8)
		(drill 0.9)
		(layers "*.Cu" "*.Mask")
		(remove_unused_layers no)
		(uuid "76528c0c-f554-4c78-ba49-752c3eb66c7b")
	)
	(embedded_fonts no)
	(model "\${KICAD9_3DMODEL_DIR}/LED_THT.3dshapes/LED_D3.0mm.step"
		(offset (xyz 0 0 0))
		(scale (xyz 1 1 1))
		(rotate (xyz 0 0 0))
	)
)

`,
  'Jack_3.5mm_QingPu_WQP-PJ398SM_Vertical_CircularHoles': `
  (footprint "Jack_3.5mm_QingPu_WQP-PJ398SM_Vertical_CircularHoles"
	(version 20241229)
	(generator "pcbnew")
	(generator_version "9.0")
	(layer "F.Cu")
	(descr "TRS 3.5mm, vertical, Thonkiconn, PCB mount, (http://www.qingpu-electronics.com/en/products/WQP-PJ398SM-362.html)")
	(tags "WQP-PJ398SM WQP-PJ301M-12 TRS 3.5mm mono vertical jack thonkiconn qingpu")
	(property "Reference" "REF**"
		(at -4.03 1.08 180)
		(layer "F.SilkS")
		(uuid "ff79a596-1913-4551-9f28-0f12a44b1cd7")
		(effects
			(font (size 1 1) (thickness 0.15))
		)
	)
	(property "Value" "Jack_3.5mm_QingPu_WQP-PJ398SM_Vertical_CircularHoles"
		(at 0 5 180)
		(layer "F.Fab")
		(uuid "464b1a29-49d5-4249-ad50-092cf78383c9")
		(effects
			(font (size 1 1) (thickness 0.15))
		)
	)
	(property "Datasheet" ""
		(at 0 0 0)
		(unlocked yes)
		(layer "F.Fab")
		(hide yes)
		(uuid "50e3a457-a552-424e-99bb-2209dd68bcb0")
		(effects
			(font (size 1.27 1.27) (thickness 0.15))
		)
	)
	(property "Description" ""
		(at 0 0 0)
		(unlocked yes)
		(layer "F.Fab")
		(hide yes)
		(uuid "db1cec70-57ad-4179-b14c-f9a9cc19ed04")
		(effects
			(font (size 1.27 1.27) (thickness 0.15))
		)
	)
	(attr through_hole)
	(fp_line
		(start -4.5 1.98)
		(end -4.5 12.48)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "100b5f99-ad6e-406a-bbbc-244f7d189042")
	)
	(fp_line
		(start -1.23 -1.17)
		(end -1.23 -0.37)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "a0b6b62f-56a0-48b4-9432-afa3dfe977b9")
	)
	(fp_line
		(start -1.23 -1.17)
		(end -0.37 -1.17)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "a117fcdd-651d-424b-8f53-beba942d51c3")
	)
	(fp_line
		(start -0.8 12.48)
		(end -4.5 12.48)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "dc3e03c3-e1e1-43c0-a5a5-25ed70fe63c2")
	)
	(fp_line
		(start -0.72 1.98)
		(end -4.5 1.98)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "1eaaae8d-b4e4-4131-90b3-97de4c74d4ed")
	)
	(fp_line
		(start 4.5 1.98)
		(end 0.72 1.98)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "81fd6856-4251-417c-b7d0-87fc59a1eec3")
	)
	(fp_line
		(start 4.5 1.98)
		(end 4.5 12.48)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "8e50786a-6262-48a6-8aa3-0d45ee4ebddb")
	)
	(fp_line
		(start 4.5 12.48)
		(end 0.8 12.48)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "36cd35a5-9839-4718-8d92-225de83519d0")
	)
	(fp_circle
		(center 0 6.48)
		(end 1.8 6.48)
		(stroke (width 0.12) (type solid))
		(fill no)
		(layer "F.SilkS")
		(uuid "717c5284-d869-48f4-9891-62c3fdfe0914")
	)
	(fp_line
		(start -5 12.98)
		(end -5 -1.42)
		(stroke (width 0.05) (type solid))
		(layer "F.CrtYd")
		(uuid "7a9773d3-207e-42fb-9250-a02b5a70b81b")
	)
	(fp_line
		(start 5 -1.42)
		(end -5 -1.42)
		(stroke (width 0.05) (type solid))
		(layer "F.CrtYd")
		(uuid "aa48ad06-7097-4b1b-bdff-f94770fb746d")
	)
	(fp_line
		(start 5 12.98)
		(end -5 12.98)
		(stroke (width 0.05) (type solid))
		(layer "F.CrtYd")
		(uuid "ec93b8a0-a081-4dd8-bbcf-a88864cdef88")
	)
	(fp_line
		(start 5 12.98)
		(end 5 -1.42)
		(stroke (width 0.05) (type solid))
		(layer "F.CrtYd")
		(uuid "74789408-4dcf-417c-8e0a-3256d868d63a")
	)
	(fp_line
		(start -4.5 12.48)
		(end -4.5 2.08)
		(stroke (width 0.1) (type solid))
		(layer "F.Fab")
		(uuid "ba5783c7-f7ef-45ab-a8a5-e5f697c2dfe0")
	)
	(fp_line
		(start 0 0)
		(end 0 2.03)
		(stroke (width 0.1) (type solid))
		(layer "F.Fab")
		(uuid "1a09691a-94fb-4f1c-9b4f-11fb466abbe8")
	)
	(fp_line
		(start 4.5 2.03)
		(end -4.5 2.03)
		(stroke (width 0.1) (type solid))
		(layer "F.Fab")
		(uuid "5ad77acd-08d1-4c0f-8930-9f31dd603090")
	)
	(fp_line
		(start 4.5 12.48)
		(end -4.5 12.48)
		(stroke (width 0.1) (type solid))
		(layer "F.Fab")
		(uuid "87120475-974a-4d70-9dbf-33e4d8e4177e")
	)
	(fp_line
		(start 4.5 12.48)
		(end 4.5 2.08)
		(stroke (width 0.1) (type solid))
		(layer "F.Fab")
		(uuid "4e4173cb-53df-408a-95a6-89de39d88a5b")
	)
	(fp_circle
		(center 0 6.48)
		(end 1.8 6.48)
		(stroke (width 0.1) (type solid))
		(fill no)
		(layer "F.Fab")
		(uuid "26bdea80-10b0-4fb9-ae7b-b2c233c959f0")
	)
	(fp_text user "KEEPOUT"
		(at 0 6.48 0)
		(layer "Cmts.User")
		(uuid "7315ea65-45ec-4b6d-ae3c-5d071a2927f1")
		(effects
			(font (size 0.4 0.4) (thickness 0.051))
		)
	)
	(fp_text user "\${REFERENCE}"
		(at 0 8 180)
		(layer "F.Fab")
		(uuid "102a9c00-053f-46d1-a5d5-528ae70b297c")
		(effects
			(font (size 1 1) (thickness 0.15))
		)
	)
	(pad "S" thru_hole rect
		(at 0 0 180)
		(size 1.93 1.83)
		(drill 1.22)
		(layers "*.Cu" "*.Mask")
		(remove_unused_layers no)
		(uuid "0b67ef7d-aa07-468b-8b69-dc9882e360cd")
	)
	(pad "T" thru_hole circle
		(at 0 11.4 180)
		(size 2.13 2.13)
		(drill 1.43)
		(layers "*.Cu" "*.Mask")
		(remove_unused_layers no)
		(uuid "4f738bd3-724e-4772-9327-aecaf3c20e94")
	)
	(pad "TN" thru_hole circle
		(at 0 3.1 180)
		(size 2.13 2.13)
		(drill 1.42)
		(layers "*.Cu" "*.Mask")
		(remove_unused_layers no)
		(uuid "d4c5c408-d503-4605-8374-886fbb668ae0")
	)
	(zone
		(net 0)
		(net_name "")
		(layer "F.Cu")
		(uuid "3f12b4ee-7fc8-413a-b4de-1610080175dc")
		(hatch full 0.508)
		(connect_pads
			(clearance 0)
		)
		(min_thickness 0.254)
		(filled_areas_thickness no)
		(keepout
			(tracks not_allowed)
			(vias not_allowed)
			(pads not_allowed)
			(copperpour not_allowed)
			(footprints not_allowed)
		)
		(placement
			(enabled no)
			(sheetname "")
		)
		(fill (thermal_gap 0.508) (thermal_bridge_width 0.508))
		(polygon
			(pts
				(xy 1.505141 6.48) (xy 1.48493 6.234171) (xy 1.424841 5.994945) (xy 1.326486 5.768744) (xy 1.192508 5.561645)
				(xy 1.026504 5.37921) (xy 0.832932 5.226336) (xy 0.616992 5.107131) (xy 0.384482 5.024794) (xy 0.141646 4.981539)
				(xy -0.104993 4.978525) (xy -0.348813 5.015835) (xy -0.583266 5.092466) (xy -0.802054 5.20636) (xy -0.999303 5.354458)
				(xy -1.169714 5.532784) (xy -1.308712 5.736548) (xy -1.412564 5.960278) (xy -1.478481 6.197965)
				(xy -1.504692 6.443226) (xy -1.490493 6.689475) (xy -1.436266 6.930099) (xy -1.343468 7.158634)
				(xy -1.214589 7.368945) (xy -1.053092 7.555382) (xy -0.863313 7.712939) (xy -0.65035 7.837385) (xy -0.419921 7.925377)
				(xy -0.178215 7.974553) (xy 0.068278 7.983592) (xy 0.312936 7.95225) (xy 0.549191 7.88137) (xy 0.770697 7.772856)
				(xy 0.971505 7.629621) (xy 1.146223 7.455512) (xy 1.290158 7.255205) (xy 1.399445 7.034079) (xy 1.471149 6.798074)
				(xy 1.503344 6.553526)
			)
		)
	)
	(embedded_fonts no)
	(model "\${KICAD9_3DMODEL_DIR}/Connector_Audio.3dshapes/Jack_3.5mm_QingPu_WQP-PJ398SM_Vertical.step"
		(offset (xyz 0 0 0))
		(scale (xyz 1 1 1))
		(rotate (xyz 0 0 0))
	)
)

`,
  'Potentiometer_Alps_RK09K_Single_Vertical': `
  (footprint "Potentiometer_Alps_RK09K_Single_Vertical"
	(version 20241229)
	(generator "pcbnew")
	(generator_version "9.0")
	(layer "F.Cu")
	(descr "113004U 1130A6S 11300DR 1130A8G 1130081 1130A5R 1130AP5 1130AST  D1130C3W D1130C1B D1130C3C D1130C2P Potentiometer, vertical, Alps RK09K Single, https://tech.alpsalpine.com/prod/e/pdf/potentiometer/rotarypotentiometers/rk09k/rk09k.pdf")
	(tags "Potentiometer vertical Alps RK09K RK09D Single Snapin")
	(property "Reference" "REF**"
		(at 6.05 -5.15 0)
		(layer "F.SilkS")
		(uuid "c7e43cd9-e64f-4820-ba14-eb2390d3d87f")
		(effects
			(font (size 1 1) (thickness 0.15))
		)
	)
	(property "Value" "Potentiometer_Alps_RK09K_Single_Vertical"
		(at 6.05 10.15 0)
		(layer "F.Fab")
		(uuid "50ce34a9-67e8-48f6-b865-7f4b4cd5199f")
		(effects
			(font (size 1 1) (thickness 0.15))
		)
	)
	(property "Datasheet" ""
		(at 0 0 0)
		(unlocked yes)
		(layer "F.Fab")
		(hide yes)
		(uuid "85879607-e869-4ecf-a337-faa5ddcefc86")
		(effects
			(font (size 1.27 1.27) (thickness 0.15))
		)
	)
	(property "Description" ""
		(at 0 0 0)
		(unlocked yes)
		(layer "F.Fab")
		(hide yes)
		(uuid "6df8a008-5dbc-4f93-b037-4afaa3646934")
		(effects
			(font (size 1.27 1.27) (thickness 0.15))
		)
	)
	(attr through_hole)
	(fp_line
		(start 0.88 -2.521)
		(end 0.88 -1.2)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "9f82140e-b518-444d-bfa4-7cedd0bbd024")
	)
	(fp_line
		(start 0.88 -2.521)
		(end 4.817 -2.521)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "54cb2b20-298c-4ecf-bf8e-f21df0ee0f25")
	)
	(fp_line
		(start 0.88 1.25)
		(end 0.88 1.63)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "d72e2623-79c4-437d-9921-bc34deca59d6")
	)
	(fp_line
		(start 0.88 3.371)
		(end 0.88 4.13)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "77ef46b2-af82-4312-bdd0-8e9158039a4b")
	)
	(fp_line
		(start 0.88 5.87)
		(end 0.88 7.52)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "19a82e17-9738-4c9e-9f7b-de157b57e913")
	)
	(fp_line
		(start 0.88 7.52)
		(end 4.817 7.52)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "5ad2b3f6-9d3f-4104-b8ab-3e0515444f65")
	)
	(fp_line
		(start 9.184 -2.521)
		(end 13.12 -2.521)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "25601fe2-075a-4d85-bf88-90ec8d19709c")
	)
	(fp_line
		(start 9.184 7.52)
		(end 13.12 7.52)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "f42da8ef-7b52-4c9a-80b0-9793613fd9f7")
	)
	(fp_line
		(start 13.12 -2.521)
		(end 13.12 7.52)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "da917a6a-33b1-46f6-b995-d07037b3410b")
	)
	(fp_line
		(start -1.15 -4.15)
		(end -1.15 9.15)
		(stroke (width 0.05) (type solid))
		(layer "F.CrtYd")
		(uuid "6de601a6-1b27-4fc3-96d7-a0f3af6db784")
	)
	(fp_line
		(start -1.15 9.15)
		(end 13.25 9.15)
		(stroke (width 0.05) (type solid))
		(layer "F.CrtYd")
		(uuid "3fc6e973-39bf-478f-9feb-16731a8ef4c5")
	)
	(fp_line
		(start 13.25 -4.15)
		(end -1.15 -4.15)
		(stroke (width 0.05) (type solid))
		(layer "F.CrtYd")
		(uuid "3a2fc7bb-2d93-47b8-9ae0-28485b8e0d5f")
	)
	(fp_line
		(start 13.25 9.15)
		(end 13.25 -4.15)
		(stroke (width 0.05) (type solid))
		(layer "F.CrtYd")
		(uuid "ec154448-69c5-433c-9405-e559b3f8f3ad")
	)
	(fp_line
		(start 1 -2.4)
		(end 1 7.4)
		(stroke (width 0.1) (type solid))
		(layer "F.Fab")
		(uuid "d730d362-e567-40ee-9905-275286b09051")
	)
	(fp_line
		(start 1 7.4)
		(end 13 7.4)
		(stroke (width 0.1) (type solid))
		(layer "F.Fab")
		(uuid "c7a9bf5b-9fc6-4503-b80b-ee6d3544a110")
	)
	(fp_line
		(start 13 -2.4)
		(end 1 -2.4)
		(stroke (width 0.1) (type solid))
		(layer "F.Fab")
		(uuid "66205fd3-630e-46ce-af28-61c1b9615e15")
	)
	(fp_line
		(start 13 7.4)
		(end 13 -2.4)
		(stroke (width 0.1) (type solid))
		(layer "F.Fab")
		(uuid "b20168ab-94b0-4e07-9571-9230664aa401")
	)
	(fp_circle
		(center 7.5 2.5)
		(end 10.5 2.5)
		(stroke (width 0.1) (type solid))
		(fill no)
		(layer "F.Fab")
		(uuid "f38d1db8-bbb0-4966-8039-c7bbd738225e")
	)
	(fp_text user "\${REFERENCE}"
		(at 2 2.5 90)
		(layer "F.Fab")
		(uuid "f48b68b3-73cf-44f6-9298-a5d31bf51423")
		(effects
			(font (size 1 1) (thickness 0.15))
		)
	)
	(pad "1" thru_hole rect
		(at 0 0)
		(size 1.8 1.8)
		(drill 1)
		(layers "*.Cu" "*.Mask")
		(remove_unused_layers no)
		(uuid "764f5c07-2b57-4016-8285-276d0b51391b")
	)
	(pad "2" thru_hole circle
		(at 0 2.5)
		(size 1.8 1.8)
		(drill 1)
		(layers "*.Cu" "*.Mask")
		(remove_unused_layers no)
		(uuid "26cd8001-e146-4689-9cf6-89c1dcbbe6fd")
	)
	(pad "3" thru_hole circle
		(at 0 5)
		(size 1.8 1.8)
		(drill 1)
		(layers "*.Cu" "*.Mask")
		(remove_unused_layers no)
		(uuid "b84ea9a3-e3b3-4024-a5e6-3b415ead2935")
	)
	(pad "MP" thru_hole roundrect
		(at 7 -1.9)
		(size 4 3)
		(drill oval 2.1 1.8)
		(layers "*.Cu" "*.Mask")
		(remove_unused_layers no)
		(roundrect_rratio 0.25)
		(uuid "27a07e70-ad3c-45b0-ae17-11fc91e0e1e5")
	)
	(pad "MP" thru_hole roundrect
		(at 7 6.9)
		(size 4 3)
		(drill oval 2.1 1.8)
		(layers "*.Cu" "*.Mask")
		(remove_unused_layers no)
		(roundrect_rratio 0.25)
		(uuid "905e78df-9df9-44b7-ab8e-2ca633cc1164")
	)
	(embedded_fonts no)
	(model "\${KICAD9_3DMODEL_DIR}/Potentiometer_THT.3dshapes/Potentiometer_Alps_RK09K_Single_Vertical.step"
		(offset (xyz 0 0 0))
		(scale (xyz 1 1 1))
		(rotate (xyz 0 0 0))
	)
)

`,
  'C_Disc_D5.0mm_W2.5mm_P5.00mm': `
  (footprint "C_Disc_D5.0mm_W2.5mm_P5.00mm"
	(version 20241229)
	(generator "pcbnew")
	(generator_version "9.0")
	(layer "F.Cu")
	(descr "C, Disc series, Radial, pin pitch=5.00mm, diameter*width=5*2.5mm^2, Capacitor, http://cdn-reichelt.de/documents/datenblatt/B300/DS_KERKO_TC.pdf")
	(tags "C Disc series Radial pin pitch 5.00mm diameter 5mm width 2.5mm Capacitor")
	(property "Reference" "REF**"
		(at 2.5 -2.5 0)
		(layer "F.SilkS")
		(uuid "2bc23204-f2ca-4132-9c36-dc09a2a8ac0e")
		(effects
			(font (size 1 1) (thickness 0.15))
		)
	)
	(property "Value" "C_Disc_D5.0mm_W2.5mm_P5.00mm"
		(at 2.5 2.5 0)
		(layer "F.Fab")
		(uuid "1b3b20ae-b2ef-41a3-9f5c-a8b49c79f8db")
		(effects
			(font (size 1 1) (thickness 0.15))
		)
	)
	(property "Datasheet" ""
		(at 0 0 0)
		(layer "F.Fab")
		(hide yes)
		(uuid "240882d6-28dd-4d47-ae58-470e03170da3")
		(effects
			(font (size 1.27 1.27) (thickness 0.15))
		)
	)
	(property "Description" ""
		(at 0 0 0)
		(layer "F.Fab")
		(hide yes)
		(uuid "81c3326f-95b9-49a6-8e5f-237c4e37ed29")
		(effects
			(font (size 1.27 1.27) (thickness 0.15))
		)
	)
	(attr through_hole)
	(fp_line
		(start -0.12 -1.37)
		(end 5.12 -1.37)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "9ae341b6-714e-4e6b-b2a3-b3c3c61ab279")
	)
	(fp_line
		(start -0.12 -1.033)
		(end -0.12 -1.37)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "659c368a-823f-43ec-b612-aa9de25636da")
	)
	(fp_line
		(start -0.12 1.37)
		(end -0.12 1.033)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "faa754fd-2798-4ec6-8a37-ec349207a516")
	)
	(fp_line
		(start 5.12 -1.37)
		(end 5.12 -1.033)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "0151f810-09a7-443c-9f36-b2f9b6052376")
	)
	(fp_line
		(start 5.12 1.033)
		(end 5.12 1.37)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "b2c39239-9208-45e4-a963-f25b5463599c")
	)
	(fp_line
		(start 5.12 1.37)
		(end -0.12 1.37)
		(stroke (width 0.12) (type solid))
		(layer "F.SilkS")
		(uuid "6089d2cd-debd-402b-ad43-d124ad4bce52")
	)
	(fp_rect
		(start -1.05 -1.5)
		(end 6.05 1.5)
		(stroke (width 0.05) (type solid))
		(fill no)
		(layer "F.CrtYd")
		(uuid "0cfe7378-64a2-4d0b-b47c-a28df8c0e27a")
	)
	(fp_rect
		(start 0 -1.25)
		(end 5 1.25)
		(stroke (width 0.1) (type solid))
		(fill no)
		(layer "F.Fab")
		(uuid "c7ba1564-0978-475b-86e5-e97fa320cd8a")
	)
	(fp_text user "\${REFERENCE}"
		(at 2.5 0 0)
		(layer "F.Fab")
		(uuid "e04b8dd1-fc6c-473e-8f60-5db221f2ee84")
		(effects
			(font (size 1 1) (thickness 0.15))
		)
	)
	(pad "1" thru_hole circle
		(at 0 0)
		(size 1.6 1.6)
		(drill 0.8)
		(layers "*.Cu" "*.Mask")
		(remove_unused_layers no)
		(uuid "82b4fdfe-9551-468e-a3fd-6c8c705ded5b")
	)
	(pad "2" thru_hole circle
		(at 5 0)
		(size 1.6 1.6)
		(drill 0.8)
		(layers "*.Cu" "*.Mask")
		(remove_unused_layers no)
		(uuid "411eae64-9da6-44f8-8520-39f09d3c5b93")
	)
	(embedded_fonts no)
	(model "\${KICAD9_3DMODEL_DIR}/Capacitor_THT.3dshapes/C_Disc_D5.0mm_W2.5mm_P5.00mm.step"
		(offset (xyz 0 0 0))
		(scale (xyz 1 1 1))
		(rotate (xyz 0 0 0))
	)
)

`,
  'Banana_Jack_1Pin': `
  (footprint "Banana_Jack_1Pin"
	(version 20241229)
	(generator "pcbnew")
	(generator_version "9.0")
	(layer "F.Cu")
	(descr "Single banana socket, footprint - 6mm drill")
	(tags "banana socket")
	(property "Reference" "REF**"
		(at 0 -6.5 0)
		(layer "F.SilkS")
		(uuid "cae53453-23a4-4035-9373-234f77ffea6b")
		(effects
			(font (size 1 1) (thickness 0.15))
		)
	)
	(property "Value" "Banana_Jack_1Pin"
		(at -0.25 6.5 0)
		(layer "F.Fab")
		(uuid "a0a5c96e-7585-4d5a-b434-7c329e22b95f")
		(effects
			(font (size 1 1) (thickness 0.15))
		)
	)
	(property "Datasheet" ""
		(at 0 0 0)
		(unlocked yes)
		(layer "F.Fab")
		(hide yes)
		(uuid "1a24e949-e1fd-4e56-8b4d-89e78a0c9295")
		(effects
			(font (size 1.27 1.27) (thickness 0.15))
		)
	)
	(property "Description" ""
		(at 0 0 0)
		(unlocked yes)
		(layer "F.Fab")
		(hide yes)
		(uuid "7501e09f-d3e3-4a79-8c85-a97926e655ce")
		(effects
			(font (size 1.27 1.27) (thickness 0.15))
		)
	)
	(attr through_hole)
	(fp_circle
		(center 0 0)
		(end 5.5 0)
		(stroke (width 0.12) (type solid))
		(fill no)
		(layer "F.SilkS")
		(uuid "d58b8bab-042c-41e8-9d9d-9e163ce2f590")
	)
	(fp_circle
		(center 0 0)
		(end 5.75 0)
		(stroke (width 0.05) (type solid))
		(fill no)
		(layer "F.CrtYd")
		(uuid "7672db33-4cdd-4a3e-930f-80a9d3a1f4f7")
	)
	(fp_circle
		(center 0 0)
		(end 2 0)
		(stroke (width 0.1) (type solid))
		(fill no)
		(layer "F.Fab")
		(uuid "d5ac2832-d797-43a8-961a-f323f5c186ce")
	)
	(fp_circle
		(center 0 0)
		(end 4.85 0.05)
		(stroke (width 0.1) (type solid))
		(fill no)
		(layer "F.Fab")
		(uuid "1a2f15df-f8d2-4d5c-a72d-390a36c0603c")
	)
	(fp_text user "\${REFERENCE}"
		(at 0 0 0)
		(layer "F.Fab")
		(uuid "5367da88-5e8e-4ef0-a67d-252f1d50b615")
		(effects
			(font (size 0.8 0.8) (thickness 0.12))
		)
	)
	(pad "1" thru_hole circle
		(at 0 0)
		(size 10.16 10.16)
		(drill 6.1)
		(layers "*.Cu" "*.Mask")
		(remove_unused_layers no)
		(uuid "5aea2b88-a3e4-4846-81d9-542cceecd34c")
	)
	(embedded_fonts no)
	(model "\${KICAD9_3DMODEL_DIR}/Connector.3dshapes/Banana_Jack_1Pin.step"
		(offset (xyz 0 0 0))
		(scale (xyz 2 2 2))
		(rotate (xyz 0 0 0))
	)
)

`,

};


// bomExport.js
// Module information database
const moduleBaseBOM = {
  ExportLed: {
    bom: [
      { name: 'LED', quantity: 1 },
      { name: '4.7k Resistor', quantity: 1 }
    ]
  },
  ExportOutlet: {
    bom: [
      { name: 'Jack', quantity: 1 },
      { name: '1k Resistor', quantity: 1 }
    ]
  },
  ExportInlet: {
    bom: [
      { name: 'Jack', quantity: 1 },
      { name: '100k Resistor', quantity: 1 }
    ]
  },
  AND: {
    bom: [
      { name: 'CD4081', quantity: 1 },
      { name: '100nF Capacitor', quantity: 1 }
    ]
  },

  OR: {
    bom: [
      { name: 'CD4071', quantity: 1 },
      { name: '100nF Capacitor', quantity: 1 }
    ]
  },

  NAND: {
    bom: [
      { name: 'CD4011', quantity: 1 },
      { name: '100nF Capacitor', quantity: 1 }
    ]
  },

  NOR: {
    bom: [
      { name: 'CD4001', quantity: 1 },
      { name: '100nF Capacitor', quantity: 1 }
    ]
  },

  XOR: {
    bom: [
      { name: 'CD4070', quantity: 1 },
      { name: '100nF Capacitor', quantity: 1 }
    ]
  },

  XNOR: {
    bom: [
      { name: 'CD4077', quantity: 1 },
      { name: '100nF Capacitor', quantity: 1 }
    ]
  },

  NOT: {
    bom: [
      { name: 'CD4069', quantity: 1 },
      { name: '100nF Capacitor', quantity: 1 }
    ]
  },

  Oscillator: {
    bom: [
      { name: 'CD40106', quantity: 1 },
      { name: '100k Potentiometer', quantity: 1 },
      { name: 'Timing Capacitor', quantity: 1, note: '10nF–1uF' },
      { name: '100nF Capacitor', quantity: 1 },
      { name: '1k Resistor', quantity: 1 }
    ]
  },

  Button: {
    notSupported: true
  },

  'Binary Counter': {
    bom: [
      { name: 'CD4040', quantity: 1 },
      { name: '2N3904', quantity: 1, note: 'RTL inverter' },
      { name: '47k Resistor', quantity: 1 },
      { name: '10k Resistor', quantity: 1 },
      { name: '100nF Capacitor', quantity: 1 }
    ]
  },

  'Ring Counter': {
    bom: [
      { name: 'CD4017', quantity: 1 },
      { name: '100nF Capacitor', quantity: 1 }
    ]
  },

  'Shift Register': {
    bom: [
      { name: 'CD4015', quantity: 1 },
      { name: '100nF Capacitor', quantity: 1 }
    ]
  },

  'Shift Register (PISO)': {
    notSupported: true
  },

  'Binary Rate Multiplier': {
    notSupported: true
  },

  Multiplexer: {
    bom: [
      { name: 'CD4051', quantity: 1 },
      { name: '100nF Capacitor', quantity: 1 }
    ]
  },

  Demultiplexer: {
    bom: [
      { name: 'CD4051', quantity: 1 },
      { name: '100nF Capacitor', quantity: 1 }
    ]
  },

  'Flip-Flop': {
    bom: [
      { name: 'CD4013', quantity: 1 },
      { name: '100nF Capacitor', quantity: 1 }
    ]
  },

  Noise: {
    bom: [
      { name: 'CD4015', quantity: 2 },
      { name: 'CD40106', quantity: 1 },
      { name: 'CD4077', quantity: 1 },
      { name: '10nF Capacitor', quantity: 1 },
      { name: '100nF Capacitor', quantity: 4 }
    ]
  },

  Output: {
    bom: [
      { name: 'LM324', quantity: 1 },
      { name: '100k Resistor', quantity: 8 },
      { name: '1uF Capacitor', quantity: 1 },
      { name: '10uF Capacitor', quantity: 2 },
      { name: '100nF Capacitor', quantity: 3 }
    ]
  },

  Oscilloscope: {
    notSupported: true
  },

  EEPROM: {
    notSupported: true
  },

  'BCD to 7-Segment': {
    notSupported: true
  },

  '7-Segment Display': {
    notSupported: true
  }
};

// Module Designer Functions
let isBomExport = false;

function enterBomExport() {
  if (isBomExport) return;
  if (dictionaryActive) closeDictionary();
  if (tutorialActive) exitTutorial();

  // 1. Save current patch to backup
  const patchData = {
    version: 2,
    modules: modules.map(m => ({
      id: m.id,
      type: m.type,
      gridX: m.gridX,
      gridY: m.gridY,
      freq: m.freq,
      assignedKey: m.assignedKey,
      memoryData: m.memoryData,
      // Save other properties as needed
    })),
    connections: connections,
    viewState: JSON.parse(JSON.stringify(viewState)),
    performanceAssignments: {
      oscillators: Array.from(performanceSnapshot.performanceOscillators.entries()),
      buttons: Array.from(performanceSnapshot.performanceButtons.entries())
    }
  };
  // if eeprom module exists close the programmer
  if (patchData.modules.some(m => m.type === 'EEPROM')) {
    closeAllEEPROMProgrammers();
  }
  localStorage.setItem('savedPatch_backup', JSON.stringify(patchData));

  // 2. Clear canvas
  // modules = [];
  // connections = [];
  // ledElements = [];
  // const container = document.getElementById('moduleContainer');
  // if (container) container.innerHTML = '';

  // Reset output module state
  // outModuleCreated = false;
  // const button = document.getElementById('createOutputModuleButton');
  // if (button) {
  //   button.classList.remove('fake-disabled');
  // }
  // syncMobileOutputButton();

  if (audioStarted) rebuildAudioGraph();
  requestWireRedraw();

  // 3. Switch UI
  isBomExport = true;
  document.body.classList.add('bom-export-mode');

  const designerPanel = document.getElementById('exportBomPanel');
  if (designerPanel) designerPanel.style.display = 'flex';

  // Specific controls to hide/shift as per user request
  const controlsToHide = [
    'saveLoadMenuButton',
    'performanceButton',
    'moduleDesignerButton',
    'startTutorialButton',
    'volume-slider-container',
    'sevenSegButton',
    'bomExportButton'
  ];

  controlsToHide.forEach(id => {
    const el = document.getElementById(id);
    if (el) el.classList.add('designer-hidden');
  });

  const rightControls = document.getElementById('saveLoadArea');
  if (rightControls) rightControls.classList.add('designer-shifted');

  const zoomArea = document.getElementById('zoomArea');
  if (zoomArea) zoomArea.classList.add('designer-shifted');

  // Reset view
  // viewState.offsetX = -5000;
  // viewState.offsetY = -5000;
  // viewState.scale = 1.0;
  // updateViewTransform();

  showGrid = false;
  const svg = document.getElementById('gridSvg');
  if (svg) {
    svg.innerHTML = ''; // Clear existing
  }
  document.body.style.background = 'var(--module-designer-bg)';

  setTimeout(() => fitToView(), 50);
  window.designerInitialState = getDesignerStateHash();
}

async function exitBomExport() {
  if (!isBomExport) return;

  // Check if there are changes (compare with initial state)
  const currentState = getDesignerStateHash();
  if (currentState !== window.designerInitialState) {
    const confirmed = await showConfirmDialog("Cancel BOM Export? Your changes will revert to the original patch.");
    if (!confirmed) return false;
  }

  // 2. Restore backup
  const backup = localStorage.getItem('savedPatch_backup');
  if (backup) {
    try {
      const patchData = JSON.parse(backup);
      loadPatchFromData(patchData); // Reuse loadTutorialPatch for clean loading
    } catch (e) {
      console.error("Failed to restore backup", e);
      loadDefaultPatch();
    }
  } else {
    loadDefaultPatch();
  }

  // 3. Switch UI
  isBomExport = false;
  document.body.classList.remove('bom-export-mode');

  const designerPanel = document.getElementById('exportBomPanel');
  if (designerPanel) designerPanel.style.display = 'none';

  // Restore specific controls
  const controlsToHide = [
    'saveLoadMenuButton',
    'performanceButton',
    'moduleDesignerButton',
    'startTutorialButton',
    'volume-slider-container',
    'sevenSegButton',
    'bomExportButton'
  ];

  controlsToHide.forEach(id => {
    const el = document.getElementById(id);
    if (el) el.classList.remove('designer-hidden');
  });

  const rightControls = document.getElementById('saveLoadArea');
  if (rightControls) rightControls.classList.remove('designer-shifted');

  const volumeSlider = document.getElementById('volume-slider-container');
  if (volumeSlider) volumeSlider.classList.remove('designer-shifted');

  const zoomArea = document.getElementById('zoomArea');
  if (zoomArea) zoomArea.classList.remove('designer-shifted');


  showGrid = true;
  document.body.style.background = 'var(--bg-quaternary)';

  drawGrid();
  setTimeout(() => fitToView(), 50);
  return true;
}

// Initialize menu and event listeners on load
window.addEventListener('load', () => {
  // Wait for DB to load (handled in main.js)
  // updateCustomModuleMenu(); 

  // Robustly attach exit listener, handling potential duplicate from main.js or other sources
  const exitBtn = document.getElementById('exitBomExportBtn');
  if (exitBtn) {
    // Clone node to strip existing listeners (like the one in main.jsMain, if any) 
    // to prevent double execution or propagation issues
    const newExitBtn = exitBtn.cloneNode(true);
    exitBtn.parentNode.replaceChild(newExitBtn, exitBtn);
    newExitBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      e.preventDefault();
      exitBomExport();
    });
  }

  const exportBomBtn = document.getElementById('exportBom');
  if (exportBomBtn) {
    exportBomBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      e.preventDefault();
      exportBOM();
    });
  }

  const exportKicadPCBBtn = document.getElementById('exportKicadPCB');
  if (exportKicadPCBBtn) {
    exportKicadPCBBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      e.preventDefault();
      exportPCB();
    });
  }
});

function exportBOM() {
  // Filter modules to only exportable types
  const exportableModules = modules.filter(m => {
    const baseBOM = moduleBaseBOM[m.type];
    return baseBOM && !baseBOM.notSupported;
  });

  if (exportableModules.length === 0) {
    showAlert('No hardware-compatible modules in patch to export');
    return;
  }

  // Check for unsupported modules and notify user
  const unsupportedModules = modules.filter(m => {
    const baseBOM = moduleBaseBOM[m.type];
    return !baseBOM || baseBOM.notSupported;
  });

  if (unsupportedModules.length > 0) {
    const unsupportedTypes = [...new Set(unsupportedModules.map(m => m.type))];
    showAlert(`Note: These modules are not hardware-compatible and will be excluded from BOM: ${unsupportedTypes.join(', ')}`);
  }

  // Initialize component counts
  const bomMap = new Map();

  // Helper to add component to BOM
  function addComponent(name, quantity, note = '') {
    const key = note ? `${name} (${note})` : name;
    bomMap.set(key, (bomMap.get(key) || 0) + quantity);
  }

  // Count logic gates by type for intelligent grouping
  const gateTypes = {
    'AND': { chip: 'CD4081', perChip: 4, modules: [] },
    'OR': { chip: 'CD4071', perChip: 4, modules: [] },
    'NAND': { chip: 'CD4011', perChip: 4, modules: [] },
    'NOR': { chip: 'CD4001', perChip: 4, modules: [] },
    'XOR': { chip: 'CD4070', perChip: 4, modules: [] },
    'XNOR': { chip: 'CD4077', perChip: 4, modules: [] },
    'NOT': { chip: 'CD4069', perChip: 6, modules: [] }
  };

  // Count oscillators separately (they share CD40106 chips)
  const oscillators = [];

  // Categorize modules
  exportableModules.forEach(m => {
    if (gateTypes[m.type]) {
      gateTypes[m.type].modules.push(m);
    } else if (m.type === 'Oscillator') {
      oscillators.push(m);
    }
  });

  // Process logic gates with intelligent grouping
  Object.entries(gateTypes).forEach(([type, info]) => {
    if (info.modules.length > 0) {
      const chipsNeeded = Math.ceil(info.modules.length / info.perChip);
      addComponent(info.chip, chipsNeeded);
      addComponent('100nF Capacitor', chipsNeeded); // One decoupling cap per chip
    }
  });

  // Process oscillators with intelligent grouping
  if (oscillators.length > 0) {
    const oscillatorChips = Math.ceil(oscillators.length / 6); // 6 inverters per CD40106
    addComponent('CD40106', oscillatorChips);
    addComponent('100nF Capacitor', oscillatorChips); // One decoupling cap per chip

    // Each oscillator needs its own timing components
    addComponent('100k Potentiometer', oscillators.length);
    addComponent('1k Resistor', oscillators.length);
    addComponent('Timing Capacitor', oscillators.length, '10nF–1uF');
  }

  // Process remaining modules individually
  exportableModules.forEach(m => {
    // Skip gates and oscillators (already processed)
    if (gateTypes[m.type] || m.type === 'Oscillator') {
      return;
    }

    const baseBOM = moduleBaseBOM[m.type];
    if (baseBOM && baseBOM.bom) {
      baseBOM.bom.forEach(item => {
        addComponent(item.name, item.quantity, item.note || '');
      });
    }
  });

  // Generate CSV
  let csv = 'Component,Quantity,Notes\n';

  // Sort components alphabetically
  const sortedEntries = Array.from(bomMap.entries()).sort((a, b) =>
    a[0].localeCompare(b[0])
  );

  sortedEntries.forEach(([component, quantity]) => {
    // Extract note if present
    const match = component.match(/^(.+?)\s*\((.+)\)$/);
    if (match) {
      const [, name, note] = match;
      csv += `"${name}",${quantity},"${note}"\n`;
    } else {
      csv += `"${component}",${quantity},""\n`;
    }
  });

  // Create and download CSV file
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);

  link.setAttribute('href', url);
  link.setAttribute('download', 'logic_synth_bom.csv');
  link.style.visibility = 'hidden';

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  // showAlert(`BOM exported successfully! ${sortedEntries.length} unique components.`);
}

async function exportSchematic() {
  // Build intent JSON
  const intent = {
    modules: modules
      .filter(m => !moduleBaseBOM[m.type]?.notSupported)
      .map(m => ({
        id: `${m.type.toLowerCase()}_${m.id}`,
        type: m.type,
        jsModuleId: m.id
      })),
    connections: connections.map(c => ({
      from: {
        module: `${modules.find(m => m.id === c.from).type.toLowerCase()}_${c.from}`,
        port: "out",
        portIndex: c.fromOutputIndex
      },
      to: {
        module: `${modules.find(m => m.id === c.to).type.toLowerCase()}_${c.to}`,
        port: "in",
        portIndex: c.inputIndex
      }
    })),
    rules: {
      terminate_unused_inputs: true
    }
  };

  // Generate a schematic PDF based on intent

  // Download file
}

// Pinout configurations for each module type
const modulePinouts = {
  'AND': {
    chip: 'CD4081',
    gatesPerChip: 4,
    pinMapping: [
      { inputA: 1, inputB: 2, output: 3 },
      { inputA: 5, inputB: 6, output: 4 },
      { inputA: 8, inputB: 9, output: 10 },
      { inputA: 12, inputB: 13, output: 11 }
    ]
  },
  'OR': {
    chip: 'CD4071',
    gatesPerChip: 4,
    pinMapping: [
      { inputA: 1, inputB: 2, output: 3 },
      { inputA: 5, inputB: 6, output: 4 },
      { inputA: 8, inputB: 9, output: 10 },
      { inputA: 12, inputB: 13, output: 11 }
    ]
  },
  'NAND': {
    chip: 'CD4011',
    gatesPerChip: 4,
    pinMapping: [
      { inputA: 1, inputB: 2, output: 3 },
      { inputA: 5, inputB: 6, output: 4 },
      { inputA: 8, inputB: 9, output: 10 },
      { inputA: 12, inputB: 13, output: 11 }
    ]
  },
  'NOR': {
    chip: 'CD4001',
    gatesPerChip: 4,
    pinMapping: [
      { inputA: 1, inputB: 2, output: 3 },
      { inputA: 5, inputB: 6, output: 4 },
      { inputA: 8, inputB: 9, output: 10 },
      { inputA: 12, inputB: 13, output: 11 }
    ]
  },
  'XOR': {
    chip: 'CD4070',
    gatesPerChip: 4,
    pinMapping: [
      { inputA: 1, inputB: 2, output: 3 },
      { inputA: 5, inputB: 6, output: 4 },
      { inputA: 8, inputB: 9, output: 10 },
      { inputA: 12, inputB: 13, output: 11 }
    ]
  },
  'XNOR': {
    chip: 'CD4077',
    gatesPerChip: 4,
    pinMapping: [
      { inputA: 1, inputB: 2, output: 3 },
      { inputA: 5, inputB: 6, output: 4 },
      { inputA: 8, inputB: 9, output: 10 },
      { inputA: 12, inputB: 13, output: 11 }
    ]
  },
  'NOT': {
    chip: 'CD4069',
    gatesPerChip: 6,
    pinMapping: [
      { input: 1, output: 2 },
      { input: 3, output: 4 },
      { input: 5, output: 6 },
      { input: 9, output: 8 },
      { input: 11, output: 10 },
      { input: 13, output: 12 }
    ]
  },
  // Oscillators share CD40106 chips (6 oscillators per chip)
  // Each oscillator uses one Schmitt trigger inverter gate
  'Oscillator': {
    chip: 'CD40106',
    gatesPerChip: 6,
    pinMapping: [
      { input: 1, output: 2 },   // Gate 0
      { input: 3, output: 4 },   // Gate 1
      { input: 5, output: 6 },   // Gate 2
      { input: 9, output: 8 },   // Gate 3
      { input: 11, output: 10 }, // Gate 4
      { input: 13, output: 12 }  // Gate 5
    ]
  }
};

// Internal wiring configurations for modules with discrete components
const moduleInternalNets = {
  // ============================================================
  // OSCILLATOR - Uses CD40106 Schmitt trigger inverter
  // Oscillators share CD40106 chips (6 per chip) - handled in exportPCB
  // ============================================================
  'Oscillator': {
    components: [
      { id: 'IC', type: 'CD40106', gate: 0 }, // gate index assigned dynamically
      { id: 'POT', type: '100k Potentiometer' },
      { id: 'RES', type: '1k Resistor' },
      { id: 'TCAP', type: 'Timing Capacitor' },
      { id: 'DCAP', type: '100nF Capacitor' }
    ],
    internalConnections: [
      // Feedback network: Output -> Pot -> Resistor -> Input
      { from: 'IC.output', to: 'POT.pin1' },
      { from: 'POT.wiper', to: 'RES.pin1' },
      { from: 'RES.pin2', to: 'IC.input' },

      // Timing cap: Input to ground
      { from: 'IC.input', to: 'TCAP.pin1' },
      { from: 'TCAP.pin2', to: 'GND' },

      // Decoupling cap: VCC to ground (one per chip, handled in chip allocation)
      { from: 'VCC', to: 'DCAP.pin1' },
      { from: 'DCAP.pin2', to: 'GND' },

      // Module output comes from IC output
      { from: 'IC.output', to: 'MODULE_OUTPUT' }
    ]
  },

  // ============================================================
  // BINARY COUNTER - CD4040 12-bit counter with RTL clock inverter
  // ============================================================
  'Binary Counter': {
    components: [
      { id: 'IC', type: 'CD4040' },
      { id: 'Q1', type: '2N3904' },
      { id: 'R1', type: '47k Resistor' },
      { id: 'R2', type: '10k Resistor' },
      { id: 'DCAP', type: '100nF Capacitor' }
    ],
    internalConnections: [
      // RTL inverter for clock input (triggers on rising edge)
      { from: 'MODULE_INPUT.0', to: 'R2.pin1' },  // Clock input
      { from: 'R2.pin2', to: 'Q1.base' },
      { from: 'Q1.collector', to: 'R1.pin1' },
      { from: 'R1.pin2', to: 'VCC' },
      { from: 'Q1.emitter', to: 'GND' },
      { from: 'Q1.collector', to: 'IC.pin10' },   // CD4040 CLK pin

      // Reset input
      { from: 'MODULE_INPUT.1', to: 'IC.pin11' }, // CD4040 RST pin

      // Counter outputs (Q0-Q7 exposed)
      { from: 'IC.pin9', to: 'MODULE_OUTPUT.0' },  // Q0
      { from: 'IC.pin7', to: 'MODULE_OUTPUT.1' },  // Q1
      { from: 'IC.pin6', to: 'MODULE_OUTPUT.2' },  // Q2
      { from: 'IC.pin5', to: 'MODULE_OUTPUT.3' },  // Q3
      { from: 'IC.pin3', to: 'MODULE_OUTPUT.4' },  // Q4
      { from: 'IC.pin2', to: 'MODULE_OUTPUT.5' },  // Q5
      { from: 'IC.pin4', to: 'MODULE_OUTPUT.6' },  // Q6
      { from: 'IC.pin13', to: 'MODULE_OUTPUT.7' }, // Q7

      // Decoupling
      { from: 'VCC', to: 'DCAP.pin1' },
      { from: 'DCAP.pin2', to: 'GND' }
    ]
  },

  // ============================================================
  // RING COUNTER - CD4017 decade counter
  // ============================================================
  'Ring Counter': {
    components: [
      { id: 'IC', type: 'CD4017' },
      { id: 'DCAP', type: '100nF Capacitor' }
    ],
    internalConnections: [
      // Clock input
      { from: 'MODULE_INPUT.0', to: 'IC.pin14' },  // CD4017 CLK pin

      // Reset input
      { from: 'MODULE_INPUT.1', to: 'IC.pin15' },  // CD4017 RST pin

      // Clock Enable tied to GND (always enabled)
      { from: 'IC.pin13', to: 'GND' },             // CE pin

      // Outputs (0-7 exposed)
      { from: 'IC.pin3', to: 'MODULE_OUTPUT.0' },  // Q0
      { from: 'IC.pin2', to: 'MODULE_OUTPUT.1' },  // Q1
      { from: 'IC.pin4', to: 'MODULE_OUTPUT.2' },  // Q2
      { from: 'IC.pin7', to: 'MODULE_OUTPUT.3' },  // Q3
      { from: 'IC.pin10', to: 'MODULE_OUTPUT.4' }, // Q4
      { from: 'IC.pin1', to: 'MODULE_OUTPUT.5' },  // Q5
      { from: 'IC.pin5', to: 'MODULE_OUTPUT.6' },  // Q6
      { from: 'IC.pin6', to: 'MODULE_OUTPUT.7' },  // Q7

      // Decoupling
      { from: 'VCC', to: 'DCAP.pin1' },
      { from: 'DCAP.pin2', to: 'GND' }
    ]
  },

  // ============================================================
  // SHIFT REGISTER (SIPO) - CD4015 dual 4-bit shift register
  // ============================================================
  'Shift Register': {
    components: [
      { id: 'IC', type: 'CD4015' },
      { id: 'DCAP', type: '100nF Capacitor' }
    ],
    internalConnections: [
      // RTL inverter for clock input (triggers on rising edge)
      { from: 'MODULE_INPUT.0', to: 'IC.pin1' },    // CLK A
      { from: 'MODULE_INPUT.0', to: 'IC.pin9' },   // CLK B (chained)

      // Data input
      { from: 'MODULE_INPUT.1', to: 'IC.pin7' }, // DATA A

      // Chain A to B
      { from: 'IC.pin10', to: 'IC.pin15' },         // Q3A -> DATA B

      // Reset input
      { from: 'MODULE_INPUT.2', to: 'IC.pin6' },  // RST A
      { from: 'MODULE_INPUT.2', to: 'IC.pin14' }, // RST B

      // Outputs (Q0-Q7)
      { from: 'IC.pin5', to: 'MODULE_OUTPUT.0' },  // Q0A
      { from: 'IC.pin4', to: 'MODULE_OUTPUT.1' },  // Q1A
      { from: 'IC.pin3', to: 'MODULE_OUTPUT.2' },  // Q2A
      { from: 'IC.pin10', to: 'MODULE_OUTPUT.3' },  // Q3A
      { from: 'IC.pin13', to: 'MODULE_OUTPUT.4' }, // Q0B
      { from: 'IC.pin12', to: 'MODULE_OUTPUT.5' }, // Q1B
      { from: 'IC.pin11', to: 'MODULE_OUTPUT.6' }, // Q2B
      { from: 'IC.pin2', to: 'MODULE_OUTPUT.7' }, // Q3B

      // Decoupling
      { from: 'VCC', to: 'DCAP.pin1' },
      { from: 'DCAP.pin2', to: 'GND' }
    ]
  },

  // ============================================================
  // FLIP-FLOP - CD4013 dual D-type flip-flop
  // ============================================================
  'Flip-Flop': {
    components: [
      { id: 'IC', type: 'CD4013' },
      { id: 'DCAP', type: '100nF Capacitor' }
    ],
    internalConnections: [
      // Clock input
      { from: 'MODULE_INPUT.0', to: 'IC.pin3' },  // CLK

      // Data input
      { from: 'MODULE_INPUT.1', to: 'IC.pin5' },  // D

      // Set/Reset tied to GND (not used)
      { from: 'IC.pin4', to: 'GND' },             // RST
      { from: 'IC.pin6', to: 'GND' },             // SET

      // Second flip-flop unused - tie inputs to GND
      { from: 'IC.pin8', to: 'GND' },             // SET2
      { from: 'IC.pin9', to: 'GND' },             // D2
      { from: 'IC.pin10', to: 'GND' },            // RST2
      { from: 'IC.pin11', to: 'GND' },            // CLK2

      // Outputs
      { from: 'IC.pin1', to: 'MODULE_OUTPUT.0' }, // Q
      { from: 'IC.pin2', to: 'MODULE_OUTPUT.1' }, // Q' (inverted)

      // Decoupling
      { from: 'VCC', to: 'DCAP.pin1' },
      { from: 'DCAP.pin2', to: 'GND' }
    ]
  },

  // ============================================================
  // MULTIPLEXER - CD4051 8-to-1 analog mux
  // ============================================================
  'Multiplexer': {
    components: [
      { id: 'IC', type: 'CD4051' },
      { id: 'DCAP', type: '100nF Capacitor' }
    ],
    internalConnections: [
      // Address inputs A, B, C
      { from: 'MODULE_INPUT.0', to: 'IC.pin11' }, // A
      { from: 'MODULE_INPUT.1', to: 'IC.pin10' }, // B
      { from: 'MODULE_INPUT.2', to: 'IC.pin9' },  // C

      // Inhibit tied to GND (always enabled)
      { from: 'IC.pin6', to: 'GND' },             // INH

      // VEE tied to GND (single supply operation)
      { from: 'IC.pin7', to: 'GND' },             // VEE

      // Data inputs (X0-X7)
      { from: 'MODULE_INPUT.3', to: 'IC.pin13' }, // X0
      { from: 'MODULE_INPUT.4', to: 'IC.pin14' }, // X1
      { from: 'MODULE_INPUT.5', to: 'IC.pin15' }, // X2
      { from: 'MODULE_INPUT.6', to: 'IC.pin12' }, // X3
      { from: 'MODULE_INPUT.7', to: 'IC.pin1' },  // X4
      { from: 'MODULE_INPUT.8', to: 'IC.pin5' },  // X5
      { from: 'MODULE_INPUT.9', to: 'IC.pin2' },  // X6
      { from: 'MODULE_INPUT.10', to: 'IC.pin4' }, // X7

      // Common I/O (output)
      { from: 'IC.pin3', to: 'MODULE_OUTPUT' },   // COM

      // Decoupling
      { from: 'VCC', to: 'DCAP.pin1' },
      { from: 'DCAP.pin2', to: 'GND' }
    ]
  },

  // ============================================================
  // DEMULTIPLEXER - CD4051 1-to-8 analog demux
  // ============================================================
  'Demultiplexer': {
    components: [
      { id: 'IC', type: 'CD4051' },
      { id: 'DCAP', type: '100nF Capacitor' }
    ],
    internalConnections: [
      // Address inputs A, B, C
      { from: 'MODULE_INPUT.0', to: 'IC.pin11' }, // A
      { from: 'MODULE_INPUT.1', to: 'IC.pin10' }, // B
      { from: 'MODULE_INPUT.2', to: 'IC.pin9' },  // C

      // Data input
      { from: 'MODULE_INPUT.3', to: 'IC.pin3' },  // COM (input)

      // Inhibit tied to GND (always enabled)
      { from: 'IC.pin6', to: 'GND' },             // INH

      // VEE tied to GND (single supply operation)
      { from: 'IC.pin7', to: 'GND' },             // VEE

      // Data outputs (X0-X7)
      { from: 'IC.pin13', to: 'MODULE_OUTPUT.0' }, // X0
      { from: 'IC.pin14', to: 'MODULE_OUTPUT.1' }, // X1
      { from: 'IC.pin15', to: 'MODULE_OUTPUT.2' }, // X2
      { from: 'IC.pin12', to: 'MODULE_OUTPUT.3' }, // X3
      { from: 'IC.pin1', to: 'MODULE_OUTPUT.4' },  // X4
      { from: 'IC.pin5', to: 'MODULE_OUTPUT.5' },  // X5
      { from: 'IC.pin2', to: 'MODULE_OUTPUT.6' },  // X6
      { from: 'IC.pin4', to: 'MODULE_OUTPUT.7' },  // X7

      // Decoupling
      { from: 'VCC', to: 'DCAP.pin1' },
      { from: 'DCAP.pin2', to: 'GND' }
    ]
  },

  // ============================================================
  // LED INDICATOR
  // Signal -> 4.7k Resistor -> LED (anode) -> LED (cathode) -> GND
  // ============================================================
  'ExportLed': {
    components: [
      { id: 'RES', type: '4.7k Resistor' },
      { id: 'LED', type: 'LED' }
    ],
    internalConnections: [
      { from: 'MODULE_INPUT', to: 'RES.pin1' },
      { from: 'RES.pin2', to: 'LED.anode' },
      { from: 'LED.cathode', to: 'GND' }
    ]
  },

  // ============================================================
  // JACK OUTPUT (Outlet)
  // T (tip) <- 1k Resistor <- User's signal
  // S (sleeve) -> GND
  // ============================================================
  'ExportOutlet': {
    components: [
      { id: 'RES', type: '1k Resistor' },
      { id: 'JACK', type: 'Jack' }
    ],
    internalConnections: [
      { from: 'MODULE_INPUT', to: 'RES.pin1' },
      { from: 'RES.pin2', to: 'JACK.T' },
      { from: 'JACK.S', to: 'GND' }
    ]
  },

  // ============================================================
  // JACK INPUT (Inlet)
  // T (tip) -> 100k pulldown to GND
  // T (tip) -> User's connection (MODULE_OUTPUT)
  // S (sleeve) -> GND
  // ============================================================
  'ExportInlet': {
    components: [
      { id: 'JACK', type: 'Jack' },
      { id: 'RES', type: '100k Resistor' }
    ],
    internalConnections: [
      // Tip to pulldown resistor to GND
      { from: 'JACK.T', to: 'RES.pin1' },
      { from: 'RES.pin2', to: 'GND' },
      // Tip also goes to module output
      { from: 'JACK.T', to: 'MODULE_OUTPUT' },
      // Pulldown also goes to module output to share the external net
      { from: 'RES.pin1', to: 'MODULE_OUTPUT' },
      // Sleeve to GND
      { from: 'JACK.S', to: 'GND' }
    ]
  },

  // ============================================================
  // NOISE GENERATOR - 16-bit LFSR using shift registers
  // ============================================================
  'Noise': {
    components: [
      { id: 'IC1', type: 'CD4015' },         // First 8-bit shift register
      { id: 'IC2', type: 'CD4015' },         // Second 8-bit shift register
      { id: 'IC3', type: 'CD40106', gate: 0 }, // Internal oscillator
      { id: 'IC4', type: 'CD4077' },         // XNOR gates for feedback
      { id: 'TCAP', type: '10nF Capacitor' }, // Oscillator timing cap
      { id: 'DCAP1', type: '100nF Capacitor' },
      { id: 'DCAP2', type: '100nF Capacitor' },
      { id: 'DCAP3', type: '100nF Capacitor' },
      { id: 'DCAP4', type: '100nF Capacitor' }
    ],
    internalConnections: [
      // === DECOUPLING CAPS (Required) ===
      { from: 'VCC', to: 'DCAP1.pin1' },
      { from: 'DCAP1.pin2', to: 'GND' },
      { from: 'VCC', to: 'DCAP2.pin1' },
      { from: 'DCAP2.pin2', to: 'GND' },
      { from: 'VCC', to: 'DCAP3.pin1' },
      { from: 'DCAP3.pin2', to: 'GND' },
      { from: 'VCC', to: 'DCAP4.pin1' },
      { from: 'DCAP4.pin2', to: 'GND' },

      // === INTERNAL OSCILLATOR (Clock source) ===
      // Feedback resistor built into CD40106 threshold
      { from: 'IC3.output', to: 'IC3.input' }, // Direct feedback for oscillation
      { from: 'IC3.input', to: 'TCAP.pin1' },
      { from: 'TCAP.pin2', to: 'GND' },

      // === PLACEHOLDER: LFSR FEEDBACK TAPS ===
      // Common 16-bit LFSR taps: bits 15, 14, 12, 3
      // Replace with your specific configuration:
      //
      // { from: 'IC2.pin13', to: 'IC4.pin1' },  // Bit 15 -> XNOR A input 1
      // { from: 'IC2.pin12', to: 'IC4.pin2' },  // Bit 14 -> XNOR A input 2
      // { from: 'IC4.pin3', to: 'IC4.pin5' },   // XNOR A out -> XNOR B input 1
      // { from: 'IC2.pin10', to: 'IC4.pin6' },  // Bit 12 -> XNOR B input 2
      // { from: 'IC4.pin4', to: 'IC4.pin8' },   // XNOR B out -> XNOR C input 1
      // { from: 'IC1.pin4', to: 'IC4.pin9' },   // Bit 3 -> XNOR C input 2
      // { from: 'IC4.pin10', to: 'IC1.pin15' }, // XNOR C out -> Shift register data in

      // === PLACEHOLDER: CLOCK DISTRIBUTION ===
      // { from: 'IC3.output', to: 'IC1.pin1' }, // Osc -> SR1 CLK A
      // { from: 'IC3.output', to: 'IC1.pin9' }, // Osc -> SR1 CLK B
      // { from: 'IC3.output', to: 'IC2.pin1' }, // Osc -> SR2 CLK A
      // { from: 'IC3.output', to: 'IC2.pin9' }, // Osc -> SR2 CLK B

      // === PLACEHOLDER: CHAIN REGISTERS ===
      // { from: 'IC1.pin4', to: 'IC1.pin7' },   // Q3A -> DATA B
      // { from: 'IC1.pin13', to: 'IC2.pin15' }, // Q3B -> SR2 DATA A
      // { from: 'IC2.pin4', to: 'IC2.pin7' },   // Q3A -> DATA B

      // === OUTPUT ===
      // { from: 'IC2.pin13', to: 'MODULE_OUTPUT' }, // Use MSB as output

      // === RESET (Optional - tie low for continuous operation) ===
      { from: 'IC1.pin6', to: 'GND' },
      { from: 'IC1.pin14', to: 'GND' },
      { from: 'IC2.pin6', to: 'GND' },
      { from: 'IC2.pin14', to: 'GND' }
    ]
  },

  // ============================================================
  // AUDIO OUTPUT - 4-channel unity gain mixer
  // ============================================================
  'Output': {
    components: [
      { id: 'IC', type: 'LM324' },
      { id: 'DCAP1', type: '100nF Capacitor' }, // LM324 decoupling
      { id: 'DCAP2', type: '100nF Capacitor' }, // Vgnd in decoupling
      { id: 'DCAP3', type: '100nF Capacitor' }, // Vgnd out decoupling
      { id: 'CCAP1', type: '1uF Capacitor' },      // AC coupling on input 1
      { id: 'CCAP2', type: '1uF Capacitor' },      // AC coupling on input 2
      { id: 'CCAP3', type: '1uF Capacitor' },      // AC coupling on input 3
      { id: 'CCAP4', type: '1uF Capacitor' },      // AC coupling on input 4
      { id: 'CCAP5', type: '1uF Capacitor' },      // AC coupling on output
      { id: 'VGND1', type: '10uF Capacitor' },    // Virtual ground in
      { id: 'VGND2', type: '10uF Capacitor' },    // Virtual ground out

      { id: 'R1', type: '100k Resistor' },  // Input resistor 1
      { id: 'R2', type: '100k Resistor' },  // Input resistor 2
      { id: 'R3', type: '100k Resistor' },  // Input resistor 3
      { id: 'R4', type: '100k Resistor' },  // Input resistor 4
      { id: 'R5', type: '100k Resistor' },  // Vgnd divider 1
      { id: 'R6', type: '100k Resistor' },  // Vgnd divider 2
      { id: 'R7', type: '100k Resistor' },  // Summing feedback
      { id: 'R8', type: '100k Resistor' },  // inverting input
      { id: 'R9', type: '100k Resistor' },  // inverting feedback
      { id: 'ROUT', type: '1k Resistor' },  // Output 

      { id: 'MAIN_OUT', type: 'Jack' },  // Output 
    ],
    internalConnections: [
      // === DECOUPLING CAP ===
      { from: 'VCC', to: 'DCAP1.pin1' },
      { from: 'DCAP1.pin2', to: 'GND' },

      // === VIRTUAL GROUND CIRCUIT ===
      // Create Vgnd at VCC/2 using voltage divider + buffer op-amp
      { from: 'VCC', to: 'R5.pin1' },
      { from: 'R5.pin2', to: 'R6.pin1' },
      { from: 'R6.pin2', to: 'GND' },
      { from: 'R5.pin2', to: 'IC.pin3' },     // Op-amp 3 non-inv input
      { from: 'IC.pin2', to: 'IC.pin1' },      // Op-amp 3 feedback (buffer)
      { from: 'IC.pin1', to: 'VGND_NET' },     // Vgnd output

      // === VGND 100nF CAPS ===
      { from: 'VGND_NET', to: 'DCAP2.pin1' },
      { from: 'DCAP2.pin2', to: 'GND' },
      { from: 'R6.pin2', to: 'DCAP3.pin1' },
      { from: 'DCAP3.pin2', to: 'GND' },

      // // === VGND 10uF CAPS ===
      { from: 'VGND_NET', to: 'VGND1.pin1' },
      { from: 'VGND1.pin2', to: 'GND' },
      { from: 'R6.pin2', to: 'VGND2.pin1' },
      { from: 'VGND2.pin2', to: 'GND' },

      // === SUMMING AMPLIFIER ===
      { from: 'MODULE_INPUT.0', to: 'CCAP1.pin1' },
      { from: 'CCAP1.pin2', to: 'R1.pin1' },
      { from: 'R1.pin2', to: 'IC.pin6' },      // To op-amp 1 inv input
      { from: 'MODULE_INPUT.1', to: 'CCAP2.pin1' },
      { from: 'CCAP2.pin2', to: 'R2.pin1' },
      { from: 'R2.pin2', to: 'IC.pin6' },
      { from: 'MODULE_INPUT.2', to: 'CCAP3.pin1' },
      { from: 'CCAP3.pin2', to: 'R3.pin1' },
      { from: 'R3.pin2', to: 'IC.pin6' },
      { from: 'MODULE_INPUT.3', to: 'CCAP4.pin1' },
      { from: 'CCAP4.pin2', to: 'R4.pin1' },
      { from: 'R4.pin2', to: 'IC.pin6' }, // inverting input

      { from: 'VGND_NET', to: 'IC.pin5' },     // Non-inv input to Vgnd
      { from: 'IC.pin10', to: 'VGND_NET' },    // Non-inv input to Vgnd   

      { from: 'IC.pin7', to: 'R7.pin1' },      // Output to feedback
      { from: 'R7.pin2', to: 'IC.pin6' },      // Feedback to inv input

      { from: 'IC.pin7', to: 'R8.pin1' },      // input resistor to next stage
      { from: 'R8.pin2', to: 'IC.pin9' },      

      { from: 'IC.pin9', to: 'R9.pin1' },      // Feedback to inv input
      { from: 'R9.pin2', to: 'IC.pin8' },      // Feedback to inv input

      // === AC COUPLING & OUTPUT ===
      { from: 'IC.pin8', to: 'CCAP5.pin1' },    // Op-amp 1 out to cap
      { from: 'CCAP5.pin2', to: 'ROUT.pin1' },  // Cap to protection resistor
      { from: 'ROUT.pin2', to: 'JACK.T' },
      { from: 'GND', to: 'JACK.S' },

      // Note: LM324 pinout: 
      // Pin 4 = VCC, Pin 11 = GND
      // Op-amp 1: pins 1 (out), 2 (-), 3 (+)
      // Op-amp 2: pins 7 (out), 6 (-), 5 (+)
      // Op-amp 3: pins 8 (out), 9 (-), 10 (+)
      // Op-amp 4: pins 14 (out), 13 (-), 12 (+)
    ]
  }
};

const componentPinDefinitions = {
  // ============================================================
  // ICs with gate structures
  // ============================================================
  'CD40106': {
    pins: ['input', 'output', 'vcc', 'gnd'],
    gateMapping: {
      0: { input: 1, output: 2 },
      1: { input: 3, output: 4 },
      2: { input: 5, output: 6 },
      3: { input: 9, output: 8 },
      4: { input: 11, output: 10 },
      5: { input: 13, output: 12 }
    },
    vccPin: 14,
    gndPin: 7
  },
  'CD4077': {
    pins: ['input', 'output', 'vcc', 'gnd'],
    gateMapping: {
      0: { inputA: 1, inputB: 2, output: 3 },
      1: { inputA: 5, inputB: 6, output: 4 },
      2: { inputA: 8, inputB: 9, output: 10 },
      3: { inputA: 12, inputB: 13, output: 11 }
    },
    vccPin: 14,
    gndPin: 7
  },

  // ============================================================
  // Counter and Register ICs (pin-based)
  // ============================================================
  'CD4040': {
    pins: ['pin1', 'pin2', 'pin3', 'pin4', 'pin5', 'pin6', 'pin7', 'pin8',
      'pin9', 'pin10', 'pin11', 'pin12', 'pin13', 'pin14', 'pin15', 'pin16'],
    // Pin 10 = CLK, Pin 11 = RST, Pin 16 = VCC, Pin 8 = GND
    // Outputs: Q0=9, Q1=7, Q2=6, Q3=5, Q4=3, Q5=2, Q6=4, Q7=13, Q8=12, Q9=14, Q10=15, Q11=1
    vccPin: 16,
    gndPin: 8
  },
  'CD4017': {
    pins: ['pin1', 'pin2', 'pin3', 'pin4', 'pin5', 'pin6', 'pin7', 'pin8',
      'pin9', 'pin10', 'pin11', 'pin12', 'pin13', 'pin14', 'pin15', 'pin16'],
    // Pin 14 = CLK, Pin 13 = CE, Pin 15 = RST, Pin 16 = VCC, Pin 8 = GND
    // Outputs: Q0=3, Q1=2, Q2=4, Q3=7, Q4=10, Q5=1, Q6=5, Q7=6, Q8=9, Q9=11, Carry=12
    vccPin: 16,
    gndPin: 8
  },
  'CD4015': {
    pins: ['pin1', 'pin2', 'pin3', 'pin4', 'pin5', 'pin6', 'pin7', 'pin8',
      'pin9', 'pin10', 'pin11', 'pin12', 'pin13', 'pin14', 'pin15', 'pin16'],
    // Register A: CLK=1, DATA=15, RST=6, Q0=2, Q1=3, Q2=5, Q3=4
    // Register B: CLK=9, DATA=7, RST=14, Q0=10, Q1=11, Q2=12, Q3=13
    // Pin 16 = VCC, Pin 8 = GND
    vccPin: 16,
    gndPin: 8
  },
  'CD4013': {
    pins: ['pin1', 'pin2', 'pin3', 'pin4', 'pin5', 'pin6', 'pin7',
      'pin8', 'pin9', 'pin10', 'pin11', 'pin12', 'pin13', 'pin14'],
    // FF1: Q=1, Q'=2, CLK=3, RST=4, D=5, SET=6
    // FF2: SET=8, D=9, RST=10, CLK=11, Q'=12, Q=13
    // Pin 14 = VCC, Pin 7 = GND
    vccPin: 14,
    gndPin: 7
  },
  'CD4051': {
    pins: ['pin1', 'pin2', 'pin3', 'pin4', 'pin5', 'pin6', 'pin7', 'pin8',
      'pin9', 'pin10', 'pin11', 'pin12', 'pin13', 'pin14', 'pin15', 'pin16'],
    // X4=1, X6=2, COM=3, X7=4, X5=5, INH=6, VEE=7, GND=8
    // C=9, B=10, A=11, X3=12, X0=13, X1=14, X2=15, VCC=16
    vccPin: 16,
    gndPin: 8
  },
  'LM324': {
    pins: ['pin1', 'pin2', 'pin3', 'pin4', 'pin5', 'pin6', 'pin7',
      'pin8', 'pin9', 'pin10', 'pin11', 'pin12', 'pin13', 'pin14'],
    // Op1: OUT=1, -=2, +=3
    // VCC=4
    // Op2: +=5, -=6, OUT=7
    // Op3: OUT=8, -=9, +=10
    // GND=11
    // Op4: +=12, -=13, OUT=14
    vccPin: 4,
    gndPin: 11
  },

  // ============================================================
  // Transistors
  // ============================================================
  '2N3904': {
    pins: ['emitter', 'base', 'collector'],
    physicalPins: [1, 2, 3]  // E-B-C pinout for TO-92
  },

  // ============================================================
  // Potentiometers
  // ============================================================
  '100k Potentiometer': {
    pins: ['pin1', 'wiper', 'pin3'],  // CW end, wiper, CCW end
    physicalPins: [1, 2, 3]
  },

  // ============================================================
  // Resistors
  // ============================================================
  '1k Resistor': {
    pins: ['pin1', 'pin2'],
    physicalPins: [1, 2]
  },
  '4.7k Resistor': {
    pins: ['pin1', 'pin2'],
    physicalPins: [1, 2]
  },
  '10k Resistor': {
    pins: ['pin1', 'pin2'],
    physicalPins: [1, 2]
  },
  '47k Resistor': {
    pins: ['pin1', 'pin2'],
    physicalPins: [1, 2]
  },
  '100k Resistor': {
    pins: ['pin1', 'pin2'],
    physicalPins: [1, 2]
  },

  // ============================================================
  // Capacitors
  // ============================================================
  'Timing Capacitor': {
    pins: ['pin1', 'pin2'],
    physicalPins: [1, 2]
  },
  '10nF Capacitor': {
    pins: ['pin1', 'pin2'],
    physicalPins: [1, 2]
  },
  '100nF Capacitor': {
    pins: ['pin1', 'pin2'],
    physicalPins: [1, 2]
  },
  '1uF Capacitor': {
    pins: ['pin1', 'pin2'],  // pin1 = positive for polarized
    physicalPins: [1, 2]
  },
  '10uF Capacitor': {
    pins: ['pin1', 'pin2'],  // pin1 = positive for polarized
    physicalPins: [1, 2]
  },

  // ============================================================
  // LEDs and Jacks
  // ============================================================
  'LED': {
    pins: ['cathode', 'anode'],
    physicalPins: [1, 2]  //
  },
  'Jack': {
    pins: ['S', 'TN', 'T'],  // S=sleeve, TN=tip normalled, T=tip (order matches footprint)
    physicalPins: ['S', 'TN', 'T']  // Pad names in KiCad footprint
  }
};

// Generate reference designator based on component type

// Main PCB generation function
function generateKiCadPCB(nets, footprints, templateContent = null) {
  const timestamp = Date.now();

  let pcb;

  if (templateContent) {
    pcb = templateContent.trim();
    if (pcb.endsWith(')')) {
      let i = pcb.length - 1;
      while (i >= 0 && (pcb[i] === ')' || /\s/.test(pcb[i]))) {
        if (pcb[i] === ')') { pcb = pcb.substring(0, i); break; }
        i--;
      }
    }
    pcb += '\n';
  } else {
    pcb = `(kicad_pcb (version 20211014) (generator pcbnew)

  (general
    (thickness 1.6)
  )

  (paper "A4")
  (layers
    (0 "F.Cu" signal)
    (31 "B.Cu" signal)
    (32 "B.Adhes" user "B.Adhesive")
    (33 "F.Adhes" user "F.Adhesive")
    (34 "B.Paste" user)
    (35 "F.Paste" user)
    (36 "B.SilkS" user "B.Silkscreen")
    (37 "F.SilkS" user "F.Silkscreen")
    (38 "B.Mask" user)
    (39 "F.Mask" user)
    (40 "Dwgs.User" user "User.Drawings")
    (41 "Cmts.User" user "User.Comments")
    (42 "Eco1.User" user "User.Eco1")
    (43 "Eco2.User" user "User.Eco2")
    (44 "Edge.Cuts" user)
    (45 "Margin" user)
    (46 "B.CrtYd" user "B.Courtyard")
    (47 "F.CrtYd" user "F.Courtyard")
    (48 "B.Fab" user)
    (49 "F.Fab" user)
  )

  (setup
    (pad_to_mask_clearance 0)
    (pcbplotparams
      (layerselection 0x00010fc_ffffffff)
      (disableapertmacros false)
      (usegerberextensions false)
      (usegerberattributes true)
      (usegerberadvancedattributes true)
      (creategerberjobfile true)
      (svguseinch false)
      (svgprecision 6)
      (excludeedgelayer true)
      (plotframeref false)
      (viasonmask false)
      (mode 1)
      (useauxorigin false)
      (hpglpennumber 1)
      (hpglpenspeed 20)
      (hpglpendiameter 15.000000)
      (dxfpolygonmode true)
      (dxfimperialunits true)
      (dxfusepcbnewfont true)
      (psnegative false)
      (psa4output false)
      (plotreference true)
      (plotvalue true)
      (plotinvisibletext false)
      (sketchpadsonfab false)
      (subtractmaskfromsilk false)
      (outputformat 1)
      (mirror false)
      (drillshape 1)
      (scaleselection 1)
      (outputdirectory "")
    )
  )

`;
  }

  // Add nets
  nets.forEach(net => {
    pcb += `  (net ${net.id} "${net.name}")\n`;
  });

  pcb += '\n';

  // Add footprints
  footprints.forEach((fp, idx) => {
    pcb += generateFootprint(fp, idx, timestamp);
  });

  // Add ground and power planes/fills if needed
  if (!templateContent) {
    pcb += `
  (zone (net ${nets.find(n => n.name === 'GND')?.id || gndNetId}) (net_name "GND") (layer "B.Cu") (tstamp ${generateUUID()})
    (hatch edge 0.508)
    (connect_pads (clearance 0.508))
    (min_thickness 0.254)
    (filled_areas_thickness no)
    (fill yes (thermal_gap 0.508) (thermal_bridge_width 0.508))
    (polygon
      (pts
        (xy 0 0)
        (xy 200 0)
        (xy 200 150)
        (xy 0 150)
      )
    )
  )
`;
  }

  pcb += '\n)\n';

  return pcb;
}

// Generate individual footprint entry
function generateFootprint(fp, index, timestamp) {
  let template = footprintTemplates[fp.footprint];
  if (!template) {
    console.warn(`No template for ${fp.footprint}`);
    return '';
  }

  const rotation = fp.rotation || 0;

  // Insert position right after the layer declaration
  template = template.replace(
    /(\(layer "F\.Cu"\))/,
    `$1\n    (at ${fp.x} ${fp.y}${rotation ? ' ' + rotation : ''})`
  );

  // Update polygon coordinates
  template = template.replace(
    /\(xy\s+([-\d.]+)\s+([-\d.]+)\)/g,
    (match, x, y) => {
      const newX = parseFloat(x) + fp.x;
      const newY = parseFloat(y) + fp.y;
      return `(xy ${newX.toFixed(3)} ${newY.toFixed(3)})`;
    }
  );

  // Update reference and regenerate UUIDs
  template = template
    .replace('"REF**"', `"${fp.refDes}"`)
    .replace(/"DIP-14_W7\.62mm"/g, `"${fp.value}"`)
    .replace(/\(uuid "[^"]+"\)/g, () => `(uuid "${generateUUID()}")`);

  // Inject nets into pads (pass pinDef for components with named pads like jacks)
  const pinDef = componentPinDefinitions[fp.type];
  template = injectNetsIntoPads(template, fp.nets, fp.netNames, pinDef);

  return template + '\n';
}

function getPinCoordinates(footprintName, pinNumber) {
  // Simple helper to guess pin coordinates based on standard DIP packages
  // Assume Pin 1 is at (0,0) top-left
  // Pitch is 2.54mm
  // DIP-14: Pins 1-7 down left side, 8-14 up right side (7.62mm spacing)
  // DIP-16: Pins 1-8 down left side, 9-16 up right side

  const pitch = 2.54;
  const rowSpacing = 7.62; // 300 mil

  let pins = 14;
  if (footprintName.includes('DIP-16')) pins = 16;
  if (footprintName.includes('DIP-14')) pins = 14;

  const half = pins / 2;

  if (pinNumber <= half) {
    // Left side, going down
    return { x: 0, y: (pinNumber - 1) * pitch };
  } else {
    // Right side, going up (Pin half+1 is bottom right)
    // For DIP-14: Pin 8 is bottom right (at row 7 index -> y = 6 * pitch)
    // Actually, Pin half+1 is usually opposite Pin half?
    // Pin 1 (0,0), Pin 7 (0, 6*2.54).
    // Pin 8 (7.62, 6*2.54).
    // Pin 14 (7.62, 0).
    const rowFromBottom = pinNumber - (half + 1);
    const rowFromTop = (pins - 1) - (pinNumber - 1); // e.g. Pin 14 -> 13-13=0. Pin 8 -> 13-7=6.

    // Formula: y = ((pins - pinNumber)) * pitch
    // Wait, let's trace:
    // Pin 14 (top right) -> y=0. Correct.
    // Pin 8 (bottom right) -> y=6*pitch. Correct.
    return { x: rowSpacing, y: (pins - pinNumber) * pitch };
  }
}

function injectNetsIntoPads(template, nets, netNames, pinDef) {
  if (!nets || nets.length === 0) return template;

  let result = template;

  // Determine pad identifiers - either from pinDef.physicalPins or numeric 1,2,3...
  const padIds = (pinDef && pinDef.physicalPins) ||
    Array.from({ length: nets.length }, (_, i) => (i + 1).toString());

  // Process each pad individually
  for (let i = 0; i < nets.length && i < padIds.length; i++) {
    const padId = padIds[i];
    const netId = nets[i];
    const netName = netNames ? netNames[i] : '';

    if (netId !== undefined && netId > 0) {
      // Create a regex for this specific pad (handles both numeric "1" and named "T" pads)
      const escapedPadId = padId.toString().replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      const padPattern = new RegExp(
        `(\\(pad\\s+"${escapedPadId}"\\s+thru_hole[^]*?)(\\(uuid[^)]*\\))`,
        ''
      );

      result = result.replace(padPattern, (match, before, uuid) => {
        return `${before}(net ${netId} "${netName}")\n      ${uuid}`;
      });
    }
  }

  return result;
}

// Generate UUID for KiCad
function generateUUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

// Get module nets (which nets connect to which pins)
function getModuleNets(module, netMap) {
  const nets = [];

  // Find all connections involving this module
  connections.forEach(conn => {
    if (conn.from === module.id) {
      const netName = `Net-${conn.from}-${conn.to}`;
      nets.push(netMap.get(netName));
    }
    if (conn.to === module.id) {
      const netName = `Net-${conn.from}-${conn.to}`;
      nets.push(netMap.get(netName));
    }
  });

  return nets;
}

// Download helper
function downloadFile(content, filename, mimeType) {
  const blob = new Blob([content], { type: mimeType });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);

  link.setAttribute('href', url);
  link.setAttribute('download', filename);
  link.style.visibility = 'hidden';

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  URL.revokeObjectURL(url);
}



// Map dropdown values to template files
const pcbTemplates = {
  '1': 'pcb_templates/9V-center-neg.kicad_pcb',
  '2': 'pcb_templates/9V-center-pos.kicad_pcb',
};

async function exportPCB() {
  const psuType = document.getElementById('psuType').value;
  const templatePath = pcbTemplates[psuType];

  let templateContent = null;
  let templateNets = [];
  let templateMaxY = 0;
  let templateMaxNetId = 0;
  let templateRefDesCounts = {};

  // Default nets if no template
  let netId = 3;
  let gndNetId = 1;
  let vccNetId = 2;
  const nets = [
    { id: 0, name: "" },
    { id: 1, name: "GND" },
    { id: 2, name: "VCC" }
  ];

  const footprints = [];
  const netMap = new Map();
  netMap.set("GND", 1);
  netMap.set("VCC", 2);

  if (templatePath) {
    try {
      const response = await fetch(templatePath);
      if (response.ok) {
        templateContent = await response.text();

        // Parse Nets
        // (net 1 "GND")
        const netRegex = /\(net (\d+) "([^"]*)"\)/g;
        let match;
        while ((match = netRegex.exec(templateContent)) !== null) {
          const id = parseInt(match[1]);
          const name = match[2];
          templateNets.push({ id, name });
          if (id > templateMaxNetId) templateMaxNetId = id;

          if (name === "GND") gndNetId = id;
          if (name === "VCC") vccNetId = id; // Assuming template uses VCC, if it uses +9V or similar we might need mapping
          // For now, let's map standard names
        }

        // Update our starting state based on template
        netId = templateMaxNetId + 1;

        // Clear default nets and use template ones for mapping
        nets.length = 0;
        // nets.push({ id: 0, name: "" }); // Already in template

        // Ensure GND and VCC are mapped correctly
        templateNets.forEach(n => {
          if (n.id !== 0) { // Don't re-add 0
            // We don't add template nets to 'nets' array immediately because 'nets' array is used to generate (net ...) lines
            // BUT we want to preserve template nets. 
            // Actually, we should probably output the template file almost as-is, executing our insertions.
            // OR we parse everything and rebuild. Rebuilding is safer for consistency but harder.
            // Strategy: Append our new definitions. 
            // We need 'nets' to contain ONLY NEW nets we generate, OR all nets if we rewrite the section.
            // Let's assume we will inject our nets into the list.
            netMap.set(n.name, n.id);
          }
        });

        // Parse components for RefDes and Max Y
        // (at 58.505112 72 180) - we care about the Y (2nd param)
        // (property "Reference" "C2"

        // We need a more robust parser for s-expressions or just regex scan
        // Scan for (footprint ... (at x y ... ) ... (property "Reference" "Ref" ...))

        const footprintRegex = /\(footprint\s+"[^"]+"\s+\(layer\s+"[^"]+"\)\s+\(uuid\s+"[^"]+"\)\s+\(at\s+[\-\d\.]+\s+([\-\d\.]+)/g;
        while ((match = footprintRegex.exec(templateContent)) !== null) {
          const y = parseFloat(match[1]);
          if (y > templateMaxY) templateMaxY = y;
        }

        // Scan for references to offset counters
        const refRegex = /\(property\s+"Reference"\s+"([A-Z]+)(\d+)"/g;
        while ((match = refRegex.exec(templateContent)) !== null) {
          const prefix = match[1];
          const num = parseInt(match[2]);
          if (!templateRefDesCounts[prefix] || num > templateRefDesCounts[prefix]) {
            templateRefDesCounts[prefix] = num;
          }
        }

      } else {
        console.warn("Failed to load template", templatePath);
      }
    } catch (e) {
      console.error("Error loading template", e);
    }
  }

  const exportableModules = modules.filter(m => {
    const baseBOM = moduleBaseBOM[m.type];
    return baseBOM && !baseBOM.notSupported;
  });

  if (exportableModules.length === 0) {
    showAlert('No hardware-compatible modules to export');
    return;
  }

  // 1. Generate nets from inter-module connections
  // Group connections by output point to support branching (one output -> multiple inputs)
  const outputNets = new Map(); // Maps "moduleId_outputIndex" -> netId

  connections.forEach(conn => {
    const fromModule = modules.find(m => m.id === conn.from);
    const toModule = modules.find(m => m.id === conn.to);
    if (!fromModule || !toModule) return;

    // Create net name based on output point only (allows branching)
    const outputKey = `${conn.from}_O${conn.fromOutputIndex}`;

    if (!outputNets.has(outputKey)) {
      const netName = `Net-${fromModule.type}_${conn.from}_O${conn.fromOutputIndex}`;
      nets.push({ id: netId, name: netName });
      netMap.set(netName, netId);
      outputNets.set(outputKey, { netId, netName });
      netId++;
    }

    // Store connection info for later pin mapping
    conn.netId = outputNets.get(outputKey).netId;
    conn.netName = outputNets.get(outputKey).netName;
  });

  console.log('Generated nets:', nets);
  console.log('Connections with nets:', connections.map(c => ({ from: c.from, to: c.to, netName: c.netName })));

  // 2a. Pre-create oscillator internal nets (needed before chip allocation)
  const oscillatorGateMap = new Map(); // Maps oscillator module ID to its nets
  exportableModules.filter(m => m.type === 'Oscillator').forEach(m => {
    const oscNetPrefix = `Osc_${m.id}`;
    const oscInputNet = `${oscNetPrefix}_input`;

    // Create input net (always internal)
    if (!netMap.has(oscInputNet)) {
      nets.push({ id: netId, name: oscInputNet });
      netMap.set(oscInputNet, netId++);
    }

    // For output: if oscillator has external connections, use those nets
    // Otherwise create an internal output net
    let oscOutputNetName = `${oscNetPrefix}_output`;
    let oscOutputNetId;

    const oscOutgoingConns = connections.filter(c => c.from === m.id);
    if (oscOutgoingConns.length > 0 && oscOutgoingConns[0].netId) {
      // Use the external connection's net for oscillator output
      oscOutputNetId = oscOutgoingConns[0].netId;
      oscOutputNetName = oscOutgoingConns[0].netName;
    } else {
      // Create internal output net
      if (!netMap.has(oscOutputNetName)) {
        nets.push({ id: netId, name: oscOutputNetName });
        netMap.set(oscOutputNetName, netId);
        oscOutputNetId = netId++;
      } else {
        oscOutputNetId = netMap.get(oscOutputNetName);
      }
    }

    oscillatorGateMap.set(m.id, {
      inputNet: oscInputNet,
      inputNetId: netMap.get(oscInputNet),
      outputNet: oscOutputNetName,
      outputNetId: oscOutputNetId
    });
  });

  // 2b. Allocate chips for gate-based modules (including oscillators)
  const chipAllocations = new Map();

  exportableModules.forEach(m => {
    const pinout = modulePinouts[m.type];
    if (!pinout) return;

    if (!chipAllocations.has(pinout.chip)) {
      chipAllocations.set(pinout.chip, []);
    }

    const chips = chipAllocations.get(pinout.chip);
    let targetChip = chips.find(c => c.usedGates < pinout.gatesPerChip);

    if (!targetChip) {
      targetChip = {
        chipType: pinout.chip,
        usedGates: 0,
        gateAssignments: []
      };
      chips.push(targetChip);
    }

    targetChip.gateAssignments.push({
      module: m,
      gateIndex: targetChip.usedGates
    });
    targetChip.usedGates++;
  });



  // Initialize global RefDes counters from template
  const globalRefDesCounts = { ...templateRefDesCounts };

  function getNextRefDes(prefix) {
    if (!globalRefDesCounts[prefix]) globalRefDesCounts[prefix] = 0;
    globalRefDesCounts[prefix]++;
    return `${prefix}${globalRefDesCounts[prefix]}`;
  }

  // 3. Generate footprints for gate-based chips
  let globalX = 50;
  let globalY = templateMaxY > 0 ? templateMaxY + 10 : 50; // Start below template

  const moduleToICLocation = new Map();

  chipAllocations.forEach((chips, chipType) => {
    chips.forEach((chip, chipIdx) => {
      const footprintInfo = kiCadFootprints[chipType];
      if (!footprintInfo) return;

      const componentNets = new Array(footprintInfo.pins).fill(0);
      const componentNetNames = new Array(footprintInfo.pins).fill("");

      if (footprintInfo.vcc) {
        componentNets[footprintInfo.vcc - 1] = vccNetId;
        componentNetNames[footprintInfo.vcc - 1] = "VCC";
      }
      if (footprintInfo.gnd) {
        componentNets[footprintInfo.gnd - 1] = gndNetId;
        componentNetNames[footprintInfo.gnd - 1] = "GND";
      }

      chip.gateAssignments.forEach(({ module, gateIndex }) => {
        let currentRefDes = moduleToICLocation.get(module.id)?.refDes;
        if (!currentRefDes) {
          currentRefDes = getNextRefDes('U');
          moduleToICLocation.set(module.id, { x: globalX, y: globalY, refDes: currentRefDes });
        }

        const pinout = modulePinouts[module.type];
        if (!pinout) return; // Guard against undefined pinout

        const gateMapping = pinout.pinMapping[gateIndex];

        // Special handling for oscillators
        if (module.type === 'Oscillator') {
          const oscNets = oscillatorGateMap.get(module.id);
          if (oscNets && gateMapping.input !== undefined && gateMapping.output !== undefined) {
            const inputPinIndex = gateMapping.input - 1;
            componentNets[inputPinIndex] = oscNets.inputNetId;
            componentNetNames[inputPinIndex] = oscNets.inputNet;

            const outputPinIndex = gateMapping.output - 1;
            componentNets[outputPinIndex] = oscNets.outputNetId;
            componentNetNames[outputPinIndex] = oscNets.outputNet;
          }
          return;
        }

        // Normal gate handling
        connections.forEach(conn => {
          if (conn.from === module.id && conn.netId && gateMapping.output !== undefined) {
            const pinIndex = gateMapping.output - 1;
            componentNets[pinIndex] = conn.netId;
            componentNetNames[pinIndex] = conn.netName;
          }

          if (conn.to === module.id && conn.netId) {
            let pinNum;
            if (conn.inputIndex === 0 && gateMapping.inputA !== undefined) {
              pinNum = gateMapping.inputA;
            } else if (conn.inputIndex === 1 && gateMapping.inputB !== undefined) {
              pinNum = gateMapping.inputB;
            } else if (gateMapping.input !== undefined) {
              pinNum = gateMapping.input;
            }

            if (pinNum !== undefined) {
              const pinIndex = pinNum - 1;
              componentNets[pinIndex] = conn.netId;
              componentNetNames[pinIndex] = conn.netName;
            }
          }
        });
      });


      // Handle Unused Inputs (Pulldowns)
      // Find pinout definition for this chip type (reverse lookup from modulePinouts)
      const pinoutEntry = Object.entries(modulePinouts).find(([_, def]) => def.chip === chipType);
      const pinout = pinoutEntry ? pinoutEntry[1] : undefined;

      if (pinout) {
        const currentChipRefDes = `U${footprints.length + 1}`;

        for (let g = 0; g < pinout.gatesPerChip; g++) {
          const gm = pinout.pinMapping[g];
          const inputPins = [];
          if (gm.inputA !== undefined) inputPins.push(gm.inputA);
          if (gm.inputB !== undefined) inputPins.push(gm.inputB);
          if (gm.input !== undefined) inputPins.push(gm.input);

          // Check if any inputs for this gate are unconnected (net 0)
          const unusedPins = inputPins.filter(p => componentNets[p - 1] === 0);
          
          if (unusedPins.length > 0) {
            // Create a new net for the pulldown
            const pulldownNetName = `Net-${currentChipRefDes}-Gate${g}-PD`;
            const pdNetId = netId++;
            nets.push({ id: pdNetId, name: pulldownNetName });
            netMap.set(pulldownNetName, pdNetId);

            // Assign this net to the unused pins
            unusedPins.forEach(p => {
              componentNets[p - 1] = pdNetId;
              componentNetNames[p - 1] = pulldownNetName;
            });

            // Create Resistor Footprint
            const resInfo = kiCadFootprints['100k Resistor'];
            if (resInfo) {
              const resNets = [pdNetId, gndNetId]; // PullDownNet -> GND
              const resNetNames = [pulldownNetName, "GND"];
              const pinCoords = getPinCoordinates(footprintInfo.footprint, gm.inputA | gm.input);
              let resRotation = 180;
              let xOffset = -3.5;
              if (pinCoords.x > 1) xOffset = 3.5;
              if (pinCoords.x > 1) resRotation = 0;
              console.log(pinCoords);
              footprints.push({
                refDes: getNextRefDes('R'),
                type: '100k Resistor',
                value: '100k',
                footprint: resInfo.footprint,
                x: globalX + pinCoords.x + xOffset,
                y: globalY + pinCoords.y + 1,
                rotation: resRotation,
                nets: resNets,
                netNames: resNetNames
              });
            }
          }
        }
      }

      footprints.push({
        refDes: moduleToICLocation.get(chip.gateAssignments[0].module.id).refDes, // Use the RefDes assigned earlier (they share the same chip)
        type: chipType,
        value: chipType,
        footprint: footprintInfo.footprint,
        x: globalX,
        y: globalY,
        rotation: 0,
        nets: componentNets,
        netNames: componentNetNames
      });

      // Add decoupling capacitor
      const dcapInfo = kiCadFootprints['100nF Capacitor'];
      if (dcapInfo && footprintInfo.vcc) {
        const dcapNets = [vccNetId, gndNetId];
        const dcapNetNames = ['VCC', 'GND'];

        const vccCoords = getPinCoordinates(footprintInfo.footprint, footprintInfo.vcc);
        const dcapX = globalX + vccCoords.x + 2.54;
        const dcapY = globalY + vccCoords.y;

        footprints.push({
          refDes: getNextRefDes('C'),
          type: '100nF Capacitor',
          value: '100nF',
          footprint: dcapInfo.footprint,
          x: dcapX,
          y: dcapY,
          rotation: 0,
          nets: dcapNets,
          netNames: dcapNetNames
        });
      }

      globalY += 30;
    });

    globalX += 45;
    globalY = 50;
  });

  // 4a. Handle oscillator discrete components
  // Cluster strategy: Pot -> Resistor -> Cap
  const oscillatorModules = exportableModules.filter(m => m.type === 'Oscillator');
  oscillatorModules.forEach((m, idx) => {
    // ... (existing net logic) ...
    const internalNet = moduleInternalNets['Oscillator'];
    const oscGateNets = oscillatorGateMap.get(m.id);
    if (!oscGateNets) return;

    const oscInputNet = oscGateNets.inputNet;
    const oscInputNetId = oscGateNets.inputNetId;
    const oscOutputNet = oscGateNets.outputNet;
    const oscOutputNetId = oscGateNets.outputNetId;

    const oscNetPrefix = `Osc_${m.id}`;
    const oscPotWiper = `${oscNetPrefix}_pot_wiper`;

    if (!netMap.has(oscPotWiper)) {
      nets.push({ id: netId, name: oscPotWiper });
      netMap.set(oscPotWiper, netId++);
    }
    const oscPotWiperId = netMap.get(oscPotWiper);

    // Layout Cursor for this cluster
    let clusterX = globalX;
    let clusterY = globalY;

    // 1. Potentiometer (Top)
    const potInfo = kiCadFootprints['100k Potentiometer'];
    if (potInfo) {
      const potNets = [oscOutputNetId, oscPotWiperId, 0];
      const potNetNames = [oscOutputNet, oscPotWiper, ''];

      footprints.push({
        refDes: getNextRefDes('RV'),
        type: '100k Potentiometer',
        value: '100k',
        footprint: potInfo.footprint,
        x: clusterX,
        y: clusterY,
        rotation: 90,
        nets: potNets,
        netNames: potNetNames
      });
    }
    
    // 2. Resistor (Below Pot)
    const resInfo = kiCadFootprints['1k Resistor'];
    if (resInfo) {
      const resNets = [oscPotWiperId, oscInputNetId];
      const resNetNames = [oscPotWiper, oscInputNet];

      footprints.push({
        refDes: getNextRefDes('R'),
        type: '1k Resistor',
        value: '1k',
        footprint: resInfo.footprint,
        x: clusterX,
        y: clusterY + 4,
        rotation: 0,
        nets: resNets,
        netNames: resNetNames
      });
    }

    // 3. Timing Capacitor (Below Resistor)
    const capInfo = kiCadFootprints['Timing Capacitor'];
    if (capInfo) {
      const capNets = [oscInputNetId, gndNetId]; // InputNet, GND
      const capNetNames = [oscInputNet, 'GND'];

      footprints.push({
        refDes: getNextRefDes('C'),
        type: 'Timing Capacitor',
        value: '100nF',
        footprint: capInfo.footprint,
        x: clusterX + 5,
        y: clusterY + 8,
        rotation: 180,
        nets: capNets,
        netNames: capNetNames
      });
    }

    globalX += 20; // Move to next column for next oscillator
    // Reset Y if wrapping handled externally, but here we just drift X
  });

  globalY = 50; // Reset Y for next section


  // 4b. Handle modules with internal netlists
  // Handle modules with discrete components or simple ICs
  exportableModules.forEach((m, idx) => {
    // Oscillators are handled specifically in step 4a
    // Oscillators are handled specifically in step 4a
    if (m.type === 'Oscillator') return;

    // Skip modules that were already handled in Step 3 (Chip Allocation)
    if (modulePinouts[m.type]) return;

    const internalNet = moduleInternalNets[m.type];

    if (internalNet) {
      // === CASE 1: Module has internal netlist (Oscillator, LED, Jack, etc.) ===
      const componentInstances = new Map();

      // Implement robust net merging (Union-Find / Connected Components)
      const nodeGroups = [];

      // Helper to Normalize Node IDs
      // Handles: 'CompID.PinName', 'GND', 'VCC', 'MODULE_INPUT', 'MODULE_OUTPUT', 'MODULE_INPUT.0', etc.
      // Returns canonical string for graph node
      const normalizeNode = (nodeStr) => {
        if (nodeStr === 'GND' || nodeStr === 'VCC') return nodeStr;
        if (nodeStr.startsWith('MODULE_')) {
          // Ensure inputs/outputs have an index (default to 0)
          if (!nodeStr.includes('.')) return nodeStr + '.0';
          return nodeStr;
        }
        return `${m.id}_${nodeStr}`; // e.g. "mod123_R1.pin1"
      };

      // 1. Build connected groups
      internalNet.internalConnections.forEach(conn => {
        const u = normalizeNode(conn.from);
        const v = normalizeNode(conn.to);

        const groupU = nodeGroups.find(g => g.has(u));
        const groupV = nodeGroups.find(g => g.has(v));

        if (!groupU && !groupV) {
          nodeGroups.push(new Set([u, v]));
        } else if (groupU && !groupV) {
          groupU.add(v);
        } else if (!groupU && groupV) {
          groupV.add(u);
        } else if (groupU && groupV && groupU !== groupV) {
          // Merge two existing groups
          for (const item of groupV) groupU.add(item);
          const idx = nodeGroups.indexOf(groupV);
          nodeGroups.splice(idx, 1);
        }
      });

      // 2. Assign Net IDs to groups
      // Check if group contains GND, VCC, or External Connection (via MODULE_INPUT/OUTPUT node)
      const nodeToNetId = new Map();
      const nodeToNetName = new Map();

      nodeGroups.forEach(group => {
        let finalNetId = 0;
        let finalNetName = '';

        // Priority 1: Global Power Nets
        if (group.has('GND')) {
          finalNetId = gndNetId;
          finalNetName = 'GND';
        } else if (group.has('VCC')) {
          finalNetId = vccNetId;
          finalNetName = 'VCC';
        }

        // Priority 2: External Nets (via MODULE_INPUT/OUTPUT)
        if (finalNetId === 0) {
          // Check all nodes in group for connection to external net
          for (const node of group) {
            if (node.startsWith('MODULE_')) {
              const isInput = node.startsWith('MODULE_INPUT');
              const index = parseInt(node.split('.')[1] || '0');

              // Find matching external connection
              const extConn = connections.find(c => {
                if (!c.netId) return false;
                if (isInput) return c.to === m.id && c.inputIndex === index;
                else return c.from === m.id && c.fromOutputIndex === index;
              });

              if (extConn) {
                finalNetId = extConn.netId;
                finalNetName = extConn.netName;
                break;
              }
            }
          }
        }

        // Priority 2.5: Detect Unconnected External Inputs -> Add Pulldown
        if (finalNetId === 0) {
          let needsPulldown = false;
          for (const node of group) {
            // Check if this is an input node using MODULE_INPUT
            if (node.startsWith('MODULE_INPUT')) {
              // Verify it's not connected externally (which we already implicitly did by priority 2 check failing)
              // But ensure it really IS an INPUT node
              // (MODULE_OUTPUT nodes without external connections are just unused outputs, no pulldown needed)
              if (node.includes('MODULE_INPUT')) {
                needsPulldown = true;
              }
            }
          }

          if (needsPulldown) {
            // Create Pulldown Net
            finalNetId = netId++;
            // Generate descriptive name
            const firstPin = Array.from(group).find(n => !n.startsWith('MODULE_') && n !== 'GND' && n !== 'VCC');
            const baseName = firstPin ? `Net-${firstPin}` : `Net-Internal-${finalNetId}`;
            finalNetName = `${baseName}-PD`;

            nets.push({ id: finalNetId, name: finalNetName });
            netMap.set(finalNetName, finalNetId);

            // Create Resistor Footprint
            const resInfo = kiCadFootprints['100k Resistor'];
            if (resInfo) {
              const resNets = [finalNetId, gndNetId]; // Net -> GND
              const resNetNames = [finalNetName, "GND"];

              // We need a refDes. Generate one based on module.
              const pdRefDes = getNextRefDes('R');

              footprints.push({
                refDes: pdRefDes,
                type: '100k Resistor',
                value: '100k',
                footprint: resInfo.footprint,
                x: globalX + 15, // Offset from module cluster
                y: globalY + 15,
                rotation: 0,
                nets: resNets,
                netNames: resNetNames
              });
            }
          }
        }

        // Priority 3: Create New Internal Net (Default)
        if (finalNetId === 0) {
          finalNetId = netId++;
          // Generate descriptive name from first valid component pin in group
          const firstPin = Array.from(group).find(n => !n.startsWith('MODULE_') && n !== 'GND' && n !== 'VCC');
          finalNetName = firstPin ? `Net-${firstPin}` : `Net-Internal-${finalNetId}`;
          // Register globally
          nets.push({ id: finalNetId, name: finalNetName });
          netMap.set(finalNetName, finalNetId);
        }

        // Assign to all nodes in group
        for (const node of group) {
          nodeToNetId.set(node, finalNetId);
          nodeToNetName.set(node, finalNetName);
        }
      });

      // 3. Special handling for I/O Modules: Cluster Resistor near Jack
      // (Override default grid placement)
      const isIoModule = m.type === 'ExportLed' || m.type === 'ExportOutlet' || m.type === 'ExportInlet';

      if (isIoModule) {
        // Find the "Main" component (Jack or LED) and the "Satellite" (Resistor)
        const jackOrLed = internalNet.components.find(c => c.type === 'Jack' || c.type === 'LED');
        const resistor = internalNet.components.find(c => c.type.includes('Resistor'));

        let clusterX = globalX;
        let clusterY = globalY;


        // Actually, let's just let the generic loop run, but map the components to specific offsets
        const relativeOffsets = new Map();
        if (m.type === 'ExportLed') {
          // LED at (0,0), Resistor at (0, 5mm)
          relativeOffsets.set('LED', { dx: 0, dy: 0 });
          relativeOffsets.set('RES', { dx: 0, dy: 5 });
        } else if (m.type === 'ExportOutlet') {
          // Jack at (0,0), Resistor at (0, -5mm)
          relativeOffsets.set('JACK', { dx: 0, dy: 0 });
          relativeOffsets.set('RES', { dx: 0, dy: -5 });
        } else if (m.type === 'ExportInlet') {
          // Jack at (0,0), Resistor at (0, -5mm)
          relativeOffsets.set('JACK', { dx: 0, dy: 0 });
          relativeOffsets.set('RES', { dx: 0, dy: -5 });
        }

        // Special handling for Binary Counter (RTL Inverter Cluster)
        // Q1, R1, R2 should be near the IC
      }

      // Special handling for Binary Counter - Cluster RTL near IC
      let baseOffset = { x: globalX, y: globalY };
      if (m.type === 'Binary Counter') {
        const icLoc = moduleToICLocation.get(m.id);
        if (icLoc) {
          // Place RTL components to the right of the IC
          baseOffset = { x: icLoc.x + 15, y: icLoc.y + 5 };
        }
      }

      // Create footprints for each component
      internalNet.components.forEach((comp, compIdx) => {
        const footprintInfo = kiCadFootprints[comp.type];
        if (!footprintInfo) {
          console.warn(`No footprint for ${comp.type} in module ${m.type}`);
          return;
        }

        // Skip the IC if it was already placed in step 3 (Chip Allocation)
        // Only exclude chips that appear in modulePinouts (CD40106, CD4077, etc)
        // CD4040, CD4017, CD4015, CD4013, CD4051 MUST be placed here.
        if (['CD40106', 'CD4077', 'CD4081', 'CD4071', 'CD4011', 'CD4001', 'CD4070', 'CD4069'].includes(comp.type)) {
          return;
        }

        const componentNets = new Array(footprintInfo.pins).fill(0);
        const componentNetNames = new Array(footprintInfo.pins).fill("");

        // Helper to set net for a specific pin
        const setPinNet = (pinName, pinIndex) => {
          const nodeKey = `${m.id}_${comp.id}.${pinName}`; // Fixed: use dot to match normalizeNode format

          // Check explicit group assignment
          if (nodeToNetId.has(nodeKey)) {
            componentNets[pinIndex] = nodeToNetId.get(nodeKey);
            componentNetNames[pinIndex] = nodeToNetName.get(nodeKey);
            return;
          }
        };

        // Standard Pin Mapping
        if (footprintInfo.vcc) {
          componentNets[footprintInfo.vcc - 1] = vccNetId;
          componentNetNames[footprintInfo.vcc - 1] = "VCC";
        }
        if (footprintInfo.gnd) {
          componentNets[footprintInfo.gnd - 1] = gndNetId;
          componentNetNames[footprintInfo.gnd - 1] = "GND";
        }

        const pinDef = componentPinDefinitions[comp.type];
        if (pinDef) {
          pinDef.pins.forEach((pinName, idx) => {
            setPinNet(pinName, idx);
          });
        }

        // COORDINATE LOGIC
        let finalX = baseOffset.x;
        let finalY = baseOffset.y;

        if (m.type === 'Binary Counter') {
          // RTL Cluster Logic
          // IC is at baseOffset (0,0 relative).
          // Place RTL cluster (Q1, R1, R2) to the right of the IC.
          if (comp.id === 'IC') { /* defaults to baseOffset */ }
          if (comp.id === 'Q1') { finalX += 15; finalY += 0; }
          if (comp.id === 'R1') { finalX += 15; finalY += 5; }
          if (comp.id === 'R2') { finalX += 15; finalY += 10; }
          if (comp.id === 'DCAP') { finalX += 0; finalY -= 5; } // Place cap near VCC? (or just leave it)
        } else if (m.type === 'ExportLed') {
          if (comp.id === 'LED') { /* default */ }
          if (comp.id === 'RES') { finalY += 5; }
        } else if (m.type === 'ExportOutlet' || m.type === 'ExportInlet') {
          if (comp.type === 'Jack') { /* default */ }
          if (comp.type.includes('Resistor')) { finalY -= 5; }
        } else {
          // Default linear spread for others
          finalX += (compIdx * 10);
        }

        // Determine prefix based on component type
        const mapping = {
          'LED': 'D',
          'Jack': 'J',
          '100k Resistor': 'R',
          '4.7k Resistor': 'R',
          '1k Resistor': 'R',
          '10k Resistor': 'R',
          '47k Resistor': 'R',
          '100nF Capacitor': 'C',
          '1uF Capacitor': 'C',
          '10uF Capacitor': 'C',
          '2N3904': 'Q',
          'CD4040': 'U',
          'CD4017': 'U',
          'CD4015': 'U',
          'CD4013': 'U',
          'CD4051': 'U',
          'LM324': 'U'
        };
        const defaultPrefix = comp.type.startsWith('Resistor') ? 'R' : (comp.type.startsWith('Capacitor') ? 'C' : 'U');
        const prefix = mapping[comp.type] || defaultPrefix;

        footprints.push({
          refDes: getNextRefDes(prefix),
          type: comp.type,
          value: comp.type,
          footprint: footprintInfo.footprint,
          x: finalX,
          y: finalY,
          rotation: 0,
          nets: componentNets,
          netNames: componentNetNames
        });

      });

      globalY += 25;
      globalX = 50;

    } else {
      // === CASE 2: Simple IC modules without internal netlist ===
      // (Ring Counter, Flip-Flop, Multiplexer, etc.)
      const baseBOM = moduleBaseBOM[m.type];
      if (!baseBOM || !baseBOM.bom) return;

      baseBOM.bom.forEach((component, compIdx) => {
        const footprintInfo = kiCadFootprints[component.name];
        if (!footprintInfo) {
          console.warn(`No footprint for ${component.name}`);
          return;
        }

        const componentNets = new Array(footprintInfo.pins).fill(0);
        const componentNetNames = new Array(footprintInfo.pins).fill("");

        // Power pins
        if (footprintInfo.vcc) {
          componentNets[footprintInfo.vcc - 1] = vccNetId;
          componentNetNames[footprintInfo.vcc - 1] = "VCC";
        }
        if (footprintInfo.gnd) {
          componentNets[footprintInfo.gnd - 1] = gndNetId;
          componentNetNames[footprintInfo.gnd - 1] = "GND";
        }

        // For decoupling caps, we're done (only power connections)
        // For ICs, we need to map signal pins (TODO: add pinout mappings)

        // Placeholder: try to connect to module's connections
        if (component.name.startsWith('CD') || component.name.startsWith('LM')) {
          // This is an IC - needs proper pinout mapping
          // For now, just leave signal pins unconnected
          console.warn(`IC ${component.name} in ${m.type} needs pinout mapping`);
        }

        const prefix = component.name.startsWith('CD') || component.name.startsWith('LM') ? 'U' : (component.name.includes('Capacitor') ? 'C' : 'R');

        footprints.push({
          refDes: getNextRefDes(prefix),
          type: component.name,
          value: component.name,
          footprint: footprintInfo.footprint,
          x: globalX,
          y: globalY,
          rotation: 0,
          nets: componentNets,
          netNames: componentNetNames
        });

        globalX += 20;
      });

      globalY += 20;
      globalX = 50;
    }
  });

  const pcb = generateKiCadPCB(nets, footprints, templateContent);
  downloadFile(pcb, 'logic_synth.kicad_pcb', 'text/plain');
  showAlert('PCB exported with internal component wiring!');
}

